// JavaScript Document
const strLink1="https://interior-arne.com/products/"
function setGoods(url,haba,depth,height,color,form){
this.url=url;
this.haba=haba;
this.depth=depth;
this.height=height;
this.color=color;
this.form=form;
}
function searchURL(){
var habaValue=document.getElementById("haba").value;
var depthValue=document.getElementById("depth").value;
var heightValue=document.getElementById("height").value;
var idColor = document.getElementsByName( "colortype" ) ;
for ( colorValue="", i=idColor.length; i--; ) {
 if ( idColor[i].checked ) {
  colorValue = idColor[i].id ;
  break ;
 }
}
if(habaValue=="haba-select" && depthValue=="depth-selected" && heightValue=="height-selected"){
alert("「幅・奥行・高さ」を選んでください");
return false;
}
if(habaValue=="haba-select" && depthValue=="depth-selected"){
alert("「幅・奥行」を選んでください");
return false;
}
if(habaValue=="haba-select" && heightValue=="height-selected"){
alert("「幅・高さ」を選んでください");
return false;
}
if(depthValue=="depth-selected" && heightValue=="height-selected"){
alert("「奥行・高さ」を選んでください");
return false;
}
if(habaValue=="haba-select"){
alert("「幅」を選んでください");
return false;
}
if(depthValue=="depth-selected"){
alert("「奥行」を選んでください");
return false;
}
if(heightValue=="height-selected"){
alert("「高さ」を選んでください");
return false;
}
if(colorValue==""){
alert("「カラー」を選んでください");
return false;
}
var url=document.getElementById("link_url");
for(var i in goods){
if(goods[i].haba==habaValue && goods[i].depth==depthValue && goods[i].height==heightValue && goods[i].color==colorValue){
return goods[i].url;
}
}
alert("ご希望サイズ幅"+habaValue+"cm×奥行"+depthValue+"cm×高さ"+heightValue+"cmは購入ページのご用意がございません。\nお手数をおかけしますがお見積りを出しますので当店までお問合せくださいませ。");
return false;
}
function jump(){
var idColor = document.getElementsByName( "colortype" ) ;
for ( strColor="", i=idColor.length; i--; ) {
 if ( idColor[i].checked ) {
  strColor = idColor[i].id ;
  var valueColor = idColor[i].value ;
  break ;
 }
}
var url=searchURL();
if(!url){
return false;
}
window.open(strLink1+url)
return false;
}
goods = new Object();
goods[0] =new setGoods("0000a59207","60","25","40","wood","normal");
goods[1] =new setGoods("0000a59214","70","25","40","wood","normal");
goods[2] =new setGoods("0000a59221","80","25","40","wood","normal");
goods[3] =new setGoods("0000a59228","90","25","40","wood","normal");
goods[4] =new setGoods("0000a59235","100","25","40","wood","normal");
goods[5] =new setGoods("0000a59242","110","25","40","wood","normal");
goods[6] =new setGoods("0000a59249","120","25","40","wood","normal");
goods[7] =new setGoods("0000a59256","130","25","40","wood","normal");
goods[8] =new setGoods("0000a59263","140","25","40","wood","normal");
goods[9] =new setGoods("0000a59270","150","25","40","wood","normal");
goods[10] =new setGoods("0000a59277","160","25","40","wood","normal");
goods[11] =new setGoods("0000a59284","170","25","40","wood","normal");
goods[12] =new setGoods("0000a59291","180","25","40","wood","normal");
goods[13] =new setGoods("0000a59298","60","30","40","wood","normal");
goods[14] =new setGoods("0000a59305","70","30","40","wood","normal");
goods[15] =new setGoods("0000a59312","80","30","40","wood","normal");
goods[16] =new setGoods("0000a59319","90","30","40","wood","normal");
goods[17] =new setGoods("0000a59326","100","30","40","wood","normal");
goods[18] =new setGoods("0000a59333","110","30","40","wood","normal");
goods[19] =new setGoods("0000a59340","120","30","40","wood","normal");
goods[20] =new setGoods("0000a59347","130","30","40","wood","normal");
goods[21] =new setGoods("0000a59354","140","30","40","wood","normal");
goods[22] =new setGoods("0000a59361","150","30","40","wood","normal");
goods[23] =new setGoods("0000a59368","160","30","40","wood","normal");
goods[24] =new setGoods("0000a59375","170","30","40","wood","normal");
goods[25] =new setGoods("0000a59382","180","30","40","wood","normal");
goods[26] =new setGoods("0000a59389","60","35","40","wood","normal");
goods[27] =new setGoods("0000a59396","70","35","40","wood","normal");
goods[28] =new setGoods("0000a59403","80","35","40","wood","normal");
goods[29] =new setGoods("0000a59410","90","35","40","wood","normal");
goods[30] =new setGoods("0000a59417","100","35","40","wood","normal");
goods[31] =new setGoods("0000a59424","110","35","40","wood","normal");
goods[32] =new setGoods("0000a59431","120","35","40","wood","normal");
goods[33] =new setGoods("0000a59438","130","35","40","wood","normal");
goods[34] =new setGoods("0000a59445","140","35","40","wood","normal");
goods[35] =new setGoods("0000a59452","150","35","40","wood","normal");
goods[36] =new setGoods("0000a59459","160","35","40","wood","normal");
goods[37] =new setGoods("0000a59466","170","35","40","wood","normal");
goods[38] =new setGoods("0000a59473","180","35","40","wood","normal");
goods[39] =new setGoods("0000a59480","60","40","40","wood","normal");
goods[40] =new setGoods("0000a59487","70","40","40","wood","normal");
goods[41] =new setGoods("0000a59494","80","40","40","wood","normal");
goods[42] =new setGoods("0000a59501","90","40","40","wood","normal");
goods[43] =new setGoods("0000a59508","100","40","40","wood","normal");
goods[44] =new setGoods("0000a59515","110","40","40","wood","normal");
goods[45] =new setGoods("0000a59522","120","40","40","wood","normal");
goods[46] =new setGoods("0000a59529","130","40","40","wood","normal");
goods[47] =new setGoods("0000a59536","140","40","40","wood","normal");
goods[48] =new setGoods("0000a59543","150","40","40","wood","normal");
goods[49] =new setGoods("0000a59550","160","40","40","wood","normal");
goods[50] =new setGoods("0000a59557","170","40","40","wood","normal");
goods[51] =new setGoods("0000a59564","180","40","40","wood","normal");
goods[52] =new setGoods("0000a59571","60","45","40","wood","normal");
goods[53] =new setGoods("0000a59578","70","45","40","wood","normal");
goods[54] =new setGoods("0000a59585","80","45","40","wood","normal");
goods[55] =new setGoods("0000a59592","90","45","40","wood","normal");
goods[56] =new setGoods("0000a59599","100","45","40","wood","normal");
goods[57] =new setGoods("0000a59606","110","45","40","wood","normal");
goods[58] =new setGoods("0000a59613","120","45","40","wood","normal");
goods[59] =new setGoods("0000a59620","130","45","40","wood","normal");
goods[60] =new setGoods("0000a59627","140","45","40","wood","normal");
goods[61] =new setGoods("0000a59634","150","45","40","wood","normal");
goods[62] =new setGoods("0000a59641","160","45","40","wood","normal");
goods[63] =new setGoods("0000a59648","170","45","40","wood","normal");
goods[64] =new setGoods("0000a59655","180","45","40","wood","normal");
goods[65] =new setGoods("0000a59662","60","50","40","wood","normal");
goods[66] =new setGoods("0000a59669","70","50","40","wood","normal");
goods[67] =new setGoods("0000a59676","80","50","40","wood","normal");
goods[68] =new setGoods("0000a59683","90","50","40","wood","normal");
goods[69] =new setGoods("0000a59690","100","50","40","wood","normal");
goods[70] =new setGoods("0000a59697","110","50","40","wood","normal");
goods[71] =new setGoods("0000a59704","120","50","40","wood","normal");
goods[72] =new setGoods("0000a59711","130","50","40","wood","normal");
goods[73] =new setGoods("0000a59718","140","50","40","wood","normal");
goods[74] =new setGoods("0000a59725","150","50","40","wood","normal");
goods[75] =new setGoods("0000a59732","160","50","40","wood","normal");
goods[76] =new setGoods("0000a59739","170","50","40","wood","normal");
goods[77] =new setGoods("0000a59746","180","50","40","wood","normal");
goods[78] =new setGoods("0000a59753","60","55","40","wood","normal");
goods[79] =new setGoods("0000a59760","70","55","40","wood","normal");
goods[80] =new setGoods("0000a59767","80","55","40","wood","normal");
goods[81] =new setGoods("0000a59774","90","55","40","wood","normal");
goods[82] =new setGoods("0000a59781","100","55","40","wood","normal");
goods[83] =new setGoods("0000a59788","110","55","40","wood","normal");
goods[84] =new setGoods("0000a59795","120","55","40","wood","normal");
goods[85] =new setGoods("0000a59802","130","55","40","wood","normal");
goods[86] =new setGoods("0000a59809","140","55","40","wood","normal");
goods[87] =new setGoods("0000a59816","150","55","40","wood","normal");
goods[88] =new setGoods("0000a59823","160","55","40","wood","normal");
goods[89] =new setGoods("0000a59830","170","55","40","wood","normal");
goods[90] =new setGoods("0000a59837","180","55","40","wood","normal");
goods[91] =new setGoods("0000a59844","60","60","40","wood","normal");
goods[92] =new setGoods("0000a59851","70","60","40","wood","normal");
goods[93] =new setGoods("0000a59858","80","60","40","wood","normal");
goods[94] =new setGoods("0000a59865","90","60","40","wood","normal");
goods[95] =new setGoods("0000a59872","100","60","40","wood","normal");
goods[96] =new setGoods("0000a59879","110","60","40","wood","normal");
goods[97] =new setGoods("0000a59886","120","60","40","wood","normal");
goods[98] =new setGoods("0000a59893","130","60","40","wood","normal");
goods[99] =new setGoods("0000a59900","140","60","40","wood","normal");
goods[100] =new setGoods("0000a59907","150","60","40","wood","normal");
goods[101] =new setGoods("0000a59914","160","60","40","wood","normal");
goods[102] =new setGoods("0000a59921","170","60","40","wood","normal");
goods[103] =new setGoods("0000a59928","180","60","40","wood","normal");
goods[104] =new setGoods("0000a59935","60","25","50","wood","normal");
goods[105] =new setGoods("0000a59942","70","25","50","wood","normal");
goods[106] =new setGoods("0000a59949","80","25","50","wood","normal");
goods[107] =new setGoods("0000a59956","90","25","50","wood","normal");
goods[108] =new setGoods("0000a59963","100","25","50","wood","normal");
goods[109] =new setGoods("0000a59970","110","25","50","wood","normal");
goods[110] =new setGoods("0000a59977","120","25","50","wood","normal");
goods[111] =new setGoods("0000a59984","130","25","50","wood","normal");
goods[112] =new setGoods("0000a59991","140","25","50","wood","normal");
goods[113] =new setGoods("0000a59998","150","25","50","wood","normal");
goods[114] =new setGoods("0000a60005","160","25","50","wood","normal");
goods[115] =new setGoods("0000a60012","170","25","50","wood","normal");
goods[116] =new setGoods("0000a60019","180","25","50","wood","normal");
goods[117] =new setGoods("0000a60026","60","30","50","wood","normal");
goods[118] =new setGoods("0000a60033","70","30","50","wood","normal");
goods[119] =new setGoods("0000a60040","80","30","50","wood","normal");
goods[120] =new setGoods("0000a60047","90","30","50","wood","normal");
goods[121] =new setGoods("0000a60054","100","30","50","wood","normal");
goods[122] =new setGoods("0000a60061","110","30","50","wood","normal");
goods[123] =new setGoods("0000a60068","120","30","50","wood","normal");
goods[124] =new setGoods("0000a60075","130","30","50","wood","normal");
goods[125] =new setGoods("0000a60082","140","30","50","wood","normal");
goods[126] =new setGoods("0000a60089","150","30","50","wood","normal");
goods[127] =new setGoods("0000a60096","160","30","50","wood","normal");
goods[128] =new setGoods("0000a60103","170","30","50","wood","normal");
goods[129] =new setGoods("0000a60110","180","30","50","wood","normal");
goods[130] =new setGoods("0000a60117","60","35","50","wood","normal");
goods[131] =new setGoods("0000a60124","70","35","50","wood","normal");
goods[132] =new setGoods("0000a60131","80","35","50","wood","normal");
goods[133] =new setGoods("0000a60138","90","35","50","wood","normal");
goods[134] =new setGoods("0000a60145","100","35","50","wood","normal");
goods[135] =new setGoods("0000a60152","110","35","50","wood","normal");
goods[136] =new setGoods("0000a60159","120","35","50","wood","normal");
goods[137] =new setGoods("0000a60166","130","35","50","wood","normal");
goods[138] =new setGoods("0000a60173","140","35","50","wood","normal");
goods[139] =new setGoods("0000a60180","150","35","50","wood","normal");
goods[140] =new setGoods("0000a60187","160","35","50","wood","normal");
goods[141] =new setGoods("0000a60194","170","35","50","wood","normal");
goods[142] =new setGoods("0000a60201","180","35","50","wood","normal");
goods[143] =new setGoods("0000a60208","60","40","50","wood","normal");
goods[144] =new setGoods("0000a60215","70","40","50","wood","normal");
goods[145] =new setGoods("0000a60222","80","40","50","wood","normal");
goods[146] =new setGoods("0000a60229","90","40","50","wood","normal");
goods[147] =new setGoods("0000a60236","100","40","50","wood","normal");
goods[148] =new setGoods("0000a60243","110","40","50","wood","normal");
goods[149] =new setGoods("0000a60250","120","40","50","wood","normal");
goods[150] =new setGoods("0000a60257","130","40","50","wood","normal");
goods[151] =new setGoods("0000a60264","140","40","50","wood","normal");
goods[152] =new setGoods("0000a60271","150","40","50","wood","normal");
goods[153] =new setGoods("0000a60278","160","40","50","wood","normal");
goods[154] =new setGoods("0000a60285","170","40","50","wood","normal");
goods[155] =new setGoods("0000a60292","180","40","50","wood","normal");
goods[156] =new setGoods("0000a60299","60","45","50","wood","normal");
goods[157] =new setGoods("0000a60306","70","45","50","wood","normal");
goods[158] =new setGoods("0000a60313","80","45","50","wood","normal");
goods[159] =new setGoods("0000a60320","90","45","50","wood","normal");
goods[160] =new setGoods("0000a60327","100","45","50","wood","normal");
goods[161] =new setGoods("0000a60334","110","45","50","wood","normal");
goods[162] =new setGoods("0000a60341","120","45","50","wood","normal");
goods[163] =new setGoods("0000a60348","130","45","50","wood","normal");
goods[164] =new setGoods("0000a60355","140","45","50","wood","normal");
goods[165] =new setGoods("0000a60362","150","45","50","wood","normal");
goods[166] =new setGoods("0000a60369","160","45","50","wood","normal");
goods[167] =new setGoods("0000a60376","170","45","50","wood","normal");
goods[168] =new setGoods("0000a60383","180","45","50","wood","normal");
goods[169] =new setGoods("0000a60390","60","50","50","wood","normal");
goods[170] =new setGoods("0000a60397","70","50","50","wood","normal");
goods[171] =new setGoods("0000a60404","80","50","50","wood","normal");
goods[172] =new setGoods("0000a60411","90","50","50","wood","normal");
goods[173] =new setGoods("0000a60418","100","50","50","wood","normal");
goods[174] =new setGoods("0000a60425","110","50","50","wood","normal");
goods[175] =new setGoods("0000a60432","120","50","50","wood","normal");
goods[176] =new setGoods("0000a60439","130","50","50","wood","normal");
goods[177] =new setGoods("0000a60446","140","50","50","wood","normal");
goods[178] =new setGoods("0000a60453","150","50","50","wood","normal");
goods[179] =new setGoods("0000a60460","160","50","50","wood","normal");
goods[180] =new setGoods("0000a60467","170","50","50","wood","normal");
goods[181] =new setGoods("0000a60474","180","50","50","wood","normal");
goods[182] =new setGoods("0000a60481","60","55","50","wood","normal");
goods[183] =new setGoods("0000a60488","70","55","50","wood","normal");
goods[184] =new setGoods("0000a60495","80","55","50","wood","normal");
goods[185] =new setGoods("0000a60502","90","55","50","wood","normal");
goods[186] =new setGoods("0000a60509","100","55","50","wood","normal");
goods[187] =new setGoods("0000a60516","110","55","50","wood","normal");
goods[188] =new setGoods("0000a60523","120","55","50","wood","normal");
goods[189] =new setGoods("0000a60530","130","55","50","wood","normal");
goods[190] =new setGoods("0000a60537","140","55","50","wood","normal");
goods[191] =new setGoods("0000a60544","150","55","50","wood","normal");
goods[192] =new setGoods("0000a60551","160","55","50","wood","normal");
goods[193] =new setGoods("0000a60558","170","55","50","wood","normal");
goods[194] =new setGoods("0000a60565","180","55","50","wood","normal");
goods[195] =new setGoods("0000a60572","60","60","50","wood","normal");
goods[196] =new setGoods("0000a60579","70","60","50","wood","normal");
goods[197] =new setGoods("0000a60586","80","60","50","wood","normal");
goods[198] =new setGoods("0000a60593","90","60","50","wood","normal");
goods[199] =new setGoods("0000a60600","100","60","50","wood","normal");
goods[200] =new setGoods("0000a60607","110","60","50","wood","normal");
goods[201] =new setGoods("0000a60614","120","60","50","wood","normal");
goods[202] =new setGoods("0000a60621","130","60","50","wood","normal");
goods[203] =new setGoods("0000a60628","140","60","50","wood","normal");
goods[204] =new setGoods("0000a60635","150","60","50","wood","normal");
goods[205] =new setGoods("0000a60642","160","60","50","wood","normal");
goods[206] =new setGoods("0000a60649","170","60","50","wood","normal");
goods[207] =new setGoods("0000a60656","180","60","50","wood","normal");

goods[208] =new setGoods("0000a60663","60","25","60","wood","normal");
goods[209] =new setGoods("0000a60670","70","25","60","wood","normal");
goods[210] =new setGoods("0000a60677","80","25","60","wood","normal");
goods[211] =new setGoods("0000a60684","90","25","60","wood","normal");
goods[212] =new setGoods("0000a60691","100","25","60","wood","normal");
goods[213] =new setGoods("0000a60698","110","25","60","wood","normal");
goods[214] =new setGoods("0000a60705","120","25","60","wood","normal");
goods[215] =new setGoods("0000a60712","130","25","60","wood","normal");
goods[216] =new setGoods("0000a60719","140","25","60","wood","normal");
goods[217] =new setGoods("0000a60726","150","25","60","wood","normal");
goods[218] =new setGoods("0000a60733","160","25","60","wood","normal");
goods[219] =new setGoods("0000a60740","170","25","60","wood","normal");
goods[220] =new setGoods("0000a60747","180","25","60","wood","normal");
goods[221] =new setGoods("0000a60754","60","30","60","wood","normal");
goods[222] =new setGoods("0000a60761","70","30","60","wood","normal");
goods[223] =new setGoods("0000a60768","80","30","60","wood","normal");
goods[224] =new setGoods("0000a60775","90","30","60","wood","normal");
goods[225] =new setGoods("0000a60782","100","30","60","wood","normal");
goods[226] =new setGoods("0000a60789","110","30","60","wood","normal");
goods[227] =new setGoods("0000a60796","120","30","60","wood","normal");
goods[228] =new setGoods("0000a60803","130","30","60","wood","normal");
goods[229] =new setGoods("0000a60810","140","30","60","wood","normal");
goods[230] =new setGoods("0000a60817","150","30","60","wood","normal");
goods[231] =new setGoods("0000a60824","160","30","60","wood","normal");
goods[232] =new setGoods("0000a60831","170","30","60","wood","normal");
goods[233] =new setGoods("0000a60838","180","30","60","wood","normal");
goods[234] =new setGoods("0000a60845","60","35","60","wood","normal");
goods[235] =new setGoods("0000a60852","70","35","60","wood","normal");
goods[236] =new setGoods("0000a60859","80","35","60","wood","normal");
goods[237] =new setGoods("0000a60866","90","35","60","wood","normal");
goods[238] =new setGoods("0000a60873","100","35","60","wood","normal");
goods[239] =new setGoods("0000a60880","110","35","60","wood","normal");
goods[240] =new setGoods("0000a60887","120","35","60","wood","normal");
goods[241] =new setGoods("0000a60894","130","35","60","wood","normal");
goods[242] =new setGoods("0000a60901","140","35","60","wood","normal");
goods[243] =new setGoods("0000a60908","150","35","60","wood","normal");
goods[244] =new setGoods("0000a60915","160","35","60","wood","normal");
goods[245] =new setGoods("0000a60922","170","35","60","wood","normal");
goods[246] =new setGoods("0000a60929","180","35","60","wood","normal");
goods[247] =new setGoods("0000a60936","60","40","60","wood","normal");
goods[248] =new setGoods("0000a60943","70","40","60","wood","normal");
goods[249] =new setGoods("0000a60950","80","40","60","wood","normal");
goods[250] =new setGoods("0000a60957","90","40","60","wood","normal");
goods[251] =new setGoods("0000a60964","100","40","60","wood","normal");
goods[252] =new setGoods("0000a60971","110","40","60","wood","normal");
goods[253] =new setGoods("0000a60978","120","40","60","wood","normal");
goods[254] =new setGoods("0000a60985","130","40","60","wood","normal");
goods[255] =new setGoods("0000a60992","140","40","60","wood","normal");
goods[256] =new setGoods("0000a60999","150","40","60","wood","normal");
goods[257] =new setGoods("0000a61006","160","40","60","wood","normal");
goods[258] =new setGoods("0000a61013","170","40","60","wood","normal");
goods[259] =new setGoods("0000a61020","180","40","60","wood","normal");
goods[260] =new setGoods("0000a61027","60","45","60","wood","normal");
goods[261] =new setGoods("0000a61034","70","45","60","wood","normal");
goods[262] =new setGoods("0000a61041","80","45","60","wood","normal");
goods[263] =new setGoods("0000a61048","90","45","60","wood","normal");
goods[264] =new setGoods("0000a61055","100","45","60","wood","normal");
goods[265] =new setGoods("0000a61062","110","45","60","wood","normal");
goods[266] =new setGoods("0000a61069","120","45","60","wood","normal");
goods[267] =new setGoods("0000a61076","130","45","60","wood","normal");
goods[268] =new setGoods("0000a61083","140","45","60","wood","normal");
goods[269] =new setGoods("0000a61090","150","45","60","wood","normal");
goods[270] =new setGoods("0000a61097","160","45","60","wood","normal");
goods[271] =new setGoods("0000a61104","170","45","60","wood","normal");
goods[272] =new setGoods("0000a61111","180","45","60","wood","normal");
goods[273] =new setGoods("0000a61118","60","50","60","wood","normal");
goods[274] =new setGoods("0000a61125","70","50","60","wood","normal");
goods[275] =new setGoods("0000a61132","80","50","60","wood","normal");
goods[276] =new setGoods("0000a61139","90","50","60","wood","normal");
goods[277] =new setGoods("0000a61146","100","50","60","wood","normal");
goods[278] =new setGoods("0000a61153","110","50","60","wood","normal");
goods[279] =new setGoods("0000a61160","120","50","60","wood","normal");
goods[280] =new setGoods("0000a61167","130","50","60","wood","normal");
goods[281] =new setGoods("0000a61174","140","50","60","wood","normal");
goods[282] =new setGoods("0000a61181","150","50","60","wood","normal");
goods[283] =new setGoods("0000a61188","160","50","60","wood","normal");
goods[284] =new setGoods("0000a61195","170","50","60","wood","normal");
goods[285] =new setGoods("0000a61202","180","50","60","wood","normal");
goods[286] =new setGoods("0000a61209","60","55","60","wood","normal");
goods[287] =new setGoods("0000a61216","70","55","60","wood","normal");
goods[288] =new setGoods("0000a61223","80","55","60","wood","normal");
goods[289] =new setGoods("0000a61230","90","55","60","wood","normal");
goods[290] =new setGoods("0000a61237","100","55","60","wood","normal");
goods[291] =new setGoods("0000a61244","110","55","60","wood","normal");
goods[292] =new setGoods("0000a61251","120","55","60","wood","normal");
goods[293] =new setGoods("0000a61258","130","55","60","wood","normal");
goods[294] =new setGoods("0000a61265","140","55","60","wood","normal");
goods[295] =new setGoods("0000a61272","150","55","60","wood","normal");
goods[296] =new setGoods("0000a61279","160","55","60","wood","normal");
goods[297] =new setGoods("0000a61286","170","55","60","wood","normal");
goods[298] =new setGoods("0000a61293","180","55","60","wood","normal");
goods[299] =new setGoods("0000a61300","60","60","60","wood","normal");
goods[300] =new setGoods("0000a61307","70","60","60","wood","normal");
goods[301] =new setGoods("0000a61314","80","60","60","wood","normal");
goods[302] =new setGoods("0000a61321","90","60","60","wood","normal");
goods[303] =new setGoods("0000a61328","100","60","60","wood","normal");
goods[304] =new setGoods("0000a61335","110","60","60","wood","normal");
goods[305] =new setGoods("0000a61342","120","60","60","wood","normal");
goods[306] =new setGoods("0000a61349","130","60","60","wood","normal");
goods[307] =new setGoods("0000a61356","140","60","60","wood","normal");
goods[308] =new setGoods("0000a61363","150","60","60","wood","normal");
goods[309] =new setGoods("0000a61370","160","60","60","wood","normal");
goods[310] =new setGoods("0000a61377","170","60","60","wood","normal");
goods[311] =new setGoods("0000a61384","180","60","60","wood","normal");

goods[312] =new setGoods("0000a61391","60","25","70","wood","normal");
goods[313] =new setGoods("0000a61398","70","25","70","wood","normal");
goods[314] =new setGoods("0000a61405","80","25","70","wood","normal");
goods[315] =new setGoods("0000a61412","90","25","70","wood","normal");
goods[316] =new setGoods("0000a61419","100","25","70","wood","normal");
goods[317] =new setGoods("0000a61426","110","25","70","wood","normal");
goods[318] =new setGoods("0000a61433","120","25","70","wood","normal");
goods[319] =new setGoods("0000a61440","130","25","70","wood","normal");
goods[320] =new setGoods("0000a61447","140","25","70","wood","normal");
goods[321] =new setGoods("0000a61454","150","25","70","wood","normal");
goods[322] =new setGoods("0000a61461","160","25","70","wood","normal");
goods[323] =new setGoods("0000a61468","170","25","70","wood","normal");
goods[324] =new setGoods("0000a61475","180","25","70","wood","normal");
goods[325] =new setGoods("0000a61482","60","30","70","wood","normal");
goods[326] =new setGoods("0000a61489","70","30","70","wood","normal");
goods[327] =new setGoods("0000a61496","80","30","70","wood","normal");
goods[328] =new setGoods("0000a61503","90","30","70","wood","normal");
goods[329] =new setGoods("0000a61510","100","30","70","wood","normal");
goods[330] =new setGoods("0000a61517","110","30","70","wood","normal");
goods[331] =new setGoods("0000a61524","120","30","70","wood","normal");
goods[332] =new setGoods("0000a61531","130","30","70","wood","normal");
goods[333] =new setGoods("0000a61538","140","30","70","wood","normal");
goods[334] =new setGoods("0000a61545","150","30","70","wood","normal");
goods[335] =new setGoods("0000a61552","160","30","70","wood","normal");
goods[336] =new setGoods("0000a61559","170","30","70","wood","normal");
goods[337] =new setGoods("0000a61566","180","30","70","wood","normal");
goods[338] =new setGoods("0000a61573","60","35","70","wood","normal");
goods[339] =new setGoods("0000a61580","70","35","70","wood","normal");
goods[340] =new setGoods("0000a61587","80","35","70","wood","normal");
goods[341] =new setGoods("0000a61594","90","35","70","wood","normal");
goods[342] =new setGoods("0000a61601","100","35","70","wood","normal");
goods[343] =new setGoods("0000a61608","110","35","70","wood","normal");
goods[344] =new setGoods("0000a61615","120","35","70","wood","normal");
goods[345] =new setGoods("0000a61622","130","35","70","wood","normal");
goods[346] =new setGoods("0000a61629","140","35","70","wood","normal");
goods[347] =new setGoods("0000a61636","150","35","70","wood","normal");
goods[348] =new setGoods("0000a61643","160","35","70","wood","normal");
goods[349] =new setGoods("0000a61650","170","35","70","wood","normal");
goods[350] =new setGoods("0000a61657","180","35","70","wood","normal");
goods[351] =new setGoods("0000a61664","60","40","70","wood","normal");
goods[352] =new setGoods("0000a61671","70","40","70","wood","normal");
goods[353] =new setGoods("0000a61678","80","40","70","wood","normal");
goods[354] =new setGoods("0000a61685","90","40","70","wood","normal");
goods[355] =new setGoods("0000a61692","100","40","70","wood","normal");
goods[356] =new setGoods("0000a61699","110","40","70","wood","normal");
goods[357] =new setGoods("0000a61706","120","40","70","wood","normal");
goods[358] =new setGoods("0000a61713","130","40","70","wood","normal");
goods[359] =new setGoods("0000a61720","140","40","70","wood","normal");
goods[360] =new setGoods("0000a61727","150","40","70","wood","normal");
goods[361] =new setGoods("0000a61734","160","40","70","wood","normal");
goods[362] =new setGoods("0000a61741","170","40","70","wood","normal");
goods[363] =new setGoods("0000a61748","180","40","70","wood","normal");
goods[364] =new setGoods("0000a61755","60","45","70","wood","normal");
goods[365] =new setGoods("0000a61762","70","45","70","wood","normal");
goods[366] =new setGoods("0000a61769","80","45","70","wood","normal");
goods[367] =new setGoods("0000a61776","90","45","70","wood","normal");
goods[368] =new setGoods("0000a61783","100","45","70","wood","normal");
goods[369] =new setGoods("0000a61790","110","45","70","wood","normal");
goods[370] =new setGoods("0000a61797","120","45","70","wood","normal");
goods[371] =new setGoods("0000a61804","130","45","70","wood","normal");
goods[372] =new setGoods("0000a61811","140","45","70","wood","normal");
goods[373] =new setGoods("0000a61818","150","45","70","wood","normal");
goods[374] =new setGoods("0000a61825","160","45","70","wood","normal");
goods[375] =new setGoods("0000a61832","170","45","70","wood","normal");
goods[376] =new setGoods("0000a61839","180","45","70","wood","normal");
goods[377] =new setGoods("0000a61846","60","50","70","wood","normal");
goods[378] =new setGoods("0000a61853","70","50","70","wood","normal");
goods[379] =new setGoods("0000a61860","80","50","70","wood","normal");
goods[380] =new setGoods("0000a61867","90","50","70","wood","normal");
goods[381] =new setGoods("0000a61874","100","50","70","wood","normal");
goods[382] =new setGoods("0000a61881","110","50","70","wood","normal");
goods[383] =new setGoods("0000a61888","120","50","70","wood","normal");
goods[384] =new setGoods("0000a61895","130","50","70","wood","normal");
goods[385] =new setGoods("0000a61902","140","50","70","wood","normal");
goods[386] =new setGoods("0000a61909","150","50","70","wood","normal");
goods[387] =new setGoods("0000a61916","160","50","70","wood","normal");
goods[388] =new setGoods("0000a61923","170","50","70","wood","normal");
goods[389] =new setGoods("0000a61930","180","50","70","wood","normal");
goods[390] =new setGoods("0000a61937","60","55","70","wood","normal");
goods[391] =new setGoods("0000a61944","70","55","70","wood","normal");
goods[392] =new setGoods("0000a61951","80","55","70","wood","normal");
goods[393] =new setGoods("0000a61958","90","55","70","wood","normal");
goods[394] =new setGoods("0000a61965","100","55","70","wood","normal");
goods[395] =new setGoods("0000a61972","110","55","70","wood","normal");
goods[396] =new setGoods("0000a61979","120","55","70","wood","normal");
goods[397] =new setGoods("0000a61986","130","55","70","wood","normal");
goods[398] =new setGoods("0000a61993","140","55","70","wood","normal");
goods[399] =new setGoods("0000a62000","150","55","70","wood","normal");
goods[400] =new setGoods("0000a62007","160","55","70","wood","normal");
goods[401] =new setGoods("0000a62014","170","55","70","wood","normal");
goods[402] =new setGoods("0000a62021","180","55","70","wood","normal");
goods[403] =new setGoods("0000a62028","60","60","70","wood","normal");
goods[404] =new setGoods("0000a62035","70","60","70","wood","normal");
goods[405] =new setGoods("0000a62042","80","60","70","wood","normal");
goods[406] =new setGoods("0000a62049","90","60","70","wood","normal");
goods[407] =new setGoods("0000a62056","100","60","70","wood","normal");
goods[408] =new setGoods("0000a62063","110","60","70","wood","normal");
goods[409] =new setGoods("0000a62070","120","60","70","wood","normal");
goods[410] =new setGoods("0000a62077","130","60","70","wood","normal");
goods[411] =new setGoods("0000a62084","140","60","70","wood","normal");
goods[412] =new setGoods("0000a62091","150","60","70","wood","normal");
goods[413] =new setGoods("0000a62098","160","60","70","wood","normal");
goods[414] =new setGoods("0000a62105","170","60","70","wood","normal");
goods[415] =new setGoods("0000a62112","180","60","70","wood","normal");

goods[416] =new setGoods("0000a62119","60","25","80","wood","normal");
goods[417] =new setGoods("0000a62126","70","25","80","wood","normal");
goods[418] =new setGoods("0000a62133","80","25","80","wood","normal");
goods[419] =new setGoods("0000a62140","90","25","80","wood","normal");
goods[420] =new setGoods("0000a62147","100","25","80","wood","normal");
goods[421] =new setGoods("0000a62154","110","25","80","wood","normal");
goods[422] =new setGoods("0000a62161","120","25","80","wood","normal");
goods[423] =new setGoods("0000a62168","130","25","80","wood","normal");
goods[424] =new setGoods("0000a62175","140","25","80","wood","normal");
goods[425] =new setGoods("0000a62182","150","25","80","wood","normal");
goods[426] =new setGoods("0000a62189","160","25","80","wood","normal");
goods[427] =new setGoods("0000a62196","170","25","80","wood","normal");
goods[428] =new setGoods("0000a62203","180","25","80","wood","normal");
goods[429] =new setGoods("0000a62210","60","30","80","wood","normal");
goods[430] =new setGoods("0000a62217","70","30","80","wood","normal");
goods[431] =new setGoods("0000a62224","80","30","80","wood","normal");
goods[432] =new setGoods("0000a62231","90","30","80","wood","normal");
goods[433] =new setGoods("0000a62238","100","30","80","wood","normal");
goods[434] =new setGoods("0000a62245","110","30","80","wood","normal");
goods[435] =new setGoods("0000a62252","120","30","80","wood","normal");
goods[436] =new setGoods("0000a62259","130","30","80","wood","normal");
goods[437] =new setGoods("0000a62266","140","30","80","wood","normal");
goods[438] =new setGoods("0000a62273","150","30","80","wood","normal");
goods[439] =new setGoods("0000a62280","160","30","80","wood","normal");
goods[440] =new setGoods("0000a62287","170","30","80","wood","normal");
goods[441] =new setGoods("0000a62294","180","30","80","wood","normal");
goods[442] =new setGoods("0000a62301","60","35","80","wood","normal");
goods[443] =new setGoods("0000a62308","70","35","80","wood","normal");
goods[444] =new setGoods("0000a62315","80","35","80","wood","normal");
goods[445] =new setGoods("0000a62322","90","35","80","wood","normal");
goods[446] =new setGoods("0000a62329","100","35","80","wood","normal");
goods[447] =new setGoods("0000a62336","110","35","80","wood","normal");
goods[448] =new setGoods("0000a62343","120","35","80","wood","normal");
goods[449] =new setGoods("0000a62350","130","35","80","wood","normal");
goods[450] =new setGoods("0000a62357","140","35","80","wood","normal");
goods[451] =new setGoods("0000a62364","150","35","80","wood","normal");
goods[452] =new setGoods("0000a62371","160","35","80","wood","normal");
goods[453] =new setGoods("0000a62378","170","35","80","wood","normal");
goods[454] =new setGoods("0000a62385","180","35","80","wood","normal");
goods[455] =new setGoods("0000a62392","60","40","80","wood","normal");
goods[456] =new setGoods("0000a62399","70","40","80","wood","normal");
goods[457] =new setGoods("0000a62406","80","40","80","wood","normal");
goods[458] =new setGoods("0000a62413","90","40","80","wood","normal");
goods[459] =new setGoods("0000a62420","100","40","80","wood","normal");
goods[460] =new setGoods("0000a62427","110","40","80","wood","normal");
goods[461] =new setGoods("0000a62434","120","40","80","wood","normal");
goods[462] =new setGoods("0000a62441","130","40","80","wood","normal");
goods[463] =new setGoods("0000a62448","140","40","80","wood","normal");
goods[464] =new setGoods("0000a62455","150","40","80","wood","normal");
goods[465] =new setGoods("0000a62462","160","40","80","wood","normal");
goods[466] =new setGoods("0000a62469","170","40","80","wood","normal");
goods[467] =new setGoods("0000a62476","180","40","80","wood","normal");
goods[468] =new setGoods("0000a62483","60","45","80","wood","normal");
goods[469] =new setGoods("0000a62490","70","45","80","wood","normal");
goods[470] =new setGoods("0000a62497","80","45","80","wood","normal");
goods[471] =new setGoods("0000a62504","90","45","80","wood","normal");
goods[472] =new setGoods("0000a62511","100","45","80","wood","normal");
goods[473] =new setGoods("0000a62518","110","45","80","wood","normal");
goods[474] =new setGoods("0000a62525","120","45","80","wood","normal");
goods[475] =new setGoods("0000a62532","130","45","80","wood","normal");
goods[476] =new setGoods("0000a62539","140","45","80","wood","normal");
goods[477] =new setGoods("0000a62546","150","45","80","wood","normal");
goods[478] =new setGoods("0000a62553","160","45","80","wood","normal");
goods[479] =new setGoods("0000a62560","170","45","80","wood","normal");
goods[480] =new setGoods("0000a62567","180","45","80","wood","normal");
goods[481] =new setGoods("0000a62574","60","50","80","wood","normal");
goods[482] =new setGoods("0000a62581","70","50","80","wood","normal");
goods[483] =new setGoods("0000a62588","80","50","80","wood","normal");
goods[484] =new setGoods("0000a62595","90","50","80","wood","normal");
goods[485] =new setGoods("0000a62602","100","50","80","wood","normal");
goods[486] =new setGoods("0000a62609","110","50","80","wood","normal");
goods[487] =new setGoods("0000a62616","120","50","80","wood","normal");
goods[488] =new setGoods("0000a62623","130","50","80","wood","normal");
goods[489] =new setGoods("0000a62630","140","50","80","wood","normal");
goods[490] =new setGoods("0000a62637","150","50","80","wood","normal");
goods[491] =new setGoods("0000a62644","160","50","80","wood","normal");
goods[492] =new setGoods("0000a62651","170","50","80","wood","normal");
goods[493] =new setGoods("0000a62658","180","50","80","wood","normal");
goods[494] =new setGoods("0000a62665","60","55","80","wood","normal");
goods[495] =new setGoods("0000a62672","70","55","80","wood","normal");
goods[496] =new setGoods("0000a62679","80","55","80","wood","normal");
goods[497] =new setGoods("0000a62686","90","55","80","wood","normal");
goods[498] =new setGoods("0000a62693","100","55","80","wood","normal");
goods[499] =new setGoods("0000a62700","110","55","80","wood","normal");
goods[500] =new setGoods("0000a62707","120","55","80","wood","normal");
goods[501] =new setGoods("0000a62714","130","55","80","wood","normal");
goods[502] =new setGoods("0000a62721","140","55","80","wood","normal");
goods[503] =new setGoods("0000a62728","150","55","80","wood","normal");
goods[504] =new setGoods("0000a62735","160","55","80","wood","normal");
goods[505] =new setGoods("0000a62742","170","55","80","wood","normal");
goods[506] =new setGoods("0000a62749","180","55","80","wood","normal");
goods[507] =new setGoods("0000a62756","60","60","80","wood","normal");
goods[508] =new setGoods("0000a62763","70","60","80","wood","normal");
goods[509] =new setGoods("0000a62770","80","60","80","wood","normal");
goods[510] =new setGoods("0000a62777","90","60","80","wood","normal");
goods[511] =new setGoods("0000a62784","100","60","80","wood","normal");
goods[512] =new setGoods("0000a62791","110","60","80","wood","normal");
goods[513] =new setGoods("0000a62798","120","60","80","wood","normal");
goods[514] =new setGoods("0000a62805","130","60","80","wood","normal");
goods[515] =new setGoods("0000a62812","140","60","80","wood","normal");
goods[516] =new setGoods("0000a62819","150","60","80","wood","normal");
goods[517] =new setGoods("0000a62826","160","60","80","wood","normal");
goods[518] =new setGoods("0000a62833","170","60","80","wood","normal");
goods[519] =new setGoods("0000a62840","180","60","80","wood","normal");

goods[520] =new setGoods("0000a62847","60","25","90","wood","normal");
goods[521] =new setGoods("0000a62854","70","25","90","wood","normal");
goods[522] =new setGoods("0000a62861","80","25","90","wood","normal");
goods[523] =new setGoods("0000a62868","90","25","90","wood","normal");
goods[524] =new setGoods("0000a62875","100","25","90","wood","normal");
goods[525] =new setGoods("0000a62882","110","25","90","wood","normal");
goods[526] =new setGoods("0000a62889","120","25","90","wood","normal");
goods[527] =new setGoods("0000a62896","130","25","90","wood","normal");
goods[528] =new setGoods("0000a62903","140","25","90","wood","normal");
goods[529] =new setGoods("0000a62910","150","25","90","wood","normal");
goods[530] =new setGoods("0000a62917","160","25","90","wood","normal");
goods[531] =new setGoods("0000a62924","170","25","90","wood","normal");
goods[532] =new setGoods("0000a62931","180","25","90","wood","normal");
goods[533] =new setGoods("0000a62938","60","30","90","wood","normal");
goods[534] =new setGoods("0000a62945","70","30","90","wood","normal");
goods[535] =new setGoods("0000a62952","80","30","90","wood","normal");
goods[536] =new setGoods("0000a62959","90","30","90","wood","normal");
goods[537] =new setGoods("0000a62966","100","30","90","wood","normal");
goods[538] =new setGoods("0000a62973","110","30","90","wood","normal");
goods[539] =new setGoods("0000a62980","120","30","90","wood","normal");
goods[540] =new setGoods("0000a62987","130","30","90","wood","normal");
goods[541] =new setGoods("0000a62994","140","30","90","wood","normal");
goods[542] =new setGoods("0000a63001","150","30","90","wood","normal");
goods[543] =new setGoods("0000a63008","160","30","90","wood","normal");
goods[544] =new setGoods("0000a63015","170","30","90","wood","normal");
goods[545] =new setGoods("0000a63022","180","30","90","wood","normal");
goods[546] =new setGoods("0000a63029","60","35","90","wood","normal");
goods[547] =new setGoods("0000a63036","70","35","90","wood","normal");
goods[548] =new setGoods("0000a63043","80","35","90","wood","normal");
goods[549] =new setGoods("0000a63050","90","35","90","wood","normal");
goods[550] =new setGoods("0000a63057","100","35","90","wood","normal");
goods[551] =new setGoods("0000a63064","110","35","90","wood","normal");
goods[552] =new setGoods("0000a63071","120","35","90","wood","normal");
goods[553] =new setGoods("0000a63078","130","35","90","wood","normal");
goods[554] =new setGoods("0000a63085","140","35","90","wood","normal");
goods[555] =new setGoods("0000a63092","150","35","90","wood","normal");
goods[556] =new setGoods("0000a63099","160","35","90","wood","normal");
goods[557] =new setGoods("0000a63106","170","35","90","wood","normal");
goods[558] =new setGoods("0000a63113","180","35","90","wood","normal");
goods[559] =new setGoods("0000a63120","60","40","90","wood","normal");
goods[560] =new setGoods("0000a63127","70","40","90","wood","normal");
goods[561] =new setGoods("0000a63134","80","40","90","wood","normal");
goods[562] =new setGoods("0000a63141","90","40","90","wood","normal");
goods[563] =new setGoods("0000a63148","100","40","90","wood","normal");
goods[564] =new setGoods("0000a63155","110","40","90","wood","normal");
goods[565] =new setGoods("0000a63162","120","40","90","wood","normal");
goods[566] =new setGoods("0000a63169","130","40","90","wood","normal");
goods[567] =new setGoods("0000a63176","140","40","90","wood","normal");
goods[568] =new setGoods("0000a63183","150","40","90","wood","normal");
goods[569] =new setGoods("0000a63190","160","40","90","wood","normal");
goods[570] =new setGoods("0000a63197","170","40","90","wood","normal");
goods[571] =new setGoods("0000a63204","180","40","90","wood","normal");
goods[572] =new setGoods("0000a63211","60","45","90","wood","normal");
goods[573] =new setGoods("0000a63218","70","45","90","wood","normal");
goods[574] =new setGoods("0000a63225","80","45","90","wood","normal");
goods[575] =new setGoods("0000a63232","90","45","90","wood","normal");
goods[576] =new setGoods("0000a63239","100","45","90","wood","normal");
goods[577] =new setGoods("0000a63246","110","45","90","wood","normal");
goods[578] =new setGoods("0000a63253","120","45","90","wood","normal");
goods[579] =new setGoods("0000a63260","130","45","90","wood","normal");
goods[580] =new setGoods("0000a63267","140","45","90","wood","normal");
goods[581] =new setGoods("0000a63274","150","45","90","wood","normal");
goods[582] =new setGoods("0000a63281","160","45","90","wood","normal");
goods[583] =new setGoods("0000a63288","170","45","90","wood","normal");
goods[584] =new setGoods("0000a63295","180","45","90","wood","normal");
goods[585] =new setGoods("0000a63302","60","50","90","wood","normal");
goods[586] =new setGoods("0000a63309","70","50","90","wood","normal");
goods[587] =new setGoods("0000a63316","80","50","90","wood","normal");
goods[588] =new setGoods("0000a63323","90","50","90","wood","normal");
goods[589] =new setGoods("0000a63330","100","50","90","wood","normal");
goods[590] =new setGoods("0000a63337","110","50","90","wood","normal");
goods[591] =new setGoods("0000a63344","120","50","90","wood","normal");
goods[592] =new setGoods("0000a63351","130","50","90","wood","normal");
goods[593] =new setGoods("0000a63358","140","50","90","wood","normal");
goods[594] =new setGoods("0000a63365","150","50","90","wood","normal");
goods[595] =new setGoods("0000a63372","160","50","90","wood","normal");
goods[596] =new setGoods("0000a63379","170","50","90","wood","normal");
goods[597] =new setGoods("0000a63386","180","50","90","wood","normal");
goods[598] =new setGoods("0000a63393","60","55","90","wood","normal");
goods[599] =new setGoods("0000a63400","70","55","90","wood","normal");
goods[600] =new setGoods("0000a63407","80","55","90","wood","normal");
goods[601] =new setGoods("0000a63414","90","55","90","wood","normal");
goods[602] =new setGoods("0000a63421","100","55","90","wood","normal");
goods[603] =new setGoods("0000a63428","110","55","90","wood","normal");
goods[604] =new setGoods("0000a63435","120","55","90","wood","normal");
goods[605] =new setGoods("0000a63442","130","55","90","wood","normal");
goods[606] =new setGoods("0000a63449","140","55","90","wood","normal");
goods[607] =new setGoods("0000a63456","150","55","90","wood","normal");
goods[608] =new setGoods("0000a63463","160","55","90","wood","normal");
goods[609] =new setGoods("0000a63470","170","55","90","wood","normal");
goods[610] =new setGoods("0000a63477","180","55","90","wood","normal");
goods[611] =new setGoods("0000a63484","60","60","90","wood","normal");
goods[612] =new setGoods("0000a63491","70","60","90","wood","normal");
goods[613] =new setGoods("0000a63498","80","60","90","wood","normal");
goods[614] =new setGoods("0000a63505","90","60","90","wood","normal");
goods[615] =new setGoods("0000a63512","100","60","90","wood","normal");
goods[616] =new setGoods("0000a63519","110","60","90","wood","normal");
goods[617] =new setGoods("0000a63526","120","60","90","wood","normal");
goods[618] =new setGoods("0000a63533","130","60","90","wood","normal");
goods[619] =new setGoods("0000a63540","140","60","90","wood","normal");
goods[620] =new setGoods("0000a63547","150","60","90","wood","normal");
goods[621] =new setGoods("0000a63554","160","60","90","wood","normal");
goods[622] =new setGoods("0000a63561","170","60","90","wood","normal");
goods[623] =new setGoods("0000a63568","180","60","90","wood","normal");

goods[624] =new setGoods("0000a63575","60","25","100","wood","normal");
goods[625] =new setGoods("0000a63582","70","25","100","wood","normal");
goods[626] =new setGoods("0000a63589","80","25","100","wood","normal");
goods[627] =new setGoods("0000a63596","90","25","100","wood","normal");
goods[628] =new setGoods("0000a63603","100","25","100","wood","normal");
goods[629] =new setGoods("0000a63610","110","25","100","wood","normal");
goods[630] =new setGoods("0000a63617","120","25","100","wood","normal");
goods[631] =new setGoods("0000a63624","130","25","100","wood","normal");
goods[632] =new setGoods("0000a63631","140","25","100","wood","normal");
goods[633] =new setGoods("0000a63638","150","25","100","wood","normal");
goods[634] =new setGoods("0000a63645","160","25","100","wood","normal");
goods[635] =new setGoods("0000a63652","170","25","100","wood","normal");
goods[636] =new setGoods("0000a63659","180","25","100","wood","normal");
goods[637] =new setGoods("0000a63666","60","30","100","wood","normal");
goods[638] =new setGoods("0000a63673","70","30","100","wood","normal");
goods[639] =new setGoods("0000a63680","80","30","100","wood","normal");
goods[640] =new setGoods("0000a63687","90","30","100","wood","normal");
goods[641] =new setGoods("0000a63694","100","30","100","wood","normal");
goods[642] =new setGoods("0000a63701","110","30","100","wood","normal");
goods[643] =new setGoods("0000a63708","120","30","100","wood","normal");
goods[644] =new setGoods("0000a63715","130","30","100","wood","normal");
goods[645] =new setGoods("0000a63722","140","30","100","wood","normal");
goods[646] =new setGoods("0000a63729","150","30","100","wood","normal");
goods[647] =new setGoods("0000a63736","160","30","100","wood","normal");
goods[648] =new setGoods("0000a63743","170","30","100","wood","normal");
goods[649] =new setGoods("0000a63750","180","30","100","wood","normal");
goods[650] =new setGoods("0000a63757","60","35","100","wood","normal");
goods[651] =new setGoods("0000a63764","70","35","100","wood","normal");
goods[652] =new setGoods("0000a63771","80","35","100","wood","normal");
goods[653] =new setGoods("0000a63778","90","35","100","wood","normal");
goods[654] =new setGoods("0000a63785","100","35","100","wood","normal");
goods[655] =new setGoods("0000a63792","110","35","100","wood","normal");
goods[656] =new setGoods("0000a63799","120","35","100","wood","normal");
goods[657] =new setGoods("0000a63806","130","35","100","wood","normal");
goods[658] =new setGoods("0000a63813","140","35","100","wood","normal");
goods[659] =new setGoods("0000a63820","150","35","100","wood","normal");
goods[660] =new setGoods("0000a63827","160","35","100","wood","normal");
goods[661] =new setGoods("0000a63834","170","35","100","wood","normal");
goods[662] =new setGoods("0000a63841","180","35","100","wood","normal");
goods[663] =new setGoods("0000a63848","60","40","100","wood","normal");
goods[664] =new setGoods("0000a63855","70","40","100","wood","normal");
goods[665] =new setGoods("0000a63862","80","40","100","wood","normal");
goods[666] =new setGoods("0000a63869","90","40","100","wood","normal");
goods[667] =new setGoods("0000a63876","100","40","100","wood","normal");
goods[668] =new setGoods("0000a63883","110","40","100","wood","normal");
goods[669] =new setGoods("0000a63890","120","40","100","wood","normal");
goods[670] =new setGoods("0000a63897","130","40","100","wood","normal");
goods[671] =new setGoods("0000a63904","140","40","100","wood","normal");
goods[672] =new setGoods("0000a63911","150","40","100","wood","normal");
goods[673] =new setGoods("0000a63918","160","40","100","wood","normal");
goods[674] =new setGoods("0000a63925","170","40","100","wood","normal");
goods[675] =new setGoods("0000a63932","180","40","100","wood","normal");
goods[676] =new setGoods("0000a63939","60","45","100","wood","normal");
goods[677] =new setGoods("0000a63946","70","45","100","wood","normal");
goods[678] =new setGoods("0000a63953","80","45","100","wood","normal");
goods[679] =new setGoods("0000a63960","90","45","100","wood","normal");
goods[680] =new setGoods("0000a63967","100","45","100","wood","normal");
goods[681] =new setGoods("0000a63974","110","45","100","wood","normal");
goods[682] =new setGoods("0000a63981","120","45","100","wood","normal");
goods[683] =new setGoods("0000a63988","130","45","100","wood","normal");
goods[684] =new setGoods("0000a63995","140","45","100","wood","normal");
goods[685] =new setGoods("0000a64002","150","45","100","wood","normal");
goods[686] =new setGoods("0000a64009","160","45","100","wood","normal");
goods[687] =new setGoods("0000a64016","170","45","100","wood","normal");
goods[688] =new setGoods("0000a64023","180","45","100","wood","normal");
goods[689] =new setGoods("0000a64030","60","50","100","wood","normal");
goods[690] =new setGoods("0000a64037","70","50","100","wood","normal");
goods[691] =new setGoods("0000a64044","80","50","100","wood","normal");
goods[692] =new setGoods("0000a64051","90","50","100","wood","normal");
goods[693] =new setGoods("0000a64058","100","50","100","wood","normal");
goods[694] =new setGoods("0000a64065","110","50","100","wood","normal");
goods[695] =new setGoods("0000a64072","120","50","100","wood","normal");
goods[696] =new setGoods("0000a64079","130","50","100","wood","normal");
goods[697] =new setGoods("0000a64086","140","50","100","wood","normal");
goods[698] =new setGoods("0000a64093","150","50","100","wood","normal");
goods[699] =new setGoods("0000a64100","160","50","100","wood","normal");
goods[700] =new setGoods("0000a64107","170","50","100","wood","normal");
goods[701] =new setGoods("0000a64114","180","50","100","wood","normal");
goods[702] =new setGoods("0000a64121","60","55","100","wood","normal");
goods[703] =new setGoods("0000a64128","70","55","100","wood","normal");
goods[704] =new setGoods("0000a64135","80","55","100","wood","normal");
goods[705] =new setGoods("0000a64142","90","55","100","wood","normal");
goods[706] =new setGoods("0000a64149","100","55","100","wood","normal");
goods[707] =new setGoods("0000a64156","110","55","100","wood","normal");
goods[708] =new setGoods("0000a64163","120","55","100","wood","normal");
goods[709] =new setGoods("0000a64170","130","55","100","wood","normal");
goods[710] =new setGoods("0000a64177","140","55","100","wood","normal");
goods[711] =new setGoods("0000a64184","150","55","100","wood","normal");
goods[712] =new setGoods("0000a64191","160","55","100","wood","normal");
goods[713] =new setGoods("0000a64198","170","55","100","wood","normal");
goods[714] =new setGoods("0000a64205","180","55","100","wood","normal");
goods[715] =new setGoods("0000a64212","60","60","100","wood","normal");
goods[716] =new setGoods("0000a64219","70","60","100","wood","normal");
goods[717] =new setGoods("0000a64226","80","60","100","wood","normal");
goods[718] =new setGoods("0000a64233","90","60","100","wood","normal");
goods[719] =new setGoods("0000a64240","100","60","100","wood","normal");
goods[720] =new setGoods("0000a64247","110","60","100","wood","normal");
goods[721] =new setGoods("0000a64254","120","60","100","wood","normal");
goods[722] =new setGoods("0000a64261","130","60","100","wood","normal");
goods[723] =new setGoods("0000a64268","140","60","100","wood","normal");
goods[724] =new setGoods("0000a64275","150","60","100","wood","normal");
goods[725] =new setGoods("0000a64282","160","60","100","wood","normal");
goods[726] =new setGoods("0000a64289","170","60","100","wood","normal");
goods[727] =new setGoods("0000a64296","180","60","100","wood","normal");
goods[728] =new setGoods("0000a64303","60","25","40","aino","normal");
goods[729] =new setGoods("0000a64309","70","25","40","aino","normal");
goods[730] =new setGoods("0000a64315","80","25","40","aino","normal");
goods[731] =new setGoods("0000a64321","90","25","40","aino","normal");
goods[732] =new setGoods("0000a64327","100","25","40","aino","normal");
goods[733] =new setGoods("0000a64333","110","25","40","aino","normal");
goods[734] =new setGoods("0000a64339","120","25","40","aino","normal");
goods[735] =new setGoods("0000a64345","130","25","40","aino","normal");
goods[736] =new setGoods("0000a64351","140","25","40","aino","normal");
goods[737] =new setGoods("0000a64357","150","25","40","aino","normal");
goods[738] =new setGoods("0000a64363","160","25","40","aino","normal");
goods[739] =new setGoods("0000a64369","170","25","40","aino","normal");
goods[740] =new setGoods("0000a64375","180","25","40","aino","normal");
goods[741] =new setGoods("0000a64381","60","30","40","aino","normal");
goods[742] =new setGoods("0000a64387","70","30","40","aino","normal");
goods[743] =new setGoods("0000a64393","80","30","40","aino","normal");
goods[744] =new setGoods("0000a64399","90","30","40","aino","normal");
goods[745] =new setGoods("0000a64405","100","30","40","aino","normal");
goods[746] =new setGoods("0000a64411","110","30","40","aino","normal");
goods[747] =new setGoods("0000a64417","120","30","40","aino","normal");
goods[748] =new setGoods("0000a64423","130","30","40","aino","normal");
goods[749] =new setGoods("0000a64429","140","30","40","aino","normal");
goods[750] =new setGoods("0000a64435","150","30","40","aino","normal");
goods[751] =new setGoods("0000a64441","160","30","40","aino","normal");
goods[752] =new setGoods("0000a64447","170","30","40","aino","normal");
goods[753] =new setGoods("0000a64453","180","30","40","aino","normal");
goods[754] =new setGoods("0000a64459","60","35","40","aino","normal");
goods[755] =new setGoods("0000a64465","70","35","40","aino","normal");
goods[756] =new setGoods("0000a64471","80","35","40","aino","normal");
goods[757] =new setGoods("0000a64477","90","35","40","aino","normal");
goods[758] =new setGoods("0000a64483","100","35","40","aino","normal");
goods[759] =new setGoods("0000a64489","110","35","40","aino","normal");
goods[760] =new setGoods("0000a64495","120","35","40","aino","normal");
goods[761] =new setGoods("0000a64501","130","35","40","aino","normal");
goods[762] =new setGoods("0000a64507","140","35","40","aino","normal");
goods[763] =new setGoods("0000a64513","150","35","40","aino","normal");
goods[764] =new setGoods("0000a64519","160","35","40","aino","normal");
goods[765] =new setGoods("0000a64525","170","35","40","aino","normal");
goods[766] =new setGoods("0000a64531","180","35","40","aino","normal");
goods[767] =new setGoods("0000a64537","60","40","40","aino","normal");
goods[768] =new setGoods("0000a64543","70","40","40","aino","normal");
goods[769] =new setGoods("0000a64549","80","40","40","aino","normal");
goods[770] =new setGoods("0000a64555","90","40","40","aino","normal");
goods[771] =new setGoods("0000a64561","100","40","40","aino","normal");
goods[772] =new setGoods("0000a64567","110","40","40","aino","normal");
goods[773] =new setGoods("0000a64573","120","40","40","aino","normal");
goods[774] =new setGoods("0000a64579","130","40","40","aino","normal");
goods[775] =new setGoods("0000a64585","140","40","40","aino","normal");
goods[776] =new setGoods("0000a64591","150","40","40","aino","normal");
goods[777] =new setGoods("0000a64597","160","40","40","aino","normal");
goods[778] =new setGoods("0000a64603","170","40","40","aino","normal");
goods[779] =new setGoods("0000a64609","180","40","40","aino","normal");
goods[780] =new setGoods("0000a64615","60","45","40","aino","normal");
goods[781] =new setGoods("0000a64621","70","45","40","aino","normal");
goods[782] =new setGoods("0000a64627","80","45","40","aino","normal");
goods[783] =new setGoods("0000a64633","90","45","40","aino","normal");
goods[784] =new setGoods("0000a64639","100","45","40","aino","normal");
goods[785] =new setGoods("0000a64645","110","45","40","aino","normal");
goods[786] =new setGoods("0000a64651","120","45","40","aino","normal");
goods[787] =new setGoods("0000a64657","130","45","40","aino","normal");
goods[788] =new setGoods("0000a64663","140","45","40","aino","normal");
goods[789] =new setGoods("0000a64669","150","45","40","aino","normal");
goods[790] =new setGoods("0000a64675","160","45","40","aino","normal");
goods[791] =new setGoods("0000a64681","170","45","40","aino","normal");
goods[792] =new setGoods("0000a64687","180","45","40","aino","normal");
goods[793] =new setGoods("0000a64693","60","50","40","aino","normal");
goods[794] =new setGoods("0000a64699","70","50","40","aino","normal");
goods[795] =new setGoods("0000a64705","80","50","40","aino","normal");
goods[796] =new setGoods("0000a64711","90","50","40","aino","normal");
goods[797] =new setGoods("0000a64717","100","50","40","aino","normal");
goods[798] =new setGoods("0000a64723","110","50","40","aino","normal");
goods[799] =new setGoods("0000a64729","120","50","40","aino","normal");
goods[800] =new setGoods("0000a64735","130","50","40","aino","normal");
goods[801] =new setGoods("0000a64741","140","50","40","aino","normal");
goods[802] =new setGoods("0000a64747","150","50","40","aino","normal");
goods[803] =new setGoods("0000a64753","160","50","40","aino","normal");
goods[804] =new setGoods("0000a64759","170","50","40","aino","normal");
goods[805] =new setGoods("0000a64765","180","50","40","aino","normal");
goods[806] =new setGoods("0000a64771","60","55","40","aino","normal");
goods[807] =new setGoods("0000a64777","70","55","40","aino","normal");
goods[808] =new setGoods("0000a64783","80","55","40","aino","normal");
goods[809] =new setGoods("0000a64789","90","55","40","aino","normal");
goods[810] =new setGoods("0000a64795","100","55","40","aino","normal");
goods[811] =new setGoods("0000a64801","110","55","40","aino","normal");
goods[812] =new setGoods("0000a64807","120","55","40","aino","normal");
goods[813] =new setGoods("0000a64813","130","55","40","aino","normal");
goods[814] =new setGoods("0000a64819","140","55","40","aino","normal");
goods[815] =new setGoods("0000a64825","150","55","40","aino","normal");
goods[816] =new setGoods("0000a64831","160","55","40","aino","normal");
goods[817] =new setGoods("0000a64837","170","55","40","aino","normal");
goods[818] =new setGoods("0000a64843","180","55","40","aino","normal");
goods[819] =new setGoods("0000a64849","60","60","40","aino","normal");
goods[820] =new setGoods("0000a64855","70","60","40","aino","normal");
goods[821] =new setGoods("0000a64861","80","60","40","aino","normal");
goods[822] =new setGoods("0000a64867","90","60","40","aino","normal");
goods[823] =new setGoods("0000a64873","100","60","40","aino","normal");
goods[824] =new setGoods("0000a64879","110","60","40","aino","normal");
goods[825] =new setGoods("0000a64885","120","60","40","aino","normal");
goods[826] =new setGoods("0000a64891","130","60","40","aino","normal");
goods[827] =new setGoods("0000a64897","140","60","40","aino","normal");
goods[828] =new setGoods("0000a64903","150","60","40","aino","normal");
goods[829] =new setGoods("0000a64909","160","60","40","aino","normal");
goods[830] =new setGoods("0000a64915","170","60","40","aino","normal");
goods[831] =new setGoods("0000a64921","180","60","40","aino","normal");
goods[832] =new setGoods("0000a64927","60","25","50","aino","normal");
goods[833] =new setGoods("0000a64933","70","25","50","aino","normal");
goods[834] =new setGoods("0000a64939","80","25","50","aino","normal");
goods[835] =new setGoods("0000a64945","90","25","50","aino","normal");
goods[836] =new setGoods("0000a64951","100","25","50","aino","normal");
goods[837] =new setGoods("0000a64957","110","25","50","aino","normal");
goods[838] =new setGoods("0000a64963","120","25","50","aino","normal");
goods[839] =new setGoods("0000a64969","130","25","50","aino","normal");
goods[840] =new setGoods("0000a64975","140","25","50","aino","normal");
goods[841] =new setGoods("0000a64981","150","25","50","aino","normal");
goods[842] =new setGoods("0000a64987","160","25","50","aino","normal");
goods[843] =new setGoods("0000a64993","170","25","50","aino","normal");
goods[844] =new setGoods("0000a64999","180","25","50","aino","normal");
goods[845] =new setGoods("0000a65005","60","30","50","aino","normal");
goods[846] =new setGoods("0000a65011","70","30","50","aino","normal");
goods[847] =new setGoods("0000a65017","80","30","50","aino","normal");
goods[848] =new setGoods("0000a65023","90","30","50","aino","normal");
goods[849] =new setGoods("0000a65029","100","30","50","aino","normal");
goods[850] =new setGoods("0000a65035","110","30","50","aino","normal");
goods[851] =new setGoods("0000a65041","120","30","50","aino","normal");
goods[852] =new setGoods("0000a65047","130","30","50","aino","normal");
goods[853] =new setGoods("0000a65053","140","30","50","aino","normal");
goods[854] =new setGoods("0000a65059","150","30","50","aino","normal");
goods[855] =new setGoods("0000a65065","160","30","50","aino","normal");
goods[856] =new setGoods("0000a65071","170","30","50","aino","normal");
goods[857] =new setGoods("0000a65077","180","30","50","aino","normal");
goods[858] =new setGoods("0000a65083","60","35","50","aino","normal");
goods[859] =new setGoods("0000a65089","70","35","50","aino","normal");
goods[860] =new setGoods("0000a65095","80","35","50","aino","normal");
goods[861] =new setGoods("0000a65101","90","35","50","aino","normal");
goods[862] =new setGoods("0000a65107","100","35","50","aino","normal");
goods[863] =new setGoods("0000a65113","110","35","50","aino","normal");
goods[864] =new setGoods("0000a65119","120","35","50","aino","normal");
goods[865] =new setGoods("0000a65125","130","35","50","aino","normal");
goods[866] =new setGoods("0000a65131","140","35","50","aino","normal");
goods[867] =new setGoods("0000a65137","150","35","50","aino","normal");
goods[868] =new setGoods("0000a65143","160","35","50","aino","normal");
goods[869] =new setGoods("0000a65149","170","35","50","aino","normal");
goods[870] =new setGoods("0000a65155","180","35","50","aino","normal");
goods[871] =new setGoods("0000a65161","60","40","50","aino","normal");
goods[872] =new setGoods("0000a65167","70","40","50","aino","normal");
goods[873] =new setGoods("0000a65173","80","40","50","aino","normal");
goods[874] =new setGoods("0000a65179","90","40","50","aino","normal");
goods[875] =new setGoods("0000a65185","100","40","50","aino","normal");
goods[876] =new setGoods("0000a65191","110","40","50","aino","normal");
goods[877] =new setGoods("0000a65197","120","40","50","aino","normal");
goods[878] =new setGoods("0000a65203","130","40","50","aino","normal");
goods[879] =new setGoods("0000a65209","140","40","50","aino","normal");
goods[880] =new setGoods("0000a65215","150","40","50","aino","normal");
goods[881] =new setGoods("0000a65221","160","40","50","aino","normal");
goods[882] =new setGoods("0000a65227","170","40","50","aino","normal");
goods[883] =new setGoods("0000a65233","180","40","50","aino","normal");
goods[884] =new setGoods("0000a65239","60","45","50","aino","normal");
goods[885] =new setGoods("0000a65245","70","45","50","aino","normal");
goods[886] =new setGoods("0000a65251","80","45","50","aino","normal");
goods[887] =new setGoods("0000a65257","90","45","50","aino","normal");
goods[888] =new setGoods("0000a65263","100","45","50","aino","normal");
goods[889] =new setGoods("0000a65269","110","45","50","aino","normal");
goods[890] =new setGoods("0000a65275","120","45","50","aino","normal");
goods[891] =new setGoods("0000a65281","130","45","50","aino","normal");
goods[892] =new setGoods("0000a65287","140","45","50","aino","normal");
goods[893] =new setGoods("0000a65293","150","45","50","aino","normal");
goods[894] =new setGoods("0000a65299","160","45","50","aino","normal");
goods[895] =new setGoods("0000a65305","170","45","50","aino","normal");
goods[896] =new setGoods("0000a65311","180","45","50","aino","normal");
goods[897] =new setGoods("0000a65317","60","50","50","aino","normal");
goods[898] =new setGoods("0000a65323","70","50","50","aino","normal");
goods[899] =new setGoods("0000a65329","80","50","50","aino","normal");
goods[900] =new setGoods("0000a65335","90","50","50","aino","normal");
goods[901] =new setGoods("0000a65341","100","50","50","aino","normal");
goods[902] =new setGoods("0000a65347","110","50","50","aino","normal");
goods[903] =new setGoods("0000a65353","120","50","50","aino","normal");
goods[904] =new setGoods("0000a65359","130","50","50","aino","normal");
goods[905] =new setGoods("0000a65365","140","50","50","aino","normal");
goods[906] =new setGoods("0000a65371","150","50","50","aino","normal");
goods[907] =new setGoods("0000a65377","160","50","50","aino","normal");
goods[908] =new setGoods("0000a65383","170","50","50","aino","normal");
goods[909] =new setGoods("0000a65389","180","50","50","aino","normal");
goods[910] =new setGoods("0000a65395","60","55","50","aino","normal");
goods[911] =new setGoods("0000a65401","70","55","50","aino","normal");
goods[912] =new setGoods("0000a65407","80","55","50","aino","normal");
goods[913] =new setGoods("0000a65413","90","55","50","aino","normal");
goods[914] =new setGoods("0000a65419","100","55","50","aino","normal");
goods[915] =new setGoods("0000a65425","110","55","50","aino","normal");
goods[916] =new setGoods("0000a65431","120","55","50","aino","normal");
goods[917] =new setGoods("0000a65437","130","55","50","aino","normal");
goods[918] =new setGoods("0000a65443","140","55","50","aino","normal");
goods[919] =new setGoods("0000a65449","150","55","50","aino","normal");
goods[920] =new setGoods("0000a65455","160","55","50","aino","normal");
goods[921] =new setGoods("0000a65461","170","55","50","aino","normal");
goods[922] =new setGoods("0000a65467","180","55","50","aino","normal");
goods[923] =new setGoods("0000a65473","60","60","50","aino","normal");
goods[924] =new setGoods("0000a65479","70","60","50","aino","normal");
goods[925] =new setGoods("0000a65485","80","60","50","aino","normal");
goods[926] =new setGoods("0000a65491","90","60","50","aino","normal");
goods[927] =new setGoods("0000a65497","100","60","50","aino","normal");
goods[928] =new setGoods("0000a65503","110","60","50","aino","normal");
goods[929] =new setGoods("0000a65509","120","60","50","aino","normal");
goods[930] =new setGoods("0000a65515","130","60","50","aino","normal");
goods[931] =new setGoods("0000a65521","140","60","50","aino","normal");
goods[932] =new setGoods("0000a65527","150","60","50","aino","normal");
goods[933] =new setGoods("0000a65533","160","60","50","aino","normal");
goods[934] =new setGoods("0000a65539","170","60","50","aino","normal");
goods[935] =new setGoods("0000a65545","180","60","50","aino","normal");
goods[936] =new setGoods("0000a65551","60","25","60","aino","normal");
goods[937] =new setGoods("0000a65557","70","25","60","aino","normal");
goods[938] =new setGoods("0000a65563","80","25","60","aino","normal");
goods[939] =new setGoods("0000a65569","90","25","60","aino","normal");
goods[940] =new setGoods("0000a65575","100","25","60","aino","normal");
goods[941] =new setGoods("0000a65581","110","25","60","aino","normal");
goods[942] =new setGoods("0000a65587","120","25","60","aino","normal");
goods[943] =new setGoods("0000a65593","130","25","60","aino","normal");
goods[944] =new setGoods("0000a65599","140","25","60","aino","normal");
goods[945] =new setGoods("0000a65605","150","25","60","aino","normal");
goods[946] =new setGoods("0000a65611","160","25","60","aino","normal");
goods[947] =new setGoods("0000a65617","170","25","60","aino","normal");
goods[948] =new setGoods("0000a65623","180","25","60","aino","normal");
goods[949] =new setGoods("0000a65629","60","30","60","aino","normal");
goods[950] =new setGoods("0000a65635","70","30","60","aino","normal");
goods[951] =new setGoods("0000a65641","80","30","60","aino","normal");
goods[952] =new setGoods("0000a65647","90","30","60","aino","normal");
goods[953] =new setGoods("0000a65653","100","30","60","aino","normal");
goods[954] =new setGoods("0000a65659","110","30","60","aino","normal");
goods[955] =new setGoods("0000a65665","120","30","60","aino","normal");
goods[956] =new setGoods("0000a65671","130","30","60","aino","normal");
goods[957] =new setGoods("0000a65677","140","30","60","aino","normal");
goods[958] =new setGoods("0000a65683","150","30","60","aino","normal");
goods[959] =new setGoods("0000a65689","160","30","60","aino","normal");
goods[960] =new setGoods("0000a65695","170","30","60","aino","normal");
goods[961] =new setGoods("0000a65701","180","30","60","aino","normal");
goods[962] =new setGoods("0000a65707","60","35","60","aino","normal");
goods[963] =new setGoods("0000a65713","70","35","60","aino","normal");
goods[964] =new setGoods("0000a65719","80","35","60","aino","normal");
goods[965] =new setGoods("0000a65725","90","35","60","aino","normal");
goods[966] =new setGoods("0000a65731","100","35","60","aino","normal");
goods[967] =new setGoods("0000a65737","110","35","60","aino","normal");
goods[968] =new setGoods("0000a65743","120","35","60","aino","normal");
goods[969] =new setGoods("0000a65749","130","35","60","aino","normal");
goods[970] =new setGoods("0000a65755","140","35","60","aino","normal");
goods[971] =new setGoods("0000a65761","150","35","60","aino","normal");
goods[972] =new setGoods("0000a65767","160","35","60","aino","normal");
goods[973] =new setGoods("0000a65773","170","35","60","aino","normal");
goods[974] =new setGoods("0000a65779","180","35","60","aino","normal");
goods[975] =new setGoods("0000a65785","60","40","60","aino","normal");
goods[976] =new setGoods("0000a65791","70","40","60","aino","normal");
goods[977] =new setGoods("0000a65797","80","40","60","aino","normal");
goods[978] =new setGoods("0000a65803","90","40","60","aino","normal");
goods[979] =new setGoods("0000a65809","100","40","60","aino","normal");
goods[980] =new setGoods("0000a65815","110","40","60","aino","normal");
goods[981] =new setGoods("0000a65821","120","40","60","aino","normal");
goods[982] =new setGoods("0000a65827","130","40","60","aino","normal");
goods[983] =new setGoods("0000a65833","140","40","60","aino","normal");
goods[984] =new setGoods("0000a65839","150","40","60","aino","normal");
goods[985] =new setGoods("0000a65845","160","40","60","aino","normal");
goods[986] =new setGoods("0000a65851","170","40","60","aino","normal");
goods[987] =new setGoods("0000a65857","180","40","60","aino","normal");
goods[988] =new setGoods("0000a65863","60","45","60","aino","normal");
goods[989] =new setGoods("0000a65869","70","45","60","aino","normal");
goods[990] =new setGoods("0000a65875","80","45","60","aino","normal");
goods[991] =new setGoods("0000a65881","90","45","60","aino","normal");
goods[992] =new setGoods("0000a65887","100","45","60","aino","normal");
goods[993] =new setGoods("0000a65893","110","45","60","aino","normal");
goods[994] =new setGoods("0000a65899","120","45","60","aino","normal");
goods[995] =new setGoods("0000a65905","130","45","60","aino","normal");
goods[996] =new setGoods("0000a65911","140","45","60","aino","normal");
goods[997] =new setGoods("0000a65917","150","45","60","aino","normal");
goods[998] =new setGoods("0000a65923","160","45","60","aino","normal");
goods[999] =new setGoods("0000a65929","170","45","60","aino","normal");
goods[1000] =new setGoods("0000a65935","180","45","60","aino","normal");
goods[1001] =new setGoods("0000a65941","60","50","60","aino","normal");
goods[1002] =new setGoods("0000a65947","70","50","60","aino","normal");
goods[1003] =new setGoods("0000a65953","80","50","60","aino","normal");
goods[1004] =new setGoods("0000a65959","90","50","60","aino","normal");
goods[1005] =new setGoods("0000a65965","100","50","60","aino","normal");
goods[1006] =new setGoods("0000a65971","110","50","60","aino","normal");
goods[1007] =new setGoods("0000a65977","120","50","60","aino","normal");
goods[1008] =new setGoods("0000a65983","130","50","60","aino","normal");
goods[1009] =new setGoods("0000a65989","140","50","60","aino","normal");
goods[1010] =new setGoods("0000a65995","150","50","60","aino","normal");
goods[1011] =new setGoods("0000a66001","160","50","60","aino","normal");
goods[1012] =new setGoods("0000a66007","170","50","60","aino","normal");
goods[1013] =new setGoods("0000a66013","180","50","60","aino","normal");
goods[1014] =new setGoods("0000a66019","60","55","60","aino","normal");
goods[1015] =new setGoods("0000a66025","70","55","60","aino","normal");
goods[1016] =new setGoods("0000a66031","80","55","60","aino","normal");
goods[1017] =new setGoods("0000a66037","90","55","60","aino","normal");
goods[1018] =new setGoods("0000a66043","100","55","60","aino","normal");
goods[1019] =new setGoods("0000a66049","110","55","60","aino","normal");
goods[1020] =new setGoods("0000a66055","120","55","60","aino","normal");
goods[1021] =new setGoods("0000a66061","130","55","60","aino","normal");
goods[1022] =new setGoods("0000a66067","140","55","60","aino","normal");
goods[1023] =new setGoods("0000a66073","150","55","60","aino","normal");
goods[1024] =new setGoods("0000a66079","160","55","60","aino","normal");
goods[1025] =new setGoods("0000a66085","170","55","60","aino","normal");
goods[1026] =new setGoods("0000a66091","180","55","60","aino","normal");
goods[1027] =new setGoods("0000a66097","60","60","60","aino","normal");
goods[1028] =new setGoods("0000a66103","70","60","60","aino","normal");
goods[1029] =new setGoods("0000a66109","80","60","60","aino","normal");
goods[1030] =new setGoods("0000a66115","90","60","60","aino","normal");
goods[1031] =new setGoods("0000a66121","100","60","60","aino","normal");
goods[1032] =new setGoods("0000a66127","110","60","60","aino","normal");
goods[1033] =new setGoods("0000a66133","120","60","60","aino","normal");
goods[1034] =new setGoods("0000a66139","130","60","60","aino","normal");
goods[1035] =new setGoods("0000a66145","140","60","60","aino","normal");
goods[1036] =new setGoods("0000a66151","150","60","60","aino","normal");
goods[1037] =new setGoods("0000a66157","160","60","60","aino","normal");
goods[1038] =new setGoods("0000a66163","170","60","60","aino","normal");
goods[1039] =new setGoods("0000a66169","180","60","60","aino","normal");
goods[1040] =new setGoods("0000a66175","60","25","70","aino","normal");
goods[1041] =new setGoods("0000a66181","70","25","70","aino","normal");
goods[1042] =new setGoods("0000a66187","80","25","70","aino","normal");
goods[1043] =new setGoods("0000a66193","90","25","70","aino","normal");
goods[1044] =new setGoods("0000a66199","100","25","70","aino","normal");
goods[1045] =new setGoods("0000a66205","110","25","70","aino","normal");
goods[1046] =new setGoods("0000a66211","120","25","70","aino","normal");
goods[1047] =new setGoods("0000a66217","130","25","70","aino","normal");
goods[1048] =new setGoods("0000a66223","140","25","70","aino","normal");
goods[1049] =new setGoods("0000a66229","150","25","70","aino","normal");
goods[1050] =new setGoods("0000a66235","160","25","70","aino","normal");
goods[1051] =new setGoods("0000a66241","170","25","70","aino","normal");
goods[1052] =new setGoods("0000a66247","180","25","70","aino","normal");
goods[1053] =new setGoods("0000a66253","60","30","70","aino","normal");
goods[1054] =new setGoods("0000a66259","70","30","70","aino","normal");
goods[1055] =new setGoods("0000a66265","80","30","70","aino","normal");
goods[1056] =new setGoods("0000a66271","90","30","70","aino","normal");
goods[1057] =new setGoods("0000a66277","100","30","70","aino","normal");
goods[1058] =new setGoods("0000a66283","110","30","70","aino","normal");
goods[1059] =new setGoods("0000a66289","120","30","70","aino","normal");
goods[1060] =new setGoods("0000a66295","130","30","70","aino","normal");
goods[1061] =new setGoods("0000a66301","140","30","70","aino","normal");
goods[1062] =new setGoods("0000a66307","150","30","70","aino","normal");
goods[1063] =new setGoods("0000a66313","160","30","70","aino","normal");
goods[1064] =new setGoods("0000a66319","170","30","70","aino","normal");
goods[1065] =new setGoods("0000a66325","180","30","70","aino","normal");
goods[1066] =new setGoods("0000a66331","60","35","70","aino","normal");
goods[1067] =new setGoods("0000a66337","70","35","70","aino","normal");
goods[1068] =new setGoods("0000a66343","80","35","70","aino","normal");
goods[1069] =new setGoods("0000a66349","90","35","70","aino","normal");
goods[1070] =new setGoods("0000a66355","100","35","70","aino","normal");
goods[1071] =new setGoods("0000a66361","110","35","70","aino","normal");
goods[1072] =new setGoods("0000a66367","120","35","70","aino","normal");
goods[1073] =new setGoods("0000a66373","130","35","70","aino","normal");
goods[1074] =new setGoods("0000a66379","140","35","70","aino","normal");
goods[1075] =new setGoods("0000a66385","150","35","70","aino","normal");
goods[1076] =new setGoods("0000a66391","160","35","70","aino","normal");
goods[1077] =new setGoods("0000a66397","170","35","70","aino","normal");
goods[1078] =new setGoods("0000a66403","180","35","70","aino","normal");
goods[1079] =new setGoods("0000a66409","60","40","70","aino","normal");
goods[1080] =new setGoods("0000a66415","70","40","70","aino","normal");
goods[1081] =new setGoods("0000a66421","80","40","70","aino","normal");
goods[1082] =new setGoods("0000a66427","90","40","70","aino","normal");
goods[1083] =new setGoods("0000a66433","100","40","70","aino","normal");
goods[1084] =new setGoods("0000a66439","110","40","70","aino","normal");
goods[1085] =new setGoods("0000a66445","120","40","70","aino","normal");
goods[1086] =new setGoods("0000a66451","130","40","70","aino","normal");
goods[1087] =new setGoods("0000a66457","140","40","70","aino","normal");
goods[1088] =new setGoods("0000a66463","150","40","70","aino","normal");
goods[1089] =new setGoods("0000a66469","160","40","70","aino","normal");
goods[1090] =new setGoods("0000a66475","170","40","70","aino","normal");
goods[1091] =new setGoods("0000a66481","180","40","70","aino","normal");
goods[1092] =new setGoods("0000a66487","60","45","70","aino","normal");
goods[1093] =new setGoods("0000a66493","70","45","70","aino","normal");
goods[1094] =new setGoods("0000a66499","80","45","70","aino","normal");
goods[1095] =new setGoods("0000a66505","90","45","70","aino","normal");
goods[1096] =new setGoods("0000a66511","100","45","70","aino","normal");
goods[1097] =new setGoods("0000a66517","110","45","70","aino","normal");
goods[1098] =new setGoods("0000a66523","120","45","70","aino","normal");
goods[1099] =new setGoods("0000a66529","130","45","70","aino","normal");
goods[1100] =new setGoods("0000a66535","140","45","70","aino","normal");
goods[1101] =new setGoods("0000a66541","150","45","70","aino","normal");
goods[1102] =new setGoods("0000a66547","160","45","70","aino","normal");
goods[1103] =new setGoods("0000a66553","170","45","70","aino","normal");
goods[1104] =new setGoods("0000a66559","180","45","70","aino","normal");
goods[1105] =new setGoods("0000a66565","60","50","70","aino","normal");
goods[1106] =new setGoods("0000a66571","70","50","70","aino","normal");
goods[1107] =new setGoods("0000a66577","80","50","70","aino","normal");
goods[1108] =new setGoods("0000a66583","90","50","70","aino","normal");
goods[1109] =new setGoods("0000a66589","100","50","70","aino","normal");
goods[1110] =new setGoods("0000a66595","110","50","70","aino","normal");
goods[1111] =new setGoods("0000a66601","120","50","70","aino","normal");
goods[1112] =new setGoods("0000a66607","130","50","70","aino","normal");
goods[1113] =new setGoods("0000a66613","140","50","70","aino","normal");
goods[1114] =new setGoods("0000a66619","150","50","70","aino","normal");
goods[1115] =new setGoods("0000a66625","160","50","70","aino","normal");
goods[1116] =new setGoods("0000a66631","170","50","70","aino","normal");
goods[1117] =new setGoods("0000a66637","180","50","70","aino","normal");
goods[1118] =new setGoods("0000a66643","60","55","70","aino","normal");
goods[1119] =new setGoods("0000a66649","70","55","70","aino","normal");
goods[1120] =new setGoods("0000a66655","80","55","70","aino","normal");
goods[1121] =new setGoods("0000a66661","90","55","70","aino","normal");
goods[1122] =new setGoods("0000a66667","100","55","70","aino","normal");
goods[1123] =new setGoods("0000a66673","110","55","70","aino","normal");
goods[1124] =new setGoods("0000a66679","120","55","70","aino","normal");
goods[1125] =new setGoods("0000a66685","130","55","70","aino","normal");
goods[1126] =new setGoods("0000a66691","140","55","70","aino","normal");
goods[1127] =new setGoods("0000a66697","150","55","70","aino","normal");
goods[1128] =new setGoods("0000a66703","160","55","70","aino","normal");
goods[1129] =new setGoods("0000a66709","170","55","70","aino","normal");
goods[1130] =new setGoods("0000a66715","180","55","70","aino","normal");
goods[1131] =new setGoods("0000a66721","60","60","70","aino","normal");
goods[1132] =new setGoods("0000a66727","70","60","70","aino","normal");
goods[1133] =new setGoods("0000a66733","80","60","70","aino","normal");
goods[1134] =new setGoods("0000a66739","90","60","70","aino","normal");
goods[1135] =new setGoods("0000a66745","100","60","70","aino","normal");
goods[1136] =new setGoods("0000a66751","110","60","70","aino","normal");
goods[1137] =new setGoods("0000a66757","120","60","70","aino","normal");
goods[1138] =new setGoods("0000a66763","130","60","70","aino","normal");
goods[1139] =new setGoods("0000a66769","140","60","70","aino","normal");
goods[1140] =new setGoods("0000a66775","150","60","70","aino","normal");
goods[1141] =new setGoods("0000a66781","160","60","70","aino","normal");
goods[1142] =new setGoods("0000a66787","170","60","70","aino","normal");
goods[1143] =new setGoods("0000a66793","180","60","70","aino","normal");
goods[1144] =new setGoods("0000a66799","60","25","80","aino","normal");
goods[1145] =new setGoods("0000a66805","70","25","80","aino","normal");
goods[1146] =new setGoods("0000a66811","80","25","80","aino","normal");
goods[1147] =new setGoods("0000a66817","90","25","80","aino","normal");
goods[1148] =new setGoods("0000a66823","100","25","80","aino","normal");
goods[1149] =new setGoods("0000a66829","110","25","80","aino","normal");
goods[1150] =new setGoods("0000a66835","120","25","80","aino","normal");
goods[1151] =new setGoods("0000a66841","130","25","80","aino","normal");
goods[1152] =new setGoods("0000a66847","140","25","80","aino","normal");
goods[1153] =new setGoods("0000a66853","150","25","80","aino","normal");
goods[1154] =new setGoods("0000a66859","160","25","80","aino","normal");
goods[1155] =new setGoods("0000a66865","170","25","80","aino","normal");
goods[1156] =new setGoods("0000a66871","180","25","80","aino","normal");
goods[1157] =new setGoods("0000a66877","60","30","80","aino","normal");
goods[1158] =new setGoods("0000a66883","70","30","80","aino","normal");
goods[1159] =new setGoods("0000a66889","80","30","80","aino","normal");
goods[1160] =new setGoods("0000a66895","90","30","80","aino","normal");
goods[1161] =new setGoods("0000a66901","100","30","80","aino","normal");
goods[1162] =new setGoods("0000a66907","110","30","80","aino","normal");
goods[1163] =new setGoods("0000a66913","120","30","80","aino","normal");
goods[1164] =new setGoods("0000a66919","130","30","80","aino","normal");
goods[1165] =new setGoods("0000a66925","140","30","80","aino","normal");
goods[1166] =new setGoods("0000a66931","150","30","80","aino","normal");
goods[1167] =new setGoods("0000a66937","160","30","80","aino","normal");
goods[1168] =new setGoods("0000a66943","170","30","80","aino","normal");
goods[1169] =new setGoods("0000a66949","180","30","80","aino","normal");
goods[1170] =new setGoods("0000a66955","60","35","80","aino","normal");
goods[1171] =new setGoods("0000a66961","70","35","80","aino","normal");
goods[1172] =new setGoods("0000a66967","80","35","80","aino","normal");
goods[1173] =new setGoods("0000a66973","90","35","80","aino","normal");
goods[1174] =new setGoods("0000a66979","100","35","80","aino","normal");
goods[1175] =new setGoods("0000a66985","110","35","80","aino","normal");
goods[1176] =new setGoods("0000a66991","120","35","80","aino","normal");
goods[1177] =new setGoods("0000a66997","130","35","80","aino","normal");
goods[1178] =new setGoods("0000a67003","140","35","80","aino","normal");
goods[1179] =new setGoods("0000a67009","150","35","80","aino","normal");
goods[1180] =new setGoods("0000a67015","160","35","80","aino","normal");
goods[1181] =new setGoods("0000a67021","170","35","80","aino","normal");
goods[1182] =new setGoods("0000a67027","180","35","80","aino","normal");
goods[1183] =new setGoods("0000a67033","60","40","80","aino","normal");
goods[1184] =new setGoods("0000a67039","70","40","80","aino","normal");
goods[1185] =new setGoods("0000a67045","80","40","80","aino","normal");
goods[1186] =new setGoods("0000a67051","90","40","80","aino","normal");
goods[1187] =new setGoods("0000a67057","100","40","80","aino","normal");
goods[1188] =new setGoods("0000a67063","110","40","80","aino","normal");
goods[1189] =new setGoods("0000a67069","120","40","80","aino","normal");
goods[1190] =new setGoods("0000a67075","130","40","80","aino","normal");
goods[1191] =new setGoods("0000a67081","140","40","80","aino","normal");
goods[1192] =new setGoods("0000a67087","150","40","80","aino","normal");
goods[1193] =new setGoods("0000a67093","160","40","80","aino","normal");
goods[1194] =new setGoods("0000a67099","170","40","80","aino","normal");
goods[1195] =new setGoods("0000a67105","180","40","80","aino","normal");
goods[1196] =new setGoods("0000a67111","60","45","80","aino","normal");
goods[1197] =new setGoods("0000a67117","70","45","80","aino","normal");
goods[1198] =new setGoods("0000a67123","80","45","80","aino","normal");
goods[1199] =new setGoods("0000a67129","90","45","80","aino","normal");
goods[1200] =new setGoods("0000a67135","100","45","80","aino","normal");
goods[1201] =new setGoods("0000a67141","110","45","80","aino","normal");
goods[1202] =new setGoods("0000a67147","120","45","80","aino","normal");
goods[1203] =new setGoods("0000a67153","130","45","80","aino","normal");
goods[1204] =new setGoods("0000a67159","140","45","80","aino","normal");
goods[1205] =new setGoods("0000a67165","150","45","80","aino","normal");
goods[1206] =new setGoods("0000a67171","160","45","80","aino","normal");
goods[1207] =new setGoods("0000a67177","170","45","80","aino","normal");
goods[1208] =new setGoods("0000a67183","180","45","80","aino","normal");
goods[1209] =new setGoods("0000a67189","60","50","80","aino","normal");
goods[1210] =new setGoods("0000a67195","70","50","80","aino","normal");
goods[1211] =new setGoods("0000a67201","80","50","80","aino","normal");
goods[1212] =new setGoods("0000a67207","90","50","80","aino","normal");
goods[1213] =new setGoods("0000a67213","100","50","80","aino","normal");
goods[1214] =new setGoods("0000a67219","110","50","80","aino","normal");
goods[1215] =new setGoods("0000a67225","120","50","80","aino","normal");
goods[1216] =new setGoods("0000a67231","130","50","80","aino","normal");
goods[1217] =new setGoods("0000a67237","140","50","80","aino","normal");
goods[1218] =new setGoods("0000a67243","150","50","80","aino","normal");
goods[1219] =new setGoods("0000a67249","160","50","80","aino","normal");
goods[1220] =new setGoods("0000a67255","170","50","80","aino","normal");
goods[1221] =new setGoods("0000a67261","180","50","80","aino","normal");
goods[1222] =new setGoods("0000a67267","60","55","80","aino","normal");
goods[1223] =new setGoods("0000a67273","70","55","80","aino","normal");
goods[1224] =new setGoods("0000a67279","80","55","80","aino","normal");
goods[1225] =new setGoods("0000a67285","90","55","80","aino","normal");
goods[1226] =new setGoods("0000a67291","100","55","80","aino","normal");
goods[1227] =new setGoods("0000a67297","110","55","80","aino","normal");
goods[1228] =new setGoods("0000a67303","120","55","80","aino","normal");
goods[1229] =new setGoods("0000a67309","130","55","80","aino","normal");
goods[1230] =new setGoods("0000a67315","140","55","80","aino","normal");
goods[1231] =new setGoods("0000a67321","150","55","80","aino","normal");
goods[1232] =new setGoods("0000a67327","160","55","80","aino","normal");
goods[1233] =new setGoods("0000a67333","170","55","80","aino","normal");
goods[1234] =new setGoods("0000a67339","180","55","80","aino","normal");
goods[1235] =new setGoods("0000a67345","60","60","80","aino","normal");
goods[1236] =new setGoods("0000a67351","70","60","80","aino","normal");
goods[1237] =new setGoods("0000a67357","80","60","80","aino","normal");
goods[1238] =new setGoods("0000a67363","90","60","80","aino","normal");
goods[1239] =new setGoods("0000a67369","100","60","80","aino","normal");
goods[1240] =new setGoods("0000a67375","110","60","80","aino","normal");
goods[1241] =new setGoods("0000a67381","120","60","80","aino","normal");
goods[1242] =new setGoods("0000a67387","130","60","80","aino","normal");
goods[1243] =new setGoods("0000a67393","140","60","80","aino","normal");
goods[1244] =new setGoods("0000a67399","150","60","80","aino","normal");
goods[1245] =new setGoods("0000a67405","160","60","80","aino","normal");
goods[1246] =new setGoods("0000a67411","170","60","80","aino","normal");
goods[1247] =new setGoods("0000a67417","180","60","80","aino","normal");
goods[1248] =new setGoods("0000a67423","60","25","90","aino","normal");
goods[1249] =new setGoods("0000a67429","70","25","90","aino","normal");
goods[1250] =new setGoods("0000a67435","80","25","90","aino","normal");
goods[1251] =new setGoods("0000a67441","90","25","90","aino","normal");
goods[1252] =new setGoods("0000a67447","100","25","90","aino","normal");
goods[1253] =new setGoods("0000a67453","110","25","90","aino","normal");
goods[1254] =new setGoods("0000a67459","120","25","90","aino","normal");
goods[1255] =new setGoods("0000a67465","130","25","90","aino","normal");
goods[1256] =new setGoods("0000a67471","140","25","90","aino","normal");
goods[1257] =new setGoods("0000a67477","150","25","90","aino","normal");
goods[1258] =new setGoods("0000a67483","160","25","90","aino","normal");
goods[1259] =new setGoods("0000a67489","170","25","90","aino","normal");
goods[1260] =new setGoods("0000a67495","180","25","90","aino","normal");
goods[1261] =new setGoods("0000a67501","60","30","90","aino","normal");
goods[1262] =new setGoods("0000a67507","70","30","90","aino","normal");
goods[1263] =new setGoods("0000a67513","80","30","90","aino","normal");
goods[1264] =new setGoods("0000a67519","90","30","90","aino","normal");
goods[1265] =new setGoods("0000a67525","100","30","90","aino","normal");
goods[1266] =new setGoods("0000a67531","110","30","90","aino","normal");
goods[1267] =new setGoods("0000a67537","120","30","90","aino","normal");
goods[1268] =new setGoods("0000a67543","130","30","90","aino","normal");
goods[1269] =new setGoods("0000a67549","140","30","90","aino","normal");
goods[1270] =new setGoods("0000a67555","150","30","90","aino","normal");
goods[1271] =new setGoods("0000a67561","160","30","90","aino","normal");
goods[1272] =new setGoods("0000a67567","170","30","90","aino","normal");
goods[1273] =new setGoods("0000a67573","180","30","90","aino","normal");
goods[1274] =new setGoods("0000a67579","60","35","90","aino","normal");
goods[1275] =new setGoods("0000a67585","70","35","90","aino","normal");
goods[1276] =new setGoods("0000a67591","80","35","90","aino","normal");
goods[1277] =new setGoods("0000a67597","90","35","90","aino","normal");
goods[1278] =new setGoods("0000a67603","100","35","90","aino","normal");
goods[1279] =new setGoods("0000a67609","110","35","90","aino","normal");
goods[1280] =new setGoods("0000a67615","120","35","90","aino","normal");
goods[1281] =new setGoods("0000a67621","130","35","90","aino","normal");
goods[1282] =new setGoods("0000a67627","140","35","90","aino","normal");
goods[1283] =new setGoods("0000a67633","150","35","90","aino","normal");
goods[1284] =new setGoods("0000a67639","160","35","90","aino","normal");
goods[1285] =new setGoods("0000a67645","170","35","90","aino","normal");
goods[1286] =new setGoods("0000a67651","180","35","90","aino","normal");
goods[1287] =new setGoods("0000a67657","60","40","90","aino","normal");
goods[1288] =new setGoods("0000a67663","70","40","90","aino","normal");
goods[1289] =new setGoods("0000a67669","80","40","90","aino","normal");
goods[1290] =new setGoods("0000a67675","90","40","90","aino","normal");
goods[1291] =new setGoods("0000a67681","100","40","90","aino","normal");
goods[1292] =new setGoods("0000a67687","110","40","90","aino","normal");
goods[1293] =new setGoods("0000a67693","120","40","90","aino","normal");
goods[1294] =new setGoods("0000a67699","130","40","90","aino","normal");
goods[1295] =new setGoods("0000a67705","140","40","90","aino","normal");
goods[1296] =new setGoods("0000a67711","150","40","90","aino","normal");
goods[1297] =new setGoods("0000a67717","160","40","90","aino","normal");
goods[1298] =new setGoods("0000a67723","170","40","90","aino","normal");
goods[1299] =new setGoods("0000a67729","180","40","90","aino","normal");
goods[1300] =new setGoods("0000a67735","60","45","90","aino","normal");
goods[1301] =new setGoods("0000a67741","70","45","90","aino","normal");
goods[1302] =new setGoods("0000a67747","80","45","90","aino","normal");
goods[1303] =new setGoods("0000a67753","90","45","90","aino","normal");
goods[1304] =new setGoods("0000a67759","100","45","90","aino","normal");
goods[1305] =new setGoods("0000a67765","110","45","90","aino","normal");
goods[1306] =new setGoods("0000a67771","120","45","90","aino","normal");
goods[1307] =new setGoods("0000a67777","130","45","90","aino","normal");
goods[1308] =new setGoods("0000a67783","140","45","90","aino","normal");
goods[1309] =new setGoods("0000a67789","150","45","90","aino","normal");
goods[1310] =new setGoods("0000a67795","160","45","90","aino","normal");
goods[1311] =new setGoods("0000a67801","170","45","90","aino","normal");
goods[1312] =new setGoods("0000a67807","180","45","90","aino","normal");
goods[1313] =new setGoods("0000a67813","60","50","90","aino","normal");
goods[1314] =new setGoods("0000a67819","70","50","90","aino","normal");
goods[1315] =new setGoods("0000a67825","80","50","90","aino","normal");
goods[1316] =new setGoods("0000a67831","90","50","90","aino","normal");
goods[1317] =new setGoods("0000a67837","100","50","90","aino","normal");
goods[1318] =new setGoods("0000a67843","110","50","90","aino","normal");
goods[1319] =new setGoods("0000a67849","120","50","90","aino","normal");
goods[1320] =new setGoods("0000a67855","130","50","90","aino","normal");
goods[1321] =new setGoods("0000a67861","140","50","90","aino","normal");
goods[1322] =new setGoods("0000a67867","150","50","90","aino","normal");
goods[1323] =new setGoods("0000a67873","160","50","90","aino","normal");
goods[1324] =new setGoods("0000a67879","170","50","90","aino","normal");
goods[1325] =new setGoods("0000a67885","180","50","90","aino","normal");
goods[1326] =new setGoods("0000a67891","60","55","90","aino","normal");
goods[1327] =new setGoods("0000a67897","70","55","90","aino","normal");
goods[1328] =new setGoods("0000a67903","80","55","90","aino","normal");
goods[1329] =new setGoods("0000a67909","90","55","90","aino","normal");
goods[1330] =new setGoods("0000a67915","100","55","90","aino","normal");
goods[1331] =new setGoods("0000a67921","110","55","90","aino","normal");
goods[1332] =new setGoods("0000a67927","120","55","90","aino","normal");
goods[1333] =new setGoods("0000a67933","130","55","90","aino","normal");
goods[1334] =new setGoods("0000a67939","140","55","90","aino","normal");
goods[1335] =new setGoods("0000a67945","150","55","90","aino","normal");
goods[1336] =new setGoods("0000a67951","160","55","90","aino","normal");
goods[1337] =new setGoods("0000a67957","170","55","90","aino","normal");
goods[1338] =new setGoods("0000a67963","180","55","90","aino","normal");
goods[1339] =new setGoods("0000a67969","60","60","90","aino","normal");
goods[1340] =new setGoods("0000a67975","70","60","90","aino","normal");
goods[1341] =new setGoods("0000a67981","80","60","90","aino","normal");
goods[1342] =new setGoods("0000a67987","90","60","90","aino","normal");
goods[1343] =new setGoods("0000a67993","100","60","90","aino","normal");
goods[1344] =new setGoods("0000a67999","110","60","90","aino","normal");
goods[1345] =new setGoods("0000a68005","120","60","90","aino","normal");
goods[1346] =new setGoods("0000a68011","130","60","90","aino","normal");
goods[1347] =new setGoods("0000a68017","140","60","90","aino","normal");
goods[1348] =new setGoods("0000a68023","150","60","90","aino","normal");
goods[1349] =new setGoods("0000a68029","160","60","90","aino","normal");
goods[1350] =new setGoods("0000a68035","170","60","90","aino","normal");
goods[1351] =new setGoods("0000a68041","180","60","90","aino","normal");
goods[1352] =new setGoods("0000a68047","60","25","100","aino","normal");
goods[1353] =new setGoods("0000a68053","70","25","100","aino","normal");
goods[1354] =new setGoods("0000a68059","80","25","100","aino","normal");
goods[1355] =new setGoods("0000a68065","90","25","100","aino","normal");
goods[1356] =new setGoods("0000a68071","100","25","100","aino","normal");
goods[1357] =new setGoods("0000a68077","110","25","100","aino","normal");
goods[1358] =new setGoods("0000a68083","120","25","100","aino","normal");
goods[1359] =new setGoods("0000a68089","130","25","100","aino","normal");
goods[1360] =new setGoods("0000a68095","140","25","100","aino","normal");
goods[1361] =new setGoods("0000a68101","150","25","100","aino","normal");
goods[1362] =new setGoods("0000a68107","160","25","100","aino","normal");
goods[1363] =new setGoods("0000a68113","170","25","100","aino","normal");
goods[1364] =new setGoods("0000a68119","180","25","100","aino","normal");
goods[1365] =new setGoods("0000a68125","60","30","100","aino","normal");
goods[1366] =new setGoods("0000a68131","70","30","100","aino","normal");
goods[1367] =new setGoods("0000a68137","80","30","100","aino","normal");
goods[1368] =new setGoods("0000a68143","90","30","100","aino","normal");
goods[1369] =new setGoods("0000a68149","100","30","100","aino","normal");
goods[1370] =new setGoods("0000a68155","110","30","100","aino","normal");
goods[1371] =new setGoods("0000a68161","120","30","100","aino","normal");
goods[1372] =new setGoods("0000a68167","130","30","100","aino","normal");
goods[1373] =new setGoods("0000a68173","140","30","100","aino","normal");
goods[1374] =new setGoods("0000a68179","150","30","100","aino","normal");
goods[1375] =new setGoods("0000a68185","160","30","100","aino","normal");
goods[1376] =new setGoods("0000a68191","170","30","100","aino","normal");
goods[1377] =new setGoods("0000a68197","180","30","100","aino","normal");
goods[1378] =new setGoods("0000a68203","60","35","100","aino","normal");
goods[1379] =new setGoods("0000a68209","70","35","100","aino","normal");
goods[1380] =new setGoods("0000a68215","80","35","100","aino","normal");
goods[1381] =new setGoods("0000a68221","90","35","100","aino","normal");
goods[1382] =new setGoods("0000a68227","100","35","100","aino","normal");
goods[1383] =new setGoods("0000a68233","110","35","100","aino","normal");
goods[1384] =new setGoods("0000a68239","120","35","100","aino","normal");
goods[1385] =new setGoods("0000a68245","130","35","100","aino","normal");
goods[1386] =new setGoods("0000a68251","140","35","100","aino","normal");
goods[1387] =new setGoods("0000a68257","150","35","100","aino","normal");
goods[1388] =new setGoods("0000a68263","160","35","100","aino","normal");
goods[1389] =new setGoods("0000a68269","170","35","100","aino","normal");
goods[1390] =new setGoods("0000a68275","180","35","100","aino","normal");
goods[1391] =new setGoods("0000a68281","60","40","100","aino","normal");
goods[1392] =new setGoods("0000a68287","70","40","100","aino","normal");
goods[1393] =new setGoods("0000a68293","80","40","100","aino","normal");
goods[1394] =new setGoods("0000a68299","90","40","100","aino","normal");
goods[1395] =new setGoods("0000a68305","100","40","100","aino","normal");
goods[1396] =new setGoods("0000a68311","110","40","100","aino","normal");
goods[1397] =new setGoods("0000a68317","120","40","100","aino","normal");
goods[1398] =new setGoods("0000a68323","130","40","100","aino","normal");
goods[1399] =new setGoods("0000a68329","140","40","100","aino","normal");
goods[1400] =new setGoods("0000a68335","150","40","100","aino","normal");
goods[1401] =new setGoods("0000a68341","160","40","100","aino","normal");
goods[1402] =new setGoods("0000a68347","170","40","100","aino","normal");
goods[1403] =new setGoods("0000a68353","180","40","100","aino","normal");
goods[1404] =new setGoods("0000a68359","60","45","100","aino","normal");
goods[1405] =new setGoods("0000a68365","70","45","100","aino","normal");
goods[1406] =new setGoods("0000a68371","80","45","100","aino","normal");
goods[1407] =new setGoods("0000a68377","90","45","100","aino","normal");
goods[1408] =new setGoods("0000a68383","100","45","100","aino","normal");
goods[1409] =new setGoods("0000a68389","110","45","100","aino","normal");
goods[1410] =new setGoods("0000a68395","120","45","100","aino","normal");
goods[1411] =new setGoods("0000a68401","130","45","100","aino","normal");
goods[1412] =new setGoods("0000a68407","140","45","100","aino","normal");
goods[1413] =new setGoods("0000a68413","150","45","100","aino","normal");
goods[1414] =new setGoods("0000a68419","160","45","100","aino","normal");
goods[1415] =new setGoods("0000a68425","170","45","100","aino","normal");
goods[1416] =new setGoods("0000a68431","180","45","100","aino","normal");
goods[1417] =new setGoods("0000a68437","60","50","100","aino","normal");
goods[1418] =new setGoods("0000a68443","70","50","100","aino","normal");
goods[1419] =new setGoods("0000a68449","80","50","100","aino","normal");
goods[1420] =new setGoods("0000a68455","90","50","100","aino","normal");
goods[1421] =new setGoods("0000a68461","100","50","100","aino","normal");
goods[1422] =new setGoods("0000a68467","110","50","100","aino","normal");
goods[1423] =new setGoods("0000a68473","120","50","100","aino","normal");
goods[1424] =new setGoods("0000a68479","130","50","100","aino","normal");
goods[1425] =new setGoods("0000a68485","140","50","100","aino","normal");
goods[1426] =new setGoods("0000a68491","150","50","100","aino","normal");
goods[1427] =new setGoods("0000a68497","160","50","100","aino","normal");
goods[1428] =new setGoods("0000a68503","170","50","100","aino","normal");
goods[1429] =new setGoods("0000a68509","180","50","100","aino","normal");
goods[1430] =new setGoods("0000a68515","60","55","100","aino","normal");
goods[1431] =new setGoods("0000a68521","70","55","100","aino","normal");
goods[1432] =new setGoods("0000a68527","80","55","100","aino","normal");
goods[1433] =new setGoods("0000a68533","90","55","100","aino","normal");
goods[1434] =new setGoods("0000a68539","100","55","100","aino","normal");
goods[1435] =new setGoods("0000a68545","110","55","100","aino","normal");
goods[1436] =new setGoods("0000a68551","120","55","100","aino","normal");
goods[1437] =new setGoods("0000a68557","130","55","100","aino","normal");
goods[1438] =new setGoods("0000a68563","140","55","100","aino","normal");
goods[1439] =new setGoods("0000a68569","150","55","100","aino","normal");
goods[1440] =new setGoods("0000a68575","160","55","100","aino","normal");
goods[1441] =new setGoods("0000a68581","170","55","100","aino","normal");
goods[1442] =new setGoods("0000a68587","180","55","100","aino","normal");
goods[1443] =new setGoods("0000a68593","60","60","100","aino","normal");
goods[1444] =new setGoods("0000a68599","70","60","100","aino","normal");
goods[1445] =new setGoods("0000a68605","80","60","100","aino","normal");
goods[1446] =new setGoods("0000a68611","90","60","100","aino","normal");
goods[1447] =new setGoods("0000a68617","100","60","100","aino","normal");
goods[1448] =new setGoods("0000a68623","110","60","100","aino","normal");
goods[1449] =new setGoods("0000a68629","120","60","100","aino","normal");
goods[1450] =new setGoods("0000a68635","130","60","100","aino","normal");
goods[1451] =new setGoods("0000a68641","140","60","100","aino","normal");
goods[1452] =new setGoods("0000a68647","150","60","100","aino","normal");
goods[1453] =new setGoods("0000a68653","160","60","100","aino","normal");
goods[1454] =new setGoods("0000a68659","170","60","100","aino","normal");
goods[1455] =new setGoods("0000a68665","180","60","100","aino","normal");

goods[1456] =new setGoods("0000a92092","60","25","40","nail","normal");
goods[1457] =new setGoods("0000a92093","70","25","40","nail","normal");
goods[1458] =new setGoods("0000a92094","80","25","40","nail","normal");
goods[1459] =new setGoods("0000a92095","90","25","40","nail","normal");
goods[1460] =new setGoods("0000a92096","100","25","40","nail","normal");
goods[1461] =new setGoods("0000a92097","110","25","40","nail","normal");
goods[1462] =new setGoods("0000a92098","120","25","40","nail","normal");
goods[1463] =new setGoods("0000a92099","130","25","40","nail","normal");
goods[1464] =new setGoods("0000a92100","140","25","40","nail","normal");
goods[1465] =new setGoods("0000a92101","150","25","40","nail","normal");
goods[1466] =new setGoods("0000a92102","160","25","40","nail","normal");
goods[1467] =new setGoods("0000a92103","170","25","40","nail","normal");
goods[1468] =new setGoods("0000a92104","180","25","40","nail","normal");
goods[1469] =new setGoods("0000a92105","60","30","40","nail","normal");
goods[1470] =new setGoods("0000a92106","70","30","40","nail","normal");
goods[1471] =new setGoods("0000a92107","80","30","40","nail","normal");
goods[1472] =new setGoods("0000a92108","90","30","40","nail","normal");
goods[1473] =new setGoods("0000a92109","100","30","40","nail","normal");
goods[1474] =new setGoods("0000a92110","110","30","40","nail","normal");
goods[1475] =new setGoods("0000a92111","120","30","40","nail","normal");
goods[1476] =new setGoods("0000a92112","130","30","40","nail","normal");
goods[1477] =new setGoods("0000a92113","140","30","40","nail","normal");
goods[1478] =new setGoods("0000a92114","150","30","40","nail","normal");
goods[1479] =new setGoods("0000a92115","160","30","40","nail","normal");
goods[1480] =new setGoods("0000a92116","170","30","40","nail","normal");
goods[1481] =new setGoods("0000a92117","180","30","40","nail","normal");
goods[1482] =new setGoods("0000a92118","60","35","40","nail","normal");
goods[1483] =new setGoods("0000a92119","70","35","40","nail","normal");
goods[1484] =new setGoods("0000a92120","80","35","40","nail","normal");
goods[1485] =new setGoods("0000a92121","90","35","40","nail","normal");
goods[1486] =new setGoods("0000a92122","100","35","40","nail","normal");
goods[1487] =new setGoods("0000a92123","110","35","40","nail","normal");
goods[1488] =new setGoods("0000a92124","120","35","40","nail","normal");
goods[1489] =new setGoods("0000a92125","130","35","40","nail","normal");
goods[1490] =new setGoods("0000a92126","140","35","40","nail","normal");
goods[1491] =new setGoods("0000a92127","150","35","40","nail","normal");
goods[1492] =new setGoods("0000a92128","160","35","40","nail","normal");
goods[1493] =new setGoods("0000a92129","170","35","40","nail","normal");
goods[1494] =new setGoods("0000a92130","180","35","40","nail","normal");
goods[1495] =new setGoods("0000a92131","60","40","40","nail","normal");
goods[1496] =new setGoods("0000a92132","70","40","40","nail","normal");
goods[1497] =new setGoods("0000a92133","80","40","40","nail","normal");
goods[1498] =new setGoods("0000a92134","90","40","40","nail","normal");
goods[1499] =new setGoods("0000a92135","100","40","40","nail","normal");
goods[1500] =new setGoods("0000a92136","110","40","40","nail","normal");
goods[1501] =new setGoods("0000a92137","120","40","40","nail","normal");
goods[1502] =new setGoods("0000a92138","130","40","40","nail","normal");
goods[1503] =new setGoods("0000a92139","140","40","40","nail","normal");
goods[1504] =new setGoods("0000a92140","150","40","40","nail","normal");
goods[1505] =new setGoods("0000a92141","160","40","40","nail","normal");
goods[1506] =new setGoods("0000a92142","170","40","40","nail","normal");
goods[1507] =new setGoods("0000a92143","180","40","40","nail","normal");
goods[1508] =new setGoods("0000a92144","60","45","40","nail","normal");
goods[1509] =new setGoods("0000a92145","70","45","40","nail","normal");
goods[1510] =new setGoods("0000a92146","80","45","40","nail","normal");
goods[1511] =new setGoods("0000a92147","90","45","40","nail","normal");
goods[1512] =new setGoods("0000a92148","100","45","40","nail","normal");
goods[1513] =new setGoods("0000a92149","110","45","40","nail","normal");
goods[1514] =new setGoods("0000a92150","120","45","40","nail","normal");
goods[1515] =new setGoods("0000a92151","130","45","40","nail","normal");
goods[1516] =new setGoods("0000a92152","140","45","40","nail","normal");
goods[1517] =new setGoods("0000a92153","150","45","40","nail","normal");
goods[1518] =new setGoods("0000a92154","160","45","40","nail","normal");
goods[1519] =new setGoods("0000a92155","170","45","40","nail","normal");
goods[1520] =new setGoods("0000a92156","180","45","40","nail","normal");
goods[1521] =new setGoods("0000a92157","60","50","40","nail","normal");
goods[1522] =new setGoods("0000a92158","70","50","40","nail","normal");
goods[1523] =new setGoods("0000a92159","80","50","40","nail","normal");
goods[1524] =new setGoods("0000a92160","90","50","40","nail","normal");
goods[1525] =new setGoods("0000a92161","100","50","40","nail","normal");
goods[1526] =new setGoods("0000a92162","110","50","40","nail","normal");
goods[1527] =new setGoods("0000a92163","120","50","40","nail","normal");
goods[1528] =new setGoods("0000a92164","130","50","40","nail","normal");
goods[1529] =new setGoods("0000a92165","140","50","40","nail","normal");
goods[1530] =new setGoods("0000a92166","150","50","40","nail","normal");
goods[1531] =new setGoods("0000a92167","160","50","40","nail","normal");
goods[1532] =new setGoods("0000a92168","170","50","40","nail","normal");
goods[1533] =new setGoods("0000a92169","180","50","40","nail","normal");
goods[1534] =new setGoods("0000a92170","60","55","40","nail","normal");
goods[1535] =new setGoods("0000a92171","70","55","40","nail","normal");
goods[1536] =new setGoods("0000a92172","80","55","40","nail","normal");
goods[1537] =new setGoods("0000a92173","90","55","40","nail","normal");
goods[1538] =new setGoods("0000a92174","100","55","40","nail","normal");
goods[1539] =new setGoods("0000a92175","110","55","40","nail","normal");
goods[1540] =new setGoods("0000a92176","120","55","40","nail","normal");
goods[1541] =new setGoods("0000a92177","130","55","40","nail","normal");
goods[1542] =new setGoods("0000a92178","140","55","40","nail","normal");
goods[1543] =new setGoods("0000a92179","150","55","40","nail","normal");
goods[1544] =new setGoods("0000a92180","160","55","40","nail","normal");
goods[1545] =new setGoods("0000a92181","170","55","40","nail","normal");
goods[1546] =new setGoods("0000a92182","180","55","40","nail","normal");
goods[1547] =new setGoods("0000a92183","60","60","40","nail","normal");
goods[1548] =new setGoods("0000a92184","70","60","40","nail","normal");
goods[1549] =new setGoods("0000a92185","80","60","40","nail","normal");
goods[1550] =new setGoods("0000a92186","90","60","40","nail","normal");
goods[1551] =new setGoods("0000a92187","100","60","40","nail","normal");
goods[1552] =new setGoods("0000a92188","110","60","40","nail","normal");
goods[1553] =new setGoods("0000a92189","120","60","40","nail","normal");
goods[1554] =new setGoods("0000a92190","130","60","40","nail","normal");
goods[1555] =new setGoods("0000a92191","140","60","40","nail","normal");
goods[1556] =new setGoods("0000a92192","150","60","40","nail","normal");
goods[1557] =new setGoods("0000a92193","160","60","40","nail","normal");
goods[1558] =new setGoods("0000a92194","170","60","40","nail","normal");
goods[1559] =new setGoods("0000a92195","180","60","40","nail","normal");
goods[1560] =new setGoods("0000a92196","60","25","50","nail","normal");
goods[1561] =new setGoods("0000a92197","70","25","50","nail","normal");
goods[1562] =new setGoods("0000a92198","80","25","50","nail","normal");
goods[1563] =new setGoods("0000a92199","90","25","50","nail","normal");
goods[1564] =new setGoods("0000a92200","100","25","50","nail","normal");
goods[1565] =new setGoods("0000a92201","110","25","50","nail","normal");
goods[1566] =new setGoods("0000a92202","120","25","50","nail","normal");
goods[1567] =new setGoods("0000a92203","130","25","50","nail","normal");
goods[1568] =new setGoods("0000a92204","140","25","50","nail","normal");
goods[1569] =new setGoods("0000a92205","150","25","50","nail","normal");
goods[1570] =new setGoods("0000a92206","160","25","50","nail","normal");
goods[1571] =new setGoods("0000a92207","170","25","50","nail","normal");
goods[1572] =new setGoods("0000a92208","180","25","50","nail","normal");
goods[1573] =new setGoods("0000a92209","60","30","50","nail","normal");
goods[1574] =new setGoods("0000a92210","70","30","50","nail","normal");
goods[1575] =new setGoods("0000a92211","80","30","50","nail","normal");
goods[1576] =new setGoods("0000a92212","90","30","50","nail","normal");
goods[1577] =new setGoods("0000a92213","100","30","50","nail","normal");
goods[1578] =new setGoods("0000a92214","110","30","50","nail","normal");
goods[1579] =new setGoods("0000a92215","120","30","50","nail","normal");
goods[1580] =new setGoods("0000a92216","130","30","50","nail","normal");
goods[1581] =new setGoods("0000a92217","140","30","50","nail","normal");
goods[1582] =new setGoods("0000a92218","150","30","50","nail","normal");
goods[1583] =new setGoods("0000a92219","160","30","50","nail","normal");
goods[1584] =new setGoods("0000a92220","170","30","50","nail","normal");
goods[1585] =new setGoods("0000a92221","180","30","50","nail","normal");
goods[1586] =new setGoods("0000a92222","60","35","50","nail","normal");
goods[1587] =new setGoods("0000a92223","70","35","50","nail","normal");
goods[1588] =new setGoods("0000a92224","80","35","50","nail","normal");
goods[1589] =new setGoods("0000a92225","90","35","50","nail","normal");
goods[1590] =new setGoods("0000a92226","100","35","50","nail","normal");
goods[1591] =new setGoods("0000a92227","110","35","50","nail","normal");
goods[1592] =new setGoods("0000a92228","120","35","50","nail","normal");
goods[1593] =new setGoods("0000a92229","130","35","50","nail","normal");
goods[1594] =new setGoods("0000a92230","140","35","50","nail","normal");
goods[1595] =new setGoods("0000a92231","150","35","50","nail","normal");
goods[1596] =new setGoods("0000a92232","160","35","50","nail","normal");
goods[1597] =new setGoods("0000a92233","170","35","50","nail","normal");
goods[1598] =new setGoods("0000a92234","180","35","50","nail","normal");
goods[1599] =new setGoods("0000a92235","60","40","50","nail","normal");
goods[1600] =new setGoods("0000a92236","70","40","50","nail","normal");
goods[1601] =new setGoods("0000a92237","80","40","50","nail","normal");
goods[1602] =new setGoods("0000a92238","90","40","50","nail","normal");
goods[1603] =new setGoods("0000a92239","100","40","50","nail","normal");
goods[1604] =new setGoods("0000a92240","110","40","50","nail","normal");
goods[1605] =new setGoods("0000a92241","120","40","50","nail","normal");
goods[1606] =new setGoods("0000a92242","130","40","50","nail","normal");
goods[1607] =new setGoods("0000a92243","140","40","50","nail","normal");
goods[1608] =new setGoods("0000a92244","150","40","50","nail","normal");
goods[1609] =new setGoods("0000a92245","160","40","50","nail","normal");
goods[1610] =new setGoods("0000a92246","170","40","50","nail","normal");
goods[1611] =new setGoods("0000a92247","180","40","50","nail","normal");
goods[1612] =new setGoods("0000a92248","60","45","50","nail","normal");
goods[1613] =new setGoods("0000a92249","70","45","50","nail","normal");
goods[1614] =new setGoods("0000a92250","80","45","50","nail","normal");
goods[1615] =new setGoods("0000a92251","90","45","50","nail","normal");
goods[1616] =new setGoods("0000a92252","100","45","50","nail","normal");
goods[1617] =new setGoods("0000a92253","110","45","50","nail","normal");
goods[1618] =new setGoods("0000a92254","120","45","50","nail","normal");
goods[1619] =new setGoods("0000a92255","130","45","50","nail","normal");
goods[1620] =new setGoods("0000a92256","140","45","50","nail","normal");
goods[1621] =new setGoods("0000a92257","150","45","50","nail","normal");
goods[1622] =new setGoods("0000a92258","160","45","50","nail","normal");
goods[1623] =new setGoods("0000a92259","170","45","50","nail","normal");
goods[1624] =new setGoods("0000a92260","180","45","50","nail","normal");
goods[1625] =new setGoods("0000a92261","60","50","50","nail","normal");
goods[1626] =new setGoods("0000a92262","70","50","50","nail","normal");
goods[1627] =new setGoods("0000a92263","80","50","50","nail","normal");
goods[1628] =new setGoods("0000a92264","90","50","50","nail","normal");
goods[1629] =new setGoods("0000a92265","100","50","50","nail","normal");
goods[1630] =new setGoods("0000a92266","110","50","50","nail","normal");
goods[1631] =new setGoods("0000a92267","120","50","50","nail","normal");
goods[1632] =new setGoods("0000a92268","130","50","50","nail","normal");
goods[1633] =new setGoods("0000a92269","140","50","50","nail","normal");
goods[1634] =new setGoods("0000a92270","150","50","50","nail","normal");
goods[1635] =new setGoods("0000a92271","160","50","50","nail","normal");
goods[1636] =new setGoods("0000a92272","170","50","50","nail","normal");
goods[1637] =new setGoods("0000a92273","180","50","50","nail","normal");
goods[1638] =new setGoods("0000a92274","60","55","50","nail","normal");
goods[1639] =new setGoods("0000a92275","70","55","50","nail","normal");
goods[1640] =new setGoods("0000a92276","80","55","50","nail","normal");
goods[1641] =new setGoods("0000a92277","90","55","50","nail","normal");
goods[1642] =new setGoods("0000a92278","100","55","50","nail","normal");
goods[1643] =new setGoods("0000a92279","110","55","50","nail","normal");
goods[1644] =new setGoods("0000a92280","120","55","50","nail","normal");
goods[1645] =new setGoods("0000a92281","130","55","50","nail","normal");
goods[1646] =new setGoods("0000a92282","140","55","50","nail","normal");
goods[1647] =new setGoods("0000a92283","150","55","50","nail","normal");
goods[1648] =new setGoods("0000a92284","160","55","50","nail","normal");
goods[1649] =new setGoods("0000a92285","170","55","50","nail","normal");
goods[1650] =new setGoods("0000a92286","180","55","50","nail","normal");
goods[1651] =new setGoods("0000a92287","60","60","50","nail","normal");
goods[1652] =new setGoods("0000a92288","70","60","50","nail","normal");
goods[1653] =new setGoods("0000a92289","80","60","50","nail","normal");
goods[1654] =new setGoods("0000a92290","90","60","50","nail","normal");
goods[1655] =new setGoods("0000a92291","100","60","50","nail","normal");
goods[1656] =new setGoods("0000a92292","110","60","50","nail","normal");
goods[1657] =new setGoods("0000a92293","120","60","50","nail","normal");
goods[1658] =new setGoods("0000a92294","130","60","50","nail","normal");
goods[1659] =new setGoods("0000a92295","140","60","50","nail","normal");
goods[1660] =new setGoods("0000a92296","150","60","50","nail","normal");
goods[1661] =new setGoods("0000a92297","160","60","50","nail","normal");
goods[1662] =new setGoods("0000a92298","170","60","50","nail","normal");
goods[1663] =new setGoods("0000a92299","180","60","50","nail","normal");
goods[1664] =new setGoods("0000a92300","60","25","60","nail","normal");
goods[1665] =new setGoods("0000a92301","70","25","60","nail","normal");
goods[1666] =new setGoods("0000a92302","80","25","60","nail","normal");
goods[1667] =new setGoods("0000a92303","90","25","60","nail","normal");
goods[1668] =new setGoods("0000a92304","100","25","60","nail","normal");
goods[1669] =new setGoods("0000a92305","110","25","60","nail","normal");
goods[1670] =new setGoods("0000a92306","120","25","60","nail","normal");
goods[1671] =new setGoods("0000a92307","130","25","60","nail","normal");
goods[1672] =new setGoods("0000a92308","140","25","60","nail","normal");
goods[1673] =new setGoods("0000a92309","150","25","60","nail","normal");
goods[1674] =new setGoods("0000a92310","160","25","60","nail","normal");
goods[1675] =new setGoods("0000a92311","170","25","60","nail","normal");
goods[1676] =new setGoods("0000a92312","180","25","60","nail","normal");
goods[1677] =new setGoods("0000a92313","60","30","60","nail","normal");
goods[1678] =new setGoods("0000a92314","70","30","60","nail","normal");
goods[1679] =new setGoods("0000a92315","80","30","60","nail","normal");
goods[1680] =new setGoods("0000a92316","90","30","60","nail","normal");
goods[1681] =new setGoods("0000a92317","100","30","60","nail","normal");
goods[1682] =new setGoods("0000a92318","110","30","60","nail","normal");
goods[1683] =new setGoods("0000a92319","120","30","60","nail","normal");
goods[1684] =new setGoods("0000a92320","130","30","60","nail","normal");
goods[1685] =new setGoods("0000a92321","140","30","60","nail","normal");
goods[1686] =new setGoods("0000a92322","150","30","60","nail","normal");
goods[1687] =new setGoods("0000a92323","160","30","60","nail","normal");
goods[1688] =new setGoods("0000a92324","170","30","60","nail","normal");
goods[1689] =new setGoods("0000a92325","180","30","60","nail","normal");
goods[1690] =new setGoods("0000a92326","60","35","60","nail","normal");
goods[1691] =new setGoods("0000a92327","70","35","60","nail","normal");
goods[1692] =new setGoods("0000a92328","80","35","60","nail","normal");
goods[1693] =new setGoods("0000a92329","90","35","60","nail","normal");
goods[1694] =new setGoods("0000a92330","100","35","60","nail","normal");
goods[1695] =new setGoods("0000a92331","110","35","60","nail","normal");
goods[1696] =new setGoods("0000a92332","120","35","60","nail","normal");
goods[1697] =new setGoods("0000a92333","130","35","60","nail","normal");
goods[1698] =new setGoods("0000a92334","140","35","60","nail","normal");
goods[1699] =new setGoods("0000a92335","150","35","60","nail","normal");
goods[1700] =new setGoods("0000a92336","160","35","60","nail","normal");
goods[1701] =new setGoods("0000a92337","170","35","60","nail","normal");
goods[1702] =new setGoods("0000a92338","180","35","60","nail","normal");
goods[1703] =new setGoods("0000a92339","60","40","60","nail","normal");
goods[1704] =new setGoods("0000a92340","70","40","60","nail","normal");
goods[1705] =new setGoods("0000a92341","80","40","60","nail","normal");
goods[1706] =new setGoods("0000a92342","90","40","60","nail","normal");
goods[1707] =new setGoods("0000a92343","100","40","60","nail","normal");
goods[1708] =new setGoods("0000a92344","110","40","60","nail","normal");
goods[1709] =new setGoods("0000a92345","120","40","60","nail","normal");
goods[1710] =new setGoods("0000a92346","130","40","60","nail","normal");
goods[1711] =new setGoods("0000a92347","140","40","60","nail","normal");
goods[1712] =new setGoods("0000a92348","150","40","60","nail","normal");
goods[1713] =new setGoods("0000a92349","160","40","60","nail","normal");
goods[1714] =new setGoods("0000a92350","170","40","60","nail","normal");
goods[1715] =new setGoods("0000a92351","180","40","60","nail","normal");
goods[1716] =new setGoods("0000a92352","60","45","60","nail","normal");
goods[1717] =new setGoods("0000a92353","70","45","60","nail","normal");
goods[1718] =new setGoods("0000a92354","80","45","60","nail","normal");
goods[1719] =new setGoods("0000a92355","90","45","60","nail","normal");
goods[1720] =new setGoods("0000a92356","100","45","60","nail","normal");
goods[1721] =new setGoods("0000a92357","110","45","60","nail","normal");
goods[1722] =new setGoods("0000a92358","120","45","60","nail","normal");
goods[1723] =new setGoods("0000a92359","130","45","60","nail","normal");
goods[1724] =new setGoods("0000a92360","140","45","60","nail","normal");
goods[1725] =new setGoods("0000a92361","150","45","60","nail","normal");
goods[1726] =new setGoods("0000a92362","160","45","60","nail","normal");
goods[1727] =new setGoods("0000a92363","170","45","60","nail","normal");
goods[1728] =new setGoods("0000a92364","180","45","60","nail","normal");
goods[1729] =new setGoods("0000a92365","60","50","60","nail","normal");
goods[1730] =new setGoods("0000a92366","70","50","60","nail","normal");
goods[1731] =new setGoods("0000a92367","80","50","60","nail","normal");
goods[1732] =new setGoods("0000a92368","90","50","60","nail","normal");
goods[1733] =new setGoods("0000a92369","100","50","60","nail","normal");
goods[1734] =new setGoods("0000a92370","110","50","60","nail","normal");
goods[1735] =new setGoods("0000a92371","120","50","60","nail","normal");
goods[1736] =new setGoods("0000a92372","130","50","60","nail","normal");
goods[1737] =new setGoods("0000a92373","140","50","60","nail","normal");
goods[1738] =new setGoods("0000a92374","150","50","60","nail","normal");
goods[1739] =new setGoods("0000a92375","160","50","60","nail","normal");
goods[1740] =new setGoods("0000a92376","170","50","60","nail","normal");
goods[1741] =new setGoods("0000a92377","180","50","60","nail","normal");
goods[1742] =new setGoods("0000a92378","60","55","60","nail","normal");
goods[1743] =new setGoods("0000a92379","70","55","60","nail","normal");
goods[1744] =new setGoods("0000a92380","80","55","60","nail","normal");
goods[1745] =new setGoods("0000a92381","90","55","60","nail","normal");
goods[1746] =new setGoods("0000a92382","100","55","60","nail","normal");
goods[1747] =new setGoods("0000a92383","110","55","60","nail","normal");
goods[1748] =new setGoods("0000a92384","120","55","60","nail","normal");
goods[1749] =new setGoods("0000a92385","130","55","60","nail","normal");
goods[1750] =new setGoods("0000a92386","140","55","60","nail","normal");
goods[1751] =new setGoods("0000a92387","150","55","60","nail","normal");
goods[1752] =new setGoods("0000a92388","160","55","60","nail","normal");
goods[1753] =new setGoods("0000a92389","170","55","60","nail","normal");
goods[1754] =new setGoods("0000a92390","180","55","60","nail","normal");
goods[1755] =new setGoods("0000a92391","60","60","60","nail","normal");
goods[1756] =new setGoods("0000a92392","70","60","60","nail","normal");
goods[1757] =new setGoods("0000a92393","80","60","60","nail","normal");
goods[1758] =new setGoods("0000a92394","90","60","60","nail","normal");
goods[1759] =new setGoods("0000a92395","100","60","60","nail","normal");
goods[1760] =new setGoods("0000a92396","110","60","60","nail","normal");
goods[1761] =new setGoods("0000a92397","120","60","60","nail","normal");
goods[1762] =new setGoods("0000a92398","130","60","60","nail","normal");
goods[1763] =new setGoods("0000a92399","140","60","60","nail","normal");
goods[1764] =new setGoods("0000a92400","150","60","60","nail","normal");
goods[1765] =new setGoods("0000a92401","160","60","60","nail","normal");
goods[1766] =new setGoods("0000a92402","170","60","60","nail","normal");
goods[1767] =new setGoods("0000a92403","180","60","60","nail","normal");
goods[1768] =new setGoods("0000a92404","60","25","70","nail","normal");
goods[1769] =new setGoods("0000a92405","70","25","70","nail","normal");
goods[1770] =new setGoods("0000a92406","80","25","70","nail","normal");
goods[1771] =new setGoods("0000a92407","90","25","70","nail","normal");
goods[1772] =new setGoods("0000a92408","100","25","70","nail","normal");
goods[1773] =new setGoods("0000a92409","110","25","70","nail","normal");
goods[1774] =new setGoods("0000a92410","120","25","70","nail","normal");
goods[1775] =new setGoods("0000a92411","130","25","70","nail","normal");
goods[1776] =new setGoods("0000a92412","140","25","70","nail","normal");
goods[1777] =new setGoods("0000a92413","150","25","70","nail","normal");
goods[1778] =new setGoods("0000a92414","160","25","70","nail","normal");
goods[1779] =new setGoods("0000a92415","170","25","70","nail","normal");
goods[1780] =new setGoods("0000a92416","180","25","70","nail","normal");
goods[1781] =new setGoods("0000a92417","60","30","70","nail","normal");
goods[1782] =new setGoods("0000a92418","70","30","70","nail","normal");
goods[1783] =new setGoods("0000a92419","80","30","70","nail","normal");
goods[1784] =new setGoods("0000a92420","90","30","70","nail","normal");
goods[1785] =new setGoods("0000a92421","100","30","70","nail","normal");
goods[1786] =new setGoods("0000a92422","110","30","70","nail","normal");
goods[1787] =new setGoods("0000a92423","120","30","70","nail","normal");
goods[1788] =new setGoods("0000a92424","130","30","70","nail","normal");
goods[1789] =new setGoods("0000a92425","140","30","70","nail","normal");
goods[1790] =new setGoods("0000a92426","150","30","70","nail","normal");
goods[1791] =new setGoods("0000a92427","160","30","70","nail","normal");
goods[1792] =new setGoods("0000a92428","170","30","70","nail","normal");
goods[1793] =new setGoods("0000a92429","180","30","70","nail","normal");
goods[1794] =new setGoods("0000a92430","60","35","70","nail","normal");
goods[1795] =new setGoods("0000a92431","70","35","70","nail","normal");
goods[1796] =new setGoods("0000a92432","80","35","70","nail","normal");
goods[1797] =new setGoods("0000a92433","90","35","70","nail","normal");
goods[1798] =new setGoods("0000a92434","100","35","70","nail","normal");
goods[1799] =new setGoods("0000a92435","110","35","70","nail","normal");
goods[1800] =new setGoods("0000a92436","120","35","70","nail","normal");
goods[1801] =new setGoods("0000a92437","130","35","70","nail","normal");
goods[1802] =new setGoods("0000a92438","140","35","70","nail","normal");
goods[1803] =new setGoods("0000a92439","150","35","70","nail","normal");
goods[1804] =new setGoods("0000a92440","160","35","70","nail","normal");
goods[1805] =new setGoods("0000a92441","170","35","70","nail","normal");
goods[1806] =new setGoods("0000a92442","180","35","70","nail","normal");
goods[1807] =new setGoods("0000a92443","60","40","70","nail","normal");
goods[1808] =new setGoods("0000a92444","70","40","70","nail","normal");
goods[1809] =new setGoods("0000a92445","80","40","70","nail","normal");
goods[1810] =new setGoods("0000a92446","90","40","70","nail","normal");
goods[1811] =new setGoods("0000a92447","100","40","70","nail","normal");
goods[1812] =new setGoods("0000a92448","110","40","70","nail","normal");
goods[1813] =new setGoods("0000a92449","120","40","70","nail","normal");
goods[1814] =new setGoods("0000a92450","130","40","70","nail","normal");
goods[1815] =new setGoods("0000a92451","140","40","70","nail","normal");
goods[1816] =new setGoods("0000a92452","150","40","70","nail","normal");
goods[1817] =new setGoods("0000a92453","160","40","70","nail","normal");
goods[1818] =new setGoods("0000a92454","170","40","70","nail","normal");
goods[1819] =new setGoods("0000a92455","180","40","70","nail","normal");
goods[1820] =new setGoods("0000a92456","60","45","70","nail","normal");
goods[1821] =new setGoods("0000a92457","70","45","70","nail","normal");
goods[1822] =new setGoods("0000a92458","80","45","70","nail","normal");
goods[1823] =new setGoods("0000a92459","90","45","70","nail","normal");
goods[1824] =new setGoods("0000a92460","100","45","70","nail","normal");
goods[1825] =new setGoods("0000a92461","110","45","70","nail","normal");
goods[1826] =new setGoods("0000a92462","120","45","70","nail","normal");
goods[1827] =new setGoods("0000a92463","130","45","70","nail","normal");
goods[1828] =new setGoods("0000a92464","140","45","70","nail","normal");
goods[1829] =new setGoods("0000a92465","150","45","70","nail","normal");
goods[1830] =new setGoods("0000a92466","160","45","70","nail","normal");
goods[1831] =new setGoods("0000a92467","170","45","70","nail","normal");
goods[1832] =new setGoods("0000a92468","180","45","70","nail","normal");
goods[1833] =new setGoods("0000a92469","60","50","70","nail","normal");
goods[1834] =new setGoods("0000a92470","70","50","70","nail","normal");
goods[1835] =new setGoods("0000a92471","80","50","70","nail","normal");
goods[1836] =new setGoods("0000a92472","90","50","70","nail","normal");
goods[1837] =new setGoods("0000a92473","100","50","70","nail","normal");
goods[1838] =new setGoods("0000a92474","110","50","70","nail","normal");
goods[1839] =new setGoods("0000a92475","120","50","70","nail","normal");
goods[1840] =new setGoods("0000a92476","130","50","70","nail","normal");
goods[1841] =new setGoods("0000a92477","140","50","70","nail","normal");
goods[1842] =new setGoods("0000a92478","150","50","70","nail","normal");
goods[1843] =new setGoods("0000a92479","160","50","70","nail","normal");
goods[1844] =new setGoods("0000a92480","170","50","70","nail","normal");
goods[1845] =new setGoods("0000a92481","180","50","70","nail","normal");
goods[1846] =new setGoods("0000a92482","60","55","70","nail","normal");
goods[1847] =new setGoods("0000a92483","70","55","70","nail","normal");
goods[1848] =new setGoods("0000a92484","80","55","70","nail","normal");
goods[1849] =new setGoods("0000a92485","90","55","70","nail","normal");
goods[1850] =new setGoods("0000a92486","100","55","70","nail","normal");
goods[1851] =new setGoods("0000a92487","110","55","70","nail","normal");
goods[1852] =new setGoods("0000a92488","120","55","70","nail","normal");
goods[1853] =new setGoods("0000a92489","130","55","70","nail","normal");
goods[1854] =new setGoods("0000a92490","140","55","70","nail","normal");
goods[1855] =new setGoods("0000a92491","150","55","70","nail","normal");
goods[1856] =new setGoods("0000a92492","160","55","70","nail","normal");
goods[1857] =new setGoods("0000a92493","170","55","70","nail","normal");
goods[1858] =new setGoods("0000a92494","180","55","70","nail","normal");
goods[1859] =new setGoods("0000a92495","60","60","70","nail","normal");
goods[1860] =new setGoods("0000a92496","70","60","70","nail","normal");
goods[1861] =new setGoods("0000a92497","80","60","70","nail","normal");
goods[1862] =new setGoods("0000a92498","90","60","70","nail","normal");
goods[1863] =new setGoods("0000a92499","100","60","70","nail","normal");
goods[1864] =new setGoods("0000a92500","110","60","70","nail","normal");
goods[1865] =new setGoods("0000a92501","120","60","70","nail","normal");
goods[1866] =new setGoods("0000a92502","130","60","70","nail","normal");
goods[1867] =new setGoods("0000a92503","140","60","70","nail","normal");
goods[1868] =new setGoods("0000a92504","150","60","70","nail","normal");
goods[1869] =new setGoods("0000a92505","160","60","70","nail","normal");
goods[1870] =new setGoods("0000a92506","170","60","70","nail","normal");
goods[1871] =new setGoods("0000a92507","180","60","70","nail","normal");
goods[1872] =new setGoods("0000a92508","60","25","80","nail","normal");
goods[1873] =new setGoods("0000a92509","70","25","80","nail","normal");
goods[1874] =new setGoods("0000a92510","80","25","80","nail","normal");
goods[1875] =new setGoods("0000a92511","90","25","80","nail","normal");
goods[1876] =new setGoods("0000a92512","100","25","80","nail","normal");
goods[1877] =new setGoods("0000a92513","110","25","80","nail","normal");
goods[1878] =new setGoods("0000a92514","120","25","80","nail","normal");
goods[1879] =new setGoods("0000a92515","130","25","80","nail","normal");
goods[1880] =new setGoods("0000a92516","140","25","80","nail","normal");
goods[1881] =new setGoods("0000a92517","150","25","80","nail","normal");
goods[1882] =new setGoods("0000a92518","160","25","80","nail","normal");
goods[1883] =new setGoods("0000a92519","170","25","80","nail","normal");
goods[1884] =new setGoods("0000a92520","180","25","80","nail","normal");
goods[1885] =new setGoods("0000a92521","60","30","80","nail","normal");
goods[1886] =new setGoods("0000a92522","70","30","80","nail","normal");
goods[1887] =new setGoods("0000a92523","80","30","80","nail","normal");
goods[1888] =new setGoods("0000a92524","90","30","80","nail","normal");
goods[1889] =new setGoods("0000a92525","100","30","80","nail","normal");
goods[1890] =new setGoods("0000a92526","110","30","80","nail","normal");
goods[1891] =new setGoods("0000a92527","120","30","80","nail","normal");
goods[1892] =new setGoods("0000a92528","130","30","80","nail","normal");
goods[1893] =new setGoods("0000a92529","140","30","80","nail","normal");
goods[1894] =new setGoods("0000a92530","150","30","80","nail","normal");
goods[1895] =new setGoods("0000a92531","160","30","80","nail","normal");
goods[1896] =new setGoods("0000a92532","170","30","80","nail","normal");
goods[1897] =new setGoods("0000a92533","180","30","80","nail","normal");
goods[1898] =new setGoods("0000a92534","60","35","80","nail","normal");
goods[1899] =new setGoods("0000a92535","70","35","80","nail","normal");
goods[1900] =new setGoods("0000a92536","80","35","80","nail","normal");
goods[1901] =new setGoods("0000a92537","90","35","80","nail","normal");
goods[1902] =new setGoods("0000a92538","100","35","80","nail","normal");
goods[1903] =new setGoods("0000a92539","110","35","80","nail","normal");
goods[1904] =new setGoods("0000a92540","120","35","80","nail","normal");
goods[1905] =new setGoods("0000a92541","130","35","80","nail","normal");
goods[1906] =new setGoods("0000a92542","140","35","80","nail","normal");
goods[1907] =new setGoods("0000a92543","150","35","80","nail","normal");
goods[1908] =new setGoods("0000a92544","160","35","80","nail","normal");
goods[1909] =new setGoods("0000a92545","170","35","80","nail","normal");
goods[1910] =new setGoods("0000a92546","180","35","80","nail","normal");
goods[1911] =new setGoods("0000a92547","60","40","80","nail","normal");
goods[1912] =new setGoods("0000a92548","70","40","80","nail","normal");
goods[1913] =new setGoods("0000a92549","80","40","80","nail","normal");
goods[1914] =new setGoods("0000a92550","90","40","80","nail","normal");
goods[1915] =new setGoods("0000a92551","100","40","80","nail","normal");
goods[1916] =new setGoods("0000a92552","110","40","80","nail","normal");
goods[1917] =new setGoods("0000a92553","120","40","80","nail","normal");
goods[1918] =new setGoods("0000a92554","130","40","80","nail","normal");
goods[1919] =new setGoods("0000a92555","140","40","80","nail","normal");
goods[1920] =new setGoods("0000a92556","150","40","80","nail","normal");
goods[1921] =new setGoods("0000a92557","160","40","80","nail","normal");
goods[1922] =new setGoods("0000a92558","170","40","80","nail","normal");
goods[1923] =new setGoods("0000a92559","180","40","80","nail","normal");
goods[1924] =new setGoods("0000a92560","60","45","80","nail","normal");
goods[1925] =new setGoods("0000a92561","70","45","80","nail","normal");
goods[1926] =new setGoods("0000a92562","80","45","80","nail","normal");
goods[1927] =new setGoods("0000a92563","90","45","80","nail","normal");
goods[1928] =new setGoods("0000a92564","100","45","80","nail","normal");
goods[1929] =new setGoods("0000a92565","110","45","80","nail","normal");
goods[1930] =new setGoods("0000a92566","120","45","80","nail","normal");
goods[1931] =new setGoods("0000a92567","130","45","80","nail","normal");
goods[1932] =new setGoods("0000a92568","140","45","80","nail","normal");
goods[1933] =new setGoods("0000a92569","150","45","80","nail","normal");
goods[1934] =new setGoods("0000a92570","160","45","80","nail","normal");
goods[1935] =new setGoods("0000a92571","170","45","80","nail","normal");
goods[1936] =new setGoods("0000a92572","180","45","80","nail","normal");
goods[1937] =new setGoods("0000a92573","60","50","80","nail","normal");
goods[1938] =new setGoods("0000a92574","70","50","80","nail","normal");
goods[1939] =new setGoods("0000a92575","80","50","80","nail","normal");
goods[1940] =new setGoods("0000a92576","90","50","80","nail","normal");
goods[1941] =new setGoods("0000a92577","100","50","80","nail","normal");
goods[1942] =new setGoods("0000a92578","110","50","80","nail","normal");
goods[1943] =new setGoods("0000a92579","120","50","80","nail","normal");
goods[1944] =new setGoods("0000a92580","130","50","80","nail","normal");
goods[1945] =new setGoods("0000a92581","140","50","80","nail","normal");
goods[1946] =new setGoods("0000a92582","150","50","80","nail","normal");
goods[1947] =new setGoods("0000a92583","160","50","80","nail","normal");
goods[1948] =new setGoods("0000a92584","170","50","80","nail","normal");
goods[1949] =new setGoods("0000a92585","180","50","80","nail","normal");
goods[1950] =new setGoods("0000a92586","60","55","80","nail","normal");
goods[1951] =new setGoods("0000a92587","70","55","80","nail","normal");
goods[1952] =new setGoods("0000a92588","80","55","80","nail","normal");
goods[1953] =new setGoods("0000a92589","90","55","80","nail","normal");
goods[1954] =new setGoods("0000a92590","100","55","80","nail","normal");
goods[1955] =new setGoods("0000a92591","110","55","80","nail","normal");
goods[1956] =new setGoods("0000a92592","120","55","80","nail","normal");
goods[1957] =new setGoods("0000a92593","130","55","80","nail","normal");
goods[1958] =new setGoods("0000a92594","140","55","80","nail","normal");
goods[1959] =new setGoods("0000a92595","150","55","80","nail","normal");
goods[1960] =new setGoods("0000a92596","160","55","80","nail","normal");
goods[1961] =new setGoods("0000a92597","170","55","80","nail","normal");
goods[1962] =new setGoods("0000a92598","180","55","80","nail","normal");
goods[1963] =new setGoods("0000a92599","60","60","80","nail","normal");
goods[1964] =new setGoods("0000a92600","70","60","80","nail","normal");
goods[1965] =new setGoods("0000a92601","80","60","80","nail","normal");
goods[1966] =new setGoods("0000a92602","90","60","80","nail","normal");
goods[1967] =new setGoods("0000a92603","100","60","80","nail","normal");
goods[1968] =new setGoods("0000a92604","110","60","80","nail","normal");
goods[1969] =new setGoods("0000a92605","120","60","80","nail","normal");
goods[1970] =new setGoods("0000a92606","130","60","80","nail","normal");
goods[1971] =new setGoods("0000a92607","140","60","80","nail","normal");
goods[1972] =new setGoods("0000a92608","150","60","80","nail","normal");
goods[1973] =new setGoods("0000a92609","160","60","80","nail","normal");
goods[1974] =new setGoods("0000a92610","170","60","80","nail","normal");
goods[1975] =new setGoods("0000a92611","180","60","80","nail","normal");
goods[1976] =new setGoods("0000a92612","60","25","90","nail","normal");
goods[1977] =new setGoods("0000a92613","70","25","90","nail","normal");
goods[1978] =new setGoods("0000a92614","80","25","90","nail","normal");
goods[1979] =new setGoods("0000a92615","90","25","90","nail","normal");
goods[1980] =new setGoods("0000a92616","100","25","90","nail","normal");
goods[1981] =new setGoods("0000a92617","110","25","90","nail","normal");
goods[1982] =new setGoods("0000a92618","120","25","90","nail","normal");
goods[1983] =new setGoods("0000a92619","130","25","90","nail","normal");
goods[1984] =new setGoods("0000a92620","140","25","90","nail","normal");
goods[1985] =new setGoods("0000a92621","150","25","90","nail","normal");
goods[1986] =new setGoods("0000a92622","160","25","90","nail","normal");
goods[1987] =new setGoods("0000a92623","170","25","90","nail","normal");
goods[1988] =new setGoods("0000a92624","180","25","90","nail","normal");
goods[1989] =new setGoods("0000a92625","60","30","90","nail","normal");
goods[1990] =new setGoods("0000a92626","70","30","90","nail","normal");
goods[1991] =new setGoods("0000a92627","80","30","90","nail","normal");
goods[1992] =new setGoods("0000a92628","90","30","90","nail","normal");
goods[1993] =new setGoods("0000a92629","100","30","90","nail","normal");
goods[1994] =new setGoods("0000a92630","110","30","90","nail","normal");
goods[1995] =new setGoods("0000a92631","120","30","90","nail","normal");
goods[1996] =new setGoods("0000a92632","130","30","90","nail","normal");
goods[1997] =new setGoods("0000a92633","140","30","90","nail","normal");
goods[1998] =new setGoods("0000a92634","150","30","90","nail","normal");
goods[1999] =new setGoods("0000a92635","160","30","90","nail","normal");
goods[2000] =new setGoods("0000a92636","170","30","90","nail","normal");
goods[2001] =new setGoods("0000a92637","180","30","90","nail","normal");
goods[2002] =new setGoods("0000a92638","60","35","90","nail","normal");
goods[2003] =new setGoods("0000a92639","70","35","90","nail","normal");
goods[2004] =new setGoods("0000a92640","80","35","90","nail","normal");
goods[2005] =new setGoods("0000a92641","90","35","90","nail","normal");
goods[2006] =new setGoods("0000a92642","100","35","90","nail","normal");
goods[2007] =new setGoods("0000a92643","110","35","90","nail","normal");
goods[2008] =new setGoods("0000a92644","120","35","90","nail","normal");
goods[2009] =new setGoods("0000a92645","130","35","90","nail","normal");
goods[2010] =new setGoods("0000a92646","140","35","90","nail","normal");
goods[2011] =new setGoods("0000a92647","150","35","90","nail","normal");
goods[2012] =new setGoods("0000a92648","160","35","90","nail","normal");
goods[2013] =new setGoods("0000a92649","170","35","90","nail","normal");
goods[2014] =new setGoods("0000a92650","180","35","90","nail","normal");
goods[2015] =new setGoods("0000a92651","60","40","90","nail","normal");
goods[2016] =new setGoods("0000a92652","70","40","90","nail","normal");
goods[2017] =new setGoods("0000a92653","80","40","90","nail","normal");
goods[2018] =new setGoods("0000a92654","90","40","90","nail","normal");
goods[2019] =new setGoods("0000a92655","100","40","90","nail","normal");
goods[2020] =new setGoods("0000a92656","110","40","90","nail","normal");
goods[2021] =new setGoods("0000a92657","120","40","90","nail","normal");
goods[2022] =new setGoods("0000a92658","130","40","90","nail","normal");
goods[2023] =new setGoods("0000a92659","140","40","90","nail","normal");
goods[2024] =new setGoods("0000a92660","150","40","90","nail","normal");
goods[2025] =new setGoods("0000a92661","160","40","90","nail","normal");
goods[2026] =new setGoods("0000a92662","170","40","90","nail","normal");
goods[2027] =new setGoods("0000a92663","180","40","90","nail","normal");
goods[2028] =new setGoods("0000a92664","60","45","90","nail","normal");
goods[2029] =new setGoods("0000a92665","70","45","90","nail","normal");
goods[2030] =new setGoods("0000a92666","80","45","90","nail","normal");
goods[2031] =new setGoods("0000a92667","90","45","90","nail","normal");
goods[2032] =new setGoods("0000a92668","100","45","90","nail","normal");
goods[2033] =new setGoods("0000a92669","110","45","90","nail","normal");
goods[2034] =new setGoods("0000a92670","120","45","90","nail","normal");
goods[2035] =new setGoods("0000a92671","130","45","90","nail","normal");
goods[2036] =new setGoods("0000a92672","140","45","90","nail","normal");
goods[2037] =new setGoods("0000a92673","150","45","90","nail","normal");
goods[2038] =new setGoods("0000a92674","160","45","90","nail","normal");
goods[2039] =new setGoods("0000a92675","170","45","90","nail","normal");
goods[2040] =new setGoods("0000a92676","180","45","90","nail","normal");
goods[2041] =new setGoods("0000a92677","60","50","90","nail","normal");
goods[2042] =new setGoods("0000a92678","70","50","90","nail","normal");
goods[2043] =new setGoods("0000a92679","80","50","90","nail","normal");
goods[2044] =new setGoods("0000a92680","90","50","90","nail","normal");
goods[2045] =new setGoods("0000a92681","100","50","90","nail","normal");
goods[2046] =new setGoods("0000a92682","110","50","90","nail","normal");
goods[2047] =new setGoods("0000a92683","120","50","90","nail","normal");
goods[2048] =new setGoods("0000a92684","130","50","90","nail","normal");
goods[2049] =new setGoods("0000a92685","140","50","90","nail","normal");
goods[2050] =new setGoods("0000a92686","150","50","90","nail","normal");
goods[2051] =new setGoods("0000a92687","160","50","90","nail","normal");
goods[2052] =new setGoods("0000a92688","170","50","90","nail","normal");
goods[2053] =new setGoods("0000a92689","180","50","90","nail","normal");
goods[2054] =new setGoods("0000a92690","60","55","90","nail","normal");
goods[2055] =new setGoods("0000a92691","70","55","90","nail","normal");
goods[2056] =new setGoods("0000a92692","80","55","90","nail","normal");
goods[2057] =new setGoods("0000a92693","90","55","90","nail","normal");
goods[2058] =new setGoods("0000a92694","100","55","90","nail","normal");
goods[2059] =new setGoods("0000a92695","110","55","90","nail","normal");
goods[2060] =new setGoods("0000a92696","120","55","90","nail","normal");
goods[2061] =new setGoods("0000a92697","130","55","90","nail","normal");
goods[2062] =new setGoods("0000a92698","140","55","90","nail","normal");
goods[2063] =new setGoods("0000a92699","150","55","90","nail","normal");
goods[2064] =new setGoods("0000a92700","160","55","90","nail","normal");
goods[2065] =new setGoods("0000a92701","170","55","90","nail","normal");
goods[2066] =new setGoods("0000a92702","180","55","90","nail","normal");
goods[2067] =new setGoods("0000a92703","60","60","90","nail","normal");
goods[2068] =new setGoods("0000a92704","70","60","90","nail","normal");
goods[2069] =new setGoods("0000a92705","80","60","90","nail","normal");
goods[2070] =new setGoods("0000a92706","90","60","90","nail","normal");
goods[2071] =new setGoods("0000a92707","100","60","90","nail","normal");
goods[2072] =new setGoods("0000a92708","110","60","90","nail","normal");
goods[2073] =new setGoods("0000a92709","120","60","90","nail","normal");
goods[2074] =new setGoods("0000a92710","130","60","90","nail","normal");
goods[2075] =new setGoods("0000a92711","140","60","90","nail","normal");
goods[2076] =new setGoods("0000a92712","150","60","90","nail","normal");
goods[2077] =new setGoods("0000a92713","160","60","90","nail","normal");
goods[2078] =new setGoods("0000a92714","170","60","90","nail","normal");
goods[2079] =new setGoods("0000a92715","180","60","90","nail","normal");
goods[2080] =new setGoods("0000a92716","60","25","100","nail","normal");
goods[2081] =new setGoods("0000a92717","70","25","100","nail","normal");
goods[2082] =new setGoods("0000a92718","80","25","100","nail","normal");
goods[2083] =new setGoods("0000a92719","90","25","100","nail","normal");
goods[2084] =new setGoods("0000a92720","100","25","100","nail","normal");
goods[2085] =new setGoods("0000a92721","110","25","100","nail","normal");
goods[2086] =new setGoods("0000a92722","120","25","100","nail","normal");
goods[2087] =new setGoods("0000a92723","130","25","100","nail","normal");
goods[2088] =new setGoods("0000a92724","140","25","100","nail","normal");
goods[2089] =new setGoods("0000a92725","150","25","100","nail","normal");
goods[2090] =new setGoods("0000a92726","160","25","100","nail","normal");
goods[2091] =new setGoods("0000a92727","170","25","100","nail","normal");
goods[2092] =new setGoods("0000a92728","180","25","100","nail","normal");
goods[2093] =new setGoods("0000a92729","60","30","100","nail","normal");
goods[2094] =new setGoods("0000a92730","70","30","100","nail","normal");
goods[2095] =new setGoods("0000a92731","80","30","100","nail","normal");
goods[2096] =new setGoods("0000a92732","90","30","100","nail","normal");
goods[2097] =new setGoods("0000a92733","100","30","100","nail","normal");
goods[2098] =new setGoods("0000a92734","110","30","100","nail","normal");
goods[2099] =new setGoods("0000a92735","120","30","100","nail","normal");
goods[2100] =new setGoods("0000a92736","130","30","100","nail","normal");
goods[2101] =new setGoods("0000a92737","140","30","100","nail","normal");
goods[2102] =new setGoods("0000a92738","150","30","100","nail","normal");
goods[2103] =new setGoods("0000a92739","160","30","100","nail","normal");
goods[2104] =new setGoods("0000a92740","170","30","100","nail","normal");
goods[2105] =new setGoods("0000a92741","180","30","100","nail","normal");
goods[2106] =new setGoods("0000a92742","60","35","100","nail","normal");
goods[2107] =new setGoods("0000a92743","70","35","100","nail","normal");
goods[2108] =new setGoods("0000a92744","80","35","100","nail","normal");
goods[2109] =new setGoods("0000a92745","90","35","100","nail","normal");
goods[2110] =new setGoods("0000a92746","100","35","100","nail","normal");
goods[2111] =new setGoods("0000a92747","110","35","100","nail","normal");
goods[2112] =new setGoods("0000a92748","120","35","100","nail","normal");
goods[2113] =new setGoods("0000a92749","130","35","100","nail","normal");
goods[2114] =new setGoods("0000a92750","140","35","100","nail","normal");
goods[2115] =new setGoods("0000a92751","150","35","100","nail","normal");
goods[2116] =new setGoods("0000a92752","160","35","100","nail","normal");
goods[2117] =new setGoods("0000a92753","170","35","100","nail","normal");
goods[2118] =new setGoods("0000a92754","180","35","100","nail","normal");
goods[2119] =new setGoods("0000a92755","60","40","100","nail","normal");
goods[2120] =new setGoods("0000a92756","70","40","100","nail","normal");
goods[2121] =new setGoods("0000a92757","80","40","100","nail","normal");
goods[2122] =new setGoods("0000a92758","90","40","100","nail","normal");
goods[2123] =new setGoods("0000a92759","100","40","100","nail","normal");
goods[2124] =new setGoods("0000a92760","110","40","100","nail","normal");
goods[2125] =new setGoods("0000a92761","120","40","100","nail","normal");
goods[2126] =new setGoods("0000a92762","130","40","100","nail","normal");
goods[2127] =new setGoods("0000a92763","140","40","100","nail","normal");
goods[2128] =new setGoods("0000a92764","150","40","100","nail","normal");
goods[2129] =new setGoods("0000a92765","160","40","100","nail","normal");
goods[2130] =new setGoods("0000a92766","170","40","100","nail","normal");
goods[2131] =new setGoods("0000a92767","180","40","100","nail","normal");
goods[2132] =new setGoods("0000a92768","60","45","100","nail","normal");
goods[2133] =new setGoods("0000a92769","70","45","100","nail","normal");
goods[2134] =new setGoods("0000a92770","80","45","100","nail","normal");
goods[2135] =new setGoods("0000a92771","90","45","100","nail","normal");
goods[2136] =new setGoods("0000a92772","100","45","100","nail","normal");
goods[2137] =new setGoods("0000a92773","110","45","100","nail","normal");
goods[2138] =new setGoods("0000a92774","120","45","100","nail","normal");
goods[2139] =new setGoods("0000a92775","130","45","100","nail","normal");
goods[2140] =new setGoods("0000a92776","140","45","100","nail","normal");
goods[2141] =new setGoods("0000a92777","150","45","100","nail","normal");
goods[2142] =new setGoods("0000a92778","160","45","100","nail","normal");
goods[2143] =new setGoods("0000a92779","170","45","100","nail","normal");
goods[2144] =new setGoods("0000a92780","180","45","100","nail","normal");
goods[2145] =new setGoods("0000a92781","60","50","100","nail","normal");
goods[2146] =new setGoods("0000a92782","70","50","100","nail","normal");
goods[2147] =new setGoods("0000a92783","80","50","100","nail","normal");
goods[2148] =new setGoods("0000a92784","90","50","100","nail","normal");
goods[2149] =new setGoods("0000a92785","100","50","100","nail","normal");
goods[2150] =new setGoods("0000a92786","110","50","100","nail","normal");
goods[2151] =new setGoods("0000a92787","120","50","100","nail","normal");
goods[2152] =new setGoods("0000a92788","130","50","100","nail","normal");
goods[2153] =new setGoods("0000a92789","140","50","100","nail","normal");
goods[2154] =new setGoods("0000a92790","150","50","100","nail","normal");
goods[2155] =new setGoods("0000a92791","160","50","100","nail","normal");
goods[2156] =new setGoods("0000a92792","170","50","100","nail","normal");
goods[2157] =new setGoods("0000a92793","180","50","100","nail","normal");
goods[2158] =new setGoods("0000a92794","60","55","100","nail","normal");
goods[2159] =new setGoods("0000a92795","70","55","100","nail","normal");
goods[2160] =new setGoods("0000a92796","80","55","100","nail","normal");
goods[2161] =new setGoods("0000a92797","90","55","100","nail","normal");
goods[2162] =new setGoods("0000a92798","100","55","100","nail","normal");
goods[2163] =new setGoods("0000a92799","110","55","100","nail","normal");
goods[2164] =new setGoods("0000a92800","120","55","100","nail","normal");
goods[2165] =new setGoods("0000a92801","130","55","100","nail","normal");
goods[2166] =new setGoods("0000a92802","140","55","100","nail","normal");
goods[2167] =new setGoods("0000a92803","150","55","100","nail","normal");
goods[2168] =new setGoods("0000a92804","160","55","100","nail","normal");
goods[2169] =new setGoods("0000a92805","170","55","100","nail","normal");
goods[2170] =new setGoods("0000a92806","180","55","100","nail","normal");
goods[2171] =new setGoods("0000a92807","60","60","100","nail","normal");
goods[2172] =new setGoods("0000a92808","70","60","100","nail","normal");
goods[2173] =new setGoods("0000a92809","80","60","100","nail","normal");
goods[2174] =new setGoods("0000a92810","90","60","100","nail","normal");
goods[2175] =new setGoods("0000a92811","100","60","100","nail","normal");
goods[2176] =new setGoods("0000a92812","110","60","100","nail","normal");
goods[2177] =new setGoods("0000a92813","120","60","100","nail","normal");
goods[2178] =new setGoods("0000a92814","130","60","100","nail","normal");
goods[2179] =new setGoods("0000a92815","140","60","100","nail","normal");
goods[2180] =new setGoods("0000a92816","150","60","100","nail","normal");
goods[2181] =new setGoods("0000a92817","160","60","100","nail","normal");
goods[2182] =new setGoods("0000a92818","170","60","100","nail","normal");
goods[2183] =new setGoods("0000a92819","180","60","100","nail","normal");
goods[2184] =new setGoods("0000a92820","60","25","40","black","normal");
goods[2185] =new setGoods("0000a92821","70","25","40","black","normal");
goods[2186] =new setGoods("0000a92822","80","25","40","black","normal");
goods[2187] =new setGoods("0000a92823","90","25","40","black","normal");
goods[2188] =new setGoods("0000a92824","100","25","40","black","normal");
goods[2189] =new setGoods("0000a92825","110","25","40","black","normal");
goods[2190] =new setGoods("0000a92826","120","25","40","black","normal");
goods[2191] =new setGoods("0000a92827","130","25","40","black","normal");
goods[2192] =new setGoods("0000a92828","140","25","40","black","normal");
goods[2193] =new setGoods("0000a92829","150","25","40","black","normal");
goods[2194] =new setGoods("0000a92830","160","25","40","black","normal");
goods[2195] =new setGoods("0000a92831","170","25","40","black","normal");
goods[2196] =new setGoods("0000a92832","180","25","40","black","normal");
goods[2197] =new setGoods("0000a92833","60","30","40","black","normal");
goods[2198] =new setGoods("0000a92834","70","30","40","black","normal");
goods[2199] =new setGoods("0000a92835","80","30","40","black","normal");
goods[2200] =new setGoods("0000a92836","90","30","40","black","normal");
goods[2201] =new setGoods("0000a92837","100","30","40","black","normal");
goods[2202] =new setGoods("0000a92838","110","30","40","black","normal");
goods[2203] =new setGoods("0000a92839","120","30","40","black","normal");
goods[2204] =new setGoods("0000a92840","130","30","40","black","normal");
goods[2205] =new setGoods("0000a92841","140","30","40","black","normal");
goods[2206] =new setGoods("0000a92842","150","30","40","black","normal");
goods[2207] =new setGoods("0000a92843","160","30","40","black","normal");
goods[2208] =new setGoods("0000a92844","170","30","40","black","normal");
goods[2209] =new setGoods("0000a92845","180","30","40","black","normal");
goods[2210] =new setGoods("0000a92846","60","35","40","black","normal");
goods[2211] =new setGoods("0000a92847","70","35","40","black","normal");
goods[2212] =new setGoods("0000a92848","80","35","40","black","normal");
goods[2213] =new setGoods("0000a92849","90","35","40","black","normal");
goods[2214] =new setGoods("0000a92850","100","35","40","black","normal");
goods[2215] =new setGoods("0000a92851","110","35","40","black","normal");
goods[2216] =new setGoods("0000a92852","120","35","40","black","normal");
goods[2217] =new setGoods("0000a92853","130","35","40","black","normal");
goods[2218] =new setGoods("0000a92854","140","35","40","black","normal");
goods[2219] =new setGoods("0000a92855","150","35","40","black","normal");
goods[2220] =new setGoods("0000a92856","160","35","40","black","normal");
goods[2221] =new setGoods("0000a92857","170","35","40","black","normal");
goods[2222] =new setGoods("0000a92858","180","35","40","black","normal");
goods[2223] =new setGoods("0000a92859","60","40","40","black","normal");
goods[2224] =new setGoods("0000a92860","70","40","40","black","normal");
goods[2225] =new setGoods("0000a92861","80","40","40","black","normal");
goods[2226] =new setGoods("0000a92862","90","40","40","black","normal");
goods[2227] =new setGoods("0000a92863","100","40","40","black","normal");
goods[2228] =new setGoods("0000a92864","110","40","40","black","normal");
goods[2229] =new setGoods("0000a92865","120","40","40","black","normal");
goods[2230] =new setGoods("0000a92866","130","40","40","black","normal");
goods[2231] =new setGoods("0000a92867","140","40","40","black","normal");
goods[2232] =new setGoods("0000a92868","150","40","40","black","normal");
goods[2233] =new setGoods("0000a92869","160","40","40","black","normal");
goods[2234] =new setGoods("0000a92870","170","40","40","black","normal");
goods[2235] =new setGoods("0000a92871","180","40","40","black","normal");
goods[2236] =new setGoods("0000a92872","60","45","40","black","normal");
goods[2237] =new setGoods("0000a92873","70","45","40","black","normal");
goods[2238] =new setGoods("0000a92874","80","45","40","black","normal");
goods[2239] =new setGoods("0000a92875","90","45","40","black","normal");
goods[2240] =new setGoods("0000a92876","100","45","40","black","normal");
goods[2241] =new setGoods("0000a92877","110","45","40","black","normal");
goods[2242] =new setGoods("0000a92878","120","45","40","black","normal");
goods[2243] =new setGoods("0000a92879","130","45","40","black","normal");
goods[2244] =new setGoods("0000a92880","140","45","40","black","normal");
goods[2245] =new setGoods("0000a92881","150","45","40","black","normal");
goods[2246] =new setGoods("0000a92882","160","45","40","black","normal");
goods[2247] =new setGoods("0000a92883","170","45","40","black","normal");
goods[2248] =new setGoods("0000a92884","180","45","40","black","normal");
goods[2249] =new setGoods("0000a92885","60","50","40","black","normal");
goods[2250] =new setGoods("0000a92886","70","50","40","black","normal");
goods[2251] =new setGoods("0000a92887","80","50","40","black","normal");
goods[2252] =new setGoods("0000a92888","90","50","40","black","normal");
goods[2253] =new setGoods("0000a92889","100","50","40","black","normal");
goods[2254] =new setGoods("0000a92890","110","50","40","black","normal");
goods[2255] =new setGoods("0000a92891","120","50","40","black","normal");
goods[2256] =new setGoods("0000a92892","130","50","40","black","normal");
goods[2257] =new setGoods("0000a92893","140","50","40","black","normal");
goods[2258] =new setGoods("0000a92894","150","50","40","black","normal");
goods[2259] =new setGoods("0000a92895","160","50","40","black","normal");
goods[2260] =new setGoods("0000a92896","170","50","40","black","normal");
goods[2261] =new setGoods("0000a92897","180","50","40","black","normal");
goods[2262] =new setGoods("0000a92898","60","55","40","black","normal");
goods[2263] =new setGoods("0000a92899","70","55","40","black","normal");
goods[2264] =new setGoods("0000a92900","80","55","40","black","normal");
goods[2265] =new setGoods("0000a92901","90","55","40","black","normal");
goods[2266] =new setGoods("0000a92902","100","55","40","black","normal");
goods[2267] =new setGoods("0000a92903","110","55","40","black","normal");
goods[2268] =new setGoods("0000a92904","120","55","40","black","normal");
goods[2269] =new setGoods("0000a92905","130","55","40","black","normal");
goods[2270] =new setGoods("0000a92906","140","55","40","black","normal");
goods[2271] =new setGoods("0000a92907","150","55","40","black","normal");
goods[2272] =new setGoods("0000a92908","160","55","40","black","normal");
goods[2273] =new setGoods("0000a92909","170","55","40","black","normal");
goods[2274] =new setGoods("0000a92910","180","55","40","black","normal");
goods[2275] =new setGoods("0000a92911","60","60","40","black","normal");
goods[2276] =new setGoods("0000a92912","70","60","40","black","normal");
goods[2277] =new setGoods("0000a92913","80","60","40","black","normal");
goods[2278] =new setGoods("0000a92914","90","60","40","black","normal");
goods[2279] =new setGoods("0000a92915","100","60","40","black","normal");
goods[2280] =new setGoods("0000a92916","110","60","40","black","normal");
goods[2281] =new setGoods("0000a92917","120","60","40","black","normal");
goods[2282] =new setGoods("0000a92918","130","60","40","black","normal");
goods[2283] =new setGoods("0000a92919","140","60","40","black","normal");
goods[2284] =new setGoods("0000a92920","150","60","40","black","normal");
goods[2285] =new setGoods("0000a92921","160","60","40","black","normal");
goods[2286] =new setGoods("0000a92922","170","60","40","black","normal");
goods[2287] =new setGoods("0000a92923","180","60","40","black","normal");
goods[2288] =new setGoods("0000a92924","60","25","50","black","normal");
goods[2289] =new setGoods("0000a92925","70","25","50","black","normal");
goods[2290] =new setGoods("0000a92926","80","25","50","black","normal");
goods[2291] =new setGoods("0000a92927","90","25","50","black","normal");
goods[2292] =new setGoods("0000a92928","100","25","50","black","normal");
goods[2293] =new setGoods("0000a92929","110","25","50","black","normal");
goods[2294] =new setGoods("0000a92930","120","25","50","black","normal");
goods[2295] =new setGoods("0000a92931","130","25","50","black","normal");
goods[2296] =new setGoods("0000a92932","140","25","50","black","normal");
goods[2297] =new setGoods("0000a92933","150","25","50","black","normal");
goods[2298] =new setGoods("0000a92934","160","25","50","black","normal");
goods[2299] =new setGoods("0000a92935","170","25","50","black","normal");
goods[2300] =new setGoods("0000a92936","180","25","50","black","normal");
goods[2301] =new setGoods("0000a92937","60","30","50","black","normal");
goods[2302] =new setGoods("0000a92938","70","30","50","black","normal");
goods[2303] =new setGoods("0000a92939","80","30","50","black","normal");
goods[2304] =new setGoods("0000a92940","90","30","50","black","normal");
goods[2305] =new setGoods("0000a92941","100","30","50","black","normal");
goods[2306] =new setGoods("0000a92942","110","30","50","black","normal");
goods[2307] =new setGoods("0000a92943","120","30","50","black","normal");
goods[2308] =new setGoods("0000a92944","130","30","50","black","normal");
goods[2309] =new setGoods("0000a92945","140","30","50","black","normal");
goods[2310] =new setGoods("0000a92946","150","30","50","black","normal");
goods[2311] =new setGoods("0000a92947","160","30","50","black","normal");
goods[2312] =new setGoods("0000a92948","170","30","50","black","normal");
goods[2313] =new setGoods("0000a92949","180","30","50","black","normal");
goods[2314] =new setGoods("0000a92950","60","35","50","black","normal");
goods[2315] =new setGoods("0000a92951","70","35","50","black","normal");
goods[2316] =new setGoods("0000a92952","80","35","50","black","normal");
goods[2317] =new setGoods("0000a92953","90","35","50","black","normal");
goods[2318] =new setGoods("0000a92954","100","35","50","black","normal");
goods[2319] =new setGoods("0000a92955","110","35","50","black","normal");
goods[2320] =new setGoods("0000a92956","120","35","50","black","normal");
goods[2321] =new setGoods("0000a92957","130","35","50","black","normal");
goods[2322] =new setGoods("0000a92958","140","35","50","black","normal");
goods[2323] =new setGoods("0000a92959","150","35","50","black","normal");
goods[2324] =new setGoods("0000a92960","160","35","50","black","normal");
goods[2325] =new setGoods("0000a92961","170","35","50","black","normal");
goods[2326] =new setGoods("0000a92962","180","35","50","black","normal");
goods[2327] =new setGoods("0000a92963","60","40","50","black","normal");
goods[2328] =new setGoods("0000a92964","70","40","50","black","normal");
goods[2329] =new setGoods("0000a92965","80","40","50","black","normal");
goods[2330] =new setGoods("0000a92966","90","40","50","black","normal");
goods[2331] =new setGoods("0000a92967","100","40","50","black","normal");
goods[2332] =new setGoods("0000a92968","110","40","50","black","normal");
goods[2333] =new setGoods("0000a92969","120","40","50","black","normal");
goods[2334] =new setGoods("0000a92970","130","40","50","black","normal");
goods[2335] =new setGoods("0000a92971","140","40","50","black","normal");
goods[2336] =new setGoods("0000a92972","150","40","50","black","normal");
goods[2337] =new setGoods("0000a92973","160","40","50","black","normal");
goods[2338] =new setGoods("0000a92974","170","40","50","black","normal");
goods[2339] =new setGoods("0000a92975","180","40","50","black","normal");
goods[2340] =new setGoods("0000a92976","60","45","50","black","normal");
goods[2341] =new setGoods("0000a92977","70","45","50","black","normal");
goods[2342] =new setGoods("0000a92978","80","45","50","black","normal");
goods[2343] =new setGoods("0000a92979","90","45","50","black","normal");
goods[2344] =new setGoods("0000a92980","100","45","50","black","normal");
goods[2345] =new setGoods("0000a92981","110","45","50","black","normal");
goods[2346] =new setGoods("0000a92982","120","45","50","black","normal");
goods[2347] =new setGoods("0000a92983","130","45","50","black","normal");
goods[2348] =new setGoods("0000a92984","140","45","50","black","normal");
goods[2349] =new setGoods("0000a92985","150","45","50","black","normal");
goods[2350] =new setGoods("0000a92986","160","45","50","black","normal");
goods[2351] =new setGoods("0000a92987","170","45","50","black","normal");
goods[2352] =new setGoods("0000a92988","180","45","50","black","normal");
goods[2353] =new setGoods("0000a92989","60","50","50","black","normal");
goods[2354] =new setGoods("0000a92990","70","50","50","black","normal");
goods[2355] =new setGoods("0000a92991","80","50","50","black","normal");
goods[2356] =new setGoods("0000a92992","90","50","50","black","normal");
goods[2357] =new setGoods("0000a92993","100","50","50","black","normal");
goods[2358] =new setGoods("0000a92994","110","50","50","black","normal");
goods[2359] =new setGoods("0000a92995","120","50","50","black","normal");
goods[2360] =new setGoods("0000a92996","130","50","50","black","normal");
goods[2361] =new setGoods("0000a92997","140","50","50","black","normal");
goods[2362] =new setGoods("0000a92998","150","50","50","black","normal");
goods[2363] =new setGoods("0000a92999","160","50","50","black","normal");
goods[2364] =new setGoods("0000a93000","170","50","50","black","normal");
goods[2365] =new setGoods("0000a93001","180","50","50","black","normal");
goods[2366] =new setGoods("0000a93002","60","55","50","black","normal");
goods[2367] =new setGoods("0000a93003","70","55","50","black","normal");
goods[2368] =new setGoods("0000a93004","80","55","50","black","normal");
goods[2369] =new setGoods("0000a93005","90","55","50","black","normal");
goods[2370] =new setGoods("0000a93006","100","55","50","black","normal");
goods[2371] =new setGoods("0000a93007","110","55","50","black","normal");
goods[2372] =new setGoods("0000a93008","120","55","50","black","normal");
goods[2373] =new setGoods("0000a93009","130","55","50","black","normal");
goods[2374] =new setGoods("0000a93010","140","55","50","black","normal");
goods[2375] =new setGoods("0000a93011","150","55","50","black","normal");
goods[2376] =new setGoods("0000a93012","160","55","50","black","normal");
goods[2377] =new setGoods("0000a93013","170","55","50","black","normal");
goods[2378] =new setGoods("0000a93014","180","55","50","black","normal");
goods[2379] =new setGoods("0000a93015","60","60","50","black","normal");
goods[2380] =new setGoods("0000a93016","70","60","50","black","normal");
goods[2381] =new setGoods("0000a93017","80","60","50","black","normal");
goods[2382] =new setGoods("0000a93018","90","60","50","black","normal");
goods[2383] =new setGoods("0000a93019","100","60","50","black","normal");
goods[2384] =new setGoods("0000a93020","110","60","50","black","normal");
goods[2385] =new setGoods("0000a93021","120","60","50","black","normal");
goods[2386] =new setGoods("0000a93022","130","60","50","black","normal");
goods[2387] =new setGoods("0000a93023","140","60","50","black","normal");
goods[2388] =new setGoods("0000a93024","150","60","50","black","normal");
goods[2389] =new setGoods("0000a93025","160","60","50","black","normal");
goods[2390] =new setGoods("0000a93026","170","60","50","black","normal");
goods[2391] =new setGoods("0000a93027","180","60","50","black","normal");
goods[2392] =new setGoods("0000a93028","60","25","60","black","normal");
goods[2393] =new setGoods("0000a93029","70","25","60","black","normal");
goods[2394] =new setGoods("0000a93030","80","25","60","black","normal");
goods[2395] =new setGoods("0000a93031","90","25","60","black","normal");
goods[2396] =new setGoods("0000a93032","100","25","60","black","normal");
goods[2397] =new setGoods("0000a93033","110","25","60","black","normal");
goods[2398] =new setGoods("0000a93034","120","25","60","black","normal");
goods[2399] =new setGoods("0000a93035","130","25","60","black","normal");
goods[2400] =new setGoods("0000a93036","140","25","60","black","normal");
goods[2401] =new setGoods("0000a93037","150","25","60","black","normal");
goods[2402] =new setGoods("0000a93038","160","25","60","black","normal");
goods[2403] =new setGoods("0000a93039","170","25","60","black","normal");
goods[2404] =new setGoods("0000a93040","180","25","60","black","normal");
goods[2405] =new setGoods("0000a93041","60","30","60","black","normal");
goods[2406] =new setGoods("0000a93042","70","30","60","black","normal");
goods[2407] =new setGoods("0000a93043","80","30","60","black","normal");
goods[2408] =new setGoods("0000a93044","90","30","60","black","normal");
goods[2409] =new setGoods("0000a93045","100","30","60","black","normal");
goods[2410] =new setGoods("0000a93046","110","30","60","black","normal");
goods[2411] =new setGoods("0000a93047","120","30","60","black","normal");
goods[2412] =new setGoods("0000a93048","130","30","60","black","normal");
goods[2413] =new setGoods("0000a93049","140","30","60","black","normal");
goods[2414] =new setGoods("0000a93050","150","30","60","black","normal");
goods[2415] =new setGoods("0000a93051","160","30","60","black","normal");
goods[2416] =new setGoods("0000a93052","170","30","60","black","normal");
goods[2417] =new setGoods("0000a93053","180","30","60","black","normal");
goods[2418] =new setGoods("0000a93054","60","35","60","black","normal");
goods[2419] =new setGoods("0000a93055","70","35","60","black","normal");
goods[2420] =new setGoods("0000a93056","80","35","60","black","normal");
goods[2421] =new setGoods("0000a93057","90","35","60","black","normal");
goods[2422] =new setGoods("0000a93058","100","35","60","black","normal");
goods[2423] =new setGoods("0000a93059","110","35","60","black","normal");
goods[2424] =new setGoods("0000a93060","120","35","60","black","normal");
goods[2425] =new setGoods("0000a93061","130","35","60","black","normal");
goods[2426] =new setGoods("0000a93062","140","35","60","black","normal");
goods[2427] =new setGoods("0000a93063","150","35","60","black","normal");
goods[2428] =new setGoods("0000a93064","160","35","60","black","normal");
goods[2429] =new setGoods("0000a93065","170","35","60","black","normal");
goods[2430] =new setGoods("0000a93066","180","35","60","black","normal");
goods[2431] =new setGoods("0000a93067","60","40","60","black","normal");
goods[2432] =new setGoods("0000a93068","70","40","60","black","normal");
goods[2433] =new setGoods("0000a93069","80","40","60","black","normal");
goods[2434] =new setGoods("0000a93070","90","40","60","black","normal");
goods[2435] =new setGoods("0000a93071","100","40","60","black","normal");
goods[2436] =new setGoods("0000a93072","110","40","60","black","normal");
goods[2437] =new setGoods("0000a93073","120","40","60","black","normal");
goods[2438] =new setGoods("0000a93074","130","40","60","black","normal");
goods[2439] =new setGoods("0000a93075","140","40","60","black","normal");
goods[2440] =new setGoods("0000a93076","150","40","60","black","normal");
goods[2441] =new setGoods("0000a93077","160","40","60","black","normal");
goods[2442] =new setGoods("0000a93078","170","40","60","black","normal");
goods[2443] =new setGoods("0000a93079","180","40","60","black","normal");
goods[2444] =new setGoods("0000a93080","60","45","60","black","normal");
goods[2445] =new setGoods("0000a93081","70","45","60","black","normal");
goods[2446] =new setGoods("0000a93082","80","45","60","black","normal");
goods[2447] =new setGoods("0000a93083","90","45","60","black","normal");
goods[2448] =new setGoods("0000a93084","100","45","60","black","normal");
goods[2449] =new setGoods("0000a93085","110","45","60","black","normal");
goods[2450] =new setGoods("0000a93086","120","45","60","black","normal");
goods[2451] =new setGoods("0000a93087","130","45","60","black","normal");
goods[2452] =new setGoods("0000a93088","140","45","60","black","normal");
goods[2453] =new setGoods("0000a93089","150","45","60","black","normal");
goods[2454] =new setGoods("0000a93090","160","45","60","black","normal");
goods[2455] =new setGoods("0000a93091","170","45","60","black","normal");
goods[2456] =new setGoods("0000a93092","180","45","60","black","normal");
goods[2457] =new setGoods("0000a93093","60","50","60","black","normal");
goods[2458] =new setGoods("0000a93094","70","50","60","black","normal");
goods[2459] =new setGoods("0000a93095","80","50","60","black","normal");
goods[2460] =new setGoods("0000a93096","90","50","60","black","normal");
goods[2461] =new setGoods("0000a93097","100","50","60","black","normal");
goods[2462] =new setGoods("0000a93098","110","50","60","black","normal");
goods[2463] =new setGoods("0000a93099","120","50","60","black","normal");
goods[2464] =new setGoods("0000a93100","130","50","60","black","normal");
goods[2465] =new setGoods("0000a93101","140","50","60","black","normal");
goods[2466] =new setGoods("0000a93102","150","50","60","black","normal");
goods[2467] =new setGoods("0000a93103","160","50","60","black","normal");
goods[2468] =new setGoods("0000a93104","170","50","60","black","normal");
goods[2469] =new setGoods("0000a93105","180","50","60","black","normal");
goods[2470] =new setGoods("0000a93106","60","55","60","black","normal");
goods[2471] =new setGoods("0000a93107","70","55","60","black","normal");
goods[2472] =new setGoods("0000a93108","80","55","60","black","normal");
goods[2473] =new setGoods("0000a93109","90","55","60","black","normal");
goods[2474] =new setGoods("0000a93110","100","55","60","black","normal");
goods[2475] =new setGoods("0000a93111","110","55","60","black","normal");
goods[2476] =new setGoods("0000a93112","120","55","60","black","normal");
goods[2477] =new setGoods("0000a93113","130","55","60","black","normal");
goods[2478] =new setGoods("0000a93114","140","55","60","black","normal");
goods[2479] =new setGoods("0000a93115","150","55","60","black","normal");
goods[2480] =new setGoods("0000a93116","160","55","60","black","normal");
goods[2481] =new setGoods("0000a93117","170","55","60","black","normal");
goods[2482] =new setGoods("0000a93118","180","55","60","black","normal");
goods[2483] =new setGoods("0000a93119","60","60","60","black","normal");
goods[2484] =new setGoods("0000a93120","70","60","60","black","normal");
goods[2485] =new setGoods("0000a93121","80","60","60","black","normal");
goods[2486] =new setGoods("0000a93122","90","60","60","black","normal");
goods[2487] =new setGoods("0000a93123","100","60","60","black","normal");
goods[2488] =new setGoods("0000a93124","110","60","60","black","normal");
goods[2489] =new setGoods("0000a93125","120","60","60","black","normal");
goods[2490] =new setGoods("0000a93126","130","60","60","black","normal");
goods[2491] =new setGoods("0000a93127","140","60","60","black","normal");
goods[2492] =new setGoods("0000a93128","150","60","60","black","normal");
goods[2493] =new setGoods("0000a93129","160","60","60","black","normal");
goods[2494] =new setGoods("0000a93130","170","60","60","black","normal");
goods[2495] =new setGoods("0000a93131","180","60","60","black","normal");
goods[2496] =new setGoods("0000a93132","60","25","70","black","normal");
goods[2497] =new setGoods("0000a93133","70","25","70","black","normal");
goods[2498] =new setGoods("0000a93134","80","25","70","black","normal");
goods[2499] =new setGoods("0000a93135","90","25","70","black","normal");
goods[2500] =new setGoods("0000a93136","100","25","70","black","normal");
goods[2501] =new setGoods("0000a93137","110","25","70","black","normal");
goods[2502] =new setGoods("0000a93138","120","25","70","black","normal");
goods[2503] =new setGoods("0000a93139","130","25","70","black","normal");
goods[2504] =new setGoods("0000a93140","140","25","70","black","normal");
goods[2505] =new setGoods("0000a93141","150","25","70","black","normal");
goods[2506] =new setGoods("0000a93142","160","25","70","black","normal");
goods[2507] =new setGoods("0000a93143","170","25","70","black","normal");
goods[2508] =new setGoods("0000a93144","180","25","70","black","normal");
goods[2509] =new setGoods("0000a93145","60","30","70","black","normal");
goods[2510] =new setGoods("0000a93146","70","30","70","black","normal");
goods[2511] =new setGoods("0000a93147","80","30","70","black","normal");
goods[2512] =new setGoods("0000a93148","90","30","70","black","normal");
goods[2513] =new setGoods("0000a93149","100","30","70","black","normal");
goods[2514] =new setGoods("0000a93150","110","30","70","black","normal");
goods[2515] =new setGoods("0000a93151","120","30","70","black","normal");
goods[2516] =new setGoods("0000a93152","130","30","70","black","normal");
goods[2517] =new setGoods("0000a93153","140","30","70","black","normal");
goods[2518] =new setGoods("0000a93154","150","30","70","black","normal");
goods[2519] =new setGoods("0000a93155","160","30","70","black","normal");
goods[2520] =new setGoods("0000a93156","170","30","70","black","normal");
goods[2521] =new setGoods("0000a93157","180","30","70","black","normal");
goods[2522] =new setGoods("0000a93158","60","35","70","black","normal");
goods[2523] =new setGoods("0000a93159","70","35","70","black","normal");
goods[2524] =new setGoods("0000a93160","80","35","70","black","normal");
goods[2525] =new setGoods("0000a93161","90","35","70","black","normal");
goods[2526] =new setGoods("0000a93162","100","35","70","black","normal");
goods[2527] =new setGoods("0000a93163","110","35","70","black","normal");
goods[2528] =new setGoods("0000a93164","120","35","70","black","normal");
goods[2529] =new setGoods("0000a93165","130","35","70","black","normal");
goods[2530] =new setGoods("0000a93166","140","35","70","black","normal");
goods[2531] =new setGoods("0000a93167","150","35","70","black","normal");
goods[2532] =new setGoods("0000a93168","160","35","70","black","normal");
goods[2533] =new setGoods("0000a93169","170","35","70","black","normal");
goods[2534] =new setGoods("0000a93170","180","35","70","black","normal");
goods[2535] =new setGoods("0000a93171","60","40","70","black","normal");
goods[2536] =new setGoods("0000a93172","70","40","70","black","normal");
goods[2537] =new setGoods("0000a93173","80","40","70","black","normal");
goods[2538] =new setGoods("0000a93174","90","40","70","black","normal");
goods[2539] =new setGoods("0000a93175","100","40","70","black","normal");
goods[2540] =new setGoods("0000a93176","110","40","70","black","normal");
goods[2541] =new setGoods("0000a93177","120","40","70","black","normal");
goods[2542] =new setGoods("0000a93178","130","40","70","black","normal");
goods[2543] =new setGoods("0000a93179","140","40","70","black","normal");
goods[2544] =new setGoods("0000a93180","150","40","70","black","normal");
goods[2545] =new setGoods("0000a93181","160","40","70","black","normal");
goods[2546] =new setGoods("0000a93182","170","40","70","black","normal");
goods[2547] =new setGoods("0000a93183","180","40","70","black","normal");
goods[2548] =new setGoods("0000a93184","60","45","70","black","normal");
goods[2549] =new setGoods("0000a93185","70","45","70","black","normal");
goods[2550] =new setGoods("0000a93186","80","45","70","black","normal");
goods[2551] =new setGoods("0000a93187","90","45","70","black","normal");
goods[2552] =new setGoods("0000a93188","100","45","70","black","normal");
goods[2553] =new setGoods("0000a93189","110","45","70","black","normal");
goods[2554] =new setGoods("0000a93190","120","45","70","black","normal");
goods[2555] =new setGoods("0000a93191","130","45","70","black","normal");
goods[2556] =new setGoods("0000a93192","140","45","70","black","normal");
goods[2557] =new setGoods("0000a93193","150","45","70","black","normal");
goods[2558] =new setGoods("0000a93194","160","45","70","black","normal");
goods[2559] =new setGoods("0000a93195","170","45","70","black","normal");
goods[2560] =new setGoods("0000a93196","180","45","70","black","normal");
goods[2561] =new setGoods("0000a93197","60","50","70","black","normal");
goods[2562] =new setGoods("0000a93198","70","50","70","black","normal");
goods[2563] =new setGoods("0000a93199","80","50","70","black","normal");
goods[2564] =new setGoods("0000a93200","90","50","70","black","normal");
goods[2565] =new setGoods("0000a93201","100","50","70","black","normal");
goods[2566] =new setGoods("0000a93202","110","50","70","black","normal");
goods[2567] =new setGoods("0000a93203","120","50","70","black","normal");
goods[2568] =new setGoods("0000a93204","130","50","70","black","normal");
goods[2569] =new setGoods("0000a93205","140","50","70","black","normal");
goods[2570] =new setGoods("0000a93206","150","50","70","black","normal");
goods[2571] =new setGoods("0000a93207","160","50","70","black","normal");
goods[2572] =new setGoods("0000a93208","170","50","70","black","normal");
goods[2573] =new setGoods("0000a93209","180","50","70","black","normal");
goods[2574] =new setGoods("0000a93210","60","55","70","black","normal");
goods[2575] =new setGoods("0000a93211","70","55","70","black","normal");
goods[2576] =new setGoods("0000a93212","80","55","70","black","normal");
goods[2577] =new setGoods("0000a93213","90","55","70","black","normal");
goods[2578] =new setGoods("0000a93214","100","55","70","black","normal");
goods[2579] =new setGoods("0000a93215","110","55","70","black","normal");
goods[2580] =new setGoods("0000a93216","120","55","70","black","normal");
goods[2581] =new setGoods("0000a93217","130","55","70","black","normal");
goods[2582] =new setGoods("0000a93218","140","55","70","black","normal");
goods[2583] =new setGoods("0000a93219","150","55","70","black","normal");
goods[2584] =new setGoods("0000a93220","160","55","70","black","normal");
goods[2585] =new setGoods("0000a93221","170","55","70","black","normal");
goods[2586] =new setGoods("0000a93222","180","55","70","black","normal");
goods[2587] =new setGoods("0000a93223","60","60","70","black","normal");
goods[2588] =new setGoods("0000a93224","70","60","70","black","normal");
goods[2589] =new setGoods("0000a93225","80","60","70","black","normal");
goods[2590] =new setGoods("0000a93226","90","60","70","black","normal");
goods[2591] =new setGoods("0000a93227","100","60","70","black","normal");
goods[2592] =new setGoods("0000a93228","110","60","70","black","normal");
goods[2593] =new setGoods("0000a93229","120","60","70","black","normal");
goods[2594] =new setGoods("0000a93230","130","60","70","black","normal");
goods[2595] =new setGoods("0000a93231","140","60","70","black","normal");
goods[2596] =new setGoods("0000a93232","150","60","70","black","normal");
goods[2597] =new setGoods("0000a93233","160","60","70","black","normal");
goods[2598] =new setGoods("0000a93234","170","60","70","black","normal");
goods[2599] =new setGoods("0000a93235","180","60","70","black","normal");
goods[2600] =new setGoods("0000a93236","60","25","80","black","normal");
goods[2601] =new setGoods("0000a93237","70","25","80","black","normal");
goods[2602] =new setGoods("0000a93238","80","25","80","black","normal");
goods[2603] =new setGoods("0000a93239","90","25","80","black","normal");
goods[2604] =new setGoods("0000a93240","100","25","80","black","normal");
goods[2605] =new setGoods("0000a93241","110","25","80","black","normal");
goods[2606] =new setGoods("0000a93242","120","25","80","black","normal");
goods[2607] =new setGoods("0000a93243","130","25","80","black","normal");
goods[2608] =new setGoods("0000a93244","140","25","80","black","normal");
goods[2609] =new setGoods("0000a93245","150","25","80","black","normal");
goods[2610] =new setGoods("0000a93246","160","25","80","black","normal");
goods[2611] =new setGoods("0000a93247","170","25","80","black","normal");
goods[2612] =new setGoods("0000a93248","180","25","80","black","normal");
goods[2613] =new setGoods("0000a93249","60","30","80","black","normal");
goods[2614] =new setGoods("0000a93250","70","30","80","black","normal");
goods[2615] =new setGoods("0000a93251","80","30","80","black","normal");
goods[2616] =new setGoods("0000a93252","90","30","80","black","normal");
goods[2617] =new setGoods("0000a93253","100","30","80","black","normal");
goods[2618] =new setGoods("0000a93254","110","30","80","black","normal");
goods[2619] =new setGoods("0000a93255","120","30","80","black","normal");
goods[2620] =new setGoods("0000a93256","130","30","80","black","normal");
goods[2621] =new setGoods("0000a93257","140","30","80","black","normal");
goods[2622] =new setGoods("0000a93258","150","30","80","black","normal");
goods[2623] =new setGoods("0000a93259","160","30","80","black","normal");
goods[2624] =new setGoods("0000a93260","170","30","80","black","normal");
goods[2625] =new setGoods("0000a93261","180","30","80","black","normal");
goods[2626] =new setGoods("0000a93262","60","35","80","black","normal");
goods[2627] =new setGoods("0000a93263","70","35","80","black","normal");
goods[2628] =new setGoods("0000a93264","80","35","80","black","normal");
goods[2629] =new setGoods("0000a93265","90","35","80","black","normal");
goods[2630] =new setGoods("0000a93266","100","35","80","black","normal");
goods[2631] =new setGoods("0000a93267","110","35","80","black","normal");
goods[2632] =new setGoods("0000a93268","120","35","80","black","normal");
goods[2633] =new setGoods("0000a93269","130","35","80","black","normal");
goods[2634] =new setGoods("0000a93270","140","35","80","black","normal");
goods[2635] =new setGoods("0000a93271","150","35","80","black","normal");
goods[2636] =new setGoods("0000a93272","160","35","80","black","normal");
goods[2637] =new setGoods("0000a93273","170","35","80","black","normal");
goods[2638] =new setGoods("0000a93274","180","35","80","black","normal");

goods[2639] =new setGoods("0000a93275","60","40","80","black","normal");
goods[2640] =new setGoods("0000a93276","70","40","80","black","normal");
goods[2641] =new setGoods("0000a93277","80","40","80","black","normal");
goods[2642] =new setGoods("0000a93278","90","40","80","black","normal");
goods[2643] =new setGoods("0000a93279","100","40","80","black","normal");
goods[2644] =new setGoods("0000a93280","110","40","80","black","normal");
goods[2645] =new setGoods("0000a93281","120","40","80","black","normal");
goods[2646] =new setGoods("0000a93282","130","40","80","black","normal");
goods[2647] =new setGoods("0000a93283","140","40","80","black","normal");
goods[2648] =new setGoods("0000a93284","150","40","80","black","normal");
goods[2649] =new setGoods("0000a93285","160","40","80","black","normal");
goods[2650] =new setGoods("0000a93286","170","40","80","black","normal");
goods[2651] =new setGoods("0000a93287","180","40","80","black","normal");
goods[2652] =new setGoods("0000a93288","60","45","80","black","normal");
goods[2653] =new setGoods("0000a93289","70","45","80","black","normal");
goods[2654] =new setGoods("0000a93290","80","45","80","black","normal");
goods[2655] =new setGoods("0000a93291","90","45","80","black","normal");
goods[2656] =new setGoods("0000a93292","100","45","80","black","normal");
goods[2657] =new setGoods("0000a93293","110","45","80","black","normal");
goods[2658] =new setGoods("0000a93294","120","45","80","black","normal");
goods[2659] =new setGoods("0000a93295","130","45","80","black","normal");
goods[2660] =new setGoods("0000a93296","140","45","80","black","normal");
goods[2661] =new setGoods("0000a93297","150","45","80","black","normal");
goods[2662] =new setGoods("0000a93298","160","45","80","black","normal");
goods[2663] =new setGoods("0000a93299","170","45","80","black","normal");
goods[2664] =new setGoods("0000a93300","180","45","80","black","normal");
goods[2665] =new setGoods("0000a93301","60","50","80","black","normal");
goods[2666] =new setGoods("0000a93302","70","50","80","black","normal");
goods[2667] =new setGoods("0000a93303","80","50","80","black","normal");
goods[2668] =new setGoods("0000a93304","90","50","80","black","normal");
goods[2669] =new setGoods("0000a93305","100","50","80","black","normal");
goods[2670] =new setGoods("0000a93306","110","50","80","black","normal");
goods[2671] =new setGoods("0000a93307","120","50","80","black","normal");
goods[2672] =new setGoods("0000a93308","130","50","80","black","normal");
goods[2673] =new setGoods("0000a93309","140","50","80","black","normal");
goods[2674] =new setGoods("0000a93310","150","50","80","black","normal");
goods[2675] =new setGoods("0000a93311","160","50","80","black","normal");
goods[2676] =new setGoods("0000a93312","170","50","80","black","normal");
goods[2677] =new setGoods("0000a93313","180","50","80","black","normal");
goods[2678] =new setGoods("0000a93314","60","55","80","black","normal");
goods[2679] =new setGoods("0000a93315","70","55","80","black","normal");
goods[2680] =new setGoods("0000a93316","80","55","80","black","normal");
goods[2681] =new setGoods("0000a93317","90","55","80","black","normal");
goods[2682] =new setGoods("0000a93318","100","55","80","black","normal");
goods[2683] =new setGoods("0000a93319","110","55","80","black","normal");
goods[2684] =new setGoods("0000a93320","120","55","80","black","normal");
goods[2685] =new setGoods("0000a93321","130","55","80","black","normal");
goods[2686] =new setGoods("0000a93322","140","55","80","black","normal");
goods[2687] =new setGoods("0000a93323","150","55","80","black","normal");
goods[2688] =new setGoods("0000a93324","160","55","80","black","normal");
goods[2689] =new setGoods("0000a93325","170","55","80","black","normal");
goods[2690] =new setGoods("0000a93326","180","55","80","black","normal");
goods[2691] =new setGoods("0000a93327","60","60","80","black","normal");
goods[2692] =new setGoods("0000a93328","70","60","80","black","normal");
goods[2693] =new setGoods("0000a93329","80","60","80","black","normal");
goods[2694] =new setGoods("0000a93330","90","60","80","black","normal");
goods[2695] =new setGoods("0000a93331","100","60","80","black","normal");
goods[2696] =new setGoods("0000a93332","110","60","80","black","normal");
goods[2697] =new setGoods("0000a93333","120","60","80","black","normal");
goods[2698] =new setGoods("0000a93334","130","60","80","black","normal");
goods[2699] =new setGoods("0000a93335","140","60","80","black","normal");
goods[2700] =new setGoods("0000a93336","150","60","80","black","normal");
goods[2701] =new setGoods("0000a93337","160","60","80","black","normal");
goods[2702] =new setGoods("0000a93338","170","60","80","black","normal");
goods[2703] =new setGoods("0000a93339","180","60","80","black","normal");
goods[2704] =new setGoods("0000a93340","60","25","90","black","normal");
goods[2705] =new setGoods("0000a93341","70","25","90","black","normal");
goods[2706] =new setGoods("0000a93342","80","25","90","black","normal");
goods[2707] =new setGoods("0000a93343","90","25","90","black","normal");
goods[2708] =new setGoods("0000a93344","100","25","90","black","normal");
goods[2709] =new setGoods("0000a93345","110","25","90","black","normal");
goods[2710] =new setGoods("0000a93346","120","25","90","black","normal");
goods[2711] =new setGoods("0000a93347","130","25","90","black","normal");
goods[2712] =new setGoods("0000a93348","140","25","90","black","normal");
goods[2713] =new setGoods("0000a93349","150","25","90","black","normal");
goods[2714] =new setGoods("0000a93350","160","25","90","black","normal");
goods[2715] =new setGoods("0000a93351","170","25","90","black","normal");
goods[2716] =new setGoods("0000a93352","180","25","90","black","normal");
goods[2717] =new setGoods("0000a93353","60","30","90","black","normal");
goods[2718] =new setGoods("0000a93354","70","30","90","black","normal");
goods[2719] =new setGoods("0000a93355","80","30","90","black","normal");
goods[2720] =new setGoods("0000a93356","90","30","90","black","normal");
goods[2721] =new setGoods("0000a93357","100","30","90","black","normal");
goods[2722] =new setGoods("0000a93358","110","30","90","black","normal");
goods[2723] =new setGoods("0000a93359","120","30","90","black","normal");
goods[2724] =new setGoods("0000a93360","130","30","90","black","normal");
goods[2725] =new setGoods("0000a93361","140","30","90","black","normal");
goods[2726] =new setGoods("0000a93362","150","30","90","black","normal");
goods[2727] =new setGoods("0000a93363","160","30","90","black","normal");
goods[2728] =new setGoods("0000a93364","170","30","90","black","normal");
goods[2729] =new setGoods("0000a93365","180","30","90","black","normal");
goods[2730] =new setGoods("0000a93366","60","35","90","black","normal");
goods[2731] =new setGoods("0000a93367","70","35","90","black","normal");
goods[2732] =new setGoods("0000a93368","80","35","90","black","normal");
goods[2733] =new setGoods("0000a93369","90","35","90","black","normal");
goods[2734] =new setGoods("0000a93370","100","35","90","black","normal");
goods[2735] =new setGoods("0000a93371","110","35","90","black","normal");
goods[2736] =new setGoods("0000a93372","120","35","90","black","normal");
goods[2737] =new setGoods("0000a93373","130","35","90","black","normal");
goods[2738] =new setGoods("0000a93374","140","35","90","black","normal");
goods[2739] =new setGoods("0000a93375","150","35","90","black","normal");
goods[2740] =new setGoods("0000a93376","160","35","90","black","normal");
goods[2741] =new setGoods("0000a93377","170","35","90","black","normal");
goods[2742] =new setGoods("0000a93378","180","35","90","black","normal");
goods[2743] =new setGoods("0000a93379","60","40","90","black","normal");
goods[2744] =new setGoods("0000a93380","70","40","90","black","normal");
goods[2745] =new setGoods("0000a93381","80","40","90","black","normal");
goods[2746] =new setGoods("0000a93382","90","40","90","black","normal");
goods[2747] =new setGoods("0000a93383","100","40","90","black","normal");
goods[2748] =new setGoods("0000a93384","110","40","90","black","normal");
goods[2749] =new setGoods("0000a93385","120","40","90","black","normal");
goods[2750] =new setGoods("0000a93386","130","40","90","black","normal");
goods[2751] =new setGoods("0000a93387","140","40","90","black","normal");
goods[2752] =new setGoods("0000a93388","150","40","90","black","normal");
goods[2753] =new setGoods("0000a93389","160","40","90","black","normal");
goods[2754] =new setGoods("0000a93390","170","40","90","black","normal");
goods[2755] =new setGoods("0000a93391","180","40","90","black","normal");
goods[2756] =new setGoods("0000a93392","60","45","90","black","normal");
goods[2757] =new setGoods("0000a93393","70","45","90","black","normal");
goods[2758] =new setGoods("0000a93394","80","45","90","black","normal");
goods[2759] =new setGoods("0000a93395","90","45","90","black","normal");
goods[2760] =new setGoods("0000a93396","100","45","90","black","normal");
goods[2761] =new setGoods("0000a93397","110","45","90","black","normal");
goods[2762] =new setGoods("0000a93398","120","45","90","black","normal");
goods[2763] =new setGoods("0000a93399","130","45","90","black","normal");
goods[2764] =new setGoods("0000a93400","140","45","90","black","normal");
goods[2765] =new setGoods("0000a93401","150","45","90","black","normal");
goods[2766] =new setGoods("0000a93402","160","45","90","black","normal");
goods[2767] =new setGoods("0000a93403","170","45","90","black","normal");
goods[2768] =new setGoods("0000a93404","180","45","90","black","normal");
goods[2769] =new setGoods("0000a93405","60","50","90","black","normal");
goods[2770] =new setGoods("0000a93406","70","50","90","black","normal");
goods[2771] =new setGoods("0000a93407","80","50","90","black","normal");
goods[2772] =new setGoods("0000a93408","90","50","90","black","normal");
goods[2773] =new setGoods("0000a93409","100","50","90","black","normal");
goods[2774] =new setGoods("0000a93410","110","50","90","black","normal");
goods[2775] =new setGoods("0000a93411","120","50","90","black","normal");
goods[2776] =new setGoods("0000a93412","130","50","90","black","normal");
goods[2777] =new setGoods("0000a93413","140","50","90","black","normal");
goods[2778] =new setGoods("0000a93414","150","50","90","black","normal");
goods[2779] =new setGoods("0000a93415","160","50","90","black","normal");
goods[2780] =new setGoods("0000a93416","170","50","90","black","normal");
goods[2781] =new setGoods("0000a93417","180","50","90","black","normal");
goods[2782] =new setGoods("0000a93418","60","55","90","black","normal");
goods[2783] =new setGoods("0000a93419","70","55","90","black","normal");
goods[2784] =new setGoods("0000a93420","80","55","90","black","normal");
goods[2785] =new setGoods("0000a93421","90","55","90","black","normal");
goods[2786] =new setGoods("0000a93422","100","55","90","black","normal");
goods[2787] =new setGoods("0000a93423","110","55","90","black","normal");
goods[2788] =new setGoods("0000a93424","120","55","90","black","normal");
goods[2789] =new setGoods("0000a93425","130","55","90","black","normal");
goods[2790] =new setGoods("0000a93426","140","55","90","black","normal");
goods[2791] =new setGoods("0000a93427","150","55","90","black","normal");
goods[2792] =new setGoods("0000a93428","160","55","90","black","normal");
goods[2793] =new setGoods("0000a93429","170","55","90","black","normal");
goods[2794] =new setGoods("0000a93430","180","55","90","black","normal");
goods[2795] =new setGoods("0000a93431","60","60","90","black","normal");
goods[2796] =new setGoods("0000a93432","70","60","90","black","normal");
goods[2797] =new setGoods("0000a93433","80","60","90","black","normal");
goods[2798] =new setGoods("0000a93434","90","60","90","black","normal");
goods[2799] =new setGoods("0000a93435","100","60","90","black","normal");
goods[2800] =new setGoods("0000a93436","110","60","90","black","normal");
goods[2801] =new setGoods("0000a93437","120","60","90","black","normal");
goods[2802] =new setGoods("0000a93438","130","60","90","black","normal");
goods[2803] =new setGoods("0000a93439","140","60","90","black","normal");
goods[2804] =new setGoods("0000a93440","150","60","90","black","normal");
goods[2805] =new setGoods("0000a93441","160","60","90","black","normal");
goods[2806] =new setGoods("0000a93442","170","60","90","black","normal");
goods[2807] =new setGoods("0000a93443","180","60","90","black","normal");
goods[2808] =new setGoods("0000a93444","60","25","100","black","normal");
goods[2809] =new setGoods("0000a93445","70","25","100","black","normal");
goods[2810] =new setGoods("0000a93446","80","25","100","black","normal");
goods[2811] =new setGoods("0000a93447","90","25","100","black","normal");
goods[2812] =new setGoods("0000a93448","100","25","100","black","normal");
goods[2813] =new setGoods("0000a93449","110","25","100","black","normal");
goods[2814] =new setGoods("0000a93450","120","25","100","black","normal");
goods[2815] =new setGoods("0000a93451","130","25","100","black","normal");
goods[2816] =new setGoods("0000a93452","140","25","100","black","normal");
goods[2817] =new setGoods("0000a93453","150","25","100","black","normal");
goods[2818] =new setGoods("0000a93454","160","25","100","black","normal");
goods[2819] =new setGoods("0000a93455","170","25","100","black","normal");
goods[2820] =new setGoods("0000a93456","180","25","100","black","normal");
goods[2821] =new setGoods("0000a93457","60","30","100","black","normal");
goods[2822] =new setGoods("0000a93458","70","30","100","black","normal");
goods[2823] =new setGoods("0000a93459","80","30","100","black","normal");
goods[2824] =new setGoods("0000a93460","90","30","100","black","normal");
goods[2825] =new setGoods("0000a93461","100","30","100","black","normal");
goods[2826] =new setGoods("0000a93462","110","30","100","black","normal");
goods[2827] =new setGoods("0000a93463","120","30","100","black","normal");
goods[2828] =new setGoods("0000a93464","130","30","100","black","normal");
goods[2829] =new setGoods("0000a93465","140","30","100","black","normal");
goods[2830] =new setGoods("0000a93466","150","30","100","black","normal");
goods[2831] =new setGoods("0000a93467","160","30","100","black","normal");
goods[2832] =new setGoods("0000a93468","170","30","100","black","normal");
goods[2833] =new setGoods("0000a93469","180","30","100","black","normal");
goods[2834] =new setGoods("0000a93470","60","35","100","black","normal");
goods[2835] =new setGoods("0000a93471","70","35","100","black","normal");
goods[2836] =new setGoods("0000a93472","80","35","100","black","normal");
goods[2837] =new setGoods("0000a93473","90","35","100","black","normal");
goods[2838] =new setGoods("0000a93474","100","35","100","black","normal");
goods[2839] =new setGoods("0000a93475","110","35","100","black","normal");
goods[2840] =new setGoods("0000a93476","120","35","100","black","normal");
goods[2841] =new setGoods("0000a93477","130","35","100","black","normal");
goods[2842] =new setGoods("0000a93478","140","35","100","black","normal");
goods[2843] =new setGoods("0000a93479","150","35","100","black","normal");
goods[2844] =new setGoods("0000a93480","160","35","100","black","normal");
goods[2845] =new setGoods("0000a93481","170","35","100","black","normal");
goods[2846] =new setGoods("0000a93482","180","35","100","black","normal");
goods[2847] =new setGoods("0000a93483","60","40","100","black","normal");
goods[2848] =new setGoods("0000a93484","70","40","100","black","normal");
goods[2849] =new setGoods("0000a93485","80","40","100","black","normal");
goods[2850] =new setGoods("0000a93486","90","40","100","black","normal");
goods[2851] =new setGoods("0000a93487","100","40","100","black","normal");
goods[2852] =new setGoods("0000a93488","110","40","100","black","normal");
goods[2853] =new setGoods("0000a93489","120","40","100","black","normal");
goods[2854] =new setGoods("0000a93490","130","40","100","black","normal");
goods[2855] =new setGoods("0000a93491","140","40","100","black","normal");
goods[2856] =new setGoods("0000a93492","150","40","100","black","normal");
goods[2857] =new setGoods("0000a93493","160","40","100","black","normal");
goods[2858] =new setGoods("0000a93494","170","40","100","black","normal");
goods[2859] =new setGoods("0000a93495","180","40","100","black","normal");
goods[2860] =new setGoods("0000a93496","60","45","100","black","normal");
goods[2861] =new setGoods("0000a93497","70","45","100","black","normal");
goods[2862] =new setGoods("0000a93498","80","45","100","black","normal");
goods[2863] =new setGoods("0000a93499","90","45","100","black","normal");
goods[2864] =new setGoods("0000a93500","100","45","100","black","normal");
goods[2865] =new setGoods("0000a93501","110","45","100","black","normal");
goods[2866] =new setGoods("0000a93502","120","45","100","black","normal");
goods[2867] =new setGoods("0000a93503","130","45","100","black","normal");
goods[2868] =new setGoods("0000a93504","140","45","100","black","normal");
goods[2869] =new setGoods("0000a93505","150","45","100","black","normal");
goods[2870] =new setGoods("0000a93506","160","45","100","black","normal");
goods[2871] =new setGoods("0000a93507","170","45","100","black","normal");
goods[2872] =new setGoods("0000a93508","180","45","100","black","normal");
goods[2873] =new setGoods("0000a93509","60","50","100","black","normal");
goods[2874] =new setGoods("0000a93510","70","50","100","black","normal");
goods[2875] =new setGoods("0000a93511","80","50","100","black","normal");
goods[2876] =new setGoods("0000a93512","90","50","100","black","normal");
goods[2877] =new setGoods("0000a93513","100","50","100","black","normal");
goods[2878] =new setGoods("0000a93514","110","50","100","black","normal");
goods[2879] =new setGoods("0000a93515","120","50","100","black","normal");
goods[2880] =new setGoods("0000a93516","130","50","100","black","normal");
goods[2881] =new setGoods("0000a93517","140","50","100","black","normal");
goods[2882] =new setGoods("0000a93518","150","50","100","black","normal");
goods[2883] =new setGoods("0000a93519","160","50","100","black","normal");
goods[2884] =new setGoods("0000a93520","170","50","100","black","normal");
goods[2885] =new setGoods("0000a93521","180","50","100","black","normal");
goods[2886] =new setGoods("0000a93522","60","55","100","black","normal");
goods[2887] =new setGoods("0000a93523","70","55","100","black","normal");
goods[2888] =new setGoods("0000a93524","80","55","100","black","normal");
goods[2889] =new setGoods("0000a93525","90","55","100","black","normal");
goods[2890] =new setGoods("0000a93526","100","55","100","black","normal");
goods[2891] =new setGoods("0000a93527","110","55","100","black","normal");
goods[2892] =new setGoods("0000a93528","120","55","100","black","normal");
goods[2893] =new setGoods("0000a93529","130","55","100","black","normal");
goods[2894] =new setGoods("0000a93530","140","55","100","black","normal");
goods[2895] =new setGoods("0000a93531","150","55","100","black","normal");
goods[2896] =new setGoods("0000a93532","160","55","100","black","normal");
goods[2897] =new setGoods("0000a93533","170","55","100","black","normal");
goods[2898] =new setGoods("0000a93534","180","55","100","black","normal");
goods[2899] =new setGoods("0000a93535","60","60","100","black","normal");
goods[2900] =new setGoods("0000a93536","70","60","100","black","normal");
goods[2901] =new setGoods("0000a93537","80","60","100","black","normal");
goods[2902] =new setGoods("0000a93538","90","60","100","black","normal");
goods[2903] =new setGoods("0000a93539","100","60","100","black","normal");
goods[2904] =new setGoods("0000a93540","110","60","100","black","normal");
goods[2905] =new setGoods("0000a93541","120","60","100","black","normal");
goods[2906] =new setGoods("0000a93542","130","60","100","black","normal");
goods[2907] =new setGoods("0000a93543","140","60","100","black","normal");
goods[2908] =new setGoods("0000a93544","150","60","100","black","normal");
goods[2909] =new setGoods("0000a93545","160","60","100","black","normal");
goods[2910] =new setGoods("0000a93546","170","60","100","black","normal");
goods[2911] =new setGoods("0000a93547","180","60","100","black","normal");
goods[2912] =new setGoods("0000a93548","60","25","40","bp","normal");
goods[2913] =new setGoods("0000a93549","70","25","40","bp","normal");
goods[2914] =new setGoods("0000a93550","80","25","40","bp","normal");
goods[2915] =new setGoods("0000a93551","90","25","40","bp","normal");
goods[2916] =new setGoods("0000a93552","100","25","40","bp","normal");
goods[2917] =new setGoods("0000a93553","110","25","40","bp","normal");
goods[2918] =new setGoods("0000a93554","120","25","40","bp","normal");
goods[2919] =new setGoods("0000a93555","130","25","40","bp","normal");
goods[2920] =new setGoods("0000a93556","140","25","40","bp","normal");
goods[2921] =new setGoods("0000a93557","150","25","40","bp","normal");
goods[2922] =new setGoods("0000a93558","160","25","40","bp","normal");
goods[2923] =new setGoods("0000a93559","170","25","40","bp","normal");
goods[2924] =new setGoods("0000a93560","180","25","40","bp","normal");
goods[2925] =new setGoods("0000a93561","60","30","40","bp","normal");
goods[2926] =new setGoods("0000a93562","70","30","40","bp","normal");
goods[2927] =new setGoods("0000a93563","80","30","40","bp","normal");
goods[2928] =new setGoods("0000a93564","90","30","40","bp","normal");
goods[2929] =new setGoods("0000a93565","100","30","40","bp","normal");
goods[2930] =new setGoods("0000a93566","110","30","40","bp","normal");
goods[2931] =new setGoods("0000a93567","120","30","40","bp","normal");
goods[2932] =new setGoods("0000a93568","130","30","40","bp","normal");
goods[2933] =new setGoods("0000a93569","140","30","40","bp","normal");
goods[2934] =new setGoods("0000a93570","150","30","40","bp","normal");
goods[2935] =new setGoods("0000a93571","160","30","40","bp","normal");
goods[2936] =new setGoods("0000a93572","170","30","40","bp","normal");
goods[2937] =new setGoods("0000a93573","180","30","40","bp","normal");
goods[2938] =new setGoods("0000a93574","60","35","40","bp","normal");
goods[2939] =new setGoods("0000a93575","70","35","40","bp","normal");
goods[2940] =new setGoods("0000a93576","80","35","40","bp","normal");
goods[2941] =new setGoods("0000a93577","90","35","40","bp","normal");
goods[2942] =new setGoods("0000a93578","100","35","40","bp","normal");
goods[2943] =new setGoods("0000a93579","110","35","40","bp","normal");
goods[2944] =new setGoods("0000a93580","120","35","40","bp","normal");
goods[2945] =new setGoods("0000a93581","130","35","40","bp","normal");
goods[2946] =new setGoods("0000a93582","140","35","40","bp","normal");
goods[2947] =new setGoods("0000a93583","150","35","40","bp","normal");
goods[2948] =new setGoods("0000a93584","160","35","40","bp","normal");
goods[2949] =new setGoods("0000a93585","170","35","40","bp","normal");
goods[2950] =new setGoods("0000a93586","180","35","40","bp","normal");
goods[2951] =new setGoods("0000a93587","60","40","40","bp","normal");
goods[2952] =new setGoods("0000a93588","70","40","40","bp","normal");
goods[2953] =new setGoods("0000a93589","80","40","40","bp","normal");
goods[2954] =new setGoods("0000a93590","90","40","40","bp","normal");
goods[2955] =new setGoods("0000a93591","100","40","40","bp","normal");
goods[2956] =new setGoods("0000a93592","110","40","40","bp","normal");
goods[2957] =new setGoods("0000a93593","120","40","40","bp","normal");
goods[2958] =new setGoods("0000a93594","130","40","40","bp","normal");
goods[2959] =new setGoods("0000a93595","140","40","40","bp","normal");
goods[2960] =new setGoods("0000a93596","150","40","40","bp","normal");
goods[2961] =new setGoods("0000a93597","160","40","40","bp","normal");
goods[2962] =new setGoods("0000a93598","170","40","40","bp","normal");
goods[2963] =new setGoods("0000a93599","180","40","40","bp","normal");
goods[2964] =new setGoods("0000a93600","60","45","40","bp","normal");
goods[2965] =new setGoods("0000a93601","70","45","40","bp","normal");
goods[2966] =new setGoods("0000a93602","80","45","40","bp","normal");
goods[2967] =new setGoods("0000a93603","90","45","40","bp","normal");
goods[2968] =new setGoods("0000a93604","100","45","40","bp","normal");
goods[2969] =new setGoods("0000a93605","110","45","40","bp","normal");
goods[2970] =new setGoods("0000a93606","120","45","40","bp","normal");
goods[2971] =new setGoods("0000a93607","130","45","40","bp","normal");
goods[2972] =new setGoods("0000a93608","140","45","40","bp","normal");
goods[2973] =new setGoods("0000a93609","150","45","40","bp","normal");
goods[2974] =new setGoods("0000a93610","160","45","40","bp","normal");
goods[2975] =new setGoods("0000a93611","170","45","40","bp","normal");
goods[2976] =new setGoods("0000a93612","180","45","40","bp","normal");
goods[2977] =new setGoods("0000a93613","60","50","40","bp","normal");
goods[2978] =new setGoods("0000a93614","70","50","40","bp","normal");
goods[2979] =new setGoods("0000a93615","80","50","40","bp","normal");
goods[2980] =new setGoods("0000a93616","90","50","40","bp","normal");
goods[2981] =new setGoods("0000a93617","100","50","40","bp","normal");
goods[2982] =new setGoods("0000a93618","110","50","40","bp","normal");
goods[2983] =new setGoods("0000a93619","120","50","40","bp","normal");
goods[2984] =new setGoods("0000a93620","130","50","40","bp","normal");
goods[2985] =new setGoods("0000a93621","140","50","40","bp","normal");
goods[2986] =new setGoods("0000a93622","150","50","40","bp","normal");
goods[2987] =new setGoods("0000a93623","160","50","40","bp","normal");
goods[2988] =new setGoods("0000a93624","170","50","40","bp","normal");
goods[2989] =new setGoods("0000a93625","180","50","40","bp","normal");
goods[2990] =new setGoods("0000a93626","60","55","40","bp","normal");
goods[2991] =new setGoods("0000a93627","70","55","40","bp","normal");
goods[2992] =new setGoods("0000a93628","80","55","40","bp","normal");
goods[2993] =new setGoods("0000a93629","90","55","40","bp","normal");
goods[2994] =new setGoods("0000a93630","100","55","40","bp","normal");
goods[2995] =new setGoods("0000a93631","110","55","40","bp","normal");
goods[2996] =new setGoods("0000a93632","120","55","40","bp","normal");
goods[2997] =new setGoods("0000a93633","130","55","40","bp","normal");
goods[2998] =new setGoods("0000a93634","140","55","40","bp","normal");
goods[2999] =new setGoods("0000a93635","150","55","40","bp","normal");
goods[3000] =new setGoods("0000a93636","160","55","40","bp","normal");
goods[3001] =new setGoods("0000a93637","170","55","40","bp","normal");
goods[3002] =new setGoods("0000a93638","180","55","40","bp","normal");
goods[3003] =new setGoods("0000a93639","60","60","40","bp","normal");
goods[3004] =new setGoods("0000a93640","70","60","40","bp","normal");
goods[3005] =new setGoods("0000a93641","80","60","40","bp","normal");
goods[3006] =new setGoods("0000a93642","90","60","40","bp","normal");
goods[3007] =new setGoods("0000a93643","100","60","40","bp","normal");
goods[3008] =new setGoods("0000a93644","110","60","40","bp","normal");
goods[3009] =new setGoods("0000a93645","120","60","40","bp","normal");
goods[3010] =new setGoods("0000a93646","130","60","40","bp","normal");
goods[3011] =new setGoods("0000a93647","140","60","40","bp","normal");
goods[3012] =new setGoods("0000a93648","150","60","40","bp","normal");
goods[3013] =new setGoods("0000a93649","160","60","40","bp","normal");
goods[3014] =new setGoods("0000a93650","170","60","40","bp","normal");
goods[3015] =new setGoods("0000a93651","180","60","40","bp","normal");
goods[3016] =new setGoods("0000a93652","60","25","50","bp","normal");
goods[3017] =new setGoods("0000a93653","70","25","50","bp","normal");
goods[3018] =new setGoods("0000a93654","80","25","50","bp","normal");
goods[3019] =new setGoods("0000a93655","90","25","50","bp","normal");
goods[3020] =new setGoods("0000a93656","100","25","50","bp","normal");
goods[3021] =new setGoods("0000a93657","110","25","50","bp","normal");
goods[3022] =new setGoods("0000a93658","120","25","50","bp","normal");
goods[3023] =new setGoods("0000a93659","130","25","50","bp","normal");
goods[3024] =new setGoods("0000a93660","140","25","50","bp","normal");
goods[3025] =new setGoods("0000a93661","150","25","50","bp","normal");
goods[3026] =new setGoods("0000a93662","160","25","50","bp","normal");
goods[3027] =new setGoods("0000a93663","170","25","50","bp","normal");
goods[3028] =new setGoods("0000a93664","180","25","50","bp","normal");
goods[3029] =new setGoods("0000a93665","60","30","50","bp","normal");
goods[3030] =new setGoods("0000a93666","70","30","50","bp","normal");
goods[3031] =new setGoods("0000a93667","80","30","50","bp","normal");
goods[3032] =new setGoods("0000a93668","90","30","50","bp","normal");
goods[3033] =new setGoods("0000a93669","100","30","50","bp","normal");
goods[3034] =new setGoods("0000a93670","110","30","50","bp","normal");
goods[3035] =new setGoods("0000a93671","120","30","50","bp","normal");
goods[3036] =new setGoods("0000a93672","130","30","50","bp","normal");
goods[3037] =new setGoods("0000a93673","140","30","50","bp","normal");
goods[3038] =new setGoods("0000a93674","150","30","50","bp","normal");
goods[3039] =new setGoods("0000a93675","160","30","50","bp","normal");
goods[3040] =new setGoods("0000a93676","170","30","50","bp","normal");
goods[3041] =new setGoods("0000a93677","180","30","50","bp","normal");
goods[3042] =new setGoods("0000a93678","60","35","50","bp","normal");
goods[3043] =new setGoods("0000a93679","70","35","50","bp","normal");
goods[3044] =new setGoods("0000a93680","80","35","50","bp","normal");
goods[3045] =new setGoods("0000a93681","90","35","50","bp","normal");
goods[3046] =new setGoods("0000a93682","100","35","50","bp","normal");
goods[3047] =new setGoods("0000a93683","110","35","50","bp","normal");
goods[3048] =new setGoods("0000a93684","120","35","50","bp","normal");
goods[3049] =new setGoods("0000a93685","130","35","50","bp","normal");
goods[3050] =new setGoods("0000a93686","140","35","50","bp","normal");
goods[3051] =new setGoods("0000a93687","150","35","50","bp","normal");
goods[3052] =new setGoods("0000a93688","160","35","50","bp","normal");
goods[3053] =new setGoods("0000a93689","170","35","50","bp","normal");
goods[3054] =new setGoods("0000a93690","180","35","50","bp","normal");
goods[3055] =new setGoods("0000a93691","60","40","50","bp","normal");
goods[3056] =new setGoods("0000a93692","70","40","50","bp","normal");
goods[3057] =new setGoods("0000a93693","80","40","50","bp","normal");
goods[3058] =new setGoods("0000a93694","90","40","50","bp","normal");
goods[3059] =new setGoods("0000a93695","100","40","50","bp","normal");
goods[3060] =new setGoods("0000a93696","110","40","50","bp","normal");
goods[3061] =new setGoods("0000a93697","120","40","50","bp","normal");
goods[3062] =new setGoods("0000a93698","130","40","50","bp","normal");
goods[3063] =new setGoods("0000a93699","140","40","50","bp","normal");
goods[3064] =new setGoods("0000a93700","150","40","50","bp","normal");
goods[3065] =new setGoods("0000a93701","160","40","50","bp","normal");
goods[3066] =new setGoods("0000a93702","170","40","50","bp","normal");
goods[3067] =new setGoods("0000a93703","180","40","50","bp","normal");
goods[3068] =new setGoods("0000a93704","60","45","50","bp","normal");
goods[3069] =new setGoods("0000a93705","70","45","50","bp","normal");
goods[3070] =new setGoods("0000a93706","80","45","50","bp","normal");
goods[3071] =new setGoods("0000a93707","90","45","50","bp","normal");
goods[3072] =new setGoods("0000a93708","100","45","50","bp","normal");
goods[3073] =new setGoods("0000a93709","110","45","50","bp","normal");
goods[3074] =new setGoods("0000a93710","120","45","50","bp","normal");
goods[3075] =new setGoods("0000a93711","130","45","50","bp","normal");
goods[3076] =new setGoods("0000a93712","140","45","50","bp","normal");
goods[3077] =new setGoods("0000a93713","150","45","50","bp","normal");
goods[3078] =new setGoods("0000a93714","160","45","50","bp","normal");
goods[3079] =new setGoods("0000a93715","170","45","50","bp","normal");
goods[3080] =new setGoods("0000a93716","180","45","50","bp","normal");
goods[3081] =new setGoods("0000a93717","60","50","50","bp","normal");
goods[3082] =new setGoods("0000a93718","70","50","50","bp","normal");
goods[3083] =new setGoods("0000a93719","80","50","50","bp","normal");
goods[3084] =new setGoods("0000a93720","90","50","50","bp","normal");
goods[3085] =new setGoods("0000a93721","100","50","50","bp","normal");
goods[3086] =new setGoods("0000a93722","110","50","50","bp","normal");
goods[3087] =new setGoods("0000a93723","120","50","50","bp","normal");
goods[3088] =new setGoods("0000a93724","130","50","50","bp","normal");
goods[3089] =new setGoods("0000a93725","140","50","50","bp","normal");
goods[3090] =new setGoods("0000a93726","150","50","50","bp","normal");
goods[3091] =new setGoods("0000a93727","160","50","50","bp","normal");
goods[3092] =new setGoods("0000a93728","170","50","50","bp","normal");
goods[3093] =new setGoods("0000a93729","180","50","50","bp","normal");
goods[3094] =new setGoods("0000a93730","60","55","50","bp","normal");
goods[3095] =new setGoods("0000a93731","70","55","50","bp","normal");
goods[3096] =new setGoods("0000a93732","80","55","50","bp","normal");
goods[3097] =new setGoods("0000a93733","90","55","50","bp","normal");
goods[3098] =new setGoods("0000a93734","100","55","50","bp","normal");
goods[3099] =new setGoods("0000a93735","110","55","50","bp","normal");
goods[3100] =new setGoods("0000a93736","120","55","50","bp","normal");
goods[3101] =new setGoods("0000a93737","130","55","50","bp","normal");
goods[3102] =new setGoods("0000a93738","140","55","50","bp","normal");
goods[3103] =new setGoods("0000a93739","150","55","50","bp","normal");
goods[3104] =new setGoods("0000a93740","160","55","50","bp","normal");
goods[3105] =new setGoods("0000a93741","170","55","50","bp","normal");
goods[3106] =new setGoods("0000a93742","180","55","50","bp","normal");
goods[3107] =new setGoods("0000a93743","60","60","50","bp","normal");
goods[3108] =new setGoods("0000a93744","70","60","50","bp","normal");
goods[3109] =new setGoods("0000a93745","80","60","50","bp","normal");
goods[3110] =new setGoods("0000a93746","90","60","50","bp","normal");
goods[3111] =new setGoods("0000a93747","100","60","50","bp","normal");
goods[3112] =new setGoods("0000a93748","110","60","50","bp","normal");
goods[3113] =new setGoods("0000a93749","120","60","50","bp","normal");
goods[3114] =new setGoods("0000a93750","130","60","50","bp","normal");
goods[3115] =new setGoods("0000a93751","140","60","50","bp","normal");
goods[3116] =new setGoods("0000a93752","150","60","50","bp","normal");
goods[3117] =new setGoods("0000a93753","160","60","50","bp","normal");
goods[3118] =new setGoods("0000a93754","170","60","50","bp","normal");
goods[3119] =new setGoods("0000a93755","180","60","50","bp","normal");
goods[3120] =new setGoods("0000a93756","60","25","60","bp","normal");
goods[3121] =new setGoods("0000a93757","70","25","60","bp","normal");
goods[3122] =new setGoods("0000a93758","80","25","60","bp","normal");
goods[3123] =new setGoods("0000a93759","90","25","60","bp","normal");
goods[3124] =new setGoods("0000a93760","100","25","60","bp","normal");
goods[3125] =new setGoods("0000a93761","110","25","60","bp","normal");
goods[3126] =new setGoods("0000a93762","120","25","60","bp","normal");
goods[3127] =new setGoods("0000a93763","130","25","60","bp","normal");
goods[3128] =new setGoods("0000a93764","140","25","60","bp","normal");
goods[3129] =new setGoods("0000a93765","150","25","60","bp","normal");
goods[3130] =new setGoods("0000a93766","160","25","60","bp","normal");
goods[3131] =new setGoods("0000a93767","170","25","60","bp","normal");
goods[3132] =new setGoods("0000a93768","180","25","60","bp","normal");
goods[3133] =new setGoods("0000a93769","60","30","60","bp","normal");
goods[3134] =new setGoods("0000a93770","70","30","60","bp","normal");
goods[3135] =new setGoods("0000a93771","80","30","60","bp","normal");
goods[3136] =new setGoods("0000a93772","90","30","60","bp","normal");
goods[3137] =new setGoods("0000a93773","100","30","60","bp","normal");
goods[3138] =new setGoods("0000a93774","110","30","60","bp","normal");
goods[3139] =new setGoods("0000a93775","120","30","60","bp","normal");
goods[3140] =new setGoods("0000a93776","130","30","60","bp","normal");
goods[3141] =new setGoods("0000a93777","140","30","60","bp","normal");
goods[3142] =new setGoods("0000a93778","150","30","60","bp","normal");
goods[3143] =new setGoods("0000a93779","160","30","60","bp","normal");
goods[3144] =new setGoods("0000a93780","170","30","60","bp","normal");
goods[3145] =new setGoods("0000a93781","180","30","60","bp","normal");
goods[3146] =new setGoods("0000a93782","60","35","60","bp","normal");
goods[3147] =new setGoods("0000a93783","70","35","60","bp","normal");
goods[3148] =new setGoods("0000a93784","80","35","60","bp","normal");
goods[3149] =new setGoods("0000a93785","90","35","60","bp","normal");
goods[3150] =new setGoods("0000a93786","100","35","60","bp","normal");
goods[3151] =new setGoods("0000a93787","110","35","60","bp","normal");
goods[3152] =new setGoods("0000a93788","120","35","60","bp","normal");
goods[3153] =new setGoods("0000a93789","130","35","60","bp","normal");
goods[3154] =new setGoods("0000a93790","140","35","60","bp","normal");
goods[3155] =new setGoods("0000a93791","150","35","60","bp","normal");
goods[3156] =new setGoods("0000a93792","160","35","60","bp","normal");
goods[3157] =new setGoods("0000a93793","170","35","60","bp","normal");
goods[3158] =new setGoods("0000a93794","180","35","60","bp","normal");
goods[3159] =new setGoods("0000a93795","60","40","60","bp","normal");
goods[3160] =new setGoods("0000a93796","70","40","60","bp","normal");
goods[3161] =new setGoods("0000a93797","80","40","60","bp","normal");
goods[3162] =new setGoods("0000a93798","90","40","60","bp","normal");
goods[3163] =new setGoods("0000a93799","100","40","60","bp","normal");
goods[3164] =new setGoods("0000a93800","110","40","60","bp","normal");
goods[3165] =new setGoods("0000a93801","120","40","60","bp","normal");
goods[3166] =new setGoods("0000a93802","130","40","60","bp","normal");
goods[3167] =new setGoods("0000a93803","140","40","60","bp","normal");
goods[3168] =new setGoods("0000a93804","150","40","60","bp","normal");
goods[3169] =new setGoods("0000a93805","160","40","60","bp","normal");
goods[3170] =new setGoods("0000a93806","170","40","60","bp","normal");
goods[3171] =new setGoods("0000a93807","180","40","60","bp","normal");
goods[3172] =new setGoods("0000a93808","60","45","60","bp","normal");
goods[3173] =new setGoods("0000a93809","70","45","60","bp","normal");
goods[3174] =new setGoods("0000a93810","80","45","60","bp","normal");
goods[3175] =new setGoods("0000a93811","90","45","60","bp","normal");
goods[3176] =new setGoods("0000a93812","100","45","60","bp","normal");
goods[3177] =new setGoods("0000a93813","110","45","60","bp","normal");
goods[3178] =new setGoods("0000a93814","120","45","60","bp","normal");
goods[3179] =new setGoods("0000a93815","130","45","60","bp","normal");
goods[3180] =new setGoods("0000a93816","140","45","60","bp","normal");
goods[3181] =new setGoods("0000a93817","150","45","60","bp","normal");
goods[3182] =new setGoods("0000a93818","160","45","60","bp","normal");
goods[3183] =new setGoods("0000a93819","170","45","60","bp","normal");
goods[3184] =new setGoods("0000a93820","180","45","60","bp","normal");
goods[3185] =new setGoods("0000a93821","60","50","60","bp","normal");
goods[3186] =new setGoods("0000a93822","70","50","60","bp","normal");
goods[3187] =new setGoods("0000a93823","80","50","60","bp","normal");
goods[3188] =new setGoods("0000a93824","90","50","60","bp","normal");
goods[3189] =new setGoods("0000a93825","100","50","60","bp","normal");
goods[3190] =new setGoods("0000a93826","110","50","60","bp","normal");
goods[3191] =new setGoods("0000a93827","120","50","60","bp","normal");
goods[3192] =new setGoods("0000a93828","130","50","60","bp","normal");
goods[3193] =new setGoods("0000a93829","140","50","60","bp","normal");
goods[3194] =new setGoods("0000a93830","150","50","60","bp","normal");
goods[3195] =new setGoods("0000a93831","160","50","60","bp","normal");
goods[3196] =new setGoods("0000a93832","170","50","60","bp","normal");
goods[3197] =new setGoods("0000a93833","180","50","60","bp","normal");
goods[3198] =new setGoods("0000a93834","60","55","60","bp","normal");
goods[3199] =new setGoods("0000a93835","70","55","60","bp","normal");
goods[3200] =new setGoods("0000a93836","80","55","60","bp","normal");
goods[3201] =new setGoods("0000a93837","90","55","60","bp","normal");
goods[3202] =new setGoods("0000a93838","100","55","60","bp","normal");
goods[3203] =new setGoods("0000a93839","110","55","60","bp","normal");
goods[3204] =new setGoods("0000a93840","120","55","60","bp","normal");
goods[3205] =new setGoods("0000a93841","130","55","60","bp","normal");
goods[3206] =new setGoods("0000a93842","140","55","60","bp","normal");
goods[3207] =new setGoods("0000a93843","150","55","60","bp","normal");
goods[3208] =new setGoods("0000a93844","160","55","60","bp","normal");
goods[3209] =new setGoods("0000a93845","170","55","60","bp","normal");
goods[3210] =new setGoods("0000a93846","180","55","60","bp","normal");
goods[3211] =new setGoods("0000a93847","60","60","60","bp","normal");
goods[3212] =new setGoods("0000a93848","70","60","60","bp","normal");
goods[3213] =new setGoods("0000a93849","80","60","60","bp","normal");
goods[3214] =new setGoods("0000a93850","90","60","60","bp","normal");
goods[3215] =new setGoods("0000a93851","100","60","60","bp","normal");
goods[3216] =new setGoods("0000a93852","110","60","60","bp","normal");
goods[3217] =new setGoods("0000a93853","120","60","60","bp","normal");
goods[3218] =new setGoods("0000a93854","130","60","60","bp","normal");
goods[3219] =new setGoods("0000a93855","140","60","60","bp","normal");
goods[3220] =new setGoods("0000a93856","150","60","60","bp","normal");
goods[3221] =new setGoods("0000a93857","160","60","60","bp","normal");
goods[3222] =new setGoods("0000a93858","170","60","60","bp","normal");
goods[3223] =new setGoods("0000a93859","180","60","60","bp","normal");
goods[3224] =new setGoods("0000a93860","60","25","70","bp","normal");
goods[3225] =new setGoods("0000a93861","70","25","70","bp","normal");
goods[3226] =new setGoods("0000a93862","80","25","70","bp","normal");
goods[3227] =new setGoods("0000a93863","90","25","70","bp","normal");
goods[3228] =new setGoods("0000a93864","100","25","70","bp","normal");
goods[3229] =new setGoods("0000a93865","110","25","70","bp","normal");
goods[3230] =new setGoods("0000a93866","120","25","70","bp","normal");
goods[3231] =new setGoods("0000a93867","130","25","70","bp","normal");
goods[3232] =new setGoods("0000a93868","140","25","70","bp","normal");
goods[3233] =new setGoods("0000a93869","150","25","70","bp","normal");
goods[3234] =new setGoods("0000a93870","160","25","70","bp","normal");
goods[3235] =new setGoods("0000a93871","170","25","70","bp","normal");
goods[3236] =new setGoods("0000a93872","180","25","70","bp","normal");
goods[3237] =new setGoods("0000a93873","60","30","70","bp","normal");
goods[3238] =new setGoods("0000a93874","70","30","70","bp","normal");
goods[3239] =new setGoods("0000a93875","80","30","70","bp","normal");
goods[3240] =new setGoods("0000a93876","90","30","70","bp","normal");
goods[3241] =new setGoods("0000a93877","100","30","70","bp","normal");
goods[3242] =new setGoods("0000a93878","110","30","70","bp","normal");
goods[3243] =new setGoods("0000a93879","120","30","70","bp","normal");
goods[3244] =new setGoods("0000a93880","130","30","70","bp","normal");
goods[3245] =new setGoods("0000a93881","140","30","70","bp","normal");
goods[3246] =new setGoods("0000a93882","150","30","70","bp","normal");
goods[3247] =new setGoods("0000a93883","160","30","70","bp","normal");
goods[3248] =new setGoods("0000a93884","170","30","70","bp","normal");
goods[3249] =new setGoods("0000a93885","180","30","70","bp","normal");
goods[3250] =new setGoods("0000a93886","60","35","70","bp","normal");
goods[3251] =new setGoods("0000a93887","70","35","70","bp","normal");
goods[3252] =new setGoods("0000a93888","80","35","70","bp","normal");
goods[3253] =new setGoods("0000a93889","90","35","70","bp","normal");
goods[3254] =new setGoods("0000a93890","100","35","70","bp","normal");
goods[3255] =new setGoods("0000a93891","110","35","70","bp","normal");
goods[3256] =new setGoods("0000a93892","120","35","70","bp","normal");
goods[3257] =new setGoods("0000a93893","130","35","70","bp","normal");
goods[3258] =new setGoods("0000a93894","140","35","70","bp","normal");
goods[3259] =new setGoods("0000a93895","150","35","70","bp","normal");
goods[3260] =new setGoods("0000a93896","160","35","70","bp","normal");
goods[3261] =new setGoods("0000a93897","170","35","70","bp","normal");
goods[3262] =new setGoods("0000a93898","180","35","70","bp","normal");
goods[3263] =new setGoods("0000a93899","60","40","70","bp","normal");
goods[3264] =new setGoods("0000a93900","70","40","70","bp","normal");
goods[3265] =new setGoods("0000a93901","80","40","70","bp","normal");
goods[3266] =new setGoods("0000a93902","90","40","70","bp","normal");
goods[3267] =new setGoods("0000a93903","100","40","70","bp","normal");
goods[3268] =new setGoods("0000a93904","110","40","70","bp","normal");
goods[3269] =new setGoods("0000a93905","120","40","70","bp","normal");
goods[3270] =new setGoods("0000a93906","130","40","70","bp","normal");
goods[3271] =new setGoods("0000a93907","140","40","70","bp","normal");
goods[3272] =new setGoods("0000a93908","150","40","70","bp","normal");
goods[3273] =new setGoods("0000a93909","160","40","70","bp","normal");
goods[3274] =new setGoods("0000a93910","170","40","70","bp","normal");
goods[3275] =new setGoods("0000a93911","180","40","70","bp","normal");
goods[3276] =new setGoods("0000a93912","60","45","70","bp","normal");
goods[3277] =new setGoods("0000a93913","70","45","70","bp","normal");
goods[3278] =new setGoods("0000a93914","80","45","70","bp","normal");
goods[3279] =new setGoods("0000a93915","90","45","70","bp","normal");
goods[3280] =new setGoods("0000a93916","100","45","70","bp","normal");
goods[3281] =new setGoods("0000a93917","110","45","70","bp","normal");
goods[3282] =new setGoods("0000a93918","120","45","70","bp","normal");
goods[3283] =new setGoods("0000a93919","130","45","70","bp","normal");
goods[3284] =new setGoods("0000a93920","140","45","70","bp","normal");
goods[3285] =new setGoods("0000a93921","150","45","70","bp","normal");
goods[3286] =new setGoods("0000a93922","160","45","70","bp","normal");
goods[3287] =new setGoods("0000a93923","170","45","70","bp","normal");
goods[3288] =new setGoods("0000a93924","180","45","70","bp","normal");
goods[3289] =new setGoods("0000a93925","60","50","70","bp","normal");
goods[3290] =new setGoods("0000a93926","70","50","70","bp","normal");
goods[3291] =new setGoods("0000a93927","80","50","70","bp","normal");
goods[3292] =new setGoods("0000a93928","90","50","70","bp","normal");
goods[3293] =new setGoods("0000a93929","100","50","70","bp","normal");
goods[3294] =new setGoods("0000a93930","110","50","70","bp","normal");
goods[3295] =new setGoods("0000a93931","120","50","70","bp","normal");
goods[3296] =new setGoods("0000a93932","130","50","70","bp","normal");
goods[3297] =new setGoods("0000a93933","140","50","70","bp","normal");
goods[3298] =new setGoods("0000a93934","150","50","70","bp","normal");
goods[3299] =new setGoods("0000a93935","160","50","70","bp","normal");
goods[3300] =new setGoods("0000a93936","170","50","70","bp","normal");
goods[3301] =new setGoods("0000a93937","180","50","70","bp","normal");
goods[3302] =new setGoods("0000a93938","60","55","70","bp","normal");
goods[3303] =new setGoods("0000a93939","70","55","70","bp","normal");
goods[3304] =new setGoods("0000a93940","80","55","70","bp","normal");
goods[3305] =new setGoods("0000a93941","90","55","70","bp","normal");
goods[3306] =new setGoods("0000a93942","100","55","70","bp","normal");
goods[3307] =new setGoods("0000a93943","110","55","70","bp","normal");
goods[3308] =new setGoods("0000a93944","120","55","70","bp","normal");
goods[3309] =new setGoods("0000a93945","130","55","70","bp","normal");
goods[3310] =new setGoods("0000a93946","140","55","70","bp","normal");
goods[3311] =new setGoods("0000a93947","150","55","70","bp","normal");
goods[3312] =new setGoods("0000a93948","160","55","70","bp","normal");
goods[3313] =new setGoods("0000a93949","170","55","70","bp","normal");
goods[3314] =new setGoods("0000a93950","180","55","70","bp","normal");
goods[3315] =new setGoods("0000a93951","60","60","70","bp","normal");
goods[3316] =new setGoods("0000a93952","70","60","70","bp","normal");
goods[3317] =new setGoods("0000a93953","80","60","70","bp","normal");
goods[3318] =new setGoods("0000a93954","90","60","70","bp","normal");
goods[3319] =new setGoods("0000a93955","100","60","70","bp","normal");
goods[3320] =new setGoods("0000a93956","110","60","70","bp","normal");
goods[3321] =new setGoods("0000a93957","120","60","70","bp","normal");
goods[3322] =new setGoods("0000a93958","130","60","70","bp","normal");
goods[3323] =new setGoods("0000a93959","140","60","70","bp","normal");
goods[3324] =new setGoods("0000a93960","150","60","70","bp","normal");
goods[3325] =new setGoods("0000a93961","160","60","70","bp","normal");
goods[3326] =new setGoods("0000a93962","170","60","70","bp","normal");
goods[3327] =new setGoods("0000a93963","180","60","70","bp","normal");
goods[3328] =new setGoods("0000a93964","60","25","80","bp","normal");
goods[3329] =new setGoods("0000a93965","70","25","80","bp","normal");
goods[3330] =new setGoods("0000a93966","80","25","80","bp","normal");
goods[3331] =new setGoods("0000a93967","90","25","80","bp","normal");
goods[3332] =new setGoods("0000a93968","100","25","80","bp","normal");
goods[3333] =new setGoods("0000a93969","110","25","80","bp","normal");
goods[3334] =new setGoods("0000a93970","120","25","80","bp","normal");
goods[3335] =new setGoods("0000a93971","130","25","80","bp","normal");
goods[3336] =new setGoods("0000a93972","140","25","80","bp","normal");
goods[3337] =new setGoods("0000a93973","150","25","80","bp","normal");
goods[3338] =new setGoods("0000a93974","160","25","80","bp","normal");
goods[3339] =new setGoods("0000a93975","170","25","80","bp","normal");
goods[3340] =new setGoods("0000a93976","180","25","80","bp","normal");
goods[3341] =new setGoods("0000a93977","60","30","80","bp","normal");
goods[3342] =new setGoods("0000a93978","70","30","80","bp","normal");
goods[3343] =new setGoods("0000a93979","80","30","80","bp","normal");
goods[3344] =new setGoods("0000a93980","90","30","80","bp","normal");
goods[3345] =new setGoods("0000a93981","100","30","80","bp","normal");
goods[3346] =new setGoods("0000a93982","110","30","80","bp","normal");
goods[3347] =new setGoods("0000a93983","120","30","80","bp","normal");
goods[3348] =new setGoods("0000a93984","130","30","80","bp","normal");
goods[3349] =new setGoods("0000a93985","140","30","80","bp","normal");
goods[3350] =new setGoods("0000a93986","150","30","80","bp","normal");
goods[3351] =new setGoods("0000a93987","160","30","80","bp","normal");
goods[3352] =new setGoods("0000a93988","170","30","80","bp","normal");
goods[3353] =new setGoods("0000a93989","180","30","80","bp","normal");
goods[3354] =new setGoods("0000a93990","60","35","80","bp","normal");
goods[3355] =new setGoods("0000a93991","70","35","80","bp","normal");
goods[3356] =new setGoods("0000a93992","80","35","80","bp","normal");
goods[3357] =new setGoods("0000a93993","90","35","80","bp","normal");
goods[3358] =new setGoods("0000a93994","100","35","80","bp","normal");
goods[3359] =new setGoods("0000a93995","110","35","80","bp","normal");
goods[3360] =new setGoods("0000a93996","120","35","80","bp","normal");
goods[3361] =new setGoods("0000a93997","130","35","80","bp","normal");
goods[3362] =new setGoods("0000a93998","140","35","80","bp","normal");
goods[3363] =new setGoods("0000a93999","150","35","80","bp","normal");
goods[3364] =new setGoods("0000a94000","160","35","80","bp","normal");
goods[3365] =new setGoods("0000a94001","170","35","80","bp","normal");
goods[3366] =new setGoods("0000a94002","180","35","80","bp","normal");
goods[3367] =new setGoods("0000a94003","60","40","80","bp","normal");
goods[3368] =new setGoods("0000a94004","70","40","80","bp","normal");
goods[3369] =new setGoods("0000a94005","80","40","80","bp","normal");
goods[3370] =new setGoods("0000a94006","90","40","80","bp","normal");
goods[3371] =new setGoods("0000a94007","100","40","80","bp","normal");
goods[3372] =new setGoods("0000a94008","110","40","80","bp","normal");
goods[3373] =new setGoods("0000a94009","120","40","80","bp","normal");
goods[3374] =new setGoods("0000a94010","130","40","80","bp","normal");
goods[3375] =new setGoods("0000a94011","140","40","80","bp","normal");
goods[3376] =new setGoods("0000a94012","150","40","80","bp","normal");
goods[3377] =new setGoods("0000a94013","160","40","80","bp","normal");
goods[3378] =new setGoods("0000a94014","170","40","80","bp","normal");
goods[3379] =new setGoods("0000a94015","180","40","80","bp","normal");
goods[3380] =new setGoods("0000a94016","60","45","80","bp","normal");
goods[3381] =new setGoods("0000a94017","70","45","80","bp","normal");
goods[3382] =new setGoods("0000a94018","80","45","80","bp","normal");
goods[3383] =new setGoods("0000a94019","90","45","80","bp","normal");
goods[3384] =new setGoods("0000a94020","100","45","80","bp","normal");
goods[3385] =new setGoods("0000a94021","110","45","80","bp","normal");
goods[3386] =new setGoods("0000a94022","120","45","80","bp","normal");
goods[3387] =new setGoods("0000a94023","130","45","80","bp","normal");
goods[3388] =new setGoods("0000a94024","140","45","80","bp","normal");
goods[3389] =new setGoods("0000a94025","150","45","80","bp","normal");
goods[3390] =new setGoods("0000a94026","160","45","80","bp","normal");
goods[3391] =new setGoods("0000a94027","170","45","80","bp","normal");
goods[3392] =new setGoods("0000a94028","180","45","80","bp","normal");
goods[3393] =new setGoods("0000a94029","60","50","80","bp","normal");
goods[3394] =new setGoods("0000a94030","70","50","80","bp","normal");
goods[3395] =new setGoods("0000a94031","80","50","80","bp","normal");
goods[3396] =new setGoods("0000a94032","90","50","80","bp","normal");
goods[3397] =new setGoods("0000a94033","100","50","80","bp","normal");
goods[3398] =new setGoods("0000a94034","110","50","80","bp","normal");
goods[3399] =new setGoods("0000a94035","120","50","80","bp","normal");
goods[3400] =new setGoods("0000a94036","130","50","80","bp","normal");
goods[3401] =new setGoods("0000a94037","140","50","80","bp","normal");
goods[3402] =new setGoods("0000a94038","150","50","80","bp","normal");
goods[3403] =new setGoods("0000a94039","160","50","80","bp","normal");
goods[3404] =new setGoods("0000a94040","170","50","80","bp","normal");
goods[3405] =new setGoods("0000a94041","180","50","80","bp","normal");
goods[3406] =new setGoods("0000a94042","60","55","80","bp","normal");
goods[3407] =new setGoods("0000a94043","70","55","80","bp","normal");
goods[3408] =new setGoods("0000a94044","80","55","80","bp","normal");
goods[3409] =new setGoods("0000a94045","90","55","80","bp","normal");
goods[3410] =new setGoods("0000a94046","100","55","80","bp","normal");
goods[3411] =new setGoods("0000a94047","110","55","80","bp","normal");
goods[3412] =new setGoods("0000a94048","120","55","80","bp","normal");
goods[3413] =new setGoods("0000a94049","130","55","80","bp","normal");
goods[3414] =new setGoods("0000a94050","140","55","80","bp","normal");
goods[3415] =new setGoods("0000a94051","150","55","80","bp","normal");
goods[3416] =new setGoods("0000a94052","160","55","80","bp","normal");
goods[3417] =new setGoods("0000a94053","170","55","80","bp","normal");
goods[3418] =new setGoods("0000a94054","180","55","80","bp","normal");
goods[3419] =new setGoods("0000a94055","60","60","80","bp","normal");
goods[3420] =new setGoods("0000a94056","70","60","80","bp","normal");
goods[3421] =new setGoods("0000a94057","80","60","80","bp","normal");
goods[3422] =new setGoods("0000a94058","90","60","80","bp","normal");
goods[3423] =new setGoods("0000a94059","100","60","80","bp","normal");
goods[3424] =new setGoods("0000a94060","110","60","80","bp","normal");
goods[3425] =new setGoods("0000a94061","120","60","80","bp","normal");
goods[3426] =new setGoods("0000a94062","130","60","80","bp","normal");
goods[3427] =new setGoods("0000a94063","140","60","80","bp","normal");
goods[3428] =new setGoods("0000a94064","150","60","80","bp","normal");
goods[3429] =new setGoods("0000a94065","160","60","80","bp","normal");
goods[3430] =new setGoods("0000a94066","170","60","80","bp","normal");
goods[3431] =new setGoods("0000a94067","180","60","80","bp","normal");
goods[3432] =new setGoods("0000a94068","60","25","90","bp","normal");
goods[3433] =new setGoods("0000a94069","70","25","90","bp","normal");
goods[3434] =new setGoods("0000a94070","80","25","90","bp","normal");
goods[3435] =new setGoods("0000a94071","90","25","90","bp","normal");
goods[3436] =new setGoods("0000a94072","100","25","90","bp","normal");
goods[3437] =new setGoods("0000a94073","110","25","90","bp","normal");
goods[3438] =new setGoods("0000a94074","120","25","90","bp","normal");
goods[3439] =new setGoods("0000a94075","130","25","90","bp","normal");
goods[3440] =new setGoods("0000a94076","140","25","90","bp","normal");
goods[3441] =new setGoods("0000a94077","150","25","90","bp","normal");
goods[3442] =new setGoods("0000a94078","160","25","90","bp","normal");
goods[3443] =new setGoods("0000a94079","170","25","90","bp","normal");
goods[3444] =new setGoods("0000a94080","180","25","90","bp","normal");
goods[3445] =new setGoods("0000a94081","60","30","90","bp","normal");
goods[3446] =new setGoods("0000a94082","70","30","90","bp","normal");
goods[3447] =new setGoods("0000a94083","80","30","90","bp","normal");
goods[3448] =new setGoods("0000a94084","90","30","90","bp","normal");
goods[3449] =new setGoods("0000a94085","100","30","90","bp","normal");
goods[3450] =new setGoods("0000a94086","110","30","90","bp","normal");
goods[3451] =new setGoods("0000a94087","120","30","90","bp","normal");
goods[3452] =new setGoods("0000a94088","130","30","90","bp","normal");
goods[3453] =new setGoods("0000a94089","140","30","90","bp","normal");
goods[3454] =new setGoods("0000a94090","150","30","90","bp","normal");
goods[3455] =new setGoods("0000a94091","160","30","90","bp","normal");
goods[3456] =new setGoods("0000a94092","170","30","90","bp","normal");
goods[3457] =new setGoods("0000a94093","180","30","90","bp","normal");
goods[3458] =new setGoods("0000a94094","60","35","90","bp","normal");
goods[3459] =new setGoods("0000a94095","70","35","90","bp","normal");
goods[3460] =new setGoods("0000a94096","80","35","90","bp","normal");
goods[3461] =new setGoods("0000a94097","90","35","90","bp","normal");
goods[3462] =new setGoods("0000a94098","100","35","90","bp","normal");
goods[3463] =new setGoods("0000a94099","110","35","90","bp","normal");
goods[3464] =new setGoods("0000a94100","120","35","90","bp","normal");
goods[3465] =new setGoods("0000a94101","130","35","90","bp","normal");
goods[3466] =new setGoods("0000a94102","140","35","90","bp","normal");
goods[3467] =new setGoods("0000a94103","150","35","90","bp","normal");
goods[3468] =new setGoods("0000a94104","160","35","90","bp","normal");
goods[3469] =new setGoods("0000a94105","170","35","90","bp","normal");
goods[3470] =new setGoods("0000a94106","180","35","90","bp","normal");
goods[3471] =new setGoods("0000a94107","60","40","90","bp","normal");
goods[3472] =new setGoods("0000a94108","70","40","90","bp","normal");
goods[3473] =new setGoods("0000a94109","80","40","90","bp","normal");
goods[3474] =new setGoods("0000a94110","90","40","90","bp","normal");
goods[3475] =new setGoods("0000a94111","100","40","90","bp","normal");
goods[3476] =new setGoods("0000a94112","110","40","90","bp","normal");
goods[3477] =new setGoods("0000a94113","120","40","90","bp","normal");
goods[3478] =new setGoods("0000a94114","130","40","90","bp","normal");
goods[3479] =new setGoods("0000a94115","140","40","90","bp","normal");
goods[3480] =new setGoods("0000a94116","150","40","90","bp","normal");
goods[3481] =new setGoods("0000a94117","160","40","90","bp","normal");
goods[3482] =new setGoods("0000a94118","170","40","90","bp","normal");
goods[3483] =new setGoods("0000a94119","180","40","90","bp","normal");
goods[3484] =new setGoods("0000a94120","60","45","90","bp","normal");
goods[3485] =new setGoods("0000a94121","70","45","90","bp","normal");
goods[3486] =new setGoods("0000a94122","80","45","90","bp","normal");
goods[3487] =new setGoods("0000a94123","90","45","90","bp","normal");
goods[3488] =new setGoods("0000a94124","100","45","90","bp","normal");
goods[3489] =new setGoods("0000a94125","110","45","90","bp","normal");
goods[3490] =new setGoods("0000a94126","120","45","90","bp","normal");
goods[3491] =new setGoods("0000a94127","130","45","90","bp","normal");
goods[3492] =new setGoods("0000a94128","140","45","90","bp","normal");
goods[3493] =new setGoods("0000a94129","150","45","90","bp","normal");
goods[3494] =new setGoods("0000a94130","160","45","90","bp","normal");
goods[3495] =new setGoods("0000a94131","170","45","90","bp","normal");
goods[3496] =new setGoods("0000a94132","180","45","90","bp","normal");
goods[3497] =new setGoods("0000a94133","60","50","90","bp","normal");
goods[3498] =new setGoods("0000a94134","70","50","90","bp","normal");
goods[3499] =new setGoods("0000a94135","80","50","90","bp","normal");
goods[3500] =new setGoods("0000a94136","90","50","90","bp","normal");
goods[3501] =new setGoods("0000a94137","100","50","90","bp","normal");
goods[3502] =new setGoods("0000a94138","110","50","90","bp","normal");
goods[3503] =new setGoods("0000a94139","120","50","90","bp","normal");
goods[3504] =new setGoods("0000a94140","130","50","90","bp","normal");
goods[3505] =new setGoods("0000a94141","140","50","90","bp","normal");
goods[3506] =new setGoods("0000a94142","150","50","90","bp","normal");
goods[3507] =new setGoods("0000a94143","160","50","90","bp","normal");
goods[3508] =new setGoods("0000a94144","170","50","90","bp","normal");
goods[3509] =new setGoods("0000a94145","180","50","90","bp","normal");
goods[3510] =new setGoods("0000a94146","60","55","90","bp","normal");
goods[3511] =new setGoods("0000a94147","70","55","90","bp","normal");
goods[3512] =new setGoods("0000a94148","80","55","90","bp","normal");
goods[3513] =new setGoods("0000a94149","90","55","90","bp","normal");
goods[3514] =new setGoods("0000a94150","100","55","90","bp","normal");
goods[3515] =new setGoods("0000a94151","110","55","90","bp","normal");
goods[3516] =new setGoods("0000a94152","120","55","90","bp","normal");
goods[3517] =new setGoods("0000a94153","130","55","90","bp","normal");
goods[3518] =new setGoods("0000a94154","140","55","90","bp","normal");
goods[3519] =new setGoods("0000a94155","150","55","90","bp","normal");
goods[3520] =new setGoods("0000a94156","160","55","90","bp","normal");
goods[3521] =new setGoods("0000a94157","170","55","90","bp","normal");
goods[3522] =new setGoods("0000a94158","180","55","90","bp","normal");
goods[3523] =new setGoods("0000a94159","60","60","90","bp","normal");
goods[3524] =new setGoods("0000a94160","70","60","90","bp","normal");
goods[3525] =new setGoods("0000a94161","80","60","90","bp","normal");
goods[3526] =new setGoods("0000a94162","90","60","90","bp","normal");
goods[3527] =new setGoods("0000a94163","100","60","90","bp","normal");
goods[3528] =new setGoods("0000a94164","110","60","90","bp","normal");
goods[3529] =new setGoods("0000a94165","120","60","90","bp","normal");
goods[3530] =new setGoods("0000a94166","130","60","90","bp","normal");
goods[3531] =new setGoods("0000a94167","140","60","90","bp","normal");
goods[3532] =new setGoods("0000a94168","150","60","90","bp","normal");
goods[3533] =new setGoods("0000a94169","160","60","90","bp","normal");
goods[3534] =new setGoods("0000a94170","170","60","90","bp","normal");
goods[3535] =new setGoods("0000a94171","180","60","90","bp","normal");
goods[3536] =new setGoods("0000a94172","60","25","100","bp","normal");
goods[3537] =new setGoods("0000a94173","70","25","100","bp","normal");
goods[3538] =new setGoods("0000a94174","80","25","100","bp","normal");
goods[3539] =new setGoods("0000a94175","90","25","100","bp","normal");
goods[3540] =new setGoods("0000a94176","100","25","100","bp","normal");
goods[3541] =new setGoods("0000a94177","110","25","100","bp","normal");
goods[3542] =new setGoods("0000a94178","120","25","100","bp","normal");
goods[3543] =new setGoods("0000a94179","130","25","100","bp","normal");
goods[3544] =new setGoods("0000a94180","140","25","100","bp","normal");
goods[3545] =new setGoods("0000a94181","150","25","100","bp","normal");
goods[3546] =new setGoods("0000a94182","160","25","100","bp","normal");
goods[3547] =new setGoods("0000a94183","170","25","100","bp","normal");
goods[3548] =new setGoods("0000a94184","180","25","100","bp","normal");
goods[3549] =new setGoods("0000a94185","60","30","100","bp","normal");
goods[3550] =new setGoods("0000a94186","70","30","100","bp","normal");
goods[3551] =new setGoods("0000a94187","80","30","100","bp","normal");
goods[3552] =new setGoods("0000a94188","90","30","100","bp","normal");
goods[3553] =new setGoods("0000a94189","100","30","100","bp","normal");
goods[3554] =new setGoods("0000a94190","110","30","100","bp","normal");
goods[3555] =new setGoods("0000a94191","120","30","100","bp","normal");
goods[3556] =new setGoods("0000a94192","130","30","100","bp","normal");
goods[3557] =new setGoods("0000a94193","140","30","100","bp","normal");
goods[3558] =new setGoods("0000a94194","150","30","100","bp","normal");
goods[3559] =new setGoods("0000a94195","160","30","100","bp","normal");
goods[3560] =new setGoods("0000a94196","170","30","100","bp","normal");
goods[3561] =new setGoods("0000a94197","180","30","100","bp","normal");
goods[3562] =new setGoods("0000a94198","60","35","100","bp","normal");
goods[3563] =new setGoods("0000a94199","70","35","100","bp","normal");
goods[3564] =new setGoods("0000a94200","80","35","100","bp","normal");
goods[3565] =new setGoods("0000a94201","90","35","100","bp","normal");
goods[3566] =new setGoods("0000a94202","100","35","100","bp","normal");
goods[3567] =new setGoods("0000a94203","110","35","100","bp","normal");
goods[3568] =new setGoods("0000a94204","120","35","100","bp","normal");
goods[3569] =new setGoods("0000a94205","130","35","100","bp","normal");
goods[3570] =new setGoods("0000a94206","140","35","100","bp","normal");
goods[3571] =new setGoods("0000a94207","150","35","100","bp","normal");
goods[3572] =new setGoods("0000a94208","160","35","100","bp","normal");
goods[3573] =new setGoods("0000a94209","170","35","100","bp","normal");
goods[3574] =new setGoods("0000a94210","180","35","100","bp","normal");
goods[3575] =new setGoods("0000a94211","60","40","100","bp","normal");
goods[3576] =new setGoods("0000a94212","70","40","100","bp","normal");
goods[3577] =new setGoods("0000a94213","80","40","100","bp","normal");
goods[3578] =new setGoods("0000a94214","90","40","100","bp","normal");
goods[3579] =new setGoods("0000a94215","100","40","100","bp","normal");
goods[3580] =new setGoods("0000a94216","110","40","100","bp","normal");
goods[3581] =new setGoods("0000a94217","120","40","100","bp","normal");
goods[3582] =new setGoods("0000a94218","130","40","100","bp","normal");
goods[3583] =new setGoods("0000a94219","140","40","100","bp","normal");
goods[3584] =new setGoods("0000a94220","150","40","100","bp","normal");
goods[3585] =new setGoods("0000a94221","160","40","100","bp","normal");
goods[3586] =new setGoods("0000a94222","170","40","100","bp","normal");
goods[3587] =new setGoods("0000a94223","180","40","100","bp","normal");
goods[3588] =new setGoods("0000a94224","60","45","100","bp","normal");
goods[3589] =new setGoods("0000a94225","70","45","100","bp","normal");
goods[3590] =new setGoods("0000a94226","80","45","100","bp","normal");
goods[3591] =new setGoods("0000a94227","90","45","100","bp","normal");
goods[3592] =new setGoods("0000a94228","100","45","100","bp","normal");
goods[3593] =new setGoods("0000a94229","110","45","100","bp","normal");
goods[3594] =new setGoods("0000a94230","120","45","100","bp","normal");
goods[3595] =new setGoods("0000a94231","130","45","100","bp","normal");
goods[3596] =new setGoods("0000a94232","140","45","100","bp","normal");
goods[3597] =new setGoods("0000a94233","150","45","100","bp","normal");
goods[3598] =new setGoods("0000a94234","160","45","100","bp","normal");
goods[3599] =new setGoods("0000a94235","170","45","100","bp","normal");
goods[3600] =new setGoods("0000a94236","180","45","100","bp","normal");
goods[3601] =new setGoods("0000a94237","60","50","100","bp","normal");
goods[3602] =new setGoods("0000a94238","70","50","100","bp","normal");
goods[3603] =new setGoods("0000a94239","80","50","100","bp","normal");
goods[3604] =new setGoods("0000a94240","90","50","100","bp","normal");
goods[3605] =new setGoods("0000a94241","100","50","100","bp","normal");
goods[3606] =new setGoods("0000a94242","110","50","100","bp","normal");
goods[3607] =new setGoods("0000a94243","120","50","100","bp","normal");
goods[3608] =new setGoods("0000a94244","130","50","100","bp","normal");
goods[3609] =new setGoods("0000a94245","140","50","100","bp","normal");
goods[3610] =new setGoods("0000a94246","150","50","100","bp","normal");
goods[3611] =new setGoods("0000a94247","160","50","100","bp","normal");
goods[3612] =new setGoods("0000a94248","170","50","100","bp","normal");
goods[3613] =new setGoods("0000a94249","180","50","100","bp","normal");
goods[3614] =new setGoods("0000a94250","60","55","100","bp","normal");
goods[3615] =new setGoods("0000a94251","70","55","100","bp","normal");
goods[3616] =new setGoods("0000a94252","80","55","100","bp","normal");
goods[3617] =new setGoods("0000a94253","90","55","100","bp","normal");
goods[3618] =new setGoods("0000a94254","100","55","100","bp","normal");
goods[3619] =new setGoods("0000a94255","110","55","100","bp","normal");
goods[3620] =new setGoods("0000a94256","120","55","100","bp","normal");
goods[3621] =new setGoods("0000a94257","130","55","100","bp","normal");
goods[3622] =new setGoods("0000a94258","140","55","100","bp","normal");
goods[3623] =new setGoods("0000a94259","150","55","100","bp","normal");
goods[3624] =new setGoods("0000a94260","160","55","100","bp","normal");
goods[3625] =new setGoods("0000a94261","170","55","100","bp","normal");
goods[3626] =new setGoods("0000a94262","180","55","100","bp","normal");
goods[3627] =new setGoods("0000a94263","60","60","100","bp","normal");
goods[3628] =new setGoods("0000a94264","70","60","100","bp","normal");
goods[3629] =new setGoods("0000a94265","80","60","100","bp","normal");
goods[3630] =new setGoods("0000a94266","90","60","100","bp","normal");
goods[3631] =new setGoods("0000a94267","100","60","100","bp","normal");
goods[3632] =new setGoods("0000a94268","110","60","100","bp","normal");
goods[3633] =new setGoods("0000a94269","120","60","100","bp","normal");
goods[3634] =new setGoods("0000a94270","130","60","100","bp","normal");
goods[3635] =new setGoods("0000a94271","140","60","100","bp","normal");
goods[3636] =new setGoods("0000a94272","150","60","100","bp","normal");
goods[3637] =new setGoods("0000a94273","160","60","100","bp","normal");
goods[3638] =new setGoods("0000a94274","170","60","100","bp","normal");
goods[3639] =new setGoods("0000a94275","180","60","100","bp","normal");
goods[3640] =new setGoods("0000a94276","60","25","40","mb","normal");
goods[3641] =new setGoods("0000a94277","70","25","40","mb","normal");
goods[3642] =new setGoods("0000a94278","80","25","40","mb","normal");
goods[3643] =new setGoods("0000a94279","90","25","40","mb","normal");
goods[3644] =new setGoods("0000a94280","100","25","40","mb","normal");
goods[3645] =new setGoods("0000a94281","110","25","40","mb","normal");
goods[3646] =new setGoods("0000a94282","120","25","40","mb","normal");
goods[3647] =new setGoods("0000a94283","130","25","40","mb","normal");
goods[3648] =new setGoods("0000a94284","140","25","40","mb","normal");
goods[3649] =new setGoods("0000a94285","150","25","40","mb","normal");
goods[3650] =new setGoods("0000a94286","160","25","40","mb","normal");
goods[3651] =new setGoods("0000a94287","170","25","40","mb","normal");
goods[3652] =new setGoods("0000a94288","180","25","40","mb","normal");
goods[3653] =new setGoods("0000a94289","60","30","40","mb","normal");
goods[3654] =new setGoods("0000a94290","70","30","40","mb","normal");
goods[3655] =new setGoods("0000a94291","80","30","40","mb","normal");
goods[3656] =new setGoods("0000a94292","90","30","40","mb","normal");
goods[3657] =new setGoods("0000a94293","100","30","40","mb","normal");
goods[3658] =new setGoods("0000a94294","110","30","40","mb","normal");
goods[3659] =new setGoods("0000a94295","120","30","40","mb","normal");
goods[3660] =new setGoods("0000a94296","130","30","40","mb","normal");
goods[3661] =new setGoods("0000a94297","140","30","40","mb","normal");
goods[3662] =new setGoods("0000a94298","150","30","40","mb","normal");
goods[3663] =new setGoods("0000a94299","160","30","40","mb","normal");
goods[3664] =new setGoods("0000a94300","170","30","40","mb","normal");
goods[3665] =new setGoods("0000a94301","180","30","40","mb","normal");
goods[3666] =new setGoods("0000a94302","60","35","40","mb","normal");
goods[3667] =new setGoods("0000a94303","70","35","40","mb","normal");
goods[3668] =new setGoods("0000a94304","80","35","40","mb","normal");
goods[3669] =new setGoods("0000a94305","90","35","40","mb","normal");
goods[3670] =new setGoods("0000a94306","100","35","40","mb","normal");
goods[3671] =new setGoods("0000a94307","110","35","40","mb","normal");
goods[3672] =new setGoods("0000a94308","120","35","40","mb","normal");
goods[3673] =new setGoods("0000a94309","130","35","40","mb","normal");
goods[3674] =new setGoods("0000a94310","140","35","40","mb","normal");
goods[3675] =new setGoods("0000a94311","150","35","40","mb","normal");
goods[3676] =new setGoods("0000a94312","160","35","40","mb","normal");
goods[3677] =new setGoods("0000a94313","170","35","40","mb","normal");
goods[3678] =new setGoods("0000a94314","180","35","40","mb","normal");
goods[3679] =new setGoods("0000a94315","60","40","40","mb","normal");
goods[3680] =new setGoods("0000a94316","70","40","40","mb","normal");
goods[3681] =new setGoods("0000a94317","80","40","40","mb","normal");
goods[3682] =new setGoods("0000a94318","90","40","40","mb","normal");
goods[3683] =new setGoods("0000a94319","100","40","40","mb","normal");
goods[3684] =new setGoods("0000a94320","110","40","40","mb","normal");
goods[3685] =new setGoods("0000a94321","120","40","40","mb","normal");
goods[3686] =new setGoods("0000a94322","130","40","40","mb","normal");
goods[3687] =new setGoods("0000a94323","140","40","40","mb","normal");
goods[3688] =new setGoods("0000a94324","150","40","40","mb","normal");
goods[3689] =new setGoods("0000a94325","160","40","40","mb","normal");
goods[3690] =new setGoods("0000a94326","170","40","40","mb","normal");
goods[3691] =new setGoods("0000a94327","180","40","40","mb","normal");
goods[3692] =new setGoods("0000a94328","60","45","40","mb","normal");
goods[3693] =new setGoods("0000a94329","70","45","40","mb","normal");
goods[3694] =new setGoods("0000a94330","80","45","40","mb","normal");
goods[3695] =new setGoods("0000a94331","90","45","40","mb","normal");
goods[3696] =new setGoods("0000a94332","100","45","40","mb","normal");
goods[3697] =new setGoods("0000a94333","110","45","40","mb","normal");
goods[3698] =new setGoods("0000a94334","120","45","40","mb","normal");
goods[3699] =new setGoods("0000a94335","130","45","40","mb","normal");
goods[3700] =new setGoods("0000a94336","140","45","40","mb","normal");
goods[3701] =new setGoods("0000a94337","150","45","40","mb","normal");
goods[3702] =new setGoods("0000a94338","160","45","40","mb","normal");
goods[3703] =new setGoods("0000a94339","170","45","40","mb","normal");
goods[3704] =new setGoods("0000a94340","180","45","40","mb","normal");
goods[3705] =new setGoods("0000a94341","60","50","40","mb","normal");
goods[3706] =new setGoods("0000a94342","70","50","40","mb","normal");
goods[3707] =new setGoods("0000a94343","80","50","40","mb","normal");
goods[3708] =new setGoods("0000a94344","90","50","40","mb","normal");
goods[3709] =new setGoods("0000a94345","100","50","40","mb","normal");
goods[3710] =new setGoods("0000a94346","110","50","40","mb","normal");
goods[3711] =new setGoods("0000a94347","120","50","40","mb","normal");
goods[3712] =new setGoods("0000a94348","130","50","40","mb","normal");
goods[3713] =new setGoods("0000a94349","140","50","40","mb","normal");
goods[3714] =new setGoods("0000a94350","150","50","40","mb","normal");
goods[3715] =new setGoods("0000a94351","160","50","40","mb","normal");
goods[3716] =new setGoods("0000a94352","170","50","40","mb","normal");
goods[3717] =new setGoods("0000a94353","180","50","40","mb","normal");
goods[3718] =new setGoods("0000a94354","60","55","40","mb","normal");
goods[3719] =new setGoods("0000a94355","70","55","40","mb","normal");
goods[3720] =new setGoods("0000a94356","80","55","40","mb","normal");
goods[3721] =new setGoods("0000a94357","90","55","40","mb","normal");
goods[3722] =new setGoods("0000a94358","100","55","40","mb","normal");
goods[3723] =new setGoods("0000a94359","110","55","40","mb","normal");
goods[3724] =new setGoods("0000a94360","120","55","40","mb","normal");
goods[3725] =new setGoods("0000a94361","130","55","40","mb","normal");
goods[3726] =new setGoods("0000a94362","140","55","40","mb","normal");
goods[3727] =new setGoods("0000a94363","150","55","40","mb","normal");
goods[3728] =new setGoods("0000a94364","160","55","40","mb","normal");
goods[3729] =new setGoods("0000a94365","170","55","40","mb","normal");
goods[3730] =new setGoods("0000a94366","180","55","40","mb","normal");
goods[3731] =new setGoods("0000a94367","60","60","40","mb","normal");
goods[3732] =new setGoods("0000a94368","70","60","40","mb","normal");
goods[3733] =new setGoods("0000a94369","80","60","40","mb","normal");
goods[3734] =new setGoods("0000a94370","90","60","40","mb","normal");
goods[3735] =new setGoods("0000a94371","100","60","40","mb","normal");
goods[3736] =new setGoods("0000a94372","110","60","40","mb","normal");
goods[3737] =new setGoods("0000a94373","120","60","40","mb","normal");
goods[3738] =new setGoods("0000a94374","130","60","40","mb","normal");
goods[3739] =new setGoods("0000a94375","140","60","40","mb","normal");
goods[3740] =new setGoods("0000a94376","150","60","40","mb","normal");
goods[3741] =new setGoods("0000a94377","160","60","40","mb","normal");
goods[3742] =new setGoods("0000a94378","170","60","40","mb","normal");
goods[3743] =new setGoods("0000a94379","180","60","40","mb","normal");
goods[3744] =new setGoods("0000a94380","60","25","50","mb","normal");
goods[3745] =new setGoods("0000a94381","70","25","50","mb","normal");
goods[3746] =new setGoods("0000a94382","80","25","50","mb","normal");
goods[3747] =new setGoods("0000a94383","90","25","50","mb","normal");
goods[3748] =new setGoods("0000a94384","100","25","50","mb","normal");
goods[3749] =new setGoods("0000a94385","110","25","50","mb","normal");
goods[3750] =new setGoods("0000a94386","120","25","50","mb","normal");
goods[3751] =new setGoods("0000a94387","130","25","50","mb","normal");
goods[3752] =new setGoods("0000a94388","140","25","50","mb","normal");
goods[3753] =new setGoods("0000a94389","150","25","50","mb","normal");
goods[3754] =new setGoods("0000a94390","160","25","50","mb","normal");
goods[3755] =new setGoods("0000a94391","170","25","50","mb","normal");
goods[3756] =new setGoods("0000a94392","180","25","50","mb","normal");
goods[3757] =new setGoods("0000a94393","60","30","50","mb","normal");
goods[3758] =new setGoods("0000a94394","70","30","50","mb","normal");
goods[3759] =new setGoods("0000a94395","80","30","50","mb","normal");
goods[3760] =new setGoods("0000a94396","90","30","50","mb","normal");
goods[3761] =new setGoods("0000a94397","100","30","50","mb","normal");
goods[3762] =new setGoods("0000a94398","110","30","50","mb","normal");
goods[3763] =new setGoods("0000a94399","120","30","50","mb","normal");
goods[3764] =new setGoods("0000a94400","130","30","50","mb","normal");
goods[3765] =new setGoods("0000a94401","140","30","50","mb","normal");
goods[3766] =new setGoods("0000a94402","150","30","50","mb","normal");
goods[3767] =new setGoods("0000a94403","160","30","50","mb","normal");
goods[3768] =new setGoods("0000a94404","170","30","50","mb","normal");
goods[3769] =new setGoods("0000a94405","180","30","50","mb","normal");
goods[3770] =new setGoods("0000a94406","60","35","50","mb","normal");
goods[3771] =new setGoods("0000a94407","70","35","50","mb","normal");
goods[3772] =new setGoods("0000a94408","80","35","50","mb","normal");
goods[3773] =new setGoods("0000a94409","90","35","50","mb","normal");
goods[3774] =new setGoods("0000a94410","100","35","50","mb","normal");
goods[3775] =new setGoods("0000a94411","110","35","50","mb","normal");
goods[3776] =new setGoods("0000a94412","120","35","50","mb","normal");
goods[3777] =new setGoods("0000a94413","130","35","50","mb","normal");
goods[3778] =new setGoods("0000a94414","140","35","50","mb","normal");
goods[3779] =new setGoods("0000a94415","150","35","50","mb","normal");
goods[3780] =new setGoods("0000a94416","160","35","50","mb","normal");
goods[3781] =new setGoods("0000a94417","170","35","50","mb","normal");
goods[3782] =new setGoods("0000a94418","180","35","50","mb","normal");
goods[3783] =new setGoods("0000a94419","60","40","50","mb","normal");
goods[3784] =new setGoods("0000a94420","70","40","50","mb","normal");
goods[3785] =new setGoods("0000a94421","80","40","50","mb","normal");
goods[3786] =new setGoods("0000a94422","90","40","50","mb","normal");
goods[3787] =new setGoods("0000a94423","100","40","50","mb","normal");
goods[3788] =new setGoods("0000a94424","110","40","50","mb","normal");
goods[3789] =new setGoods("0000a94425","120","40","50","mb","normal");
goods[3790] =new setGoods("0000a94426","130","40","50","mb","normal");
goods[3791] =new setGoods("0000a94427","140","40","50","mb","normal");
goods[3792] =new setGoods("0000a94428","150","40","50","mb","normal");
goods[3793] =new setGoods("0000a94429","160","40","50","mb","normal");
goods[3794] =new setGoods("0000a94430","170","40","50","mb","normal");
goods[3795] =new setGoods("0000a94431","180","40","50","mb","normal");
goods[3796] =new setGoods("0000a94432","60","45","50","mb","normal");
goods[3797] =new setGoods("0000a94433","70","45","50","mb","normal");
goods[3798] =new setGoods("0000a94434","80","45","50","mb","normal");
goods[3799] =new setGoods("0000a94435","90","45","50","mb","normal");
goods[3800] =new setGoods("0000a94436","100","45","50","mb","normal");
goods[3801] =new setGoods("0000a94437","110","45","50","mb","normal");
goods[3802] =new setGoods("0000a94438","120","45","50","mb","normal");
goods[3803] =new setGoods("0000a94439","130","45","50","mb","normal");
goods[3804] =new setGoods("0000a94440","140","45","50","mb","normal");
goods[3805] =new setGoods("0000a94441","150","45","50","mb","normal");
goods[3806] =new setGoods("0000a94442","160","45","50","mb","normal");
goods[3807] =new setGoods("0000a94443","170","45","50","mb","normal");
goods[3808] =new setGoods("0000a94444","180","45","50","mb","normal");
goods[3809] =new setGoods("0000a94445","60","50","50","mb","normal");
goods[3810] =new setGoods("0000a94446","70","50","50","mb","normal");
goods[3811] =new setGoods("0000a94447","80","50","50","mb","normal");
goods[3812] =new setGoods("0000a94448","90","50","50","mb","normal");
goods[3813] =new setGoods("0000a94449","100","50","50","mb","normal");
goods[3814] =new setGoods("0000a94450","110","50","50","mb","normal");
goods[3815] =new setGoods("0000a94451","120","50","50","mb","normal");
goods[3816] =new setGoods("0000a94452","130","50","50","mb","normal");
goods[3817] =new setGoods("0000a94453","140","50","50","mb","normal");
goods[3818] =new setGoods("0000a94454","150","50","50","mb","normal");
goods[3819] =new setGoods("0000a94455","160","50","50","mb","normal");
goods[3820] =new setGoods("0000a94456","170","50","50","mb","normal");
goods[3821] =new setGoods("0000a94457","180","50","50","mb","normal");
goods[3822] =new setGoods("0000a94458","60","55","50","mb","normal");
goods[3823] =new setGoods("0000a94459","70","55","50","mb","normal");
goods[3824] =new setGoods("0000a94460","80","55","50","mb","normal");
goods[3825] =new setGoods("0000a94461","90","55","50","mb","normal");
goods[3826] =new setGoods("0000a94462","100","55","50","mb","normal");
goods[3827] =new setGoods("0000a94463","110","55","50","mb","normal");
goods[3828] =new setGoods("0000a94464","120","55","50","mb","normal");
goods[3829] =new setGoods("0000a94465","130","55","50","mb","normal");
goods[3830] =new setGoods("0000a94466","140","55","50","mb","normal");
goods[3831] =new setGoods("0000a94467","150","55","50","mb","normal");
goods[3832] =new setGoods("0000a94468","160","55","50","mb","normal");
goods[3833] =new setGoods("0000a94469","170","55","50","mb","normal");
goods[3834] =new setGoods("0000a94470","180","55","50","mb","normal");
goods[3835] =new setGoods("0000a94471","60","60","50","mb","normal");
goods[3836] =new setGoods("0000a94472","70","60","50","mb","normal");
goods[3837] =new setGoods("0000a94473","80","60","50","mb","normal");
goods[3838] =new setGoods("0000a94474","90","60","50","mb","normal");
goods[3839] =new setGoods("0000a94475","100","60","50","mb","normal");
goods[3840] =new setGoods("0000a94476","110","60","50","mb","normal");
goods[3841] =new setGoods("0000a94477","120","60","50","mb","normal");
goods[3842] =new setGoods("0000a94478","130","60","50","mb","normal");
goods[3843] =new setGoods("0000a94479","140","60","50","mb","normal");
goods[3844] =new setGoods("0000a94480","150","60","50","mb","normal");
goods[3845] =new setGoods("0000a94481","160","60","50","mb","normal");
goods[3846] =new setGoods("0000a94482","170","60","50","mb","normal");
goods[3847] =new setGoods("0000a94483","180","60","50","mb","normal");
goods[3848] =new setGoods("0000a94484","60","25","60","mb","normal");
goods[3849] =new setGoods("0000a94485","70","25","60","mb","normal");
goods[3850] =new setGoods("0000a94486","80","25","60","mb","normal");
goods[3851] =new setGoods("0000a94487","90","25","60","mb","normal");
goods[3852] =new setGoods("0000a94488","100","25","60","mb","normal");
goods[3853] =new setGoods("0000a94489","110","25","60","mb","normal");
goods[3854] =new setGoods("0000a94490","120","25","60","mb","normal");
goods[3855] =new setGoods("0000a94491","130","25","60","mb","normal");
goods[3856] =new setGoods("0000a94492","140","25","60","mb","normal");
goods[3857] =new setGoods("0000a94493","150","25","60","mb","normal");
goods[3858] =new setGoods("0000a94494","160","25","60","mb","normal");
goods[3859] =new setGoods("0000a94495","170","25","60","mb","normal");
goods[3860] =new setGoods("0000a94496","180","25","60","mb","normal");
goods[3861] =new setGoods("0000a94497","60","30","60","mb","normal");
goods[3862] =new setGoods("0000a94498","70","30","60","mb","normal");
goods[3863] =new setGoods("0000a94499","80","30","60","mb","normal");
goods[3864] =new setGoods("0000a94500","90","30","60","mb","normal");
goods[3865] =new setGoods("0000a94501","100","30","60","mb","normal");
goods[3866] =new setGoods("0000a94502","110","30","60","mb","normal");
goods[3867] =new setGoods("0000a94503","120","30","60","mb","normal");
goods[3868] =new setGoods("0000a94504","130","30","60","mb","normal");
goods[3869] =new setGoods("0000a94505","140","30","60","mb","normal");
goods[3870] =new setGoods("0000a94506","150","30","60","mb","normal");
goods[3871] =new setGoods("0000a94507","160","30","60","mb","normal");
goods[3872] =new setGoods("0000a94508","170","30","60","mb","normal");
goods[3873] =new setGoods("0000a94509","180","30","60","mb","normal");
goods[3874] =new setGoods("0000a94510","60","35","60","mb","normal");
goods[3875] =new setGoods("0000a94511","70","35","60","mb","normal");
goods[3876] =new setGoods("0000a94512","80","35","60","mb","normal");
goods[3877] =new setGoods("0000a94513","90","35","60","mb","normal");
goods[3878] =new setGoods("0000a94514","100","35","60","mb","normal");
goods[3879] =new setGoods("0000a94515","110","35","60","mb","normal");
goods[3880] =new setGoods("0000a94516","120","35","60","mb","normal");
goods[3881] =new setGoods("0000a94517","130","35","60","mb","normal");
goods[3882] =new setGoods("0000a94518","140","35","60","mb","normal");
goods[3883] =new setGoods("0000a94519","150","35","60","mb","normal");
goods[3884] =new setGoods("0000a94520","160","35","60","mb","normal");
goods[3885] =new setGoods("0000a94521","170","35","60","mb","normal");
goods[3886] =new setGoods("0000a94522","180","35","60","mb","normal");
goods[3887] =new setGoods("0000a94523","60","40","60","mb","normal");
goods[3888] =new setGoods("0000a94524","70","40","60","mb","normal");
goods[3889] =new setGoods("0000a94525","80","40","60","mb","normal");
goods[3890] =new setGoods("0000a94526","90","40","60","mb","normal");
goods[3891] =new setGoods("0000a94527","100","40","60","mb","normal");
goods[3892] =new setGoods("0000a94528","110","40","60","mb","normal");
goods[3893] =new setGoods("0000a94529","120","40","60","mb","normal");
goods[3894] =new setGoods("0000a94530","130","40","60","mb","normal");
goods[3895] =new setGoods("0000a94531","140","40","60","mb","normal");
goods[3896] =new setGoods("0000a94532","150","40","60","mb","normal");
goods[3897] =new setGoods("0000a94533","160","40","60","mb","normal");
goods[3898] =new setGoods("0000a94534","170","40","60","mb","normal");
goods[3899] =new setGoods("0000a94535","180","40","60","mb","normal");
goods[3900] =new setGoods("0000a94536","60","45","60","mb","normal");
goods[3901] =new setGoods("0000a94537","70","45","60","mb","normal");
goods[3902] =new setGoods("0000a94538","80","45","60","mb","normal");
goods[3903] =new setGoods("0000a94539","90","45","60","mb","normal");
goods[3904] =new setGoods("0000a94540","100","45","60","mb","normal");
goods[3905] =new setGoods("0000a94541","110","45","60","mb","normal");
goods[3906] =new setGoods("0000a94542","120","45","60","mb","normal");
goods[3907] =new setGoods("0000a94543","130","45","60","mb","normal");
goods[3908] =new setGoods("0000a94544","140","45","60","mb","normal");
goods[3909] =new setGoods("0000a94545","150","45","60","mb","normal");
goods[3910] =new setGoods("0000a94546","160","45","60","mb","normal");
goods[3911] =new setGoods("0000a94547","170","45","60","mb","normal");
goods[3912] =new setGoods("0000a94548","180","45","60","mb","normal");
goods[3913] =new setGoods("0000a94549","60","50","60","mb","normal");
goods[3914] =new setGoods("0000a94550","70","50","60","mb","normal");
goods[3915] =new setGoods("0000a94551","80","50","60","mb","normal");
goods[3916] =new setGoods("0000a94552","90","50","60","mb","normal");
goods[3917] =new setGoods("0000a94553","100","50","60","mb","normal");
goods[3918] =new setGoods("0000a94554","110","50","60","mb","normal");
goods[3919] =new setGoods("0000a94555","120","50","60","mb","normal");
goods[3920] =new setGoods("0000a94556","130","50","60","mb","normal");
goods[3921] =new setGoods("0000a94557","140","50","60","mb","normal");
goods[3922] =new setGoods("0000a94558","150","50","60","mb","normal");
goods[3923] =new setGoods("0000a94559","160","50","60","mb","normal");
goods[3924] =new setGoods("0000a94560","170","50","60","mb","normal");
goods[3925] =new setGoods("0000a94561","180","50","60","mb","normal");
goods[3926] =new setGoods("0000a94562","60","55","60","mb","normal");
goods[3927] =new setGoods("0000a94563","70","55","60","mb","normal");
goods[3928] =new setGoods("0000a94564","80","55","60","mb","normal");
goods[3929] =new setGoods("0000a94565","90","55","60","mb","normal");
goods[3930] =new setGoods("0000a94566","100","55","60","mb","normal");
goods[3931] =new setGoods("0000a94567","110","55","60","mb","normal");
goods[3932] =new setGoods("0000a94568","120","55","60","mb","normal");
goods[3933] =new setGoods("0000a94569","130","55","60","mb","normal");
goods[3934] =new setGoods("0000a94570","140","55","60","mb","normal");
goods[3935] =new setGoods("0000a94571","150","55","60","mb","normal");
goods[3936] =new setGoods("0000a94572","160","55","60","mb","normal");
goods[3937] =new setGoods("0000a94573","170","55","60","mb","normal");
goods[3938] =new setGoods("0000a94574","180","55","60","mb","normal");
goods[3939] =new setGoods("0000a94575","60","60","60","mb","normal");
goods[3940] =new setGoods("0000a94576","70","60","60","mb","normal");
goods[3941] =new setGoods("0000a94577","80","60","60","mb","normal");
goods[3942] =new setGoods("0000a94578","90","60","60","mb","normal");
goods[3943] =new setGoods("0000a94579","100","60","60","mb","normal");
goods[3944] =new setGoods("0000a94580","110","60","60","mb","normal");
goods[3945] =new setGoods("0000a94581","120","60","60","mb","normal");
goods[3946] =new setGoods("0000a94582","130","60","60","mb","normal");
goods[3947] =new setGoods("0000a94583","140","60","60","mb","normal");
goods[3948] =new setGoods("0000a94584","150","60","60","mb","normal");
goods[3949] =new setGoods("0000a94585","160","60","60","mb","normal");
goods[3950] =new setGoods("0000a94586","170","60","60","mb","normal");
goods[3951] =new setGoods("0000a94587","180","60","60","mb","normal");
goods[3952] =new setGoods("0000a94588","60","25","70","mb","normal");
goods[3953] =new setGoods("0000a94589","70","25","70","mb","normal");
goods[3954] =new setGoods("0000a94590","80","25","70","mb","normal");
goods[3955] =new setGoods("0000a94591","90","25","70","mb","normal");
goods[3956] =new setGoods("0000a94592","100","25","70","mb","normal");
goods[3957] =new setGoods("0000a94593","110","25","70","mb","normal");
goods[3958] =new setGoods("0000a94594","120","25","70","mb","normal");
goods[3959] =new setGoods("0000a94595","130","25","70","mb","normal");
goods[3960] =new setGoods("0000a94596","140","25","70","mb","normal");
goods[3961] =new setGoods("0000a94597","150","25","70","mb","normal");
goods[3962] =new setGoods("0000a94598","160","25","70","mb","normal");
goods[3963] =new setGoods("0000a94599","170","25","70","mb","normal");
goods[3964] =new setGoods("0000a94600","180","25","70","mb","normal");
goods[3965] =new setGoods("0000a94601","60","30","70","mb","normal");
goods[3966] =new setGoods("0000a94602","70","30","70","mb","normal");
goods[3967] =new setGoods("0000a94603","80","30","70","mb","normal");
goods[3968] =new setGoods("0000a94604","90","30","70","mb","normal");
goods[3969] =new setGoods("0000a94605","100","30","70","mb","normal");
goods[3970] =new setGoods("0000a94606","110","30","70","mb","normal");
goods[3971] =new setGoods("0000a94607","120","30","70","mb","normal");
goods[3972] =new setGoods("0000a94608","130","30","70","mb","normal");
goods[3973] =new setGoods("0000a94609","140","30","70","mb","normal");
goods[3974] =new setGoods("0000a94610","150","30","70","mb","normal");
goods[3975] =new setGoods("0000a94611","160","30","70","mb","normal");
goods[3976] =new setGoods("0000a94612","170","30","70","mb","normal");
goods[3977] =new setGoods("0000a94613","180","30","70","mb","normal");
goods[3978] =new setGoods("0000a94614","60","35","70","mb","normal");
goods[3979] =new setGoods("0000a94615","70","35","70","mb","normal");
goods[3980] =new setGoods("0000a94616","80","35","70","mb","normal");
goods[3981] =new setGoods("0000a94617","90","35","70","mb","normal");
goods[3982] =new setGoods("0000a94618","100","35","70","mb","normal");
goods[3983] =new setGoods("0000a94619","110","35","70","mb","normal");
goods[3984] =new setGoods("0000a94620","120","35","70","mb","normal");
goods[3985] =new setGoods("0000a94621","130","35","70","mb","normal");
goods[3986] =new setGoods("0000a94622","140","35","70","mb","normal");
goods[3987] =new setGoods("0000a94623","150","35","70","mb","normal");
goods[3988] =new setGoods("0000a94624","160","35","70","mb","normal");
goods[3989] =new setGoods("0000a94625","170","35","70","mb","normal");
goods[3990] =new setGoods("0000a94626","180","35","70","mb","normal");
goods[3991] =new setGoods("0000a94627","60","40","70","mb","normal");
goods[3992] =new setGoods("0000a94628","70","40","70","mb","normal");
goods[3993] =new setGoods("0000a94629","80","40","70","mb","normal");
goods[3994] =new setGoods("0000a94630","90","40","70","mb","normal");
goods[3995] =new setGoods("0000a94631","100","40","70","mb","normal");
goods[3996] =new setGoods("0000a94632","110","40","70","mb","normal");
goods[3997] =new setGoods("0000a94633","120","40","70","mb","normal");
goods[3998] =new setGoods("0000a94634","130","40","70","mb","normal");
goods[3999] =new setGoods("0000a94635","140","40","70","mb","normal");
goods[4000] =new setGoods("0000a94636","150","40","70","mb","normal");
goods[4001] =new setGoods("0000a94637","160","40","70","mb","normal");
goods[4002] =new setGoods("0000a94638","170","40","70","mb","normal");
goods[4003] =new setGoods("0000a94639","180","40","70","mb","normal");
goods[4004] =new setGoods("0000a94640","60","45","70","mb","normal");
goods[4005] =new setGoods("0000a94641","70","45","70","mb","normal");
goods[4006] =new setGoods("0000a94642","80","45","70","mb","normal");
goods[4007] =new setGoods("0000a94643","90","45","70","mb","normal");
goods[4008] =new setGoods("0000a94644","100","45","70","mb","normal");
goods[4009] =new setGoods("0000a94645","110","45","70","mb","normal");
goods[4010] =new setGoods("0000a94646","120","45","70","mb","normal");
goods[4011] =new setGoods("0000a94647","130","45","70","mb","normal");
goods[4012] =new setGoods("0000a94648","140","45","70","mb","normal");
goods[4013] =new setGoods("0000a94649","150","45","70","mb","normal");
goods[4014] =new setGoods("0000a94650","160","45","70","mb","normal");
goods[4015] =new setGoods("0000a94651","170","45","70","mb","normal");
goods[4016] =new setGoods("0000a94652","180","45","70","mb","normal");
goods[4017] =new setGoods("0000a94653","60","50","70","mb","normal");
goods[4018] =new setGoods("0000a94654","70","50","70","mb","normal");
goods[4019] =new setGoods("0000a94655","80","50","70","mb","normal");
goods[4020] =new setGoods("0000a94656","90","50","70","mb","normal");
goods[4021] =new setGoods("0000a94657","100","50","70","mb","normal");
goods[4022] =new setGoods("0000a94658","110","50","70","mb","normal");
goods[4023] =new setGoods("0000a94659","120","50","70","mb","normal");
goods[4024] =new setGoods("0000a94660","130","50","70","mb","normal");
goods[4025] =new setGoods("0000a94661","140","50","70","mb","normal");
goods[4026] =new setGoods("0000a94662","150","50","70","mb","normal");
goods[4027] =new setGoods("0000a94663","160","50","70","mb","normal");
goods[4028] =new setGoods("0000a94664","170","50","70","mb","normal");
goods[4029] =new setGoods("0000a94665","180","50","70","mb","normal");
goods[4030] =new setGoods("0000a94666","60","55","70","mb","normal");
goods[4031] =new setGoods("0000a94667","70","55","70","mb","normal");
goods[4032] =new setGoods("0000a94668","80","55","70","mb","normal");
goods[4033] =new setGoods("0000a94669","90","55","70","mb","normal");
goods[4034] =new setGoods("0000a94670","100","55","70","mb","normal");
goods[4035] =new setGoods("0000a94671","110","55","70","mb","normal");
goods[4036] =new setGoods("0000a94672","120","55","70","mb","normal");
goods[4037] =new setGoods("0000a94673","130","55","70","mb","normal");
goods[4038] =new setGoods("0000a94674","140","55","70","mb","normal");
goods[4039] =new setGoods("0000a94675","150","55","70","mb","normal");
goods[4040] =new setGoods("0000a94676","160","55","70","mb","normal");
goods[4041] =new setGoods("0000a94677","170","55","70","mb","normal");
goods[4042] =new setGoods("0000a94678","180","55","70","mb","normal");
goods[4043] =new setGoods("0000a94679","60","60","70","mb","normal");
goods[4044] =new setGoods("0000a94680","70","60","70","mb","normal");
goods[4045] =new setGoods("0000a94681","80","60","70","mb","normal");
goods[4046] =new setGoods("0000a94682","90","60","70","mb","normal");
goods[4047] =new setGoods("0000a94683","100","60","70","mb","normal");
goods[4048] =new setGoods("0000a94684","110","60","70","mb","normal");
goods[4049] =new setGoods("0000a94685","120","60","70","mb","normal");
goods[4050] =new setGoods("0000a94686","130","60","70","mb","normal");
goods[4051] =new setGoods("0000a94687","140","60","70","mb","normal");
goods[4052] =new setGoods("0000a94688","150","60","70","mb","normal");
goods[4053] =new setGoods("0000a94689","160","60","70","mb","normal");
goods[4054] =new setGoods("0000a94690","170","60","70","mb","normal");
goods[4055] =new setGoods("0000a94691","180","60","70","mb","normal");
goods[4056] =new setGoods("0000a94692","60","25","80","mb","normal");
goods[4057] =new setGoods("0000a94693","70","25","80","mb","normal");
goods[4058] =new setGoods("0000a94694","80","25","80","mb","normal");
goods[4059] =new setGoods("0000a94695","90","25","80","mb","normal");
goods[4060] =new setGoods("0000a94696","100","25","80","mb","normal");
goods[4061] =new setGoods("0000a94697","110","25","80","mb","normal");
goods[4062] =new setGoods("0000a94698","120","25","80","mb","normal");
goods[4063] =new setGoods("0000a94699","130","25","80","mb","normal");
goods[4064] =new setGoods("0000a94700","140","25","80","mb","normal");
goods[4065] =new setGoods("0000a94701","150","25","80","mb","normal");
goods[4066] =new setGoods("0000a94702","160","25","80","mb","normal");
goods[4067] =new setGoods("0000a94703","170","25","80","mb","normal");
goods[4068] =new setGoods("0000a94704","180","25","80","mb","normal");
goods[4069] =new setGoods("0000a94705","60","30","80","mb","normal");
goods[4070] =new setGoods("0000a94706","70","30","80","mb","normal");
goods[4071] =new setGoods("0000a94707","80","30","80","mb","normal");
goods[4072] =new setGoods("0000a94708","90","30","80","mb","normal");
goods[4073] =new setGoods("0000a94709","100","30","80","mb","normal");
goods[4074] =new setGoods("0000a94710","110","30","80","mb","normal");
goods[4075] =new setGoods("0000a94711","120","30","80","mb","normal");
goods[4076] =new setGoods("0000a94712","130","30","80","mb","normal");
goods[4077] =new setGoods("0000a94713","140","30","80","mb","normal");
goods[4078] =new setGoods("0000a94714","150","30","80","mb","normal");
goods[4079] =new setGoods("0000a94715","160","30","80","mb","normal");
goods[4080] =new setGoods("0000a94716","170","30","80","mb","normal");
goods[4081] =new setGoods("0000a94717","180","30","80","mb","normal");
goods[4082] =new setGoods("0000a94718","60","35","80","mb","normal");
goods[4083] =new setGoods("0000a94719","70","35","80","mb","normal");
goods[4084] =new setGoods("0000a94720","80","35","80","mb","normal");
goods[4085] =new setGoods("0000a94721","90","35","80","mb","normal");
goods[4086] =new setGoods("0000a94722","100","35","80","mb","normal");
goods[4087] =new setGoods("0000a94723","110","35","80","mb","normal");
goods[4088] =new setGoods("0000a94724","120","35","80","mb","normal");
goods[4089] =new setGoods("0000a94725","130","35","80","mb","normal");
goods[4090] =new setGoods("0000a94726","140","35","80","mb","normal");
goods[4091] =new setGoods("0000a94727","150","35","80","mb","normal");
goods[4092] =new setGoods("0000a94728","160","35","80","mb","normal");
goods[4093] =new setGoods("0000a94729","170","35","80","mb","normal");
goods[4094] =new setGoods("0000a94730","180","35","80","mb","normal");
goods[4095] =new setGoods("0000a94731","60","40","80","mb","normal");
goods[4096] =new setGoods("0000a94732","70","40","80","mb","normal");
goods[4097] =new setGoods("0000a94733","80","40","80","mb","normal");
goods[4098] =new setGoods("0000a94734","90","40","80","mb","normal");
goods[4099] =new setGoods("0000a94735","100","40","80","mb","normal");
goods[4100] =new setGoods("0000a94736","110","40","80","mb","normal");
goods[4101] =new setGoods("0000a94737","120","40","80","mb","normal");
goods[4102] =new setGoods("0000a94738","130","40","80","mb","normal");
goods[4103] =new setGoods("0000a94739","140","40","80","mb","normal");
goods[4104] =new setGoods("0000a94740","150","40","80","mb","normal");
goods[4105] =new setGoods("0000a94741","160","40","80","mb","normal");
goods[4106] =new setGoods("0000a94742","170","40","80","mb","normal");
goods[4107] =new setGoods("0000a94743","180","40","80","mb","normal");
goods[4108] =new setGoods("0000a94744","60","45","80","mb","normal");
goods[4109] =new setGoods("0000a94745","70","45","80","mb","normal");
goods[4110] =new setGoods("0000a94746","80","45","80","mb","normal");
goods[4111] =new setGoods("0000a94747","90","45","80","mb","normal");
goods[4112] =new setGoods("0000a94748","100","45","80","mb","normal");
goods[4113] =new setGoods("0000a94749","110","45","80","mb","normal");
goods[4114] =new setGoods("0000a94750","120","45","80","mb","normal");
goods[4115] =new setGoods("0000a94751","130","45","80","mb","normal");
goods[4116] =new setGoods("0000a94752","140","45","80","mb","normal");
goods[4117] =new setGoods("0000a94753","150","45","80","mb","normal");
goods[4118] =new setGoods("0000a94754","160","45","80","mb","normal");
goods[4119] =new setGoods("0000a94755","170","45","80","mb","normal");
goods[4120] =new setGoods("0000a94756","180","45","80","mb","normal");
goods[4121] =new setGoods("0000a94757","60","50","80","mb","normal");
goods[4122] =new setGoods("0000a94758","70","50","80","mb","normal");
goods[4123] =new setGoods("0000a94759","80","50","80","mb","normal");
goods[4124] =new setGoods("0000a94760","90","50","80","mb","normal");
goods[4125] =new setGoods("0000a94761","100","50","80","mb","normal");
goods[4126] =new setGoods("0000a94762","110","50","80","mb","normal");
goods[4127] =new setGoods("0000a94763","120","50","80","mb","normal");
goods[4128] =new setGoods("0000a94764","130","50","80","mb","normal");
goods[4129] =new setGoods("0000a94765","140","50","80","mb","normal");
goods[4130] =new setGoods("0000a94766","150","50","80","mb","normal");
goods[4131] =new setGoods("0000a94767","160","50","80","mb","normal");
goods[4132] =new setGoods("0000a94768","170","50","80","mb","normal");
goods[4133] =new setGoods("0000a94769","180","50","80","mb","normal");
goods[4134] =new setGoods("0000a94770","60","55","80","mb","normal");
goods[4135] =new setGoods("0000a94771","70","55","80","mb","normal");
goods[4136] =new setGoods("0000a94772","80","55","80","mb","normal");
goods[4137] =new setGoods("0000a94773","90","55","80","mb","normal");
goods[4138] =new setGoods("0000a94774","100","55","80","mb","normal");
goods[4139] =new setGoods("0000a94775","110","55","80","mb","normal");
goods[4140] =new setGoods("0000a94776","120","55","80","mb","normal");
goods[4141] =new setGoods("0000a94777","130","55","80","mb","normal");
goods[4142] =new setGoods("0000a94778","140","55","80","mb","normal");
goods[4143] =new setGoods("0000a94779","150","55","80","mb","normal");
goods[4144] =new setGoods("0000a94780","160","55","80","mb","normal");
goods[4145] =new setGoods("0000a94781","170","55","80","mb","normal");
goods[4146] =new setGoods("0000a94782","180","55","80","mb","normal");
goods[4147] =new setGoods("0000a94783","60","60","80","mb","normal");
goods[4148] =new setGoods("0000a94784","70","60","80","mb","normal");
goods[4149] =new setGoods("0000a94785","80","60","80","mb","normal");
goods[4150] =new setGoods("0000a94786","90","60","80","mb","normal");
goods[4151] =new setGoods("0000a94787","100","60","80","mb","normal");
goods[4152] =new setGoods("0000a94788","110","60","80","mb","normal");
goods[4153] =new setGoods("0000a94789","120","60","80","mb","normal");
goods[4154] =new setGoods("0000a94790","130","60","80","mb","normal");
goods[4155] =new setGoods("0000a94791","140","60","80","mb","normal");
goods[4156] =new setGoods("0000a94792","150","60","80","mb","normal");
goods[4157] =new setGoods("0000a94793","160","60","80","mb","normal");
goods[4158] =new setGoods("0000a94794","170","60","80","mb","normal");
goods[4159] =new setGoods("0000a94795","180","60","80","mb","normal");
goods[4160] =new setGoods("0000a94796","60","25","90","mb","normal");
goods[4161] =new setGoods("0000a94797","70","25","90","mb","normal");
goods[4162] =new setGoods("0000a94798","80","25","90","mb","normal");
goods[4163] =new setGoods("0000a94799","90","25","90","mb","normal");
goods[4164] =new setGoods("0000a94800","100","25","90","mb","normal");
goods[4165] =new setGoods("0000a94801","110","25","90","mb","normal");
goods[4166] =new setGoods("0000a94802","120","25","90","mb","normal");
goods[4167] =new setGoods("0000a94803","130","25","90","mb","normal");
goods[4168] =new setGoods("0000a94804","140","25","90","mb","normal");
goods[4169] =new setGoods("0000a94805","150","25","90","mb","normal");
goods[4170] =new setGoods("0000a94806","160","25","90","mb","normal");
goods[4171] =new setGoods("0000a94807","170","25","90","mb","normal");
goods[4172] =new setGoods("0000a94808","180","25","90","mb","normal");
goods[4173] =new setGoods("0000a94809","60","30","90","mb","normal");
goods[4174] =new setGoods("0000a94810","70","30","90","mb","normal");
goods[4175] =new setGoods("0000a94811","80","30","90","mb","normal");
goods[4176] =new setGoods("0000a94812","90","30","90","mb","normal");
goods[4177] =new setGoods("0000a94813","100","30","90","mb","normal");
goods[4178] =new setGoods("0000a94814","110","30","90","mb","normal");
goods[4179] =new setGoods("0000a94815","120","30","90","mb","normal");
goods[4180] =new setGoods("0000a94816","130","30","90","mb","normal");
goods[4181] =new setGoods("0000a94817","140","30","90","mb","normal");
goods[4182] =new setGoods("0000a94818","150","30","90","mb","normal");
goods[4183] =new setGoods("0000a94819","160","30","90","mb","normal");
goods[4184] =new setGoods("0000a94820","170","30","90","mb","normal");
goods[4185] =new setGoods("0000a94821","180","30","90","mb","normal");
goods[4186] =new setGoods("0000a94822","60","35","90","mb","normal");
goods[4187] =new setGoods("0000a94823","70","35","90","mb","normal");
goods[4188] =new setGoods("0000a94824","80","35","90","mb","normal");
goods[4189] =new setGoods("0000a94825","90","35","90","mb","normal");
goods[4190] =new setGoods("0000a94826","100","35","90","mb","normal");
goods[4191] =new setGoods("0000a94827","110","35","90","mb","normal");
goods[4192] =new setGoods("0000a94828","120","35","90","mb","normal");
goods[4193] =new setGoods("0000a94829","130","35","90","mb","normal");
goods[4194] =new setGoods("0000a94830","140","35","90","mb","normal");
goods[4195] =new setGoods("0000a94831","150","35","90","mb","normal");
goods[4196] =new setGoods("0000a94832","160","35","90","mb","normal");
goods[4197] =new setGoods("0000a94833","170","35","90","mb","normal");
goods[4198] =new setGoods("0000a94834","180","35","90","mb","normal");
goods[4199] =new setGoods("0000a94835","60","40","90","mb","normal");
goods[4200] =new setGoods("0000a94836","70","40","90","mb","normal");
goods[4201] =new setGoods("0000a94837","80","40","90","mb","normal");
goods[4202] =new setGoods("0000a94838","90","40","90","mb","normal");
goods[4203] =new setGoods("0000a94839","100","40","90","mb","normal");
goods[4204] =new setGoods("0000a94840","110","40","90","mb","normal");
goods[4205] =new setGoods("0000a94841","120","40","90","mb","normal");
goods[4206] =new setGoods("0000a94842","130","40","90","mb","normal");
goods[4207] =new setGoods("0000a94843","140","40","90","mb","normal");
goods[4208] =new setGoods("0000a94844","150","40","90","mb","normal");
goods[4209] =new setGoods("0000a94845","160","40","90","mb","normal");
goods[4210] =new setGoods("0000a94846","170","40","90","mb","normal");
goods[4211] =new setGoods("0000a94847","180","40","90","mb","normal");
goods[4212] =new setGoods("0000a94848","60","45","90","mb","normal");
goods[4213] =new setGoods("0000a94849","70","45","90","mb","normal");
goods[4214] =new setGoods("0000a94850","80","45","90","mb","normal");
goods[4215] =new setGoods("0000a94851","90","45","90","mb","normal");
goods[4216] =new setGoods("0000a94852","100","45","90","mb","normal");
goods[4217] =new setGoods("0000a94853","110","45","90","mb","normal");
goods[4218] =new setGoods("0000a94854","120","45","90","mb","normal");
goods[4219] =new setGoods("0000a94855","130","45","90","mb","normal");
goods[4220] =new setGoods("0000a94856","140","45","90","mb","normal");
goods[4221] =new setGoods("0000a94857","150","45","90","mb","normal");
goods[4222] =new setGoods("0000a94858","160","45","90","mb","normal");
goods[4223] =new setGoods("0000a94859","170","45","90","mb","normal");
goods[4224] =new setGoods("0000a94860","180","45","90","mb","normal");
goods[4225] =new setGoods("0000a94861","60","50","90","mb","normal");
goods[4226] =new setGoods("0000a94862","70","50","90","mb","normal");
goods[4227] =new setGoods("0000a94863","80","50","90","mb","normal");
goods[4228] =new setGoods("0000a94864","90","50","90","mb","normal");
goods[4229] =new setGoods("0000a94865","100","50","90","mb","normal");
goods[4230] =new setGoods("0000a94866","110","50","90","mb","normal");
goods[4231] =new setGoods("0000a94867","120","50","90","mb","normal");
goods[4232] =new setGoods("0000a94868","130","50","90","mb","normal");
goods[4233] =new setGoods("0000a94869","140","50","90","mb","normal");
goods[4234] =new setGoods("0000a94870","150","50","90","mb","normal");
goods[4235] =new setGoods("0000a94871","160","50","90","mb","normal");
goods[4236] =new setGoods("0000a94872","170","50","90","mb","normal");
goods[4237] =new setGoods("0000a94873","180","50","90","mb","normal");
goods[4238] =new setGoods("0000a94874","60","55","90","mb","normal");
goods[4239] =new setGoods("0000a94875","70","55","90","mb","normal");
goods[4240] =new setGoods("0000a94876","80","55","90","mb","normal");
goods[4241] =new setGoods("0000a94877","90","55","90","mb","normal");
goods[4242] =new setGoods("0000a94878","100","55","90","mb","normal");
goods[4243] =new setGoods("0000a94879","110","55","90","mb","normal");
goods[4244] =new setGoods("0000a94880","120","55","90","mb","normal");
goods[4245] =new setGoods("0000a94881","130","55","90","mb","normal");
goods[4246] =new setGoods("0000a94882","140","55","90","mb","normal");
goods[4247] =new setGoods("0000a94883","150","55","90","mb","normal");
goods[4248] =new setGoods("0000a94884","160","55","90","mb","normal");
goods[4249] =new setGoods("0000a94885","170","55","90","mb","normal");
goods[4250] =new setGoods("0000a94886","180","55","90","mb","normal");
goods[4251] =new setGoods("0000a94887","60","60","90","mb","normal");
goods[4252] =new setGoods("0000a94888","70","60","90","mb","normal");
goods[4253] =new setGoods("0000a94889","80","60","90","mb","normal");
goods[4254] =new setGoods("0000a94890","90","60","90","mb","normal");
goods[4255] =new setGoods("0000a94891","100","60","90","mb","normal");
goods[4256] =new setGoods("0000a94892","110","60","90","mb","normal");
goods[4257] =new setGoods("0000a94893","120","60","90","mb","normal");
goods[4258] =new setGoods("0000a94894","130","60","90","mb","normal");
goods[4259] =new setGoods("0000a94895","140","60","90","mb","normal");
goods[4260] =new setGoods("0000a94896","150","60","90","mb","normal");
goods[4261] =new setGoods("0000a94897","160","60","90","mb","normal");
goods[4262] =new setGoods("0000a94898","170","60","90","mb","normal");
goods[4263] =new setGoods("0000a94899","180","60","90","mb","normal");
goods[4264] =new setGoods("0000a94900","60","25","100","mb","normal");
goods[4265] =new setGoods("0000a94901","70","25","100","mb","normal");
goods[4266] =new setGoods("0000a94902","80","25","100","mb","normal");
goods[4267] =new setGoods("0000a94903","90","25","100","mb","normal");
goods[4268] =new setGoods("0000a94904","100","25","100","mb","normal");
goods[4269] =new setGoods("0000a94905","110","25","100","mb","normal");
goods[4270] =new setGoods("0000a94906","120","25","100","mb","normal");
goods[4271] =new setGoods("0000a94907","130","25","100","mb","normal");
goods[4272] =new setGoods("0000a94908","140","25","100","mb","normal");
goods[4273] =new setGoods("0000a94909","150","25","100","mb","normal");
goods[4274] =new setGoods("0000a94910","160","25","100","mb","normal");
goods[4275] =new setGoods("0000a94911","170","25","100","mb","normal");
goods[4276] =new setGoods("0000a94912","180","25","100","mb","normal");
goods[4277] =new setGoods("0000a94913","60","30","100","mb","normal");
goods[4278] =new setGoods("0000a94914","70","30","100","mb","normal");
goods[4279] =new setGoods("0000a94915","80","30","100","mb","normal");
goods[4280] =new setGoods("0000a94916","90","30","100","mb","normal");
goods[4281] =new setGoods("0000a94917","100","30","100","mb","normal");
goods[4282] =new setGoods("0000a94918","110","30","100","mb","normal");
goods[4283] =new setGoods("0000a94919","120","30","100","mb","normal");
goods[4284] =new setGoods("0000a94920","130","30","100","mb","normal");
goods[4285] =new setGoods("0000a94921","140","30","100","mb","normal");
goods[4286] =new setGoods("0000a94922","150","30","100","mb","normal");
goods[4287] =new setGoods("0000a94923","160","30","100","mb","normal");
goods[4288] =new setGoods("0000a94924","170","30","100","mb","normal");
goods[4289] =new setGoods("0000a94925","180","30","100","mb","normal");
goods[4290] =new setGoods("0000a94926","60","35","100","mb","normal");
goods[4291] =new setGoods("0000a94927","70","35","100","mb","normal");
goods[4292] =new setGoods("0000a94928","80","35","100","mb","normal");
goods[4293] =new setGoods("0000a94929","90","35","100","mb","normal");
goods[4294] =new setGoods("0000a94930","100","35","100","mb","normal");
goods[4295] =new setGoods("0000a94931","110","35","100","mb","normal");
goods[4296] =new setGoods("0000a94932","120","35","100","mb","normal");
goods[4297] =new setGoods("0000a94933","130","35","100","mb","normal");
goods[4298] =new setGoods("0000a94934","140","35","100","mb","normal");
goods[4299] =new setGoods("0000a94935","150","35","100","mb","normal");
goods[4300] =new setGoods("0000a94936","160","35","100","mb","normal");
goods[4301] =new setGoods("0000a94937","170","35","100","mb","normal");
goods[4302] =new setGoods("0000a94938","180","35","100","mb","normal");
goods[4303] =new setGoods("0000a94939","60","40","100","mb","normal");
goods[4304] =new setGoods("0000a94940","70","40","100","mb","normal");
goods[4305] =new setGoods("0000a94941","80","40","100","mb","normal");
goods[4306] =new setGoods("0000a94942","90","40","100","mb","normal");
goods[4307] =new setGoods("0000a94943","100","40","100","mb","normal");
goods[4308] =new setGoods("0000a94944","110","40","100","mb","normal");
goods[4309] =new setGoods("0000a94945","120","40","100","mb","normal");
goods[4310] =new setGoods("0000a94946","130","40","100","mb","normal");
goods[4311] =new setGoods("0000a94947","140","40","100","mb","normal");
goods[4312] =new setGoods("0000a94948","150","40","100","mb","normal");
goods[4313] =new setGoods("0000a94949","160","40","100","mb","normal");
goods[4314] =new setGoods("0000a94950","170","40","100","mb","normal");
goods[4315] =new setGoods("0000a94951","180","40","100","mb","normal");
goods[4316] =new setGoods("0000a94952","60","45","100","mb","normal");
goods[4317] =new setGoods("0000a94953","70","45","100","mb","normal");
goods[4318] =new setGoods("0000a94954","80","45","100","mb","normal");
goods[4319] =new setGoods("0000a94955","90","45","100","mb","normal");
goods[4320] =new setGoods("0000a94956","100","45","100","mb","normal");
goods[4321] =new setGoods("0000a94957","110","45","100","mb","normal");
goods[4322] =new setGoods("0000a94958","120","45","100","mb","normal");
goods[4323] =new setGoods("0000a94959","130","45","100","mb","normal");
goods[4324] =new setGoods("0000a94960","140","45","100","mb","normal");
goods[4325] =new setGoods("0000a94961","150","45","100","mb","normal");
goods[4326] =new setGoods("0000a94962","160","45","100","mb","normal");
goods[4327] =new setGoods("0000a94963","170","45","100","mb","normal");
goods[4328] =new setGoods("0000a94964","180","45","100","mb","normal");
goods[4329] =new setGoods("0000a94965","60","50","100","mb","normal");
goods[4330] =new setGoods("0000a94966","70","50","100","mb","normal");
goods[4331] =new setGoods("0000a94967","80","50","100","mb","normal");
goods[4332] =new setGoods("0000a94968","90","50","100","mb","normal");
goods[4333] =new setGoods("0000a94969","100","50","100","mb","normal");
goods[4334] =new setGoods("0000a94970","110","50","100","mb","normal");
goods[4335] =new setGoods("0000a94971","120","50","100","mb","normal");
goods[4336] =new setGoods("0000a94972","130","50","100","mb","normal");
goods[4337] =new setGoods("0000a94973","140","50","100","mb","normal");
goods[4338] =new setGoods("0000a94974","150","50","100","mb","normal");
goods[4339] =new setGoods("0000a94975","160","50","100","mb","normal");
goods[4340] =new setGoods("0000a94976","170","50","100","mb","normal");
goods[4341] =new setGoods("0000a94977","180","50","100","mb","normal");
goods[4342] =new setGoods("0000a94978","60","55","100","mb","normal");
goods[4343] =new setGoods("0000a94979","70","55","100","mb","normal");
goods[4344] =new setGoods("0000a94980","80","55","100","mb","normal");
goods[4345] =new setGoods("0000a94981","90","55","100","mb","normal");
goods[4346] =new setGoods("0000a94982","100","55","100","mb","normal");
goods[4347] =new setGoods("0000a94983","110","55","100","mb","normal");
goods[4348] =new setGoods("0000a94984","120","55","100","mb","normal");
goods[4349] =new setGoods("0000a94985","130","55","100","mb","normal");
goods[4350] =new setGoods("0000a94986","140","55","100","mb","normal");
goods[4351] =new setGoods("0000a94987","150","55","100","mb","normal");
goods[4352] =new setGoods("0000a94988","160","55","100","mb","normal");
goods[4353] =new setGoods("0000a94989","170","55","100","mb","normal");
goods[4354] =new setGoods("0000a94990","180","55","100","mb","normal");
goods[4355] =new setGoods("0000a94991","60","60","100","mb","normal");
goods[4356] =new setGoods("0000a94992","70","60","100","mb","normal");
goods[4357] =new setGoods("0000a94993","80","60","100","mb","normal");
goods[4358] =new setGoods("0000a94994","90","60","100","mb","normal");
goods[4359] =new setGoods("0000a94995","100","60","100","mb","normal");
goods[4360] =new setGoods("0000a94996","110","60","100","mb","normal");
goods[4361] =new setGoods("0000a94997","120","60","100","mb","normal");
goods[4362] =new setGoods("0000a94998","130","60","100","mb","normal");
goods[4363] =new setGoods("0000a94999","140","60","100","mb","normal");
goods[4364] =new setGoods("0000a95000","150","60","100","mb","normal");
goods[4365] =new setGoods("0000a95001","160","60","100","mb","normal");
goods[4366] =new setGoods("0000a95002","170","60","100","mb","normal");
goods[4367] =new setGoods("0000a95003","180","60","100","mb","normal");
goods[4368] =new setGoods("0000a95004","60","25","40","gs","normal");
goods[4369] =new setGoods("0000a95005","70","25","40","gs","normal");
goods[4370] =new setGoods("0000a95006","80","25","40","gs","normal");
goods[4371] =new setGoods("0000a95007","90","25","40","gs","normal");
goods[4372] =new setGoods("0000a95008","100","25","40","gs","normal");
goods[4373] =new setGoods("0000a95009","110","25","40","gs","normal");
goods[4374] =new setGoods("0000a95010","120","25","40","gs","normal");
goods[4375] =new setGoods("0000a95011","130","25","40","gs","normal");
goods[4376] =new setGoods("0000a95012","140","25","40","gs","normal");
goods[4377] =new setGoods("0000a95013","150","25","40","gs","normal");
goods[4378] =new setGoods("0000a95014","160","25","40","gs","normal");
goods[4379] =new setGoods("0000a95015","170","25","40","gs","normal");
goods[4380] =new setGoods("0000a95016","180","25","40","gs","normal");
goods[4381] =new setGoods("0000a95017","60","30","40","gs","normal");
goods[4382] =new setGoods("0000a95018","70","30","40","gs","normal");
goods[4383] =new setGoods("0000a95019","80","30","40","gs","normal");
goods[4384] =new setGoods("0000a95020","90","30","40","gs","normal");
goods[4385] =new setGoods("0000a95021","100","30","40","gs","normal");
goods[4386] =new setGoods("0000a95022","110","30","40","gs","normal");
goods[4387] =new setGoods("0000a95023","120","30","40","gs","normal");
goods[4388] =new setGoods("0000a95024","130","30","40","gs","normal");
goods[4389] =new setGoods("0000a95025","140","30","40","gs","normal");
goods[4390] =new setGoods("0000a95026","150","30","40","gs","normal");
goods[4391] =new setGoods("0000a95027","160","30","40","gs","normal");
goods[4392] =new setGoods("0000a95028","170","30","40","gs","normal");
goods[4393] =new setGoods("0000a95029","180","30","40","gs","normal");
goods[4394] =new setGoods("0000a95030","60","35","40","gs","normal");
goods[4395] =new setGoods("0000a95031","70","35","40","gs","normal");
goods[4396] =new setGoods("0000a95032","80","35","40","gs","normal");
goods[4397] =new setGoods("0000a95033","90","35","40","gs","normal");
goods[4398] =new setGoods("0000a95034","100","35","40","gs","normal");
goods[4399] =new setGoods("0000a95035","110","35","40","gs","normal");
goods[4400] =new setGoods("0000a95036","120","35","40","gs","normal");
goods[4401] =new setGoods("0000a95037","130","35","40","gs","normal");
goods[4402] =new setGoods("0000a95038","140","35","40","gs","normal");
goods[4403] =new setGoods("0000a95039","150","35","40","gs","normal");
goods[4404] =new setGoods("0000a95040","160","35","40","gs","normal");
goods[4405] =new setGoods("0000a95041","170","35","40","gs","normal");
goods[4406] =new setGoods("0000a95042","180","35","40","gs","normal");
goods[4407] =new setGoods("0000a95043","60","40","40","gs","normal");
goods[4408] =new setGoods("0000a95044","70","40","40","gs","normal");
goods[4409] =new setGoods("0000a95045","80","40","40","gs","normal");
goods[4410] =new setGoods("0000a95046","90","40","40","gs","normal");
goods[4411] =new setGoods("0000a95047","100","40","40","gs","normal");
goods[4412] =new setGoods("0000a95048","110","40","40","gs","normal");
goods[4413] =new setGoods("0000a95049","120","40","40","gs","normal");
goods[4414] =new setGoods("0000a95050","130","40","40","gs","normal");
goods[4415] =new setGoods("0000a95051","140","40","40","gs","normal");
goods[4416] =new setGoods("0000a95052","150","40","40","gs","normal");
goods[4417] =new setGoods("0000a95053","160","40","40","gs","normal");
goods[4418] =new setGoods("0000a95054","170","40","40","gs","normal");
goods[4419] =new setGoods("0000a95055","180","40","40","gs","normal");
goods[4420] =new setGoods("0000a95056","60","45","40","gs","normal");
goods[4421] =new setGoods("0000a95057","70","45","40","gs","normal");
goods[4422] =new setGoods("0000a95058","80","45","40","gs","normal");
goods[4423] =new setGoods("0000a95059","90","45","40","gs","normal");
goods[4424] =new setGoods("0000a95060","100","45","40","gs","normal");
goods[4425] =new setGoods("0000a95061","110","45","40","gs","normal");
goods[4426] =new setGoods("0000a95062","120","45","40","gs","normal");
goods[4427] =new setGoods("0000a95063","130","45","40","gs","normal");
goods[4428] =new setGoods("0000a95064","140","45","40","gs","normal");
goods[4429] =new setGoods("0000a95065","150","45","40","gs","normal");
goods[4430] =new setGoods("0000a95066","160","45","40","gs","normal");
goods[4431] =new setGoods("0000a95067","170","45","40","gs","normal");
goods[4432] =new setGoods("0000a95068","180","45","40","gs","normal");
goods[4433] =new setGoods("0000a95069","60","50","40","gs","normal");
goods[4434] =new setGoods("0000a95070","70","50","40","gs","normal");
goods[4435] =new setGoods("0000a95071","80","50","40","gs","normal");
goods[4436] =new setGoods("0000a95072","90","50","40","gs","normal");
goods[4437] =new setGoods("0000a95073","100","50","40","gs","normal");
goods[4438] =new setGoods("0000a95074","110","50","40","gs","normal");
goods[4439] =new setGoods("0000a95075","120","50","40","gs","normal");
goods[4440] =new setGoods("0000a95076","130","50","40","gs","normal");
goods[4441] =new setGoods("0000a95077","140","50","40","gs","normal");
goods[4442] =new setGoods("0000a95078","150","50","40","gs","normal");
goods[4443] =new setGoods("0000a95079","160","50","40","gs","normal");
goods[4444] =new setGoods("0000a95080","170","50","40","gs","normal");
goods[4445] =new setGoods("0000a95081","180","50","40","gs","normal");
goods[4446] =new setGoods("0000a95082","60","55","40","gs","normal");
goods[4447] =new setGoods("0000a95083","70","55","40","gs","normal");
goods[4448] =new setGoods("0000a95084","80","55","40","gs","normal");
goods[4449] =new setGoods("0000a95085","90","55","40","gs","normal");
goods[4450] =new setGoods("0000a95086","100","55","40","gs","normal");
goods[4451] =new setGoods("0000a95087","110","55","40","gs","normal");
goods[4452] =new setGoods("0000a95088","120","55","40","gs","normal");
goods[4453] =new setGoods("0000a95089","130","55","40","gs","normal");
goods[4454] =new setGoods("0000a95090","140","55","40","gs","normal");
goods[4455] =new setGoods("0000a95091","150","55","40","gs","normal");
goods[4456] =new setGoods("0000a95092","160","55","40","gs","normal");
goods[4457] =new setGoods("0000a95093","170","55","40","gs","normal");
goods[4458] =new setGoods("0000a95094","180","55","40","gs","normal");
goods[4459] =new setGoods("0000a95095","60","60","40","gs","normal");
goods[4460] =new setGoods("0000a95096","70","60","40","gs","normal");
goods[4461] =new setGoods("0000a95097","80","60","40","gs","normal");
goods[4462] =new setGoods("0000a95098","90","60","40","gs","normal");
goods[4463] =new setGoods("0000a95099","100","60","40","gs","normal");
goods[4464] =new setGoods("0000a95100","110","60","40","gs","normal");
goods[4465] =new setGoods("0000a95101","120","60","40","gs","normal");
goods[4466] =new setGoods("0000a95102","130","60","40","gs","normal");
goods[4467] =new setGoods("0000a95103","140","60","40","gs","normal");
goods[4468] =new setGoods("0000a95104","150","60","40","gs","normal");
goods[4469] =new setGoods("0000a95105","160","60","40","gs","normal");
goods[4470] =new setGoods("0000a95106","170","60","40","gs","normal");
goods[4471] =new setGoods("0000a95107","180","60","40","gs","normal");
goods[4472] =new setGoods("0000a95108","60","25","50","gs","normal");
goods[4473] =new setGoods("0000a95109","70","25","50","gs","normal");
goods[4474] =new setGoods("0000a95110","80","25","50","gs","normal");
goods[4475] =new setGoods("0000a95111","90","25","50","gs","normal");
goods[4476] =new setGoods("0000a95112","100","25","50","gs","normal");
goods[4477] =new setGoods("0000a95113","110","25","50","gs","normal");
goods[4478] =new setGoods("0000a95114","120","25","50","gs","normal");
goods[4479] =new setGoods("0000a95115","130","25","50","gs","normal");
goods[4480] =new setGoods("0000a95116","140","25","50","gs","normal");
goods[4481] =new setGoods("0000a95117","150","25","50","gs","normal");
goods[4482] =new setGoods("0000a95118","160","25","50","gs","normal");
goods[4483] =new setGoods("0000a95119","170","25","50","gs","normal");
goods[4484] =new setGoods("0000a95120","180","25","50","gs","normal");
goods[4485] =new setGoods("0000a95121","60","30","50","gs","normal");
goods[4486] =new setGoods("0000a95122","70","30","50","gs","normal");
goods[4487] =new setGoods("0000a95123","80","30","50","gs","normal");
goods[4488] =new setGoods("0000a95124","90","30","50","gs","normal");
goods[4489] =new setGoods("0000a95125","100","30","50","gs","normal");
goods[4490] =new setGoods("0000a95126","110","30","50","gs","normal");
goods[4491] =new setGoods("0000a95127","120","30","50","gs","normal");
goods[4492] =new setGoods("0000a95128","130","30","50","gs","normal");
goods[4493] =new setGoods("0000a95129","140","30","50","gs","normal");
goods[4494] =new setGoods("0000a95130","150","30","50","gs","normal");
goods[4495] =new setGoods("0000a95131","160","30","50","gs","normal");
goods[4496] =new setGoods("0000a95132","170","30","50","gs","normal");
goods[4497] =new setGoods("0000a95133","180","30","50","gs","normal");
goods[4498] =new setGoods("0000a95134","60","35","50","gs","normal");
goods[4499] =new setGoods("0000a95135","70","35","50","gs","normal");
goods[4500] =new setGoods("0000a95136","80","35","50","gs","normal");
goods[4501] =new setGoods("0000a95137","90","35","50","gs","normal");
goods[4502] =new setGoods("0000a95138","100","35","50","gs","normal");
goods[4503] =new setGoods("0000a95139","110","35","50","gs","normal");
goods[4504] =new setGoods("0000a95140","120","35","50","gs","normal");
goods[4505] =new setGoods("0000a95141","130","35","50","gs","normal");
goods[4506] =new setGoods("0000a95142","140","35","50","gs","normal");
goods[4507] =new setGoods("0000a95143","150","35","50","gs","normal");
goods[4508] =new setGoods("0000a95144","160","35","50","gs","normal");
goods[4509] =new setGoods("0000a95145","170","35","50","gs","normal");
goods[4510] =new setGoods("0000a95146","180","35","50","gs","normal");
goods[4511] =new setGoods("0000a95147","60","40","50","gs","normal");
goods[4512] =new setGoods("0000a95148","70","40","50","gs","normal");
goods[4513] =new setGoods("0000a95149","80","40","50","gs","normal");
goods[4514] =new setGoods("0000a95150","90","40","50","gs","normal");
goods[4515] =new setGoods("0000a95151","100","40","50","gs","normal");
goods[4516] =new setGoods("0000a95152","110","40","50","gs","normal");
goods[4517] =new setGoods("0000a95153","120","40","50","gs","normal");
goods[4518] =new setGoods("0000a95154","130","40","50","gs","normal");
goods[4519] =new setGoods("0000a95155","140","40","50","gs","normal");
goods[4520] =new setGoods("0000a95156","150","40","50","gs","normal");
goods[4521] =new setGoods("0000a95157","160","40","50","gs","normal");
goods[4522] =new setGoods("0000a95158","170","40","50","gs","normal");
goods[4523] =new setGoods("0000a95159","180","40","50","gs","normal");
goods[4524] =new setGoods("0000a95160","60","45","50","gs","normal");
goods[4525] =new setGoods("0000a95161","70","45","50","gs","normal");
goods[4526] =new setGoods("0000a95162","80","45","50","gs","normal");
goods[4527] =new setGoods("0000a95163","90","45","50","gs","normal");
goods[4528] =new setGoods("0000a95164","100","45","50","gs","normal");
goods[4529] =new setGoods("0000a95165","110","45","50","gs","normal");
goods[4530] =new setGoods("0000a95166","120","45","50","gs","normal");
goods[4531] =new setGoods("0000a95167","130","45","50","gs","normal");
goods[4532] =new setGoods("0000a95168","140","45","50","gs","normal");
goods[4533] =new setGoods("0000a95169","150","45","50","gs","normal");
goods[4534] =new setGoods("0000a95170","160","45","50","gs","normal");
goods[4535] =new setGoods("0000a95171","170","45","50","gs","normal");
goods[4536] =new setGoods("0000a95172","180","45","50","gs","normal");
goods[4537] =new setGoods("0000a95173","60","50","50","gs","normal");
goods[4538] =new setGoods("0000a95174","70","50","50","gs","normal");
goods[4539] =new setGoods("0000a95175","80","50","50","gs","normal");
goods[4540] =new setGoods("0000a95176","90","50","50","gs","normal");
goods[4541] =new setGoods("0000a95177","100","50","50","gs","normal");
goods[4542] =new setGoods("0000a95178","110","50","50","gs","normal");
goods[4543] =new setGoods("0000a95179","120","50","50","gs","normal");
goods[4544] =new setGoods("0000a95180","130","50","50","gs","normal");
goods[4545] =new setGoods("0000a95181","140","50","50","gs","normal");
goods[4546] =new setGoods("0000a95182","150","50","50","gs","normal");
goods[4547] =new setGoods("0000a95183","160","50","50","gs","normal");
goods[4548] =new setGoods("0000a95184","170","50","50","gs","normal");
goods[4549] =new setGoods("0000a95185","180","50","50","gs","normal");
goods[4550] =new setGoods("0000a95186","60","55","50","gs","normal");
goods[4551] =new setGoods("0000a95187","70","55","50","gs","normal");
goods[4552] =new setGoods("0000a95188","80","55","50","gs","normal");
goods[4553] =new setGoods("0000a95189","90","55","50","gs","normal");
goods[4554] =new setGoods("0000a95190","100","55","50","gs","normal");
goods[4555] =new setGoods("0000a95191","110","55","50","gs","normal");
goods[4556] =new setGoods("0000a95192","120","55","50","gs","normal");
goods[4557] =new setGoods("0000a95193","130","55","50","gs","normal");
goods[4558] =new setGoods("0000a95194","140","55","50","gs","normal");
goods[4559] =new setGoods("0000a95195","150","55","50","gs","normal");
goods[4560] =new setGoods("0000a95196","160","55","50","gs","normal");
goods[4561] =new setGoods("0000a95197","170","55","50","gs","normal");
goods[4562] =new setGoods("0000a95198","180","55","50","gs","normal");
goods[4563] =new setGoods("0000a95199","60","60","50","gs","normal");
goods[4564] =new setGoods("0000a95200","70","60","50","gs","normal");
goods[4565] =new setGoods("0000a95201","80","60","50","gs","normal");
goods[4566] =new setGoods("0000a95202","90","60","50","gs","normal");
goods[4567] =new setGoods("0000a95203","100","60","50","gs","normal");
goods[4568] =new setGoods("0000a95204","110","60","50","gs","normal");
goods[4569] =new setGoods("0000a95205","120","60","50","gs","normal");
goods[4570] =new setGoods("0000a95206","130","60","50","gs","normal");
goods[4571] =new setGoods("0000a95207","140","60","50","gs","normal");
goods[4572] =new setGoods("0000a95208","150","60","50","gs","normal");
goods[4573] =new setGoods("0000a95209","160","60","50","gs","normal");
goods[4574] =new setGoods("0000a95210","170","60","50","gs","normal");
goods[4575] =new setGoods("0000a95211","180","60","50","gs","normal");
goods[4576] =new setGoods("0000a95212","60","25","60","gs","normal");
goods[4577] =new setGoods("0000a95213","70","25","60","gs","normal");
goods[4578] =new setGoods("0000a95214","80","25","60","gs","normal");
goods[4579] =new setGoods("0000a95215","90","25","60","gs","normal");
goods[4580] =new setGoods("0000a95216","100","25","60","gs","normal");
goods[4581] =new setGoods("0000a95217","110","25","60","gs","normal");
goods[4582] =new setGoods("0000a95218","120","25","60","gs","normal");
goods[4583] =new setGoods("0000a95219","130","25","60","gs","normal");
goods[4584] =new setGoods("0000a95220","140","25","60","gs","normal");
goods[4585] =new setGoods("0000a95221","150","25","60","gs","normal");
goods[4586] =new setGoods("0000a95222","160","25","60","gs","normal");
goods[4587] =new setGoods("0000a95223","170","25","60","gs","normal");
goods[4588] =new setGoods("0000a95224","180","25","60","gs","normal");
goods[4589] =new setGoods("0000a95225","60","30","60","gs","normal");
goods[4590] =new setGoods("0000a95226","70","30","60","gs","normal");
goods[4591] =new setGoods("0000a95227","80","30","60","gs","normal");
goods[4592] =new setGoods("0000a95228","90","30","60","gs","normal");
goods[4593] =new setGoods("0000a95229","100","30","60","gs","normal");
goods[4594] =new setGoods("0000a95230","110","30","60","gs","normal");
goods[4595] =new setGoods("0000a95231","120","30","60","gs","normal");
goods[4596] =new setGoods("0000a95232","130","30","60","gs","normal");
goods[4597] =new setGoods("0000a95233","140","30","60","gs","normal");
goods[4598] =new setGoods("0000a95234","150","30","60","gs","normal");
goods[4599] =new setGoods("0000a95235","160","30","60","gs","normal");
goods[4600] =new setGoods("0000a95236","170","30","60","gs","normal");
goods[4601] =new setGoods("0000a95237","180","30","60","gs","normal");
goods[4602] =new setGoods("0000a95238","60","35","60","gs","normal");
goods[4603] =new setGoods("0000a95239","70","35","60","gs","normal");
goods[4604] =new setGoods("0000a95240","80","35","60","gs","normal");
goods[4605] =new setGoods("0000a95241","90","35","60","gs","normal");
goods[4606] =new setGoods("0000a95242","100","35","60","gs","normal");
goods[4607] =new setGoods("0000a95243","110","35","60","gs","normal");
goods[4608] =new setGoods("0000a95244","120","35","60","gs","normal");
goods[4609] =new setGoods("0000a95245","130","35","60","gs","normal");
goods[4610] =new setGoods("0000a95246","140","35","60","gs","normal");
goods[4611] =new setGoods("0000a95247","150","35","60","gs","normal");
goods[4612] =new setGoods("0000a95248","160","35","60","gs","normal");
goods[4613] =new setGoods("0000a95249","170","35","60","gs","normal");
goods[4614] =new setGoods("0000a95250","180","35","60","gs","normal");
goods[4615] =new setGoods("0000a95251","60","40","60","gs","normal");
goods[4616] =new setGoods("0000a95252","70","40","60","gs","normal");
goods[4617] =new setGoods("0000a95253","80","40","60","gs","normal");
goods[4618] =new setGoods("0000a95254","90","40","60","gs","normal");
goods[4619] =new setGoods("0000a95255","100","40","60","gs","normal");
goods[4620] =new setGoods("0000a95256","110","40","60","gs","normal");
goods[4621] =new setGoods("0000a95257","120","40","60","gs","normal");
goods[4622] =new setGoods("0000a95258","130","40","60","gs","normal");
goods[4623] =new setGoods("0000a95259","140","40","60","gs","normal");
goods[4624] =new setGoods("0000a95260","150","40","60","gs","normal");
goods[4625] =new setGoods("0000a95261","160","40","60","gs","normal");
goods[4626] =new setGoods("0000a95262","170","40","60","gs","normal");
goods[4627] =new setGoods("0000a95263","180","40","60","gs","normal");
goods[4628] =new setGoods("0000a95264","60","45","60","gs","normal");
goods[4629] =new setGoods("0000a95265","70","45","60","gs","normal");
goods[4630] =new setGoods("0000a95266","80","45","60","gs","normal");
goods[4631] =new setGoods("0000a95267","90","45","60","gs","normal");
goods[4632] =new setGoods("0000a95268","100","45","60","gs","normal");
goods[4633] =new setGoods("0000a95269","110","45","60","gs","normal");
goods[4634] =new setGoods("0000a95270","120","45","60","gs","normal");
goods[4635] =new setGoods("0000a95271","130","45","60","gs","normal");
goods[4636] =new setGoods("0000a95272","140","45","60","gs","normal");
goods[4637] =new setGoods("0000a95273","150","45","60","gs","normal");
goods[4638] =new setGoods("0000a95274","160","45","60","gs","normal");
goods[4639] =new setGoods("0000a95275","170","45","60","gs","normal");
goods[4640] =new setGoods("0000a95276","180","45","60","gs","normal");
goods[4641] =new setGoods("0000a95277","60","50","60","gs","normal");
goods[4642] =new setGoods("0000a95278","70","50","60","gs","normal");
goods[4643] =new setGoods("0000a95279","80","50","60","gs","normal");
goods[4644] =new setGoods("0000a95280","90","50","60","gs","normal");
goods[4645] =new setGoods("0000a95281","100","50","60","gs","normal");
goods[4646] =new setGoods("0000a95282","110","50","60","gs","normal");
goods[4647] =new setGoods("0000a95283","120","50","60","gs","normal");
goods[4648] =new setGoods("0000a95284","130","50","60","gs","normal");
goods[4649] =new setGoods("0000a95285","140","50","60","gs","normal");
goods[4650] =new setGoods("0000a95286","150","50","60","gs","normal");
goods[4651] =new setGoods("0000a95287","160","50","60","gs","normal");
goods[4652] =new setGoods("0000a95288","170","50","60","gs","normal");
goods[4653] =new setGoods("0000a95289","180","50","60","gs","normal");
goods[4654] =new setGoods("0000a95290","60","55","60","gs","normal");
goods[4655] =new setGoods("0000a95291","70","55","60","gs","normal");
goods[4656] =new setGoods("0000a95292","80","55","60","gs","normal");
goods[4657] =new setGoods("0000a95293","90","55","60","gs","normal");
goods[4658] =new setGoods("0000a95294","100","55","60","gs","normal");
goods[4659] =new setGoods("0000a95295","110","55","60","gs","normal");
goods[4660] =new setGoods("0000a95296","120","55","60","gs","normal");
goods[4661] =new setGoods("0000a95297","130","55","60","gs","normal");
goods[4662] =new setGoods("0000a95298","140","55","60","gs","normal");
goods[4663] =new setGoods("0000a95299","150","55","60","gs","normal");
goods[4664] =new setGoods("0000a95300","160","55","60","gs","normal");
goods[4665] =new setGoods("0000a95301","170","55","60","gs","normal");
goods[4666] =new setGoods("0000a95302","180","55","60","gs","normal");
goods[4667] =new setGoods("0000a95303","60","60","60","gs","normal");
goods[4668] =new setGoods("0000a95304","70","60","60","gs","normal");
goods[4669] =new setGoods("0000a95305","80","60","60","gs","normal");
goods[4670] =new setGoods("0000a95306","90","60","60","gs","normal");
goods[4671] =new setGoods("0000a95307","100","60","60","gs","normal");
goods[4672] =new setGoods("0000a95308","110","60","60","gs","normal");
goods[4673] =new setGoods("0000a95309","120","60","60","gs","normal");
goods[4674] =new setGoods("0000a95310","130","60","60","gs","normal");
goods[4675] =new setGoods("0000a95311","140","60","60","gs","normal");
goods[4676] =new setGoods("0000a95312","150","60","60","gs","normal");
goods[4677] =new setGoods("0000a95313","160","60","60","gs","normal");
goods[4678] =new setGoods("0000a95314","170","60","60","gs","normal");
goods[4679] =new setGoods("0000a95315","180","60","60","gs","normal");
goods[4680] =new setGoods("0000a95316","60","25","70","gs","normal");
goods[4681] =new setGoods("0000a95317","70","25","70","gs","normal");
goods[4682] =new setGoods("0000a95318","80","25","70","gs","normal");
goods[4683] =new setGoods("0000a95319","90","25","70","gs","normal");
goods[4684] =new setGoods("0000a95320","100","25","70","gs","normal");
goods[4685] =new setGoods("0000a95321","110","25","70","gs","normal");
goods[4686] =new setGoods("0000a95322","120","25","70","gs","normal");
goods[4687] =new setGoods("0000a95323","130","25","70","gs","normal");
goods[4688] =new setGoods("0000a95324","140","25","70","gs","normal");
goods[4689] =new setGoods("0000a95325","150","25","70","gs","normal");
goods[4690] =new setGoods("0000a95326","160","25","70","gs","normal");
goods[4691] =new setGoods("0000a95327","170","25","70","gs","normal");
goods[4692] =new setGoods("0000a95328","180","25","70","gs","normal");
goods[4693] =new setGoods("0000a95329","60","30","70","gs","normal");
goods[4694] =new setGoods("0000a95330","70","30","70","gs","normal");
goods[4695] =new setGoods("0000a95331","80","30","70","gs","normal");
goods[4696] =new setGoods("0000a95332","90","30","70","gs","normal");
goods[4697] =new setGoods("0000a95333","100","30","70","gs","normal");
goods[4698] =new setGoods("0000a95334","110","30","70","gs","normal");
goods[4699] =new setGoods("0000a95335","120","30","70","gs","normal");
goods[4700] =new setGoods("0000a95336","130","30","70","gs","normal");
goods[4701] =new setGoods("0000a95337","140","30","70","gs","normal");
goods[4702] =new setGoods("0000a95338","150","30","70","gs","normal");
goods[4703] =new setGoods("0000a95339","160","30","70","gs","normal");
goods[4704] =new setGoods("0000a95340","170","30","70","gs","normal");
goods[4705] =new setGoods("0000a95341","180","30","70","gs","normal");
goods[4706] =new setGoods("0000a95342","60","35","70","gs","normal");
goods[4707] =new setGoods("0000a95343","70","35","70","gs","normal");
goods[4708] =new setGoods("0000a95344","80","35","70","gs","normal");
goods[4709] =new setGoods("0000a95345","90","35","70","gs","normal");
goods[4710] =new setGoods("0000a95346","100","35","70","gs","normal");
goods[4711] =new setGoods("0000a95347","110","35","70","gs","normal");
goods[4712] =new setGoods("0000a95348","120","35","70","gs","normal");
goods[4713] =new setGoods("0000a95349","130","35","70","gs","normal");
goods[4714] =new setGoods("0000a95350","140","35","70","gs","normal");
goods[4715] =new setGoods("0000a95351","150","35","70","gs","normal");
goods[4716] =new setGoods("0000a95352","160","35","70","gs","normal");
goods[4717] =new setGoods("0000a95353","170","35","70","gs","normal");
goods[4718] =new setGoods("0000a95354","180","35","70","gs","normal");
goods[4719] =new setGoods("0000a95355","60","40","70","gs","normal");
goods[4720] =new setGoods("0000a95356","70","40","70","gs","normal");
goods[4721] =new setGoods("0000a95357","80","40","70","gs","normal");
goods[4722] =new setGoods("0000a95358","90","40","70","gs","normal");
goods[4723] =new setGoods("0000a95359","100","40","70","gs","normal");
goods[4724] =new setGoods("0000a95360","110","40","70","gs","normal");
goods[4725] =new setGoods("0000a95361","120","40","70","gs","normal");
goods[4726] =new setGoods("0000a95362","130","40","70","gs","normal");
goods[4727] =new setGoods("0000a95363","140","40","70","gs","normal");
goods[4728] =new setGoods("0000a95364","150","40","70","gs","normal");
goods[4729] =new setGoods("0000a95365","160","40","70","gs","normal");
goods[4730] =new setGoods("0000a95366","170","40","70","gs","normal");
goods[4731] =new setGoods("0000a95367","180","40","70","gs","normal");
goods[4732] =new setGoods("0000a95368","60","45","70","gs","normal");
goods[4733] =new setGoods("0000a95369","70","45","70","gs","normal");
goods[4734] =new setGoods("0000a95370","80","45","70","gs","normal");
goods[4735] =new setGoods("0000a95371","90","45","70","gs","normal");
goods[4736] =new setGoods("0000a95372","100","45","70","gs","normal");
goods[4737] =new setGoods("0000a95373","110","45","70","gs","normal");
goods[4738] =new setGoods("0000a95374","120","45","70","gs","normal");
goods[4739] =new setGoods("0000a95375","130","45","70","gs","normal");
goods[4740] =new setGoods("0000a95376","140","45","70","gs","normal");
goods[4741] =new setGoods("0000a95377","150","45","70","gs","normal");
goods[4742] =new setGoods("0000a95378","160","45","70","gs","normal");
goods[4743] =new setGoods("0000a95379","170","45","70","gs","normal");
goods[4744] =new setGoods("0000a95380","180","45","70","gs","normal");
goods[4745] =new setGoods("0000a95381","60","50","70","gs","normal");
goods[4746] =new setGoods("0000a95382","70","50","70","gs","normal");
goods[4747] =new setGoods("0000a95383","80","50","70","gs","normal");
goods[4748] =new setGoods("0000a95384","90","50","70","gs","normal");
goods[4749] =new setGoods("0000a95385","100","50","70","gs","normal");
goods[4750] =new setGoods("0000a95386","110","50","70","gs","normal");
goods[4751] =new setGoods("0000a95387","120","50","70","gs","normal");
goods[4752] =new setGoods("0000a95388","130","50","70","gs","normal");
goods[4753] =new setGoods("0000a95389","140","50","70","gs","normal");
goods[4754] =new setGoods("0000a95390","150","50","70","gs","normal");
goods[4755] =new setGoods("0000a95391","160","50","70","gs","normal");
goods[4756] =new setGoods("0000a95392","170","50","70","gs","normal");
goods[4757] =new setGoods("0000a95393","180","50","70","gs","normal");
goods[4758] =new setGoods("0000a95394","60","55","70","gs","normal");
goods[4759] =new setGoods("0000a95395","70","55","70","gs","normal");
goods[4760] =new setGoods("0000a95396","80","55","70","gs","normal");
goods[4761] =new setGoods("0000a95397","90","55","70","gs","normal");
goods[4762] =new setGoods("0000a95398","100","55","70","gs","normal");
goods[4763] =new setGoods("0000a95399","110","55","70","gs","normal");
goods[4764] =new setGoods("0000a95400","120","55","70","gs","normal");
goods[4765] =new setGoods("0000a95401","130","55","70","gs","normal");
goods[4766] =new setGoods("0000a95402","140","55","70","gs","normal");
goods[4767] =new setGoods("0000a95403","150","55","70","gs","normal");
goods[4768] =new setGoods("0000a95404","160","55","70","gs","normal");
goods[4769] =new setGoods("0000a95405","170","55","70","gs","normal");
goods[4770] =new setGoods("0000a95406","180","55","70","gs","normal");
goods[4771] =new setGoods("0000a95407","60","60","70","gs","normal");
goods[4772] =new setGoods("0000a95408","70","60","70","gs","normal");
goods[4773] =new setGoods("0000a95409","80","60","70","gs","normal");
goods[4774] =new setGoods("0000a95410","90","60","70","gs","normal");
goods[4775] =new setGoods("0000a95411","100","60","70","gs","normal");
goods[4776] =new setGoods("0000a95412","110","60","70","gs","normal");
goods[4777] =new setGoods("0000a95413","120","60","70","gs","normal");
goods[4778] =new setGoods("0000a95414","130","60","70","gs","normal");
goods[4779] =new setGoods("0000a95415","140","60","70","gs","normal");
goods[4780] =new setGoods("0000a95416","150","60","70","gs","normal");
goods[4781] =new setGoods("0000a95417","160","60","70","gs","normal");
goods[4782] =new setGoods("0000a95418","170","60","70","gs","normal");
goods[4783] =new setGoods("0000a95419","180","60","70","gs","normal");
goods[4784] =new setGoods("0000a95420","60","25","80","gs","normal");
goods[4785] =new setGoods("0000a95421","70","25","80","gs","normal");
goods[4786] =new setGoods("0000a95422","80","25","80","gs","normal");
goods[4787] =new setGoods("0000a95423","90","25","80","gs","normal");
goods[4788] =new setGoods("0000a95424","100","25","80","gs","normal");
goods[4789] =new setGoods("0000a95425","110","25","80","gs","normal");
goods[4790] =new setGoods("0000a95426","120","25","80","gs","normal");
goods[4791] =new setGoods("0000a95427","130","25","80","gs","normal");
goods[4792] =new setGoods("0000a95428","140","25","80","gs","normal");
goods[4793] =new setGoods("0000a95429","150","25","80","gs","normal");
goods[4794] =new setGoods("0000a95430","160","25","80","gs","normal");
goods[4795] =new setGoods("0000a95431","170","25","80","gs","normal");
goods[4796] =new setGoods("0000a95432","180","25","80","gs","normal");
goods[4797] =new setGoods("0000a95433","60","30","80","gs","normal");
goods[4798] =new setGoods("0000a95434","70","30","80","gs","normal");
goods[4799] =new setGoods("0000a95435","80","30","80","gs","normal");
goods[4800] =new setGoods("0000a95436","90","30","80","gs","normal");
goods[4801] =new setGoods("0000a95437","100","30","80","gs","normal");
goods[4802] =new setGoods("0000a95438","110","30","80","gs","normal");
goods[4803] =new setGoods("0000a95439","120","30","80","gs","normal");
goods[4804] =new setGoods("0000a95440","130","30","80","gs","normal");
goods[4805] =new setGoods("0000a95441","140","30","80","gs","normal");
goods[4806] =new setGoods("0000a95442","150","30","80","gs","normal");
goods[4807] =new setGoods("0000a95443","160","30","80","gs","normal");
goods[4808] =new setGoods("0000a95444","170","30","80","gs","normal");
goods[4809] =new setGoods("0000a95445","180","30","80","gs","normal");
goods[4810] =new setGoods("0000a95446","60","35","80","gs","normal");
goods[4811] =new setGoods("0000a95447","70","35","80","gs","normal");
goods[4812] =new setGoods("0000a95448","80","35","80","gs","normal");
goods[4813] =new setGoods("0000a95449","90","35","80","gs","normal");
goods[4814] =new setGoods("0000a95450","100","35","80","gs","normal");
goods[4815] =new setGoods("0000a95451","110","35","80","gs","normal");
goods[4816] =new setGoods("0000a95452","120","35","80","gs","normal");
goods[4817] =new setGoods("0000a95453","130","35","80","gs","normal");
goods[4818] =new setGoods("0000a95454","140","35","80","gs","normal");
goods[4819] =new setGoods("0000a95455","150","35","80","gs","normal");
goods[4820] =new setGoods("0000a95456","160","35","80","gs","normal");
goods[4821] =new setGoods("0000a95457","170","35","80","gs","normal");
goods[4822] =new setGoods("0000a95458","180","35","80","gs","normal");
goods[4823] =new setGoods("0000a95459","60","40","80","gs","normal");
goods[4824] =new setGoods("0000a95460","70","40","80","gs","normal");
goods[4825] =new setGoods("0000a95461","80","40","80","gs","normal");
goods[4826] =new setGoods("0000a95462","90","40","80","gs","normal");
goods[4827] =new setGoods("0000a95463","100","40","80","gs","normal");
goods[4828] =new setGoods("0000a95464","110","40","80","gs","normal");
goods[4829] =new setGoods("0000a95465","120","40","80","gs","normal");
goods[4830] =new setGoods("0000a95466","130","40","80","gs","normal");
goods[4831] =new setGoods("0000a95467","140","40","80","gs","normal");
goods[4832] =new setGoods("0000a95468","150","40","80","gs","normal");
goods[4833] =new setGoods("0000a95469","160","40","80","gs","normal");
goods[4834] =new setGoods("0000a95470","170","40","80","gs","normal");
goods[4835] =new setGoods("0000a95471","180","40","80","gs","normal");
goods[4836] =new setGoods("0000a95472","60","45","80","gs","normal");
goods[4837] =new setGoods("0000a95473","70","45","80","gs","normal");
goods[4838] =new setGoods("0000a95474","80","45","80","gs","normal");
goods[4839] =new setGoods("0000a95475","90","45","80","gs","normal");
goods[4840] =new setGoods("0000a95476","100","45","80","gs","normal");
goods[4841] =new setGoods("0000a95477","110","45","80","gs","normal");
goods[4842] =new setGoods("0000a95478","120","45","80","gs","normal");
goods[4843] =new setGoods("0000a95479","130","45","80","gs","normal");
goods[4844] =new setGoods("0000a95480","140","45","80","gs","normal");
goods[4845] =new setGoods("0000a95481","150","45","80","gs","normal");
goods[4846] =new setGoods("0000a95482","160","45","80","gs","normal");
goods[4847] =new setGoods("0000a95483","170","45","80","gs","normal");
goods[4848] =new setGoods("0000a95484","180","45","80","gs","normal");
goods[4849] =new setGoods("0000a95485","60","50","80","gs","normal");
goods[4850] =new setGoods("0000a95486","70","50","80","gs","normal");
goods[4851] =new setGoods("0000a95487","80","50","80","gs","normal");
goods[4852] =new setGoods("0000a95488","90","50","80","gs","normal");
goods[4853] =new setGoods("0000a95489","100","50","80","gs","normal");
goods[4854] =new setGoods("0000a95490","110","50","80","gs","normal");
goods[4855] =new setGoods("0000a95491","120","50","80","gs","normal");
goods[4856] =new setGoods("0000a95492","130","50","80","gs","normal");
goods[4857] =new setGoods("0000a95493","140","50","80","gs","normal");
goods[4858] =new setGoods("0000a95494","150","50","80","gs","normal");
goods[4859] =new setGoods("0000a95495","160","50","80","gs","normal");
goods[4860] =new setGoods("0000a95496","170","50","80","gs","normal");
goods[4861] =new setGoods("0000a95497","180","50","80","gs","normal");
goods[4862] =new setGoods("0000a95498","60","55","80","gs","normal");
goods[4863] =new setGoods("0000a95499","70","55","80","gs","normal");
goods[4864] =new setGoods("0000a95500","80","55","80","gs","normal");
goods[4865] =new setGoods("0000a95501","90","55","80","gs","normal");
goods[4866] =new setGoods("0000a95502","100","55","80","gs","normal");
goods[4867] =new setGoods("0000a95503","110","55","80","gs","normal");
goods[4868] =new setGoods("0000a95504","120","55","80","gs","normal");
goods[4869] =new setGoods("0000a95505","130","55","80","gs","normal");
goods[4870] =new setGoods("0000a95506","140","55","80","gs","normal");
goods[4871] =new setGoods("0000a95507","150","55","80","gs","normal");
goods[4872] =new setGoods("0000a95508","160","55","80","gs","normal");
goods[4873] =new setGoods("0000a95509","170","55","80","gs","normal");
goods[4874] =new setGoods("0000a95510","180","55","80","gs","normal");
goods[4875] =new setGoods("0000a95511","60","60","80","gs","normal");
goods[4876] =new setGoods("0000a95512","70","60","80","gs","normal");
goods[4877] =new setGoods("0000a95513","80","60","80","gs","normal");
goods[4878] =new setGoods("0000a95514","90","60","80","gs","normal");
goods[4879] =new setGoods("0000a95515","100","60","80","gs","normal");
goods[4880] =new setGoods("0000a95516","110","60","80","gs","normal");
goods[4881] =new setGoods("0000a95517","120","60","80","gs","normal");
goods[4882] =new setGoods("0000a95518","130","60","80","gs","normal");
goods[4883] =new setGoods("0000a95519","140","60","80","gs","normal");
goods[4884] =new setGoods("0000a95520","150","60","80","gs","normal");
goods[4885] =new setGoods("0000a95521","160","60","80","gs","normal");
goods[4886] =new setGoods("0000a95522","170","60","80","gs","normal");
goods[4887] =new setGoods("0000a95523","180","60","80","gs","normal");
goods[4888] =new setGoods("0000a95524","60","25","90","gs","normal");
goods[4889] =new setGoods("0000a95525","70","25","90","gs","normal");
goods[4890] =new setGoods("0000a95526","80","25","90","gs","normal");
goods[4891] =new setGoods("0000a95527","90","25","90","gs","normal");
goods[4892] =new setGoods("0000a95528","100","25","90","gs","normal");
goods[4893] =new setGoods("0000a95529","110","25","90","gs","normal");
goods[4894] =new setGoods("0000a95530","120","25","90","gs","normal");
goods[4895] =new setGoods("0000a95531","130","25","90","gs","normal");
goods[4896] =new setGoods("0000a95532","140","25","90","gs","normal");
goods[4897] =new setGoods("0000a95533","150","25","90","gs","normal");
goods[4898] =new setGoods("0000a95534","160","25","90","gs","normal");
goods[4899] =new setGoods("0000a95535","170","25","90","gs","normal");
goods[4900] =new setGoods("0000a95536","180","25","90","gs","normal");
goods[4901] =new setGoods("0000a95537","60","30","90","gs","normal");
goods[4902] =new setGoods("0000a95538","70","30","90","gs","normal");
goods[4903] =new setGoods("0000a95539","80","30","90","gs","normal");
goods[4904] =new setGoods("0000a95540","90","30","90","gs","normal");
goods[4905] =new setGoods("0000a95541","100","30","90","gs","normal");
goods[4906] =new setGoods("0000a95542","110","30","90","gs","normal");
goods[4907] =new setGoods("0000a95543","120","30","90","gs","normal");
goods[4908] =new setGoods("0000a95544","130","30","90","gs","normal");
goods[4909] =new setGoods("0000a95545","140","30","90","gs","normal");
goods[4910] =new setGoods("0000a95546","150","30","90","gs","normal");
goods[4911] =new setGoods("0000a95547","160","30","90","gs","normal");
goods[4912] =new setGoods("0000a95548","170","30","90","gs","normal");
goods[4913] =new setGoods("0000a95549","180","30","90","gs","normal");
goods[4914] =new setGoods("0000a95550","60","35","90","gs","normal");
goods[4915] =new setGoods("0000a95551","70","35","90","gs","normal");
goods[4916] =new setGoods("0000a95552","80","35","90","gs","normal");
goods[4917] =new setGoods("0000a95553","90","35","90","gs","normal");
goods[4918] =new setGoods("0000a95554","100","35","90","gs","normal");
goods[4919] =new setGoods("0000a95555","110","35","90","gs","normal");
goods[4920] =new setGoods("0000a95556","120","35","90","gs","normal");
goods[4921] =new setGoods("0000a95557","130","35","90","gs","normal");
goods[4922] =new setGoods("0000a95558","140","35","90","gs","normal");
goods[4923] =new setGoods("0000a95559","150","35","90","gs","normal");
goods[4924] =new setGoods("0000a95560","160","35","90","gs","normal");
goods[4925] =new setGoods("0000a95561","170","35","90","gs","normal");
goods[4926] =new setGoods("0000a95562","180","35","90","gs","normal");
goods[4927] =new setGoods("0000a95563","60","40","90","gs","normal");
goods[4928] =new setGoods("0000a95564","70","40","90","gs","normal");
goods[4929] =new setGoods("0000a95565","80","40","90","gs","normal");
goods[4930] =new setGoods("0000a95566","90","40","90","gs","normal");
goods[4931] =new setGoods("0000a95567","100","40","90","gs","normal");
goods[4932] =new setGoods("0000a95568","110","40","90","gs","normal");
goods[4933] =new setGoods("0000a95569","120","40","90","gs","normal");
goods[4934] =new setGoods("0000a95570","130","40","90","gs","normal");
goods[4935] =new setGoods("0000a95571","140","40","90","gs","normal");
goods[4936] =new setGoods("0000a95572","150","40","90","gs","normal");
goods[4937] =new setGoods("0000a95573","160","40","90","gs","normal");
goods[4938] =new setGoods("0000a95574","170","40","90","gs","normal");
goods[4939] =new setGoods("0000a95575","180","40","90","gs","normal");
goods[4940] =new setGoods("0000a95576","60","45","90","gs","normal");
goods[4941] =new setGoods("0000a95577","70","45","90","gs","normal");
goods[4942] =new setGoods("0000a95578","80","45","90","gs","normal");
goods[4943] =new setGoods("0000a95579","90","45","90","gs","normal");
goods[4944] =new setGoods("0000a95580","100","45","90","gs","normal");
goods[4945] =new setGoods("0000a95581","110","45","90","gs","normal");
goods[4946] =new setGoods("0000a95582","120","45","90","gs","normal");
goods[4947] =new setGoods("0000a95583","130","45","90","gs","normal");
goods[4948] =new setGoods("0000a95584","140","45","90","gs","normal");
goods[4949] =new setGoods("0000a95585","150","45","90","gs","normal");
goods[4950] =new setGoods("0000a95586","160","45","90","gs","normal");
goods[4951] =new setGoods("0000a95587","170","45","90","gs","normal");
goods[4952] =new setGoods("0000a95588","180","45","90","gs","normal");
goods[4953] =new setGoods("0000a95589","60","50","90","gs","normal");
goods[4954] =new setGoods("0000a95590","70","50","90","gs","normal");
goods[4955] =new setGoods("0000a95591","80","50","90","gs","normal");
goods[4956] =new setGoods("0000a95592","90","50","90","gs","normal");
goods[4957] =new setGoods("0000a95593","100","50","90","gs","normal");
goods[4958] =new setGoods("0000a95594","110","50","90","gs","normal");
goods[4959] =new setGoods("0000a95595","120","50","90","gs","normal");
goods[4960] =new setGoods("0000a95596","130","50","90","gs","normal");
goods[4961] =new setGoods("0000a95597","140","50","90","gs","normal");
goods[4962] =new setGoods("0000a95598","150","50","90","gs","normal");
goods[4963] =new setGoods("0000a95599","160","50","90","gs","normal");
goods[4964] =new setGoods("0000a95600","170","50","90","gs","normal");
goods[4965] =new setGoods("0000a95601","180","50","90","gs","normal");
goods[4966] =new setGoods("0000a95602","60","55","90","gs","normal");
goods[4967] =new setGoods("0000a95603","70","55","90","gs","normal");
goods[4968] =new setGoods("0000a95604","80","55","90","gs","normal");
goods[4969] =new setGoods("0000a95605","90","55","90","gs","normal");
goods[4970] =new setGoods("0000a95606","100","55","90","gs","normal");
goods[4971] =new setGoods("0000a95607","110","55","90","gs","normal");
goods[4972] =new setGoods("0000a95608","120","55","90","gs","normal");
goods[4973] =new setGoods("0000a95609","130","55","90","gs","normal");
goods[4974] =new setGoods("0000a95610","140","55","90","gs","normal");
goods[4975] =new setGoods("0000a95611","150","55","90","gs","normal");
goods[4976] =new setGoods("0000a95612","160","55","90","gs","normal");
goods[4977] =new setGoods("0000a95613","170","55","90","gs","normal");
goods[4978] =new setGoods("0000a95614","180","55","90","gs","normal");
goods[4979] =new setGoods("0000a95615","60","60","90","gs","normal");
goods[4980] =new setGoods("0000a95616","70","60","90","gs","normal");
goods[4981] =new setGoods("0000a95617","80","60","90","gs","normal");
goods[4982] =new setGoods("0000a95618","90","60","90","gs","normal");
goods[4983] =new setGoods("0000a95619","100","60","90","gs","normal");
goods[4984] =new setGoods("0000a95620","110","60","90","gs","normal");
goods[4985] =new setGoods("0000a95621","120","60","90","gs","normal");
goods[4986] =new setGoods("0000a95622","130","60","90","gs","normal");
goods[4987] =new setGoods("0000a95623","140","60","90","gs","normal");
goods[4988] =new setGoods("0000a95624","150","60","90","gs","normal");
goods[4989] =new setGoods("0000a95625","160","60","90","gs","normal");
goods[4990] =new setGoods("0000a95626","170","60","90","gs","normal");
goods[4991] =new setGoods("0000a95627","180","60","90","gs","normal");
goods[4992] =new setGoods("0000a95628","60","25","100","gs","normal");
goods[4993] =new setGoods("0000a95629","70","25","100","gs","normal");
goods[4994] =new setGoods("0000a95630","80","25","100","gs","normal");
goods[4995] =new setGoods("0000a95631","90","25","100","gs","normal");
goods[4996] =new setGoods("0000a95632","100","25","100","gs","normal");
goods[4997] =new setGoods("0000a95633","110","25","100","gs","normal");
goods[4998] =new setGoods("0000a95634","120","25","100","gs","normal");
goods[4999] =new setGoods("0000a95635","130","25","100","gs","normal");
goods[5000] =new setGoods("0000a95636","140","25","100","gs","normal");
goods[5001] =new setGoods("0000a95637","150","25","100","gs","normal");
goods[5002] =new setGoods("0000a95638","160","25","100","gs","normal");
goods[5003] =new setGoods("0000a95639","170","25","100","gs","normal");
goods[5004] =new setGoods("0000a95640","180","25","100","gs","normal");
goods[5005] =new setGoods("0000a95641","60","30","100","gs","normal");
goods[5006] =new setGoods("0000a95642","70","30","100","gs","normal");
goods[5007] =new setGoods("0000a95643","80","30","100","gs","normal");
goods[5008] =new setGoods("0000a95644","90","30","100","gs","normal");
goods[5009] =new setGoods("0000a95645","100","30","100","gs","normal");
goods[5010] =new setGoods("0000a95646","110","30","100","gs","normal");
goods[5011] =new setGoods("0000a95647","120","30","100","gs","normal");
goods[5012] =new setGoods("0000a95648","130","30","100","gs","normal");
goods[5013] =new setGoods("0000a95649","140","30","100","gs","normal");
goods[5014] =new setGoods("0000a95650","150","30","100","gs","normal");
goods[5015] =new setGoods("0000a95651","160","30","100","gs","normal");
goods[5016] =new setGoods("0000a95652","170","30","100","gs","normal");
goods[5017] =new setGoods("0000a95653","180","30","100","gs","normal");
goods[5018] =new setGoods("0000a95654","60","35","100","gs","normal");
goods[5019] =new setGoods("0000a95655","70","35","100","gs","normal");
goods[5020] =new setGoods("0000a95656","80","35","100","gs","normal");
goods[5021] =new setGoods("0000a95657","90","35","100","gs","normal");
goods[5022] =new setGoods("0000a95658","100","35","100","gs","normal");
goods[5023] =new setGoods("0000a95659","110","35","100","gs","normal");
goods[5024] =new setGoods("0000a95660","120","35","100","gs","normal");
goods[5025] =new setGoods("0000a95661","130","35","100","gs","normal");
goods[5026] =new setGoods("0000a95662","140","35","100","gs","normal");
goods[5027] =new setGoods("0000a95663","150","35","100","gs","normal");
goods[5028] =new setGoods("0000a95664","160","35","100","gs","normal");
goods[5029] =new setGoods("0000a95665","170","35","100","gs","normal");
goods[5030] =new setGoods("0000a95666","180","35","100","gs","normal");
goods[5031] =new setGoods("0000a95667","60","40","100","gs","normal");
goods[5032] =new setGoods("0000a95668","70","40","100","gs","normal");
goods[5033] =new setGoods("0000a95669","80","40","100","gs","normal");
goods[5034] =new setGoods("0000a95670","90","40","100","gs","normal");
goods[5035] =new setGoods("0000a95671","100","40","100","gs","normal");
goods[5036] =new setGoods("0000a95672","110","40","100","gs","normal");
goods[5037] =new setGoods("0000a95673","120","40","100","gs","normal");
goods[5038] =new setGoods("0000a95674","130","40","100","gs","normal");
goods[5039] =new setGoods("0000a95675","140","40","100","gs","normal");
goods[5040] =new setGoods("0000a95676","150","40","100","gs","normal");
goods[5041] =new setGoods("0000a95677","160","40","100","gs","normal");
goods[5042] =new setGoods("0000a95678","170","40","100","gs","normal");
goods[5043] =new setGoods("0000a95679","180","40","100","gs","normal");
goods[5044] =new setGoods("0000a95680","60","45","100","gs","normal");
goods[5045] =new setGoods("0000a95681","70","45","100","gs","normal");
goods[5046] =new setGoods("0000a95682","80","45","100","gs","normal");
goods[5047] =new setGoods("0000a95683","90","45","100","gs","normal");
goods[5048] =new setGoods("0000a95684","100","45","100","gs","normal");
goods[5049] =new setGoods("0000a95685","110","45","100","gs","normal");
goods[5050] =new setGoods("0000a95686","120","45","100","gs","normal");
goods[5051] =new setGoods("0000a95687","130","45","100","gs","normal");
goods[5052] =new setGoods("0000a95688","140","45","100","gs","normal");
goods[5053] =new setGoods("0000a95689","150","45","100","gs","normal");
goods[5054] =new setGoods("0000a95690","160","45","100","gs","normal");
goods[5055] =new setGoods("0000a95691","170","45","100","gs","normal");
goods[5056] =new setGoods("0000a95692","180","45","100","gs","normal");
goods[5057] =new setGoods("0000a95693","60","50","100","gs","normal");
goods[5058] =new setGoods("0000a95694","70","50","100","gs","normal");
goods[5059] =new setGoods("0000a95695","80","50","100","gs","normal");
goods[5060] =new setGoods("0000a95696","90","50","100","gs","normal");
goods[5061] =new setGoods("0000a95697","100","50","100","gs","normal");
goods[5062] =new setGoods("0000a95698","110","50","100","gs","normal");
goods[5063] =new setGoods("0000a95699","120","50","100","gs","normal");
goods[5064] =new setGoods("0000a95700","130","50","100","gs","normal");
goods[5065] =new setGoods("0000a95701","140","50","100","gs","normal");
goods[5066] =new setGoods("0000a95702","150","50","100","gs","normal");
goods[5067] =new setGoods("0000a95703","160","50","100","gs","normal");
goods[5068] =new setGoods("0000a95704","170","50","100","gs","normal");
goods[5069] =new setGoods("0000a95705","180","50","100","gs","normal");
goods[5070] =new setGoods("0000a95706","60","55","100","gs","normal");
goods[5071] =new setGoods("0000a95707","70","55","100","gs","normal");
goods[5072] =new setGoods("0000a95708","80","55","100","gs","normal");
goods[5073] =new setGoods("0000a95709","90","55","100","gs","normal");
goods[5074] =new setGoods("0000a95710","100","55","100","gs","normal");
goods[5075] =new setGoods("0000a95711","110","55","100","gs","normal");
goods[5076] =new setGoods("0000a95712","120","55","100","gs","normal");
goods[5077] =new setGoods("0000a95713","130","55","100","gs","normal");
goods[5078] =new setGoods("0000a95714","140","55","100","gs","normal");
goods[5079] =new setGoods("0000a95715","150","55","100","gs","normal");
goods[5080] =new setGoods("0000a95716","160","55","100","gs","normal");
goods[5081] =new setGoods("0000a95717","170","55","100","gs","normal");
goods[5082] =new setGoods("0000a95718","180","55","100","gs","normal");
goods[5083] =new setGoods("0000a95719","60","60","100","gs","normal");
goods[5084] =new setGoods("0000a95720","70","60","100","gs","normal");
goods[5085] =new setGoods("0000a95721","80","60","100","gs","normal");
goods[5086] =new setGoods("0000a95722","90","60","100","gs","normal");
goods[5087] =new setGoods("0000a95723","100","60","100","gs","normal");
goods[5088] =new setGoods("0000a95724","110","60","100","gs","normal");
goods[5089] =new setGoods("0000a95725","120","60","100","gs","normal");
goods[5090] =new setGoods("0000a95726","130","60","100","gs","normal");
goods[5091] =new setGoods("0000a95727","140","60","100","gs","normal");
goods[5092] =new setGoods("0000a95728","150","60","100","gs","normal");
goods[5093] =new setGoods("0000a95729","160","60","100","gs","normal");
goods[5094] =new setGoods("0000a95730","170","60","100","gs","normal");
goods[5095] =new setGoods("0000a95731","180","60","100","gs","normal");
goods[5096] =new setGoods("0000a95732","60","25","40","ww","normal");
goods[5097] =new setGoods("0000a95733","70","25","40","ww","normal");
goods[5098] =new setGoods("0000a95734","80","25","40","ww","normal");
goods[5099] =new setGoods("0000a95735","90","25","40","ww","normal");
goods[5100] =new setGoods("0000a95736","100","25","40","ww","normal");
goods[5101] =new setGoods("0000a95737","110","25","40","ww","normal");
goods[5102] =new setGoods("0000a95738","120","25","40","ww","normal");
goods[5103] =new setGoods("0000a95739","130","25","40","ww","normal");
goods[5104] =new setGoods("0000a95740","140","25","40","ww","normal");
goods[5105] =new setGoods("0000a95741","150","25","40","ww","normal");
goods[5106] =new setGoods("0000a95742","160","25","40","ww","normal");
goods[5107] =new setGoods("0000a95743","170","25","40","ww","normal");
goods[5108] =new setGoods("0000a95744","180","25","40","ww","normal");
goods[5109] =new setGoods("0000a95745","60","30","40","ww","normal");
goods[5110] =new setGoods("0000a95746","70","30","40","ww","normal");
goods[5111] =new setGoods("0000a95747","80","30","40","ww","normal");
goods[5112] =new setGoods("0000a95748","90","30","40","ww","normal");
goods[5113] =new setGoods("0000a95749","100","30","40","ww","normal");
goods[5114] =new setGoods("0000a95750","110","30","40","ww","normal");
goods[5115] =new setGoods("0000a95751","120","30","40","ww","normal");
goods[5116] =new setGoods("0000a95752","130","30","40","ww","normal");
goods[5117] =new setGoods("0000a95753","140","30","40","ww","normal");
goods[5118] =new setGoods("0000a95754","150","30","40","ww","normal");
goods[5119] =new setGoods("0000a95755","160","30","40","ww","normal");
goods[5120] =new setGoods("0000a95756","170","30","40","ww","normal");
goods[5121] =new setGoods("0000a95757","180","30","40","ww","normal");
goods[5122] =new setGoods("0000a95758","60","35","40","ww","normal");
goods[5123] =new setGoods("0000a95759","70","35","40","ww","normal");
goods[5124] =new setGoods("0000a95760","80","35","40","ww","normal");
goods[5125] =new setGoods("0000a95761","90","35","40","ww","normal");
goods[5126] =new setGoods("0000a95762","100","35","40","ww","normal");
goods[5127] =new setGoods("0000a95763","110","35","40","ww","normal");
goods[5128] =new setGoods("0000a95764","120","35","40","ww","normal");
goods[5129] =new setGoods("0000a95765","130","35","40","ww","normal");
goods[5130] =new setGoods("0000a95766","140","35","40","ww","normal");
goods[5131] =new setGoods("0000a95767","150","35","40","ww","normal");
goods[5132] =new setGoods("0000a95768","160","35","40","ww","normal");
goods[5133] =new setGoods("0000a95769","170","35","40","ww","normal");
goods[5134] =new setGoods("0000a95770","180","35","40","ww","normal");
goods[5135] =new setGoods("0000a95771","60","40","40","ww","normal");
goods[5136] =new setGoods("0000a95772","70","40","40","ww","normal");
goods[5137] =new setGoods("0000a95773","80","40","40","ww","normal");
goods[5138] =new setGoods("0000a95774","90","40","40","ww","normal");
goods[5139] =new setGoods("0000a95775","100","40","40","ww","normal");
goods[5140] =new setGoods("0000a95776","110","40","40","ww","normal");
goods[5141] =new setGoods("0000a95777","120","40","40","ww","normal");
goods[5142] =new setGoods("0000a95778","130","40","40","ww","normal");
goods[5143] =new setGoods("0000a95779","140","40","40","ww","normal");
goods[5144] =new setGoods("0000a95780","150","40","40","ww","normal");
goods[5145] =new setGoods("0000a95781","160","40","40","ww","normal");
goods[5146] =new setGoods("0000a95782","170","40","40","ww","normal");
goods[5147] =new setGoods("0000a95783","180","40","40","ww","normal");
goods[5148] =new setGoods("0000a95784","60","45","40","ww","normal");
goods[5149] =new setGoods("0000a95785","70","45","40","ww","normal");
goods[5150] =new setGoods("0000a95786","80","45","40","ww","normal");
goods[5151] =new setGoods("0000a95787","90","45","40","ww","normal");
goods[5152] =new setGoods("0000a95788","100","45","40","ww","normal");
goods[5153] =new setGoods("0000a95789","110","45","40","ww","normal");
goods[5154] =new setGoods("0000a95790","120","45","40","ww","normal");
goods[5155] =new setGoods("0000a95791","130","45","40","ww","normal");
goods[5156] =new setGoods("0000a95792","140","45","40","ww","normal");
goods[5157] =new setGoods("0000a95793","150","45","40","ww","normal");
goods[5158] =new setGoods("0000a95794","160","45","40","ww","normal");
goods[5159] =new setGoods("0000a95795","170","45","40","ww","normal");
goods[5160] =new setGoods("0000a95796","180","45","40","ww","normal");
goods[5161] =new setGoods("0000a95797","60","50","40","ww","normal");
goods[5162] =new setGoods("0000a95798","70","50","40","ww","normal");
goods[5163] =new setGoods("0000a95799","80","50","40","ww","normal");
goods[5164] =new setGoods("0000a95800","90","50","40","ww","normal");
goods[5165] =new setGoods("0000a95801","100","50","40","ww","normal");
goods[5166] =new setGoods("0000a95802","110","50","40","ww","normal");
goods[5167] =new setGoods("0000a95803","120","50","40","ww","normal");
goods[5168] =new setGoods("0000a95804","130","50","40","ww","normal");
goods[5169] =new setGoods("0000a95805","140","50","40","ww","normal");
goods[5170] =new setGoods("0000a95806","150","50","40","ww","normal");
goods[5171] =new setGoods("0000a95807","160","50","40","ww","normal");
goods[5172] =new setGoods("0000a95808","170","50","40","ww","normal");
goods[5173] =new setGoods("0000a95809","180","50","40","ww","normal");
goods[5174] =new setGoods("0000a95810","60","55","40","ww","normal");
goods[5175] =new setGoods("0000a95811","70","55","40","ww","normal");
goods[5176] =new setGoods("0000a95812","80","55","40","ww","normal");
goods[5177] =new setGoods("0000a95813","90","55","40","ww","normal");
goods[5178] =new setGoods("0000a95814","100","55","40","ww","normal");
goods[5179] =new setGoods("0000a95815","110","55","40","ww","normal");
goods[5180] =new setGoods("0000a95816","120","55","40","ww","normal");
goods[5181] =new setGoods("0000a95817","130","55","40","ww","normal");
goods[5182] =new setGoods("0000a95818","140","55","40","ww","normal");
goods[5183] =new setGoods("0000a95819","150","55","40","ww","normal");
goods[5184] =new setGoods("0000a95820","160","55","40","ww","normal");
goods[5185] =new setGoods("0000a95821","170","55","40","ww","normal");
goods[5186] =new setGoods("0000a95822","180","55","40","ww","normal");
goods[5187] =new setGoods("0000a95823","60","60","40","ww","normal");
goods[5188] =new setGoods("0000a95824","70","60","40","ww","normal");
goods[5189] =new setGoods("0000a95825","80","60","40","ww","normal");
goods[5190] =new setGoods("0000a95826","90","60","40","ww","normal");
goods[5191] =new setGoods("0000a95827","100","60","40","ww","normal");
goods[5192] =new setGoods("0000a95828","110","60","40","ww","normal");
goods[5193] =new setGoods("0000a95829","120","60","40","ww","normal");
goods[5194] =new setGoods("0000a95830","130","60","40","ww","normal");
goods[5195] =new setGoods("0000a95831","140","60","40","ww","normal");
goods[5196] =new setGoods("0000a95832","150","60","40","ww","normal");
goods[5197] =new setGoods("0000a95833","160","60","40","ww","normal");
goods[5198] =new setGoods("0000a95834","170","60","40","ww","normal");
goods[5199] =new setGoods("0000a95835","180","60","40","ww","normal");
goods[5200] =new setGoods("0000a95836","60","25","50","ww","normal");
goods[5201] =new setGoods("0000a95837","70","25","50","ww","normal");
goods[5202] =new setGoods("0000a95838","80","25","50","ww","normal");
goods[5203] =new setGoods("0000a95839","90","25","50","ww","normal");
goods[5204] =new setGoods("0000a95840","100","25","50","ww","normal");
goods[5205] =new setGoods("0000a95841","110","25","50","ww","normal");
goods[5206] =new setGoods("0000a95842","120","25","50","ww","normal");
goods[5207] =new setGoods("0000a95843","130","25","50","ww","normal");
goods[5208] =new setGoods("0000a95844","140","25","50","ww","normal");
goods[5209] =new setGoods("0000a95845","150","25","50","ww","normal");
goods[5210] =new setGoods("0000a95846","160","25","50","ww","normal");
goods[5211] =new setGoods("0000a95847","170","25","50","ww","normal");
goods[5212] =new setGoods("0000a95848","180","25","50","ww","normal");
goods[5213] =new setGoods("0000a95849","60","30","50","ww","normal");
goods[5214] =new setGoods("0000a95850","70","30","50","ww","normal");
goods[5215] =new setGoods("0000a95851","80","30","50","ww","normal");
goods[5216] =new setGoods("0000a95852","90","30","50","ww","normal");
goods[5217] =new setGoods("0000a95853","100","30","50","ww","normal");
goods[5218] =new setGoods("0000a95854","110","30","50","ww","normal");
goods[5219] =new setGoods("0000a95855","120","30","50","ww","normal");
goods[5220] =new setGoods("0000a95856","130","30","50","ww","normal");
goods[5221] =new setGoods("0000a95857","140","30","50","ww","normal");
goods[5222] =new setGoods("0000a95858","150","30","50","ww","normal");
goods[5223] =new setGoods("0000a95859","160","30","50","ww","normal");
goods[5224] =new setGoods("0000a95860","170","30","50","ww","normal");
goods[5225] =new setGoods("0000a95861","180","30","50","ww","normal");
goods[5226] =new setGoods("0000a95862","60","35","50","ww","normal");
goods[5227] =new setGoods("0000a95863","70","35","50","ww","normal");
goods[5228] =new setGoods("0000a95864","80","35","50","ww","normal");
goods[5229] =new setGoods("0000a95865","90","35","50","ww","normal");
goods[5230] =new setGoods("0000a95866","100","35","50","ww","normal");
goods[5231] =new setGoods("0000a95867","110","35","50","ww","normal");
goods[5232] =new setGoods("0000a95868","120","35","50","ww","normal");
goods[5233] =new setGoods("0000a95869","130","35","50","ww","normal");
goods[5234] =new setGoods("0000a95870","140","35","50","ww","normal");
goods[5235] =new setGoods("0000a95871","150","35","50","ww","normal");
goods[5236] =new setGoods("0000a95872","160","35","50","ww","normal");
goods[5237] =new setGoods("0000a95873","170","35","50","ww","normal");
goods[5238] =new setGoods("0000a95874","180","35","50","ww","normal");
goods[5239] =new setGoods("0000a95875","60","40","50","ww","normal");
goods[5240] =new setGoods("0000a95876","70","40","50","ww","normal");
goods[5241] =new setGoods("0000a95877","80","40","50","ww","normal");
goods[5242] =new setGoods("0000a95878","90","40","50","ww","normal");
goods[5243] =new setGoods("0000a95879","100","40","50","ww","normal");
goods[5244] =new setGoods("0000a95880","110","40","50","ww","normal");
goods[5245] =new setGoods("0000a95881","120","40","50","ww","normal");
goods[5246] =new setGoods("0000a95882","130","40","50","ww","normal");
goods[5247] =new setGoods("0000a95883","140","40","50","ww","normal");
goods[5248] =new setGoods("0000a95884","150","40","50","ww","normal");
goods[5249] =new setGoods("0000a95885","160","40","50","ww","normal");
goods[5250] =new setGoods("0000a95886","170","40","50","ww","normal");
goods[5251] =new setGoods("0000a95887","180","40","50","ww","normal");
goods[5252] =new setGoods("0000a95888","60","45","50","ww","normal");
goods[5253] =new setGoods("0000a95889","70","45","50","ww","normal");
goods[5254] =new setGoods("0000a95890","80","45","50","ww","normal");
goods[5255] =new setGoods("0000a95891","90","45","50","ww","normal");
goods[5256] =new setGoods("0000a95892","100","45","50","ww","normal");
goods[5257] =new setGoods("0000a95893","110","45","50","ww","normal");
goods[5258] =new setGoods("0000a95894","120","45","50","ww","normal");
goods[5259] =new setGoods("0000a95895","130","45","50","ww","normal");
goods[5260] =new setGoods("0000a95896","140","45","50","ww","normal");
goods[5261] =new setGoods("0000a95897","150","45","50","ww","normal");
goods[5262] =new setGoods("0000a95898","160","45","50","ww","normal");
goods[5263] =new setGoods("0000a95899","170","45","50","ww","normal");
goods[5264] =new setGoods("0000a95900","180","45","50","ww","normal");
goods[5265] =new setGoods("0000a95901","60","50","50","ww","normal");
goods[5266] =new setGoods("0000a95902","70","50","50","ww","normal");
goods[5267] =new setGoods("0000a95903","80","50","50","ww","normal");
goods[5268] =new setGoods("0000a95904","90","50","50","ww","normal");
goods[5269] =new setGoods("0000a95905","100","50","50","ww","normal");
goods[5270] =new setGoods("0000a95906","110","50","50","ww","normal");
goods[5271] =new setGoods("0000a95907","120","50","50","ww","normal");
goods[5272] =new setGoods("0000a95908","130","50","50","ww","normal");
goods[5273] =new setGoods("0000a95909","140","50","50","ww","normal");
goods[5274] =new setGoods("0000a95910","150","50","50","ww","normal");
goods[5275] =new setGoods("0000a95911","160","50","50","ww","normal");
goods[5276] =new setGoods("0000a95912","170","50","50","ww","normal");
goods[5277] =new setGoods("0000a95913","180","50","50","ww","normal");
goods[5278] =new setGoods("0000a95914","60","55","50","ww","normal");
goods[5279] =new setGoods("0000a95915","70","55","50","ww","normal");
goods[5280] =new setGoods("0000a95916","80","55","50","ww","normal");
goods[5281] =new setGoods("0000a95917","90","55","50","ww","normal");
goods[5282] =new setGoods("0000a95918","100","55","50","ww","normal");
goods[5283] =new setGoods("0000a95919","110","55","50","ww","normal");
goods[5284] =new setGoods("0000a95920","120","55","50","ww","normal");
goods[5285] =new setGoods("0000a95921","130","55","50","ww","normal");
goods[5286] =new setGoods("0000a95922","140","55","50","ww","normal");
goods[5287] =new setGoods("0000a95923","150","55","50","ww","normal");
goods[5288] =new setGoods("0000a95924","160","55","50","ww","normal");
goods[5289] =new setGoods("0000a95925","170","55","50","ww","normal");
goods[5290] =new setGoods("0000a95926","180","55","50","ww","normal");
goods[5291] =new setGoods("0000a95927","60","60","50","ww","normal");
goods[5292] =new setGoods("0000a95928","70","60","50","ww","normal");
goods[5293] =new setGoods("0000a95929","80","60","50","ww","normal");
goods[5294] =new setGoods("0000a95930","90","60","50","ww","normal");
goods[5295] =new setGoods("0000a95931","100","60","50","ww","normal");
goods[5296] =new setGoods("0000a95932","110","60","50","ww","normal");
goods[5297] =new setGoods("0000a95933","120","60","50","ww","normal");
goods[5298] =new setGoods("0000a95934","130","60","50","ww","normal");
goods[5299] =new setGoods("0000a95935","140","60","50","ww","normal");
goods[5300] =new setGoods("0000a95936","150","60","50","ww","normal");
goods[5301] =new setGoods("0000a95937","160","60","50","ww","normal");
goods[5302] =new setGoods("0000a95938","170","60","50","ww","normal");
goods[5303] =new setGoods("0000a95939","180","60","50","ww","normal");
goods[5304] =new setGoods("0000a95940","60","25","60","ww","normal");
goods[5305] =new setGoods("0000a95941","70","25","60","ww","normal");
goods[5306] =new setGoods("0000a95942","80","25","60","ww","normal");
goods[5307] =new setGoods("0000a95943","90","25","60","ww","normal");
goods[5308] =new setGoods("0000a95944","100","25","60","ww","normal");
goods[5309] =new setGoods("0000a95945","110","25","60","ww","normal");
goods[5310] =new setGoods("0000a95946","120","25","60","ww","normal");
goods[5311] =new setGoods("0000a95947","130","25","60","ww","normal");
goods[5312] =new setGoods("0000a95948","140","25","60","ww","normal");
goods[5313] =new setGoods("0000a95949","150","25","60","ww","normal");
goods[5314] =new setGoods("0000a95950","160","25","60","ww","normal");
goods[5315] =new setGoods("0000a95951","170","25","60","ww","normal");
goods[5316] =new setGoods("0000a95952","180","25","60","ww","normal");
goods[5317] =new setGoods("0000a95953","60","30","60","ww","normal");
goods[5318] =new setGoods("0000a95954","70","30","60","ww","normal");
goods[5319] =new setGoods("0000a95955","80","30","60","ww","normal");
goods[5320] =new setGoods("0000a95956","90","30","60","ww","normal");
goods[5321] =new setGoods("0000a95957","100","30","60","ww","normal");
goods[5322] =new setGoods("0000a95958","110","30","60","ww","normal");
goods[5323] =new setGoods("0000a95959","120","30","60","ww","normal");
goods[5324] =new setGoods("0000a95960","130","30","60","ww","normal");
goods[5325] =new setGoods("0000a95961","140","30","60","ww","normal");
goods[5326] =new setGoods("0000a95962","150","30","60","ww","normal");
goods[5327] =new setGoods("0000a95963","160","30","60","ww","normal");
goods[5328] =new setGoods("0000a95964","170","30","60","ww","normal");
goods[5329] =new setGoods("0000a95965","180","30","60","ww","normal");
goods[5330] =new setGoods("0000a95966","60","35","60","ww","normal");
goods[5331] =new setGoods("0000a95967","70","35","60","ww","normal");
goods[5332] =new setGoods("0000a95968","80","35","60","ww","normal");
goods[5333] =new setGoods("0000a95969","90","35","60","ww","normal");
goods[5334] =new setGoods("0000a95970","100","35","60","ww","normal");
goods[5335] =new setGoods("0000a95971","110","35","60","ww","normal");
goods[5336] =new setGoods("0000a95972","120","35","60","ww","normal");
goods[5337] =new setGoods("0000a95973","130","35","60","ww","normal");
goods[5338] =new setGoods("0000a95974","140","35","60","ww","normal");
goods[5339] =new setGoods("0000a95975","150","35","60","ww","normal");
goods[5340] =new setGoods("0000a95976","160","35","60","ww","normal");
goods[5341] =new setGoods("0000a95977","170","35","60","ww","normal");
goods[5342] =new setGoods("0000a95978","180","35","60","ww","normal");
goods[5343] =new setGoods("0000a95979","60","40","60","ww","normal");
goods[5344] =new setGoods("0000a95980","70","40","60","ww","normal");
goods[5345] =new setGoods("0000a95981","80","40","60","ww","normal");
goods[5346] =new setGoods("0000a95982","90","40","60","ww","normal");
goods[5347] =new setGoods("0000a95983","100","40","60","ww","normal");
goods[5348] =new setGoods("0000a95984","110","40","60","ww","normal");
goods[5349] =new setGoods("0000a95985","120","40","60","ww","normal");
goods[5350] =new setGoods("0000a95986","130","40","60","ww","normal");
goods[5351] =new setGoods("0000a95987","140","40","60","ww","normal");
goods[5352] =new setGoods("0000a95988","150","40","60","ww","normal");
goods[5353] =new setGoods("0000a95989","160","40","60","ww","normal");
goods[5354] =new setGoods("0000a95990","170","40","60","ww","normal");
goods[5355] =new setGoods("0000a95991","180","40","60","ww","normal");
goods[5356] =new setGoods("0000a95992","60","45","60","ww","normal");
goods[5357] =new setGoods("0000a95993","70","45","60","ww","normal");
goods[5358] =new setGoods("0000a95994","80","45","60","ww","normal");
goods[5359] =new setGoods("0000a95995","90","45","60","ww","normal");
goods[5360] =new setGoods("0000a95996","100","45","60","ww","normal");
goods[5361] =new setGoods("0000a95997","110","45","60","ww","normal");
goods[5362] =new setGoods("0000a95998","120","45","60","ww","normal");
goods[5363] =new setGoods("0000a95999","130","45","60","ww","normal");
goods[5364] =new setGoods("0000a96000","140","45","60","ww","normal");
goods[5365] =new setGoods("0000a96001","150","45","60","ww","normal");
goods[5366] =new setGoods("0000a96002","160","45","60","ww","normal");
goods[5367] =new setGoods("0000a96003","170","45","60","ww","normal");
goods[5368] =new setGoods("0000a96004","180","45","60","ww","normal");
goods[5369] =new setGoods("0000a96005","60","50","60","ww","normal");
goods[5370] =new setGoods("0000a96006","70","50","60","ww","normal");
goods[5371] =new setGoods("0000a96007","80","50","60","ww","normal");
goods[5372] =new setGoods("0000a96008","90","50","60","ww","normal");
goods[5373] =new setGoods("0000a96009","100","50","60","ww","normal");
goods[5374] =new setGoods("0000a96010","110","50","60","ww","normal");
goods[5375] =new setGoods("0000a96011","120","50","60","ww","normal");
goods[5376] =new setGoods("0000a96012","130","50","60","ww","normal");
goods[5377] =new setGoods("0000a96013","140","50","60","ww","normal");
goods[5378] =new setGoods("0000a96014","150","50","60","ww","normal");
goods[5379] =new setGoods("0000a96015","160","50","60","ww","normal");
goods[5380] =new setGoods("0000a96016","170","50","60","ww","normal");
goods[5381] =new setGoods("0000a96017","180","50","60","ww","normal");
goods[5382] =new setGoods("0000a96018","60","55","60","ww","normal");
goods[5383] =new setGoods("0000a96019","70","55","60","ww","normal");
goods[5384] =new setGoods("0000a96020","80","55","60","ww","normal");
goods[5385] =new setGoods("0000a96021","90","55","60","ww","normal");
goods[5386] =new setGoods("0000a96022","100","55","60","ww","normal");
goods[5387] =new setGoods("0000a96023","110","55","60","ww","normal");
goods[5388] =new setGoods("0000a96024","120","55","60","ww","normal");
goods[5389] =new setGoods("0000a96025","130","55","60","ww","normal");
goods[5390] =new setGoods("0000a96026","140","55","60","ww","normal");
goods[5391] =new setGoods("0000a96027","150","55","60","ww","normal");
goods[5392] =new setGoods("0000a96028","160","55","60","ww","normal");
goods[5393] =new setGoods("0000a96029","170","55","60","ww","normal");
goods[5394] =new setGoods("0000a96030","180","55","60","ww","normal");
goods[5395] =new setGoods("0000a96031","60","60","60","ww","normal");
goods[5396] =new setGoods("0000a96032","70","60","60","ww","normal");
goods[5397] =new setGoods("0000a96033","80","60","60","ww","normal");
goods[5398] =new setGoods("0000a96034","90","60","60","ww","normal");
goods[5399] =new setGoods("0000a96035","100","60","60","ww","normal");
goods[5400] =new setGoods("0000a96036","110","60","60","ww","normal");
goods[5401] =new setGoods("0000a96037","120","60","60","ww","normal");
goods[5402] =new setGoods("0000a96038","130","60","60","ww","normal");
goods[5403] =new setGoods("0000a96039","140","60","60","ww","normal");
goods[5404] =new setGoods("0000a96040","150","60","60","ww","normal");
goods[5405] =new setGoods("0000a96041","160","60","60","ww","normal");
goods[5406] =new setGoods("0000a96042","170","60","60","ww","normal");
goods[5407] =new setGoods("0000a96043","180","60","60","ww","normal");
goods[5408] =new setGoods("0000a96044","60","25","70","ww","normal");
goods[5409] =new setGoods("0000a96045","70","25","70","ww","normal");
goods[5410] =new setGoods("0000a96046","80","25","70","ww","normal");
goods[5411] =new setGoods("0000a96047","90","25","70","ww","normal");
goods[5412] =new setGoods("0000a96048","100","25","70","ww","normal");
goods[5413] =new setGoods("0000a96049","110","25","70","ww","normal");
goods[5414] =new setGoods("0000a96050","120","25","70","ww","normal");
goods[5415] =new setGoods("0000a96051","130","25","70","ww","normal");
goods[5416] =new setGoods("0000a96052","140","25","70","ww","normal");
goods[5417] =new setGoods("0000a96053","150","25","70","ww","normal");
goods[5418] =new setGoods("0000a96054","160","25","70","ww","normal");
goods[5419] =new setGoods("0000a96055","170","25","70","ww","normal");
goods[5420] =new setGoods("0000a96056","180","25","70","ww","normal");
goods[5421] =new setGoods("0000a96057","60","30","70","ww","normal");
goods[5422] =new setGoods("0000a96058","70","30","70","ww","normal");
goods[5423] =new setGoods("0000a96059","80","30","70","ww","normal");
goods[5424] =new setGoods("0000a96060","90","30","70","ww","normal");
goods[5425] =new setGoods("0000a96061","100","30","70","ww","normal");
goods[5426] =new setGoods("0000a96062","110","30","70","ww","normal");
goods[5427] =new setGoods("0000a96063","120","30","70","ww","normal");
goods[5428] =new setGoods("0000a96064","130","30","70","ww","normal");
goods[5429] =new setGoods("0000a96065","140","30","70","ww","normal");
goods[5430] =new setGoods("0000a96066","150","30","70","ww","normal");
goods[5431] =new setGoods("0000a96067","160","30","70","ww","normal");
goods[5432] =new setGoods("0000a96068","170","30","70","ww","normal");
goods[5433] =new setGoods("0000a96069","180","30","70","ww","normal");
goods[5434] =new setGoods("0000a96070","60","35","70","ww","normal");
goods[5435] =new setGoods("0000a96071","70","35","70","ww","normal");
goods[5436] =new setGoods("0000a96072","80","35","70","ww","normal");
goods[5437] =new setGoods("0000a96073","90","35","70","ww","normal");
goods[5438] =new setGoods("0000a96074","100","35","70","ww","normal");
goods[5439] =new setGoods("0000a96075","110","35","70","ww","normal");
goods[5440] =new setGoods("0000a96076","120","35","70","ww","normal");
goods[5441] =new setGoods("0000a96077","130","35","70","ww","normal");
goods[5442] =new setGoods("0000a96078","140","35","70","ww","normal");
goods[5443] =new setGoods("0000a96079","150","35","70","ww","normal");
goods[5444] =new setGoods("0000a96080","160","35","70","ww","normal");
goods[5445] =new setGoods("0000a96081","170","35","70","ww","normal");
goods[5446] =new setGoods("0000a96082","180","35","70","ww","normal");
goods[5447] =new setGoods("0000a96083","60","40","70","ww","normal");
goods[5448] =new setGoods("0000a96084","70","40","70","ww","normal");
goods[5449] =new setGoods("0000a96085","80","40","70","ww","normal");
goods[5450] =new setGoods("0000a96086","90","40","70","ww","normal");
goods[5451] =new setGoods("0000a96087","100","40","70","ww","normal");
goods[5452] =new setGoods("0000a96088","110","40","70","ww","normal");
goods[5453] =new setGoods("0000a96089","120","40","70","ww","normal");
goods[5454] =new setGoods("0000a96090","130","40","70","ww","normal");
goods[5455] =new setGoods("0000a96091","140","40","70","ww","normal");
goods[5456] =new setGoods("0000a96092","150","40","70","ww","normal");
goods[5457] =new setGoods("0000a96093","160","40","70","ww","normal");
goods[5458] =new setGoods("0000a96094","170","40","70","ww","normal");
goods[5459] =new setGoods("0000a96095","180","40","70","ww","normal");
goods[5460] =new setGoods("0000a96096","60","45","70","ww","normal");
goods[5461] =new setGoods("0000a96097","70","45","70","ww","normal");
goods[5462] =new setGoods("0000a96098","80","45","70","ww","normal");
goods[5463] =new setGoods("0000a96099","90","45","70","ww","normal");
goods[5464] =new setGoods("0000a96100","100","45","70","ww","normal");
goods[5465] =new setGoods("0000a96101","110","45","70","ww","normal");
goods[5466] =new setGoods("0000a96102","120","45","70","ww","normal");
goods[5467] =new setGoods("0000a96103","130","45","70","ww","normal");
goods[5468] =new setGoods("0000a96104","140","45","70","ww","normal");
goods[5469] =new setGoods("0000a96105","150","45","70","ww","normal");
goods[5470] =new setGoods("0000a96106","160","45","70","ww","normal");
goods[5471] =new setGoods("0000a96107","170","45","70","ww","normal");
goods[5472] =new setGoods("0000a96108","180","45","70","ww","normal");
goods[5473] =new setGoods("0000a96109","60","50","70","ww","normal");
goods[5474] =new setGoods("0000a96110","70","50","70","ww","normal");
goods[5475] =new setGoods("0000a96111","80","50","70","ww","normal");
goods[5476] =new setGoods("0000a96112","90","50","70","ww","normal");
goods[5477] =new setGoods("0000a96113","100","50","70","ww","normal");
goods[5478] =new setGoods("0000a96114","110","50","70","ww","normal");
goods[5479] =new setGoods("0000a96115","120","50","70","ww","normal");
goods[5480] =new setGoods("0000a96116","130","50","70","ww","normal");
goods[5481] =new setGoods("0000a96117","140","50","70","ww","normal");
goods[5482] =new setGoods("0000a96118","150","50","70","ww","normal");
goods[5483] =new setGoods("0000a96119","160","50","70","ww","normal");
goods[5484] =new setGoods("0000a96120","170","50","70","ww","normal");
goods[5485] =new setGoods("0000a96121","180","50","70","ww","normal");
goods[5486] =new setGoods("0000a96122","60","55","70","ww","normal");
goods[5487] =new setGoods("0000a96123","70","55","70","ww","normal");
goods[5488] =new setGoods("0000a96124","80","55","70","ww","normal");
goods[5489] =new setGoods("0000a96125","90","55","70","ww","normal");
goods[5490] =new setGoods("0000a96126","100","55","70","ww","normal");
goods[5491] =new setGoods("0000a96127","110","55","70","ww","normal");
goods[5492] =new setGoods("0000a96128","120","55","70","ww","normal");
goods[5493] =new setGoods("0000a96129","130","55","70","ww","normal");
goods[5494] =new setGoods("0000a96130","140","55","70","ww","normal");
goods[5495] =new setGoods("0000a96131","150","55","70","ww","normal");
goods[5496] =new setGoods("0000a96132","160","55","70","ww","normal");
goods[5497] =new setGoods("0000a96133","170","55","70","ww","normal");
goods[5498] =new setGoods("0000a96134","180","55","70","ww","normal");
goods[5499] =new setGoods("0000a96135","60","60","70","ww","normal");
goods[5500] =new setGoods("0000a96136","70","60","70","ww","normal");
goods[5501] =new setGoods("0000a96137","80","60","70","ww","normal");
goods[5502] =new setGoods("0000a96138","90","60","70","ww","normal");
goods[5503] =new setGoods("0000a96139","100","60","70","ww","normal");
goods[5504] =new setGoods("0000a96140","110","60","70","ww","normal");
goods[5505] =new setGoods("0000a96141","120","60","70","ww","normal");
goods[5506] =new setGoods("0000a96142","130","60","70","ww","normal");
goods[5507] =new setGoods("0000a96143","140","60","70","ww","normal");
goods[5508] =new setGoods("0000a96144","150","60","70","ww","normal");
goods[5509] =new setGoods("0000a96145","160","60","70","ww","normal");
goods[5510] =new setGoods("0000a96146","170","60","70","ww","normal");
goods[5511] =new setGoods("0000a96147","180","60","70","ww","normal");
goods[5512] =new setGoods("0000a96148","60","25","80","ww","normal");
goods[5513] =new setGoods("0000a96149","70","25","80","ww","normal");
goods[5514] =new setGoods("0000a96150","80","25","80","ww","normal");
goods[5515] =new setGoods("0000a96151","90","25","80","ww","normal");
goods[5516] =new setGoods("0000a96152","100","25","80","ww","normal");
goods[5517] =new setGoods("0000a96153","110","25","80","ww","normal");
goods[5518] =new setGoods("0000a96154","120","25","80","ww","normal");
goods[5519] =new setGoods("0000a96155","130","25","80","ww","normal");
goods[5520] =new setGoods("0000a96156","140","25","80","ww","normal");
goods[5521] =new setGoods("0000a96157","150","25","80","ww","normal");
goods[5522] =new setGoods("0000a96158","160","25","80","ww","normal");
goods[5523] =new setGoods("0000a96159","170","25","80","ww","normal");
goods[5524] =new setGoods("0000a96160","180","25","80","ww","normal");
goods[5525] =new setGoods("0000a96161","60","30","80","ww","normal");
goods[5526] =new setGoods("0000a96162","70","30","80","ww","normal");
goods[5527] =new setGoods("0000a96163","80","30","80","ww","normal");
goods[5528] =new setGoods("0000a96164","90","30","80","ww","normal");
goods[5529] =new setGoods("0000a96165","100","30","80","ww","normal");
goods[5530] =new setGoods("0000a96166","110","30","80","ww","normal");
goods[5531] =new setGoods("0000a96167","120","30","80","ww","normal");
goods[5532] =new setGoods("0000a96168","130","30","80","ww","normal");
goods[5533] =new setGoods("0000a96169","140","30","80","ww","normal");
goods[5534] =new setGoods("0000a96170","150","30","80","ww","normal");
goods[5535] =new setGoods("0000a96171","160","30","80","ww","normal");
goods[5536] =new setGoods("0000a96172","170","30","80","ww","normal");
goods[5537] =new setGoods("0000a96173","180","30","80","ww","normal");
goods[5538] =new setGoods("0000a96174","60","35","80","ww","normal");
goods[5539] =new setGoods("0000a96175","70","35","80","ww","normal");
goods[5540] =new setGoods("0000a96176","80","35","80","ww","normal");
goods[5541] =new setGoods("0000a96177","90","35","80","ww","normal");
goods[5542] =new setGoods("0000a96178","100","35","80","ww","normal");
goods[5543] =new setGoods("0000a96179","110","35","80","ww","normal");
goods[5544] =new setGoods("0000a96180","120","35","80","ww","normal");
goods[5545] =new setGoods("0000a96181","130","35","80","ww","normal");
goods[5546] =new setGoods("0000a96182","140","35","80","ww","normal");
goods[5547] =new setGoods("0000a96183","150","35","80","ww","normal");
goods[5548] =new setGoods("0000a96184","160","35","80","ww","normal");
goods[5549] =new setGoods("0000a96185","170","35","80","ww","normal");
goods[5550] =new setGoods("0000a96186","180","35","80","ww","normal");
goods[5551] =new setGoods("0000a96187","60","40","80","ww","normal");
goods[5552] =new setGoods("0000a96188","70","40","80","ww","normal");
goods[5553] =new setGoods("0000a96189","80","40","80","ww","normal");
goods[5554] =new setGoods("0000a96190","90","40","80","ww","normal");
goods[5555] =new setGoods("0000a96191","100","40","80","ww","normal");
goods[5556] =new setGoods("0000a96192","110","40","80","ww","normal");
goods[5557] =new setGoods("0000a96193","120","40","80","ww","normal");
goods[5558] =new setGoods("0000a96194","130","40","80","ww","normal");
goods[5559] =new setGoods("0000a96195","140","40","80","ww","normal");
goods[5560] =new setGoods("0000a96196","150","40","80","ww","normal");
goods[5561] =new setGoods("0000a96197","160","40","80","ww","normal");
goods[5562] =new setGoods("0000a96198","170","40","80","ww","normal");
goods[5563] =new setGoods("0000a96199","180","40","80","ww","normal");
goods[5564] =new setGoods("0000a96200","60","45","80","ww","normal");
goods[5565] =new setGoods("0000a96201","70","45","80","ww","normal");
goods[5566] =new setGoods("0000a96202","80","45","80","ww","normal");
goods[5567] =new setGoods("0000a96203","90","45","80","ww","normal");
goods[5568] =new setGoods("0000a96204","100","45","80","ww","normal");
goods[5569] =new setGoods("0000a96205","110","45","80","ww","normal");
goods[5570] =new setGoods("0000a96206","120","45","80","ww","normal");
goods[5571] =new setGoods("0000a96207","130","45","80","ww","normal");
goods[5572] =new setGoods("0000a96208","140","45","80","ww","normal");
goods[5573] =new setGoods("0000a96209","150","45","80","ww","normal");
goods[5574] =new setGoods("0000a96210","160","45","80","ww","normal");
goods[5575] =new setGoods("0000a96211","170","45","80","ww","normal");
goods[5576] =new setGoods("0000a96212","180","45","80","ww","normal");
goods[5577] =new setGoods("0000a96213","60","50","80","ww","normal");
goods[5578] =new setGoods("0000a96214","70","50","80","ww","normal");
goods[5579] =new setGoods("0000a96215","80","50","80","ww","normal");
goods[5580] =new setGoods("0000a96216","90","50","80","ww","normal");
goods[5581] =new setGoods("0000a96217","100","50","80","ww","normal");
goods[5582] =new setGoods("0000a96218","110","50","80","ww","normal");
goods[5583] =new setGoods("0000a96219","120","50","80","ww","normal");
goods[5584] =new setGoods("0000a96220","130","50","80","ww","normal");
goods[5585] =new setGoods("0000a96221","140","50","80","ww","normal");
goods[5586] =new setGoods("0000a96222","150","50","80","ww","normal");
goods[5587] =new setGoods("0000a96223","160","50","80","ww","normal");
goods[5588] =new setGoods("0000a96224","170","50","80","ww","normal");
goods[5589] =new setGoods("0000a96225","180","50","80","ww","normal");
goods[5590] =new setGoods("0000a96226","60","55","80","ww","normal");
goods[5591] =new setGoods("0000a96227","70","55","80","ww","normal");
goods[5592] =new setGoods("0000a96228","80","55","80","ww","normal");
goods[5593] =new setGoods("0000a96229","90","55","80","ww","normal");
goods[5594] =new setGoods("0000a96230","100","55","80","ww","normal");
goods[5595] =new setGoods("0000a96231","110","55","80","ww","normal");
goods[5596] =new setGoods("0000a96232","120","55","80","ww","normal");
goods[5597] =new setGoods("0000a96233","130","55","80","ww","normal");
goods[5598] =new setGoods("0000a96234","140","55","80","ww","normal");
goods[5599] =new setGoods("0000a96235","150","55","80","ww","normal");
goods[5600] =new setGoods("0000a96236","160","55","80","ww","normal");
goods[5601] =new setGoods("0000a96237","170","55","80","ww","normal");
goods[5602] =new setGoods("0000a96238","180","55","80","ww","normal");
goods[5603] =new setGoods("0000a96239","60","60","80","ww","normal");
goods[5604] =new setGoods("0000a96240","70","60","80","ww","normal");
goods[5605] =new setGoods("0000a96241","80","60","80","ww","normal");
goods[5606] =new setGoods("0000a96242","90","60","80","ww","normal");
goods[5607] =new setGoods("0000a96243","100","60","80","ww","normal");
goods[5608] =new setGoods("0000a96244","110","60","80","ww","normal");
goods[5609] =new setGoods("0000a96245","120","60","80","ww","normal");
goods[5610] =new setGoods("0000a96246","130","60","80","ww","normal");
goods[5611] =new setGoods("0000a96247","140","60","80","ww","normal");
goods[5612] =new setGoods("0000a96248","150","60","80","ww","normal");
goods[5613] =new setGoods("0000a96249","160","60","80","ww","normal");
goods[5614] =new setGoods("0000a96250","170","60","80","ww","normal");
goods[5615] =new setGoods("0000a96251","180","60","80","ww","normal");
goods[5616] =new setGoods("0000a96252","60","25","90","ww","normal");
goods[5617] =new setGoods("0000a96253","70","25","90","ww","normal");
goods[5618] =new setGoods("0000a96254","80","25","90","ww","normal");
goods[5619] =new setGoods("0000a96255","90","25","90","ww","normal");
goods[5620] =new setGoods("0000a96256","100","25","90","ww","normal");
goods[5621] =new setGoods("0000a96257","110","25","90","ww","normal");
goods[5622] =new setGoods("0000a96258","120","25","90","ww","normal");
goods[5623] =new setGoods("0000a96259","130","25","90","ww","normal");
goods[5624] =new setGoods("0000a96260","140","25","90","ww","normal");
goods[5625] =new setGoods("0000a96261","150","25","90","ww","normal");
goods[5626] =new setGoods("0000a96262","160","25","90","ww","normal");
goods[5627] =new setGoods("0000a96263","170","25","90","ww","normal");
goods[5628] =new setGoods("0000a96264","180","25","90","ww","normal");
goods[5629] =new setGoods("0000a96265","60","30","90","ww","normal");
goods[5630] =new setGoods("0000a96266","70","30","90","ww","normal");
goods[5631] =new setGoods("0000a96267","80","30","90","ww","normal");
goods[5632] =new setGoods("0000a96268","90","30","90","ww","normal");
goods[5633] =new setGoods("0000a96269","100","30","90","ww","normal");
goods[5634] =new setGoods("0000a96270","110","30","90","ww","normal");
goods[5635] =new setGoods("0000a96271","120","30","90","ww","normal");
goods[5636] =new setGoods("0000a96272","130","30","90","ww","normal");
goods[5637] =new setGoods("0000a96273","140","30","90","ww","normal");
goods[5638] =new setGoods("0000a96274","150","30","90","ww","normal");
goods[5639] =new setGoods("0000a96275","160","30","90","ww","normal");
goods[5640] =new setGoods("0000a96276","170","30","90","ww","normal");
goods[5641] =new setGoods("0000a96277","180","30","90","ww","normal");
goods[5642] =new setGoods("0000a96278","60","35","90","ww","normal");
goods[5643] =new setGoods("0000a96279","70","35","90","ww","normal");
goods[5644] =new setGoods("0000a96280","80","35","90","ww","normal");
goods[5645] =new setGoods("0000a96281","90","35","90","ww","normal");
goods[5646] =new setGoods("0000a96282","100","35","90","ww","normal");
goods[5647] =new setGoods("0000a96283","110","35","90","ww","normal");
goods[5648] =new setGoods("0000a96284","120","35","90","ww","normal");
goods[5649] =new setGoods("0000a96285","130","35","90","ww","normal");
goods[5650] =new setGoods("0000a96286","140","35","90","ww","normal");
goods[5651] =new setGoods("0000a96287","150","35","90","ww","normal");
goods[5652] =new setGoods("0000a96288","160","35","90","ww","normal");
goods[5653] =new setGoods("0000a96289","170","35","90","ww","normal");
goods[5654] =new setGoods("0000a96290","180","35","90","ww","normal");
goods[5655] =new setGoods("0000a96291","60","40","90","ww","normal");
goods[5656] =new setGoods("0000a96292","70","40","90","ww","normal");
goods[5657] =new setGoods("0000a96293","80","40","90","ww","normal");
goods[5658] =new setGoods("0000a96294","90","40","90","ww","normal");
goods[5659] =new setGoods("0000a96295","100","40","90","ww","normal");
goods[5660] =new setGoods("0000a96296","110","40","90","ww","normal");
goods[5661] =new setGoods("0000a96297","120","40","90","ww","normal");
goods[5662] =new setGoods("0000a96298","130","40","90","ww","normal");
goods[5663] =new setGoods("0000a96299","140","40","90","ww","normal");
goods[5664] =new setGoods("0000a96300","150","40","90","ww","normal");
goods[5665] =new setGoods("0000a96301","160","40","90","ww","normal");
goods[5666] =new setGoods("0000a96302","170","40","90","ww","normal");
goods[5667] =new setGoods("0000a96303","180","40","90","ww","normal");
goods[5668] =new setGoods("0000a96304","60","45","90","ww","normal");
goods[5669] =new setGoods("0000a96305","70","45","90","ww","normal");
goods[5670] =new setGoods("0000a96306","80","45","90","ww","normal");
goods[5671] =new setGoods("0000a96307","90","45","90","ww","normal");
goods[5672] =new setGoods("0000a96308","100","45","90","ww","normal");
goods[5673] =new setGoods("0000a96309","110","45","90","ww","normal");
goods[5674] =new setGoods("0000a96310","120","45","90","ww","normal");
goods[5675] =new setGoods("0000a96311","130","45","90","ww","normal");
goods[5676] =new setGoods("0000a96312","140","45","90","ww","normal");
goods[5677] =new setGoods("0000a96313","150","45","90","ww","normal");
goods[5678] =new setGoods("0000a96314","160","45","90","ww","normal");
goods[5679] =new setGoods("0000a96315","170","45","90","ww","normal");
goods[5680] =new setGoods("0000a96316","180","45","90","ww","normal");
goods[5681] =new setGoods("0000a96317","60","50","90","ww","normal");
goods[5682] =new setGoods("0000a96318","70","50","90","ww","normal");
goods[5683] =new setGoods("0000a96319","80","50","90","ww","normal");
goods[5684] =new setGoods("0000a96320","90","50","90","ww","normal");
goods[5685] =new setGoods("0000a96321","100","50","90","ww","normal");
goods[5686] =new setGoods("0000a96322","110","50","90","ww","normal");
goods[5687] =new setGoods("0000a96323","120","50","90","ww","normal");
goods[5688] =new setGoods("0000a96324","130","50","90","ww","normal");
goods[5689] =new setGoods("0000a96325","140","50","90","ww","normal");
goods[5690] =new setGoods("0000a96326","150","50","90","ww","normal");
goods[5691] =new setGoods("0000a96327","160","50","90","ww","normal");
goods[5692] =new setGoods("0000a96328","170","50","90","ww","normal");
goods[5693] =new setGoods("0000a96329","180","50","90","ww","normal");
goods[5694] =new setGoods("0000a96330","60","55","90","ww","normal");
goods[5695] =new setGoods("0000a96331","70","55","90","ww","normal");
goods[5696] =new setGoods("0000a96332","80","55","90","ww","normal");
goods[5697] =new setGoods("0000a96333","90","55","90","ww","normal");
goods[5698] =new setGoods("0000a96334","100","55","90","ww","normal");
goods[5699] =new setGoods("0000a96335","110","55","90","ww","normal");
goods[5700] =new setGoods("0000a96336","120","55","90","ww","normal");
goods[5701] =new setGoods("0000a96337","130","55","90","ww","normal");
goods[5702] =new setGoods("0000a96338","140","55","90","ww","normal");
goods[5703] =new setGoods("0000a96339","150","55","90","ww","normal");
goods[5704] =new setGoods("0000a96340","160","55","90","ww","normal");
goods[5705] =new setGoods("0000a96341","170","55","90","ww","normal");
goods[5706] =new setGoods("0000a96342","180","55","90","ww","normal");
goods[5707] =new setGoods("0000a96343","60","60","90","ww","normal");
goods[5708] =new setGoods("0000a96344","70","60","90","ww","normal");
goods[5709] =new setGoods("0000a96345","80","60","90","ww","normal");
goods[5710] =new setGoods("0000a96346","90","60","90","ww","normal");
goods[5711] =new setGoods("0000a96347","100","60","90","ww","normal");
goods[5712] =new setGoods("0000a96348","110","60","90","ww","normal");
goods[5713] =new setGoods("0000a96349","120","60","90","ww","normal");
goods[5714] =new setGoods("0000a96350","130","60","90","ww","normal");
goods[5715] =new setGoods("0000a96351","140","60","90","ww","normal");
goods[5716] =new setGoods("0000a96352","150","60","90","ww","normal");
goods[5717] =new setGoods("0000a96353","160","60","90","ww","normal");
goods[5718] =new setGoods("0000a96354","170","60","90","ww","normal");
goods[5719] =new setGoods("0000a96355","180","60","90","ww","normal");
goods[5720] =new setGoods("0000a96356","60","25","100","ww","normal");
goods[5721] =new setGoods("0000a96357","70","25","100","ww","normal");
goods[5722] =new setGoods("0000a96358","80","25","100","ww","normal");
goods[5723] =new setGoods("0000a96359","90","25","100","ww","normal");
goods[5724] =new setGoods("0000a96360","100","25","100","ww","normal");
goods[5725] =new setGoods("0000a96361","110","25","100","ww","normal");
goods[5726] =new setGoods("0000a96362","120","25","100","ww","normal");
goods[5727] =new setGoods("0000a96363","130","25","100","ww","normal");
goods[5728] =new setGoods("0000a96364","140","25","100","ww","normal");
goods[5729] =new setGoods("0000a96365","150","25","100","ww","normal");
goods[5730] =new setGoods("0000a96366","160","25","100","ww","normal");
goods[5731] =new setGoods("0000a96367","170","25","100","ww","normal");
goods[5732] =new setGoods("0000a96368","180","25","100","ww","normal");
goods[5733] =new setGoods("0000a96369","60","30","100","ww","normal");
goods[5734] =new setGoods("0000a96370","70","30","100","ww","normal");
goods[5735] =new setGoods("0000a96371","80","30","100","ww","normal");
goods[5736] =new setGoods("0000a96372","90","30","100","ww","normal");
goods[5737] =new setGoods("0000a96373","100","30","100","ww","normal");
goods[5738] =new setGoods("0000a96374","110","30","100","ww","normal");
goods[5739] =new setGoods("0000a96375","120","30","100","ww","normal");
goods[5740] =new setGoods("0000a96376","130","30","100","ww","normal");
goods[5741] =new setGoods("0000a96377","140","30","100","ww","normal");
goods[5742] =new setGoods("0000a96378","150","30","100","ww","normal");
goods[5743] =new setGoods("0000a96379","160","30","100","ww","normal");
goods[5744] =new setGoods("0000a96380","170","30","100","ww","normal");
goods[5745] =new setGoods("0000a96381","180","30","100","ww","normal");
goods[5746] =new setGoods("0000a96382","60","35","100","ww","normal");
goods[5747] =new setGoods("0000a96383","70","35","100","ww","normal");
goods[5748] =new setGoods("0000a96384","80","35","100","ww","normal");
goods[5749] =new setGoods("0000a96385","90","35","100","ww","normal");
goods[5750] =new setGoods("0000a96386","100","35","100","ww","normal");
goods[5751] =new setGoods("0000a96387","110","35","100","ww","normal");
goods[5752] =new setGoods("0000a96388","120","35","100","ww","normal");
goods[5753] =new setGoods("0000a96389","130","35","100","ww","normal");
goods[5754] =new setGoods("0000a96390","140","35","100","ww","normal");
goods[5755] =new setGoods("0000a96391","150","35","100","ww","normal");
goods[5756] =new setGoods("0000a96392","160","35","100","ww","normal");
goods[5757] =new setGoods("0000a96393","170","35","100","ww","normal");
goods[5758] =new setGoods("0000a96394","180","35","100","ww","normal");
goods[5759] =new setGoods("0000a96395","60","40","100","ww","normal");
goods[5760] =new setGoods("0000a96396","70","40","100","ww","normal");
goods[5761] =new setGoods("0000a96397","80","40","100","ww","normal");
goods[5762] =new setGoods("0000a96398","90","40","100","ww","normal");
goods[5763] =new setGoods("0000a96399","100","40","100","ww","normal");
goods[5764] =new setGoods("0000a96400","110","40","100","ww","normal");
goods[5765] =new setGoods("0000a96401","120","40","100","ww","normal");
goods[5766] =new setGoods("0000a96402","130","40","100","ww","normal");
goods[5767] =new setGoods("0000a96403","140","40","100","ww","normal");
goods[5768] =new setGoods("0000a96404","150","40","100","ww","normal");
goods[5769] =new setGoods("0000a96405","160","40","100","ww","normal");
goods[5770] =new setGoods("0000a96406","170","40","100","ww","normal");
goods[5771] =new setGoods("0000a96407","180","40","100","ww","normal");
goods[5772] =new setGoods("0000a96408","60","45","100","ww","normal");
goods[5773] =new setGoods("0000a96409","70","45","100","ww","normal");
goods[5774] =new setGoods("0000a96410","80","45","100","ww","normal");
goods[5775] =new setGoods("0000a96411","90","45","100","ww","normal");
goods[5776] =new setGoods("0000a96412","100","45","100","ww","normal");
goods[5777] =new setGoods("0000a96413","110","45","100","ww","normal");
goods[5778] =new setGoods("0000a96414","120","45","100","ww","normal");
goods[5779] =new setGoods("0000a96415","130","45","100","ww","normal");
goods[5780] =new setGoods("0000a96416","140","45","100","ww","normal");
goods[5781] =new setGoods("0000a96417","150","45","100","ww","normal");
goods[5782] =new setGoods("0000a96418","160","45","100","ww","normal");
goods[5783] =new setGoods("0000a96419","170","45","100","ww","normal");
goods[5784] =new setGoods("0000a96420","180","45","100","ww","normal");
goods[5785] =new setGoods("0000a96421","60","50","100","ww","normal");
goods[5786] =new setGoods("0000a96422","70","50","100","ww","normal");
goods[5787] =new setGoods("0000a96423","80","50","100","ww","normal");
goods[5788] =new setGoods("0000a96424","90","50","100","ww","normal");
goods[5789] =new setGoods("0000a96425","100","50","100","ww","normal");
goods[5790] =new setGoods("0000a96426","110","50","100","ww","normal");
goods[5791] =new setGoods("0000a96427","120","50","100","ww","normal");
goods[5792] =new setGoods("0000a96428","130","50","100","ww","normal");
goods[5793] =new setGoods("0000a96429","140","50","100","ww","normal");
goods[5794] =new setGoods("0000a96430","150","50","100","ww","normal");
goods[5795] =new setGoods("0000a96431","160","50","100","ww","normal");
goods[5796] =new setGoods("0000a96432","170","50","100","ww","normal");
goods[5797] =new setGoods("0000a96433","180","50","100","ww","normal");
goods[5798] =new setGoods("0000a96434","60","55","100","ww","normal");
goods[5799] =new setGoods("0000a96435","70","55","100","ww","normal");
goods[5800] =new setGoods("0000a96436","80","55","100","ww","normal");
goods[5801] =new setGoods("0000a96437","90","55","100","ww","normal");
goods[5802] =new setGoods("0000a96438","100","55","100","ww","normal");
goods[5803] =new setGoods("0000a96439","110","55","100","ww","normal");
goods[5804] =new setGoods("0000a96440","120","55","100","ww","normal");
goods[5805] =new setGoods("0000a96441","130","55","100","ww","normal");
goods[5806] =new setGoods("0000a96442","140","55","100","ww","normal");
goods[5807] =new setGoods("0000a96443","150","55","100","ww","normal");
goods[5808] =new setGoods("0000a96444","160","55","100","ww","normal");
goods[5809] =new setGoods("0000a96445","170","55","100","ww","normal");
goods[5810] =new setGoods("0000a96446","180","55","100","ww","normal");
goods[5811] =new setGoods("0000a96447","60","60","100","ww","normal");
goods[5812] =new setGoods("0000a96448","70","60","100","ww","normal");
goods[5813] =new setGoods("0000a96449","80","60","100","ww","normal");
goods[5814] =new setGoods("0000a96450","90","60","100","ww","normal");
goods[5815] =new setGoods("0000a96451","100","60","100","ww","normal");
goods[5816] =new setGoods("0000a96452","110","60","100","ww","normal");
goods[5817] =new setGoods("0000a96453","120","60","100","ww","normal");
goods[5818] =new setGoods("0000a96454","130","60","100","ww","normal");
goods[5819] =new setGoods("0000a96455","140","60","100","ww","normal");
goods[5820] =new setGoods("0000a96456","150","60","100","ww","normal");
goods[5821] =new setGoods("0000a96457","160","60","100","ww","normal");
goods[5822] =new setGoods("0000a96458","170","60","100","ww","normal");
goods[5823] =new setGoods("0000a96459","180","60","100","ww","normal");



















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































